webpackJsonp([114276838955818,60335399758886],{

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(367), __esModule: true };

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(368), __esModule: true };

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(625);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(893);
	var isArguments = __webpack_require__(892);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 892:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 893:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {(function() {
	
	  // nb. This is for IE10 and lower _only_.
	  var supportCustomEvent = window.CustomEvent;
	  if (!supportCustomEvent || typeof supportCustomEvent === 'object') {
	    supportCustomEvent = function CustomEvent(event, x) {
	      x = x || {};
	      var ev = document.createEvent('CustomEvent');
	      ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
	      return ev;
	    };
	    supportCustomEvent.prototype = window.Event.prototype;
	  }
	
	  /**
	   * @param {Element} el to check for stacking context
	   * @return {boolean} whether this el or its parents creates a stacking context
	   */
	  function createsStackingContext(el) {
	    while (el && el !== document.body) {
	      var s = window.getComputedStyle(el);
	      var invalid = function(k, ok) {
	        return !(s[k] === undefined || s[k] === ok);
	      }
	      if (s.opacity < 1 ||
	          invalid('zIndex', 'auto') ||
	          invalid('transform', 'none') ||
	          invalid('mixBlendMode', 'normal') ||
	          invalid('filter', 'none') ||
	          invalid('perspective', 'none') ||
	          s['isolation'] === 'isolate' ||
	          s.position === 'fixed' ||
	          s.webkitOverflowScrolling === 'touch') {
	        return true;
	      }
	      el = el.parentElement;
	    }
	    return false;
	  }
	
	  /**
	   * Finds the nearest <dialog> from the passed element.
	   *
	   * @param {Element} el to search from
	   * @return {HTMLDialogElement} dialog found
	   */
	  function findNearestDialog(el) {
	    while (el) {
	      if (el.localName === 'dialog') {
	        return /** @type {HTMLDialogElement} */ (el);
	      }
	      el = el.parentElement;
	    }
	    return null;
	  }
	
	  /**
	   * Blur the specified element, as long as it's not the HTML body element.
	   * This works around an IE9/10 bug - blurring the body causes Windows to
	   * blur the whole application.
	   *
	   * @param {Element} el to blur
	   */
	  function safeBlur(el) {
	    if (el && el.blur && el !== document.body) {
	      el.blur();
	    }
	  }
	
	  /**
	   * @param {!NodeList} nodeList to search
	   * @param {Node} node to find
	   * @return {boolean} whether node is inside nodeList
	   */
	  function inNodeList(nodeList, node) {
	    for (var i = 0; i < nodeList.length; ++i) {
	      if (nodeList[i] === node) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * @param {HTMLFormElement} el to check
	   * @return {boolean} whether this form has method="dialog"
	   */
	  function isFormMethodDialog(el) {
	    if (!el || !el.hasAttribute('method')) {
	      return false;
	    }
	    return el.getAttribute('method').toLowerCase() === 'dialog';
	  }
	
	  /**
	   * @param {!HTMLDialogElement} dialog to upgrade
	   * @constructor
	   */
	  function dialogPolyfillInfo(dialog) {
	    this.dialog_ = dialog;
	    this.replacedStyleTop_ = false;
	    this.openAsModal_ = false;
	
	    // Set a11y role. Browsers that support dialog implicitly know this already.
	    if (!dialog.hasAttribute('role')) {
	      dialog.setAttribute('role', 'dialog');
	    }
	
	    dialog.show = this.show.bind(this);
	    dialog.showModal = this.showModal.bind(this);
	    dialog.close = this.close.bind(this);
	
	    if (!('returnValue' in dialog)) {
	      dialog.returnValue = '';
	    }
	
	    if ('MutationObserver' in window) {
	      var mo = new MutationObserver(this.maybeHideModal.bind(this));
	      mo.observe(dialog, {attributes: true, attributeFilter: ['open']});
	    } else {
	      // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
	      // seem to fire even if the element was removed as part of a parent removal. Use the removed
	      // events to force downgrade (useful if removed/immediately added).
	      var removed = false;
	      var cb = function() {
	        removed ? this.downgradeModal() : this.maybeHideModal();
	        removed = false;
	      }.bind(this);
	      var timeout;
	      var delayModel = function(ev) {
	        if (ev.target !== dialog) { return; }  // not for a child element
	        var cand = 'DOMNodeRemoved';
	        removed |= (ev.type.substr(0, cand.length) === cand);
	        window.clearTimeout(timeout);
	        timeout = window.setTimeout(cb, 0);
	      };
	      ['DOMAttrModified', 'DOMNodeRemoved', 'DOMNodeRemovedFromDocument'].forEach(function(name) {
	        dialog.addEventListener(name, delayModel);
	      });
	    }
	    // Note that the DOM is observed inside DialogManager while any dialog
	    // is being displayed as a modal, to catch modal removal from the DOM.
	
	    Object.defineProperty(dialog, 'open', {
	      set: this.setOpen.bind(this),
	      get: dialog.hasAttribute.bind(dialog, 'open')
	    });
	
	    this.backdrop_ = document.createElement('div');
	    this.backdrop_.className = 'backdrop';
	    this.backdrop_.addEventListener('click', this.backdropClick_.bind(this));
	  }
	
	  dialogPolyfillInfo.prototype = {
	
	    get dialog() {
	      return this.dialog_;
	    },
	
	    /**
	     * Maybe remove this dialog from the modal top layer. This is called when
	     * a modal dialog may no longer be tenable, e.g., when the dialog is no
	     * longer open or is no longer part of the DOM.
	     */
	    maybeHideModal: function() {
	      if (this.dialog_.hasAttribute('open') && document.body.contains(this.dialog_)) { return; }
	      this.downgradeModal();
	    },
	
	    /**
	     * Remove this dialog from the modal top layer, leaving it as a non-modal.
	     */
	    downgradeModal: function() {
	      if (!this.openAsModal_) { return; }
	      this.openAsModal_ = false;
	      this.dialog_.style.zIndex = '';
	
	      // This won't match the native <dialog> exactly because if the user set top on a centered
	      // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
	      // possible to polyfill this perfectly.
	      if (this.replacedStyleTop_) {
	        this.dialog_.style.top = '';
	        this.replacedStyleTop_ = false;
	      }
	
	      // Clear the backdrop and remove from the manager.
	      this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
	      dialogPolyfill.dm.removeDialog(this);
	    },
	
	    /**
	     * @param {boolean} value whether to open or close this dialog
	     */
	    setOpen: function(value) {
	      if (value) {
	        this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
	      } else {
	        this.dialog_.removeAttribute('open');
	        this.maybeHideModal();  // nb. redundant with MutationObserver
	      }
	    },
	
	    /**
	     * Handles clicks on the fake .backdrop element, redirecting them as if
	     * they were on the dialog itself.
	     *
	     * @param {!Event} e to redirect
	     */
	    backdropClick_: function(e) {
	      if (!this.dialog_.hasAttribute('tabindex')) {
	        // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
	        // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
	        // would not be needed - clicks would move the implicit cursor there.
	        var fake = document.createElement('div');
	        this.dialog_.insertBefore(fake, this.dialog_.firstChild);
	        fake.tabIndex = -1;
	        fake.focus();
	        this.dialog_.removeChild(fake);
	      } else {
	        this.dialog_.focus();
	      }
	
	      var redirectedEvent = document.createEvent('MouseEvents');
	      redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window,
	          e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey,
	          e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
	      this.dialog_.dispatchEvent(redirectedEvent);
	      e.stopPropagation();
	    },
	
	    /**
	     * Focuses on the first focusable element within the dialog. This will always blur the current
	     * focus, even if nothing within the dialog is found.
	     */
	    focus_: function() {
	      // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
	      var target = this.dialog_.querySelector('[autofocus]:not([disabled])');
	      if (!target && this.dialog_.tabIndex >= 0) {
	        target = this.dialog_;
	      }
	      if (!target) {
	        // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
	        // alternative involves stepping through and trying to focus everything.
	        var opts = ['button', 'input', 'keygen', 'select', 'textarea'];
	        var query = opts.map(function(el) {
	          return el + ':not([disabled])';
	        });
	        // TODO(samthor): tabindex values that are not numeric are not focusable.
	        query.push('[tabindex]:not([disabled]):not([tabindex=""])');  // tabindex != "", not disabled
	        target = this.dialog_.querySelector(query.join(', '));
	      }
	      safeBlur(document.activeElement);
	      target && target.focus();
	    },
	
	    /**
	     * Sets the zIndex for the backdrop and dialog.
	     *
	     * @param {number} dialogZ
	     * @param {number} backdropZ
	     */
	    updateZIndex: function(dialogZ, backdropZ) {
	      if (dialogZ < backdropZ) {
	        throw new Error('dialogZ should never be < backdropZ');
	      }
	      this.dialog_.style.zIndex = dialogZ;
	      this.backdrop_.style.zIndex = backdropZ;
	    },
	
	    /**
	     * Shows the dialog. If the dialog is already open, this does nothing.
	     */
	    show: function() {
	      if (!this.dialog_.open) {
	        this.setOpen(true);
	        this.focus_();
	      }
	    },
	
	    /**
	     * Show this dialog modally.
	     */
	    showModal: function() {
	      if (this.dialog_.hasAttribute('open')) {
	        throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
	      }
	      if (!document.body.contains(this.dialog_)) {
	        throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
	      }
	      if (!dialogPolyfill.dm.pushDialog(this)) {
	        throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
	      }
	
	      if (createsStackingContext(this.dialog_.parentElement)) {
	        console.warn('A dialog is being shown inside a stacking context. ' +
	            'This may cause it to be unusable. For more information, see this link: ' +
	            'https://github.com/GoogleChrome/dialog-polyfill/#stacking-context');
	      }
	
	      this.setOpen(true);
	      this.openAsModal_ = true;
	
	      // Optionally center vertically, relative to the current viewport.
	      if (dialogPolyfill.needsCentering(this.dialog_)) {
	        dialogPolyfill.reposition(this.dialog_);
	        this.replacedStyleTop_ = true;
	      } else {
	        this.replacedStyleTop_ = false;
	      }
	
	      // Insert backdrop.
	      this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);
	
	      // Focus on whatever inside the dialog.
	      this.focus_();
	    },
	
	    /**
	     * Closes this HTMLDialogElement. This is optional vs clearing the open
	     * attribute, however this fires a 'close' event.
	     *
	     * @param {string=} opt_returnValue to use as the returnValue
	     */
	    close: function(opt_returnValue) {
	      if (!this.dialog_.hasAttribute('open')) {
	        throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
	      }
	      this.setOpen(false);
	
	      // Leave returnValue untouched in case it was set directly on the element
	      if (opt_returnValue !== undefined) {
	        this.dialog_.returnValue = opt_returnValue;
	      }
	
	      // Triggering "close" event for any attached listeners on the <dialog>.
	      var closeEvent = new supportCustomEvent('close', {
	        bubbles: false,
	        cancelable: false
	      });
	      this.dialog_.dispatchEvent(closeEvent);
	    }
	
	  };
	
	  var dialogPolyfill = {};
	
	  dialogPolyfill.reposition = function(element) {
	    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
	    var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
	    element.style.top = Math.max(scrollTop, topValue) + 'px';
	  };
	
	  dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
	    for (var i = 0; i < document.styleSheets.length; ++i) {
	      var styleSheet = document.styleSheets[i];
	      var cssRules = null;
	      // Some browsers throw on cssRules.
	      try {
	        cssRules = styleSheet.cssRules;
	      } catch (e) {}
	      if (!cssRules) { continue; }
	      for (var j = 0; j < cssRules.length; ++j) {
	        var rule = cssRules[j];
	        var selectedNodes = null;
	        // Ignore errors on invalid selector texts.
	        try {
	          selectedNodes = document.querySelectorAll(rule.selectorText);
	        } catch(e) {}
	        if (!selectedNodes || !inNodeList(selectedNodes, element)) {
	          continue;
	        }
	        var cssTop = rule.style.getPropertyValue('top');
	        var cssBottom = rule.style.getPropertyValue('bottom');
	        if ((cssTop && cssTop !== 'auto') || (cssBottom && cssBottom !== 'auto')) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  dialogPolyfill.needsCentering = function(dialog) {
	    var computedStyle = window.getComputedStyle(dialog);
	    if (computedStyle.position !== 'absolute') {
	      return false;
	    }
	
	    // We must determine whether the top/bottom specified value is non-auto.  In
	    // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
	    // Firefox returns the used value. So we do this crazy thing instead: check
	    // the inline style and then go through CSS rules.
	    if ((dialog.style.top !== 'auto' && dialog.style.top !== '') ||
	        (dialog.style.bottom !== 'auto' && dialog.style.bottom !== '')) {
	      return false;
	    }
	    return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
	  };
	
	  /**
	   * @param {!Element} element to force upgrade
	   */
	  dialogPolyfill.forceRegisterDialog = function(element) {
	    if (window.HTMLDialogElement || element.showModal) {
	      console.warn('This browser already supports <dialog>, the polyfill ' +
	          'may not work correctly', element);
	    }
	    if (element.localName !== 'dialog') {
	      throw new Error('Failed to register dialog: The element is not a dialog.');
	    }
	    new dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ (element));
	  };
	
	  /**
	   * @param {!Element} element to upgrade, if necessary
	   */
	  dialogPolyfill.registerDialog = function(element) {
	    if (!element.showModal) {
	      dialogPolyfill.forceRegisterDialog(element);
	    }
	  };
	
	  /**
	   * @constructor
	   */
	  dialogPolyfill.DialogManager = function() {
	    /** @type {!Array<!dialogPolyfillInfo>} */
	    this.pendingDialogStack = [];
	
	    var checkDOM = this.checkDOM_.bind(this);
	
	    // The overlay is used to simulate how a modal dialog blocks the document.
	    // The blocking dialog is positioned on top of the overlay, and the rest of
	    // the dialogs on the pending dialog stack are positioned below it. In the
	    // actual implementation, the modal dialog stacking is controlled by the
	    // top layer, where z-index has no effect.
	    this.overlay = document.createElement('div');
	    this.overlay.className = '_dialog_overlay';
	    this.overlay.addEventListener('click', function(e) {
	      this.forwardTab_ = undefined;
	      e.stopPropagation();
	      checkDOM([]);  // sanity-check DOM
	    }.bind(this));
	
	    this.handleKey_ = this.handleKey_.bind(this);
	    this.handleFocus_ = this.handleFocus_.bind(this);
	
	    this.zIndexLow_ = 100000;
	    this.zIndexHigh_ = 100000 + 150;
	
	    this.forwardTab_ = undefined;
	
	    if ('MutationObserver' in window) {
	      this.mo_ = new MutationObserver(function(records) {
	        var removed = [];
	        records.forEach(function(rec) {
	          for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
	            if (!(c instanceof Element)) {
	              continue;
	            } else if (c.localName === 'dialog') {
	              removed.push(c);
	            }
	            removed = removed.concat(c.querySelectorAll('dialog'));
	          }
	        });
	        removed.length && checkDOM(removed);
	      });
	    }
	  };
	
	  /**
	   * Called on the first modal dialog being shown. Adds the overlay and related
	   * handlers.
	   */
	  dialogPolyfill.DialogManager.prototype.blockDocument = function() {
	    document.documentElement.addEventListener('focus', this.handleFocus_, true);
	    document.addEventListener('keydown', this.handleKey_);
	    this.mo_ && this.mo_.observe(document, {childList: true, subtree: true});
	  };
	
	  /**
	   * Called on the first modal dialog being removed, i.e., when no more modal
	   * dialogs are visible.
	   */
	  dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
	    document.documentElement.removeEventListener('focus', this.handleFocus_, true);
	    document.removeEventListener('keydown', this.handleKey_);
	    this.mo_ && this.mo_.disconnect();
	  };
	
	  /**
	   * Updates the stacking of all known dialogs.
	   */
	  dialogPolyfill.DialogManager.prototype.updateStacking = function() {
	    var zIndex = this.zIndexHigh_;
	
	    for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
	      dpi.updateZIndex(--zIndex, --zIndex);
	      if (i === 0) {
	        this.overlay.style.zIndex = --zIndex;
	      }
	    }
	
	    // Make the overlay a sibling of the dialog itself.
	    var last = this.pendingDialogStack[0];
	    if (last) {
	      var p = last.dialog.parentNode || document.body;
	      p.appendChild(this.overlay);
	    } else if (this.overlay.parentNode) {
	      this.overlay.parentNode.removeChild(this.overlay);
	    }
	  };
	
	  /**
	   * @param {Element} candidate to check if contained or is the top-most modal dialog
	   * @return {boolean} whether candidate is contained in top dialog
	   */
	  dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
	    while (candidate = findNearestDialog(candidate)) {
	      for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
	        if (dpi.dialog === candidate) {
	          return i === 0;  // only valid if top-most
	        }
	      }
	      candidate = candidate.parentElement;
	    }
	    return false;
	  };
	
	  dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
	    if (this.containedByTopDialog_(event.target)) { return; }
	
	    event.preventDefault();
	    event.stopPropagation();
	    safeBlur(/** @type {Element} */ (event.target));
	
	    if (this.forwardTab_ === undefined) { return; }  // move focus only from a tab key
	
	    var dpi = this.pendingDialogStack[0];
	    var dialog = dpi.dialog;
	    var position = dialog.compareDocumentPosition(event.target);
	    if (position & Node.DOCUMENT_POSITION_PRECEDING) {
	      if (this.forwardTab_) {  // forward
	        dpi.focus_();
	      } else {  // backwards
	        document.documentElement.focus();
	      }
	    } else {
	      // TODO: Focus after the dialog, is ignored.
	    }
	
	    return false;
	  };
	
	  dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
	    this.forwardTab_ = undefined;
	    if (event.keyCode === 27) {
	      event.preventDefault();
	      event.stopPropagation();
	      var cancelEvent = new supportCustomEvent('cancel', {
	        bubbles: false,
	        cancelable: true
	      });
	      var dpi = this.pendingDialogStack[0];
	      if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) {
	        dpi.dialog.close();
	      }
	    } else if (event.keyCode === 9) {
	      this.forwardTab_ = !event.shiftKey;
	    }
	  };
	
	  /**
	   * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
	   * removed and immediately readded don't stay modal, they become normal.
	   *
	   * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
	   */
	  dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
	    // This operates on a clone because it may cause it to change. Each change also calls
	    // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
	    // at a time?!
	    var clone = this.pendingDialogStack.slice();
	    clone.forEach(function(dpi) {
	      if (removed.indexOf(dpi.dialog) !== -1) {
	        dpi.downgradeModal();
	      } else {
	        dpi.maybeHideModal();
	      }
	    });
	  };
	
	  /**
	   * @param {!dialogPolyfillInfo} dpi
	   * @return {boolean} whether the dialog was allowed
	   */
	  dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
	    var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
	    if (this.pendingDialogStack.length >= allowed) {
	      return false;
	    }
	    if (this.pendingDialogStack.unshift(dpi) === 1) {
	      this.blockDocument();
	    }
	    this.updateStacking();
	    return true;
	  };
	
	  /**
	   * @param {!dialogPolyfillInfo} dpi
	   */
	  dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
	    var index = this.pendingDialogStack.indexOf(dpi);
	    if (index === -1) { return; }
	
	    this.pendingDialogStack.splice(index, 1);
	    if (this.pendingDialogStack.length === 0) {
	      this.unblockDocument();
	    }
	    this.updateStacking();
	  };
	
	  dialogPolyfill.dm = new dialogPolyfill.DialogManager();
	  dialogPolyfill.formSubmitter = null;
	  dialogPolyfill.useValue = null;
	
	  /**
	   * Installs global handlers, such as click listers and native method overrides. These are needed
	   * even if a no dialog is registered, as they deal with <form method="dialog">.
	   */
	  if (window.HTMLDialogElement === undefined) {
	
	    /**
	     * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
	     * one that returns the correct value.
	     */
	    var testForm = document.createElement('form');
	    testForm.setAttribute('method', 'dialog');
	    if (testForm.method !== 'dialog') {
	      var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');
	      if (methodDescriptor) {
	        // TODO: older iOS and older PhantomJS fail to return the descriptor here
	        var realGet = methodDescriptor.get;
	        methodDescriptor.get = function() {
	          if (isFormMethodDialog(this)) {
	            return 'dialog';
	          }
	          return realGet.call(this);
	        };
	        var realSet = methodDescriptor.set;
	        methodDescriptor.set = function(v) {
	          if (typeof v === 'string' && v.toLowerCase() === 'dialog') {
	            return this.setAttribute('method', v);
	          }
	          return realSet.call(this, v);
	        };
	        Object.defineProperty(HTMLFormElement.prototype, 'method', methodDescriptor);
	      }
	    }
	
	    /**
	     * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
	     * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
	     * document.activeElement.
	     */
	    document.addEventListener('click', function(ev) {
	      dialogPolyfill.formSubmitter = null;
	      dialogPolyfill.useValue = null;
	      if (ev.defaultPrevented) { return; }  // e.g. a submit which prevents default submission
	
	      var target = /** @type {Element} */ (ev.target);
	      if (!target || !isFormMethodDialog(target.form)) { return; }
	
	      var valid = (target.type === 'submit' && ['button', 'input'].indexOf(target.localName) > -1);
	      if (!valid) {
	        if (!(target.localName === 'input' && target.type === 'image')) { return; }
	        // this is a <input type="image">, which can submit forms
	        dialogPolyfill.useValue = ev.offsetX + ',' + ev.offsetY;
	      }
	
	      var dialog = findNearestDialog(target);
	      if (!dialog) { return; }
	
	      dialogPolyfill.formSubmitter = target;
	    }, false);
	
	    /**
	     * Replace the native HTMLFormElement.submit() method, as it won't fire the
	     * submit event and give us a chance to respond.
	     */
	    var nativeFormSubmit = HTMLFormElement.prototype.submit;
	    function replacementFormSubmit() {
	      if (!isFormMethodDialog(this)) {
	        return nativeFormSubmit.call(this);
	      }
	      var dialog = findNearestDialog(this);
	      dialog && dialog.close();
	    }
	    HTMLFormElement.prototype.submit = replacementFormSubmit;
	
	    /**
	     * Global form 'dialog' method handler. Closes a dialog correctly on submit
	     * and possibly sets its return value.
	     */
	    document.addEventListener('submit', function(ev) {
	      var form = /** @type {HTMLFormElement} */ (ev.target);
	      if (!isFormMethodDialog(form)) { return; }
	      ev.preventDefault();
	
	      var dialog = findNearestDialog(form);
	      if (!dialog) { return; }
	
	      // Forms can only be submitted via .submit() or a click (?), but anyway: sanity-check that
	      // the submitter is correct before using its value as .returnValue.
	      var s = dialogPolyfill.formSubmitter;
	      if (s && s.form === form) {
	        dialog.close(dialogPolyfill.useValue || s.value);
	      } else {
	        dialog.close();
	      }
	      dialogPolyfill.formSubmitter = null;
	    }, true);
	  }
	
	  dialogPolyfill['forceRegisterDialog'] = dialogPolyfill.forceRegisterDialog;
	  dialogPolyfill['registerDialog'] = dialogPolyfill.registerDialog;
	
	  if ("function" === 'function' && 'amd' in __webpack_require__(563)) {
	    // AMD support
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return dialogPolyfill; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && typeof module['exports'] === 'object') {
	    // CommonJS support
	    module['exports'] = dialogPolyfill;
	  } else {
	    // all others
	    window['dialogPolyfill'] = dialogPolyfill;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module)))

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 910:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {(function() { var firebase=__webpack_require__(923);__webpack_require__(924);/*
	
	 Copyright 2015 Google Inc. All Rights Reserved.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	      http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	var componentHandler={upgradeDom:function(optJsClass,optCssClass){},upgradeElement:function(element,optJsClass){},upgradeElements:function(elements){},upgradeAllRegistered:function(){},registerUpgradedCallback:function(jsClass,callback){},register:function(config){},downgradeElements:function(nodes){}};
	componentHandler=function(){var registeredComponents_=[];var createdComponents_=[];var componentConfigProperty_="mdlComponentConfigInternal_";function findRegisteredClass_(name,optReplace){for(var i=0;i<registeredComponents_.length;i++)if(registeredComponents_[i].className===name){if(typeof optReplace!=="undefined")registeredComponents_[i]=optReplace;return registeredComponents_[i]}return false}function getUpgradedListOfElement_(element){var dataUpgraded=element.getAttribute("data-upgraded");return dataUpgraded===
	null?[""]:dataUpgraded.split(",")}function isElementUpgraded_(element,jsClass){var upgradedList=getUpgradedListOfElement_(element);return upgradedList.indexOf(jsClass)!==-1}function createEvent_(eventType,bubbles,cancelable){if("CustomEvent"in window&&typeof window.CustomEvent==="function")return new CustomEvent(eventType,{bubbles:bubbles,cancelable:cancelable});else{var ev=document.createEvent("Events");ev.initEvent(eventType,bubbles,cancelable);return ev}}function upgradeDomInternal(optJsClass,
	optCssClass){if(typeof optJsClass==="undefined"&&typeof optCssClass==="undefined")for(var i=0;i<registeredComponents_.length;i++)upgradeDomInternal(registeredComponents_[i].className,registeredComponents_[i].cssClass);else{var jsClass=optJsClass;if(typeof optCssClass==="undefined"){var registeredClass=findRegisteredClass_(jsClass);if(registeredClass)optCssClass=registeredClass.cssClass}var elements=document.querySelectorAll("."+optCssClass);for(var n=0;n<elements.length;n++)upgradeElementInternal(elements[n],
	jsClass)}}function upgradeElementInternal(element,optJsClass){if(!(typeof element==="object"&&element instanceof Element))throw new Error("Invalid argument provided to upgrade MDL element.");var upgradingEv=createEvent_("mdl-componentupgrading",true,true);element.dispatchEvent(upgradingEv);if(upgradingEv.defaultPrevented)return;var upgradedList=getUpgradedListOfElement_(element);var classesToUpgrade=[];if(!optJsClass){var classList=element.classList;registeredComponents_.forEach(function(component){if(classList.contains(component.cssClass)&&
	classesToUpgrade.indexOf(component)===-1&&!isElementUpgraded_(element,component.className))classesToUpgrade.push(component)})}else if(!isElementUpgraded_(element,optJsClass))classesToUpgrade.push(findRegisteredClass_(optJsClass));for(var i=0,n=classesToUpgrade.length,registeredClass;i<n;i++){registeredClass=classesToUpgrade[i];if(registeredClass){upgradedList.push(registeredClass.className);element.setAttribute("data-upgraded",upgradedList.join(","));var instance=new registeredClass.classConstructor(element);
	instance[componentConfigProperty_]=registeredClass;createdComponents_.push(instance);for(var j=0,m=registeredClass.callbacks.length;j<m;j++)registeredClass.callbacks[j](element);if(registeredClass.widget)element[registeredClass.className]=instance}else throw new Error("Unable to find a registered component for the given class.");var upgradedEv=createEvent_("mdl-componentupgraded",true,false);element.dispatchEvent(upgradedEv)}}function upgradeElementsInternal(elements){if(!Array.isArray(elements))if(elements instanceof
	Element)elements=[elements];else elements=Array.prototype.slice.call(elements);for(var i=0,n=elements.length,element;i<n;i++){element=elements[i];if(element instanceof HTMLElement){upgradeElementInternal(element);if(element.children.length>0)upgradeElementsInternal(element.children)}}}function registerInternal(config){var widgetMissing=typeof config.widget==="undefined"&&typeof config["widget"]==="undefined";var widget=true;if(!widgetMissing)widget=config.widget||config["widget"];var newConfig={classConstructor:config.constructor||
	config["constructor"],className:config.classAsString||config["classAsString"],cssClass:config.cssClass||config["cssClass"],widget:widget,callbacks:[]};registeredComponents_.forEach(function(item){if(item.cssClass===newConfig.cssClass)throw new Error("The provided cssClass has already been registered: "+item.cssClass);if(item.className===newConfig.className)throw new Error("The provided className has already been registered");});if(config.constructor.prototype.hasOwnProperty(componentConfigProperty_))throw new Error("MDL component classes must not have "+
	componentConfigProperty_+" defined as a property.");var found=findRegisteredClass_(config.classAsString,newConfig);if(!found)registeredComponents_.push(newConfig)}function registerUpgradedCallbackInternal(jsClass,callback){var regClass=findRegisteredClass_(jsClass);if(regClass)regClass.callbacks.push(callback)}function upgradeAllRegisteredInternal(){for(var n=0;n<registeredComponents_.length;n++)upgradeDomInternal(registeredComponents_[n].className)}function deconstructComponentInternal(component){if(component){var componentIndex=
	createdComponents_.indexOf(component);createdComponents_.splice(componentIndex,1);var upgrades=component.element_.getAttribute("data-upgraded").split(",");var componentPlace=upgrades.indexOf(component[componentConfigProperty_].classAsString);upgrades.splice(componentPlace,1);component.element_.setAttribute("data-upgraded",upgrades.join(","));var ev=createEvent_("mdl-componentdowngraded",true,false);component.element_.dispatchEvent(ev)}}function downgradeNodesInternal(nodes){var downgradeNode=function(node){createdComponents_.filter(function(item){return item.element_===
	node}).forEach(deconstructComponentInternal)};if(nodes instanceof Array||nodes instanceof NodeList)for(var n=0;n<nodes.length;n++)downgradeNode(nodes[n]);else if(nodes instanceof Node)downgradeNode(nodes);else throw new Error("Invalid argument provided to downgrade MDL nodes.");}return{upgradeDom:upgradeDomInternal,upgradeElement:upgradeElementInternal,upgradeElements:upgradeElementsInternal,upgradeAllRegistered:upgradeAllRegisteredInternal,registerUpgradedCallback:registerUpgradedCallbackInternal,
	register:registerInternal,downgradeElements:downgradeNodesInternal}}();componentHandler.ComponentConfigPublic;componentHandler.ComponentConfig;componentHandler.Component;componentHandler["upgradeDom"]=componentHandler.upgradeDom;componentHandler["upgradeElement"]=componentHandler.upgradeElement;componentHandler["upgradeElements"]=componentHandler.upgradeElements;componentHandler["upgradeAllRegistered"]=componentHandler.upgradeAllRegistered;componentHandler["registerUpgradedCallback"]=componentHandler.registerUpgradedCallback;
	componentHandler["register"]=componentHandler.register;componentHandler["downgradeElements"]=componentHandler.downgradeElements;window.componentHandler=componentHandler;window["componentHandler"]=componentHandler;
	window.addEventListener("load",function(){if("classList"in document.createElement("div")&&"querySelector"in document&&"addEventListener"in window&&Array.prototype.forEach){document.documentElement.classList.add("mdl-js");componentHandler.upgradeAllRegistered()}else{componentHandler.upgradeElement=function(){};componentHandler.register=function(){}}});(function(){var MaterialButton=function MaterialButton(element){this.element_=element;this.init()};window["MaterialButton"]=MaterialButton;MaterialButton.prototype.Constant_={};MaterialButton.prototype.CssClasses_={RIPPLE_EFFECT:"mdl-js-ripple-effect",RIPPLE_CONTAINER:"mdl-button__ripple-container",RIPPLE:"mdl-ripple"};MaterialButton.prototype.blurHandler_=function(event){if(event)this.element_.blur()};MaterialButton.prototype.disable=function(){this.element_.disabled=true};MaterialButton.prototype["disable"]=
	MaterialButton.prototype.disable;MaterialButton.prototype.enable=function(){this.element_.disabled=false};MaterialButton.prototype["enable"]=MaterialButton.prototype.enable;MaterialButton.prototype.init=function(){if(this.element_){if(this.element_.classList.contains(this.CssClasses_.RIPPLE_EFFECT)){var rippleContainer=document.createElement("span");rippleContainer.classList.add(this.CssClasses_.RIPPLE_CONTAINER);this.rippleElement_=document.createElement("span");this.rippleElement_.classList.add(this.CssClasses_.RIPPLE);
	rippleContainer.appendChild(this.rippleElement_);this.boundRippleBlurHandler=this.blurHandler_.bind(this);this.rippleElement_.addEventListener("mouseup",this.boundRippleBlurHandler);this.element_.appendChild(rippleContainer)}this.boundButtonBlurHandler=this.blurHandler_.bind(this);this.element_.addEventListener("mouseup",this.boundButtonBlurHandler);this.element_.addEventListener("mouseleave",this.boundButtonBlurHandler)}};componentHandler.register({constructor:MaterialButton,classAsString:"MaterialButton",
	cssClass:"mdl-js-button",widget:true})})();(function(){var MaterialProgress=function MaterialProgress(element){this.element_=element;this.init()};window["MaterialProgress"]=MaterialProgress;MaterialProgress.prototype.Constant_={};MaterialProgress.prototype.CssClasses_={INDETERMINATE_CLASS:"mdl-progress__indeterminate"};MaterialProgress.prototype.setProgress=function(p){if(this.element_.classList.contains(this.CssClasses_.INDETERMINATE_CLASS))return;this.progressbar_.style.width=p+"%"};MaterialProgress.prototype["setProgress"]=MaterialProgress.prototype.setProgress;
	MaterialProgress.prototype.setBuffer=function(p){this.bufferbar_.style.width=p+"%";this.auxbar_.style.width=100-p+"%"};MaterialProgress.prototype["setBuffer"]=MaterialProgress.prototype.setBuffer;MaterialProgress.prototype.init=function(){if(this.element_){var el=document.createElement("div");el.className="progressbar bar bar1";this.element_.appendChild(el);this.progressbar_=el;el=document.createElement("div");el.className="bufferbar bar bar2";this.element_.appendChild(el);this.bufferbar_=el;el=document.createElement("div");
	el.className="auxbar bar bar3";this.element_.appendChild(el);this.auxbar_=el;this.progressbar_.style.width="0%";this.bufferbar_.style.width="100%";this.auxbar_.style.width="0%";this.element_.classList.add("is-upgraded")}};componentHandler.register({constructor:MaterialProgress,classAsString:"MaterialProgress",cssClass:"mdl-js-progress",widget:true})})();(function(){var MaterialSpinner=function MaterialSpinner(element){this.element_=element;this.init()};window["MaterialSpinner"]=MaterialSpinner;MaterialSpinner.prototype.Constant_={MDL_SPINNER_LAYER_COUNT:4};MaterialSpinner.prototype.CssClasses_={MDL_SPINNER_LAYER:"mdl-spinner__layer",MDL_SPINNER_CIRCLE_CLIPPER:"mdl-spinner__circle-clipper",MDL_SPINNER_CIRCLE:"mdl-spinner__circle",MDL_SPINNER_GAP_PATCH:"mdl-spinner__gap-patch",MDL_SPINNER_LEFT:"mdl-spinner__left",MDL_SPINNER_RIGHT:"mdl-spinner__right"};
	MaterialSpinner.prototype.createLayer=function(index){var layer=document.createElement("div");layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER);layer.classList.add(this.CssClasses_.MDL_SPINNER_LAYER+"-"+index);var leftClipper=document.createElement("div");leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);leftClipper.classList.add(this.CssClasses_.MDL_SPINNER_LEFT);var gapPatch=document.createElement("div");gapPatch.classList.add(this.CssClasses_.MDL_SPINNER_GAP_PATCH);var rightClipper=
	document.createElement("div");rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE_CLIPPER);rightClipper.classList.add(this.CssClasses_.MDL_SPINNER_RIGHT);var circleOwners=[leftClipper,gapPatch,rightClipper];for(var i=0;i<circleOwners.length;i++){var circle=document.createElement("div");circle.classList.add(this.CssClasses_.MDL_SPINNER_CIRCLE);circleOwners[i].appendChild(circle)}layer.appendChild(leftClipper);layer.appendChild(gapPatch);layer.appendChild(rightClipper);this.element_.appendChild(layer)};
	MaterialSpinner.prototype["createLayer"]=MaterialSpinner.prototype.createLayer;MaterialSpinner.prototype.stop=function(){this.element_.classList.remove("is-active")};MaterialSpinner.prototype["stop"]=MaterialSpinner.prototype.stop;MaterialSpinner.prototype.start=function(){this.element_.classList.add("is-active")};MaterialSpinner.prototype["start"]=MaterialSpinner.prototype.start;MaterialSpinner.prototype.init=function(){if(this.element_){for(var i=1;i<=this.Constant_.MDL_SPINNER_LAYER_COUNT;i++)this.createLayer(i);
	this.element_.classList.add("is-upgraded")}};componentHandler.register({constructor:MaterialSpinner,classAsString:"MaterialSpinner",cssClass:"mdl-js-spinner",widget:true})})();(function(){var MaterialTextfield=function MaterialTextfield(element){this.element_=element;this.maxRows=this.Constant_.NO_MAX_ROWS;this.init()};window["MaterialTextfield"]=MaterialTextfield;MaterialTextfield.prototype.Constant_={NO_MAX_ROWS:-1,MAX_ROWS_ATTRIBUTE:"maxrows"};MaterialTextfield.prototype.CssClasses_={LABEL:"mdl-textfield__label",INPUT:"mdl-textfield__input",IS_DIRTY:"is-dirty",IS_FOCUSED:"is-focused",IS_DISABLED:"is-disabled",IS_INVALID:"is-invalid",IS_UPGRADED:"is-upgraded",HAS_PLACEHOLDER:"has-placeholder"};
	MaterialTextfield.prototype.onKeyDown_=function(event){var currentRowCount=event.target.value.split("\n").length;if(event.keyCode===13)if(currentRowCount>=this.maxRows)event.preventDefault()};MaterialTextfield.prototype.onFocus_=function(event){this.element_.classList.add(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onBlur_=function(event){this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype.onReset_=function(event){this.updateClasses_()};MaterialTextfield.prototype.updateClasses_=
	function(){this.checkDisabled();this.checkValidity();this.checkDirty();this.checkFocus()};MaterialTextfield.prototype.checkDisabled=function(){if(this.input_.disabled)this.element_.classList.add(this.CssClasses_.IS_DISABLED);else this.element_.classList.remove(this.CssClasses_.IS_DISABLED)};MaterialTextfield.prototype["checkDisabled"]=MaterialTextfield.prototype.checkDisabled;MaterialTextfield.prototype.checkFocus=function(){if(Boolean(this.element_.querySelector(":focus")))this.element_.classList.add(this.CssClasses_.IS_FOCUSED);
	else this.element_.classList.remove(this.CssClasses_.IS_FOCUSED)};MaterialTextfield.prototype["checkFocus"]=MaterialTextfield.prototype.checkFocus;MaterialTextfield.prototype.checkValidity=function(){if(this.input_.validity)if(this.input_.validity.valid)this.element_.classList.remove(this.CssClasses_.IS_INVALID);else this.element_.classList.add(this.CssClasses_.IS_INVALID)};MaterialTextfield.prototype["checkValidity"]=MaterialTextfield.prototype.checkValidity;MaterialTextfield.prototype.checkDirty=
	function(){if(this.input_.value&&this.input_.value.length>0)this.element_.classList.add(this.CssClasses_.IS_DIRTY);else this.element_.classList.remove(this.CssClasses_.IS_DIRTY)};MaterialTextfield.prototype["checkDirty"]=MaterialTextfield.prototype.checkDirty;MaterialTextfield.prototype.disable=function(){this.input_.disabled=true;this.updateClasses_()};MaterialTextfield.prototype["disable"]=MaterialTextfield.prototype.disable;MaterialTextfield.prototype.enable=function(){this.input_.disabled=false;
	this.updateClasses_()};MaterialTextfield.prototype["enable"]=MaterialTextfield.prototype.enable;MaterialTextfield.prototype.change=function(value){this.input_.value=value||"";this.updateClasses_()};MaterialTextfield.prototype["change"]=MaterialTextfield.prototype.change;MaterialTextfield.prototype.init=function(){if(this.element_){this.label_=this.element_.querySelector("."+this.CssClasses_.LABEL);this.input_=this.element_.querySelector("."+this.CssClasses_.INPUT);if(this.input_){if(this.input_.hasAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE)){this.maxRows=
	parseInt(this.input_.getAttribute(this.Constant_.MAX_ROWS_ATTRIBUTE),10);if(isNaN(this.maxRows))this.maxRows=this.Constant_.NO_MAX_ROWS}if(this.input_.hasAttribute("placeholder"))this.element_.classList.add(this.CssClasses_.HAS_PLACEHOLDER);this.boundUpdateClassesHandler=this.updateClasses_.bind(this);this.boundFocusHandler=this.onFocus_.bind(this);this.boundBlurHandler=this.onBlur_.bind(this);this.boundResetHandler=this.onReset_.bind(this);this.input_.addEventListener("input",this.boundUpdateClassesHandler);
	this.input_.addEventListener("focus",this.boundFocusHandler);this.input_.addEventListener("blur",this.boundBlurHandler);this.input_.addEventListener("reset",this.boundResetHandler);if(this.maxRows!==this.Constant_.NO_MAX_ROWS){this.boundKeyDownHandler=this.onKeyDown_.bind(this);this.input_.addEventListener("keydown",this.boundKeyDownHandler)}var invalid=this.element_.classList.contains(this.CssClasses_.IS_INVALID);this.updateClasses_();this.element_.classList.add(this.CssClasses_.IS_UPGRADED);if(invalid)this.element_.classList.add(this.CssClasses_.IS_INVALID);
	if(this.input_.hasAttribute("autofocus")){this.element_.focus();this.checkFocus()}}}};componentHandler.register({constructor:MaterialTextfield,classAsString:"MaterialTextfield",cssClass:"mdl-js-textfield",widget:true})})();(function(){var supportCustomEvent=window.CustomEvent;if(!supportCustomEvent||typeof supportCustomEvent==="object"){supportCustomEvent=function CustomEvent(event,x){x=x||{};var ev=document.createEvent("CustomEvent");ev.initCustomEvent(event,!!x.bubbles,!!x.cancelable,x.detail||null);return ev};supportCustomEvent.prototype=window.Event.prototype}function createsStackingContext(el){while(el&&el!==document.body){var s=window.getComputedStyle(el);var invalid=function(k,ok){return!(s[k]===undefined||s[k]===
	ok)};if(s.opacity<1||invalid("zIndex","auto")||invalid("transform","none")||invalid("mixBlendMode","normal")||invalid("filter","none")||invalid("perspective","none")||s["isolation"]==="isolate"||s.position==="fixed"||s.webkitOverflowScrolling==="touch")return true;el=el.parentElement}return false}function findNearestDialog(el){while(el){if(el.localName==="dialog")return el;el=el.parentElement}return null}function safeBlur(el){if(el&&el.blur&&el!==document.body)el.blur()}function inNodeList(nodeList,
	node){for(var i=0;i<nodeList.length;++i)if(nodeList[i]===node)return true;return false}function isFormMethodDialog(el){if(!el||!el.hasAttribute("method"))return false;return el.getAttribute("method").toLowerCase()==="dialog"}function dialogPolyfillInfo(dialog){this.dialog_=dialog;this.replacedStyleTop_=false;this.openAsModal_=false;if(!dialog.hasAttribute("role"))dialog.setAttribute("role","dialog");dialog.show=this.show.bind(this);dialog.showModal=this.showModal.bind(this);dialog.close=this.close.bind(this);
	if(!("returnValue"in dialog))dialog.returnValue="";if("MutationObserver"in window){var mo=new MutationObserver(this.maybeHideModal.bind(this));mo.observe(dialog,{attributes:true,attributeFilter:["open"]})}else{var removed=false;var cb=function(){removed?this.downgradeModal():this.maybeHideModal();removed=false}.bind(this);var timeout;var delayModel=function(ev){if(ev.target!==dialog)return;var cand="DOMNodeRemoved";removed|=ev.type.substr(0,cand.length)===cand;window.clearTimeout(timeout);timeout=
	window.setTimeout(cb,0)};["DOMAttrModified","DOMNodeRemoved","DOMNodeRemovedFromDocument"].forEach(function(name){dialog.addEventListener(name,delayModel)})}Object.defineProperty(dialog,"open",{set:this.setOpen.bind(this),get:dialog.hasAttribute.bind(dialog,"open")});this.backdrop_=document.createElement("div");this.backdrop_.className="backdrop";this.backdrop_.addEventListener("click",this.backdropClick_.bind(this))}dialogPolyfillInfo.prototype={get dialog(){return this.dialog_},maybeHideModal:function(){if(this.dialog_.hasAttribute("open")&&
	document.body.contains(this.dialog_))return;this.downgradeModal()},downgradeModal:function(){if(!this.openAsModal_)return;this.openAsModal_=false;this.dialog_.style.zIndex="";if(this.replacedStyleTop_){this.dialog_.style.top="";this.replacedStyleTop_=false}this.backdrop_.parentNode&&this.backdrop_.parentNode.removeChild(this.backdrop_);dialogPolyfill.dm.removeDialog(this)},setOpen:function(value){if(value)this.dialog_.hasAttribute("open")||this.dialog_.setAttribute("open","");else{this.dialog_.removeAttribute("open");
	this.maybeHideModal()}},backdropClick_:function(e){if(!this.dialog_.hasAttribute("tabindex")){var fake=document.createElement("div");this.dialog_.insertBefore(fake,this.dialog_.firstChild);fake.tabIndex=-1;fake.focus();this.dialog_.removeChild(fake)}else this.dialog_.focus();var redirectedEvent=document.createEvent("MouseEvents");redirectedEvent.initMouseEvent(e.type,e.bubbles,e.cancelable,window,e.detail,e.screenX,e.screenY,e.clientX,e.clientY,e.ctrlKey,e.altKey,e.shiftKey,e.metaKey,e.button,e.relatedTarget);
	this.dialog_.dispatchEvent(redirectedEvent);e.stopPropagation()},focus_:function(){var target=this.dialog_.querySelector("[autofocus]:not([disabled])");if(!target&&this.dialog_.tabIndex>=0)target=this.dialog_;if(!target){var opts=["button","input","keygen","select","textarea"];var query=opts.map(function(el){return el+":not([disabled])"});query.push('[tabindex]:not([disabled]):not([tabindex=""])');target=this.dialog_.querySelector(query.join(", "))}safeBlur(document.activeElement);target&&target.focus()},
	updateZIndex:function(dialogZ,backdropZ){if(dialogZ<backdropZ)throw new Error("dialogZ should never be < backdropZ");this.dialog_.style.zIndex=dialogZ;this.backdrop_.style.zIndex=backdropZ},show:function(){if(!this.dialog_.open){this.setOpen(true);this.focus_()}},showModal:function(){if(this.dialog_.hasAttribute("open"))throw new Error("Failed to execute 'showModal' on dialog: The element is already open, and therefore cannot be opened modally.");if(!document.body.contains(this.dialog_))throw new Error("Failed to execute 'showModal' on dialog: The element is not in a Document.");
	if(!dialogPolyfill.dm.pushDialog(this))throw new Error("Failed to execute 'showModal' on dialog: There are too many open modal dialogs.");if(createsStackingContext(this.dialog_.parentElement))console.warn("A dialog is being shown inside a stacking context. "+"This may cause it to be unusable. For more information, see this link: "+"https://github.com/GoogleChrome/dialog-polyfill/#stacking-context");this.setOpen(true);this.openAsModal_=true;if(dialogPolyfill.needsCentering(this.dialog_)){dialogPolyfill.reposition(this.dialog_);
	this.replacedStyleTop_=true}else this.replacedStyleTop_=false;this.dialog_.parentNode.insertBefore(this.backdrop_,this.dialog_.nextSibling);this.focus_()},close:function(opt_returnValue){if(!this.dialog_.hasAttribute("open"))throw new Error("Failed to execute 'close' on dialog: The element does not have an 'open' attribute, and therefore cannot be closed.");this.setOpen(false);if(opt_returnValue!==undefined)this.dialog_.returnValue=opt_returnValue;var closeEvent=new supportCustomEvent("close",{bubbles:false,
	cancelable:false});this.dialog_.dispatchEvent(closeEvent)}};var dialogPolyfill={};dialogPolyfill.reposition=function(element){var scrollTop=document.body.scrollTop||document.documentElement.scrollTop;var topValue=scrollTop+(window.innerHeight-element.offsetHeight)/2;element.style.top=Math.max(scrollTop,topValue)+"px"};dialogPolyfill.isInlinePositionSetByStylesheet=function(element){for(var i=0;i<document.styleSheets.length;++i){var styleSheet=document.styleSheets[i];var cssRules=null;try{cssRules=
	styleSheet.cssRules}catch(e){}if(!cssRules)continue;for(var j=0;j<cssRules.length;++j){var rule=cssRules[j];var selectedNodes=null;try{selectedNodes=document.querySelectorAll(rule.selectorText)}catch(e$0){}if(!selectedNodes||!inNodeList(selectedNodes,element))continue;var cssTop=rule.style.getPropertyValue("top");var cssBottom=rule.style.getPropertyValue("bottom");if(cssTop&&cssTop!=="auto"||cssBottom&&cssBottom!=="auto")return true}}return false};dialogPolyfill.needsCentering=function(dialog){var computedStyle=
	window.getComputedStyle(dialog);if(computedStyle.position!=="absolute")return false;if(dialog.style.top!=="auto"&&dialog.style.top!==""||dialog.style.bottom!=="auto"&&dialog.style.bottom!=="")return false;return!dialogPolyfill.isInlinePositionSetByStylesheet(dialog)};dialogPolyfill.forceRegisterDialog=function(element){if(window.HTMLDialogElement||element.showModal)console.warn("This browser already supports <dialog>, the polyfill "+"may not work correctly",element);if(element.localName!=="dialog")throw new Error("Failed to register dialog: The element is not a dialog.");
	new dialogPolyfillInfo(element)};dialogPolyfill.registerDialog=function(element){if(!element.showModal)dialogPolyfill.forceRegisterDialog(element)};dialogPolyfill.DialogManager=function(){this.pendingDialogStack=[];var checkDOM=this.checkDOM_.bind(this);this.overlay=document.createElement("div");this.overlay.className="_dialog_overlay";this.overlay.addEventListener("click",function(e){this.forwardTab_=undefined;e.stopPropagation();checkDOM([])}.bind(this));this.handleKey_=this.handleKey_.bind(this);
	this.handleFocus_=this.handleFocus_.bind(this);this.zIndexLow_=1E5;this.zIndexHigh_=1E5+150;this.forwardTab_=undefined;if("MutationObserver"in window)this.mo_=new MutationObserver(function(records){var removed=[];records.forEach(function(rec){for(var i=0,c;c=rec.removedNodes[i];++i){if(!(c instanceof Element))continue;else if(c.localName==="dialog")removed.push(c);removed=removed.concat(c.querySelectorAll("dialog"))}});removed.length&&checkDOM(removed)})};dialogPolyfill.DialogManager.prototype.blockDocument=
	function(){document.documentElement.addEventListener("focus",this.handleFocus_,true);document.addEventListener("keydown",this.handleKey_);this.mo_&&this.mo_.observe(document,{childList:true,subtree:true})};dialogPolyfill.DialogManager.prototype.unblockDocument=function(){document.documentElement.removeEventListener("focus",this.handleFocus_,true);document.removeEventListener("keydown",this.handleKey_);this.mo_&&this.mo_.disconnect()};dialogPolyfill.DialogManager.prototype.updateStacking=function(){var zIndex=
	this.zIndexHigh_;for(var i=0,dpi;dpi=this.pendingDialogStack[i];++i){dpi.updateZIndex(--zIndex,--zIndex);if(i===0)this.overlay.style.zIndex=--zIndex}var last=this.pendingDialogStack[0];if(last){var p=last.dialog.parentNode||document.body;p.appendChild(this.overlay)}else if(this.overlay.parentNode)this.overlay.parentNode.removeChild(this.overlay)};dialogPolyfill.DialogManager.prototype.containedByTopDialog_=function(candidate){while(candidate=findNearestDialog(candidate)){for(var i=0,dpi;dpi=this.pendingDialogStack[i];++i)if(dpi.dialog===
	candidate)return i===0;candidate=candidate.parentElement}return false};dialogPolyfill.DialogManager.prototype.handleFocus_=function(event){if(this.containedByTopDialog_(event.target))return;event.preventDefault();event.stopPropagation();safeBlur(event.target);if(this.forwardTab_===undefined)return;var dpi=this.pendingDialogStack[0];var dialog=dpi.dialog;var position=dialog.compareDocumentPosition(event.target);if(position&Node.DOCUMENT_POSITION_PRECEDING)if(this.forwardTab_)dpi.focus_();else document.documentElement.focus();
	else;return false};dialogPolyfill.DialogManager.prototype.handleKey_=function(event){this.forwardTab_=undefined;if(event.keyCode===27){event.preventDefault();event.stopPropagation();var cancelEvent=new supportCustomEvent("cancel",{bubbles:false,cancelable:true});var dpi=this.pendingDialogStack[0];if(dpi&&dpi.dialog.dispatchEvent(cancelEvent))dpi.dialog.close()}else if(event.keyCode===9)this.forwardTab_=!event.shiftKey};dialogPolyfill.DialogManager.prototype.checkDOM_=function(removed){var clone=this.pendingDialogStack.slice();
	clone.forEach(function(dpi){if(removed.indexOf(dpi.dialog)!==-1)dpi.downgradeModal();else dpi.maybeHideModal()})};dialogPolyfill.DialogManager.prototype.pushDialog=function(dpi){var allowed=(this.zIndexHigh_-this.zIndexLow_)/2-1;if(this.pendingDialogStack.length>=allowed)return false;if(this.pendingDialogStack.unshift(dpi)===1)this.blockDocument();this.updateStacking();return true};dialogPolyfill.DialogManager.prototype.removeDialog=function(dpi){var index=this.pendingDialogStack.indexOf(dpi);if(index===
	-1)return;this.pendingDialogStack.splice(index,1);if(this.pendingDialogStack.length===0)this.unblockDocument();this.updateStacking()};dialogPolyfill.dm=new dialogPolyfill.DialogManager;dialogPolyfill.formSubmitter=null;dialogPolyfill.useValue=null;if(window.HTMLDialogElement===undefined){var replacementFormSubmit=function(){if(!isFormMethodDialog(this))return nativeFormSubmit.call(this);var dialog=findNearestDialog(this);dialog&&dialog.close()};var testForm=document.createElement("form");testForm.setAttribute("method",
	"dialog");if(testForm.method!=="dialog"){var methodDescriptor=Object.getOwnPropertyDescriptor(HTMLFormElement.prototype,"method");if(methodDescriptor){var realGet=methodDescriptor.get;methodDescriptor.get=function(){if(isFormMethodDialog(this))return"dialog";return realGet.call(this)};var realSet=methodDescriptor.set;methodDescriptor.set=function(v){if(typeof v==="string"&&v.toLowerCase()==="dialog")return this.setAttribute("method",v);return realSet.call(this,v)};Object.defineProperty(HTMLFormElement.prototype,
	"method",methodDescriptor)}}document.addEventListener("click",function(ev){dialogPolyfill.formSubmitter=null;dialogPolyfill.useValue=null;if(ev.defaultPrevented)return;var target=ev.target;if(!target||!isFormMethodDialog(target.form))return;var valid=target.type==="submit"&&["button","input"].indexOf(target.localName)>-1;if(!valid){if(!(target.localName==="input"&&target.type==="image"))return;dialogPolyfill.useValue=ev.offsetX+","+ev.offsetY}var dialog=findNearestDialog(target);if(!dialog)return;
	dialogPolyfill.formSubmitter=target},false);var nativeFormSubmit=HTMLFormElement.prototype.submit;HTMLFormElement.prototype.submit=replacementFormSubmit;document.addEventListener("submit",function(ev){var form=ev.target;if(!isFormMethodDialog(form))return;ev.preventDefault();var dialog=findNearestDialog(form);if(!dialog)return;var s=dialogPolyfill.formSubmitter;if(s&&s.form===form)dialog.close(dialogPolyfill.useValue||s.value);else dialog.close();dialogPolyfill.formSubmitter=null},true)}dialogPolyfill["forceRegisterDialog"]=
	dialogPolyfill.forceRegisterDialog;dialogPolyfill["registerDialog"]=dialogPolyfill.registerDialog;if("function"==="function"&&"amd"in __webpack_require__(563))!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return dialogPolyfill}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if(typeof module==="object"&&typeof module["exports"]==="object")module["exports"]=dialogPolyfill;else window["dialogPolyfill"]=dialogPolyfill})();(function(){var h,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},ba="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function ca(){ca=function(){};ba.Symbol||(ba.Symbol=da)}var da=function(){var a=0;return function(b){return"jscomp_symbol_"+(b||"")+a++}}();function ea(){ca();var a=ba.Symbol.iterator;a||(a=ba.Symbol.iterator=ba.Symbol("iterator"));"function"!=
	typeof Array.prototype[a]&&aa(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return fa(this)}});ea=function(){}}function fa(a){var b=0;return ha(function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}})}function ha(a){ea();a={next:a};a[ba.Symbol.iterator]=function(){return this};return a}function ia(a){ea();var b=a[Symbol.iterator];return b?b.call(a):fa(a)}for(var ja=ba,ka=["Promise"],la=0;la<ka.length-1;la++){var ma=ka[la];ma in ja||(ja[ma]={});ja=ja[ma]}var na=ka[ka.length-
	1],oa=ja[na],pa=function(){function a(a){this.a=0;this.h=void 0;this.g=[];var b=this.j();try{a(b.resolve,b.reject)}catch(k){b.reject(k)}}function b(){this.a=null}function c(b){return b instanceof a?b:new a(function(a){a(b)})}if(oa)return oa;b.prototype.g=function(a){null==this.a&&(this.a=[],this.j());this.a.push(a)};b.prototype.j=function(){var a=this;this.h(function(){a.u()})};var d=ba.setTimeout;b.prototype.h=function(a){d(a,0)};b.prototype.u=function(){for(;this.a&&this.a.length;){var a=this.a;
	this.a=[];for(var b=0;b<a.length;++b){var c=a[b];delete a[b];try{c()}catch(q){this.i(q)}}}this.a=null};b.prototype.i=function(a){this.h(function(){throw a;})};a.prototype.j=function(){function a(a){return function(d){c||(c=!0,a.call(b,d))}}var b=this,c=!1;return{resolve:a(this.F),reject:a(this.i)}};a.prototype.F=function(b){if(b===this)this.i(new TypeError("A Promise cannot resolve to itself"));else if(b instanceof a)this.H(b);else{a:switch(typeof b){case "object":var c=null!=b;break a;case "function":c=
	!0;break a;default:c=!1}c?this.D(b):this.u(b)}};a.prototype.D=function(a){var b=void 0;try{b=a.then}catch(k){this.i(k);return}"function"==typeof b?this.J(b,a):this.u(a)};a.prototype.i=function(a){this.v(2,a)};a.prototype.u=function(a){this.v(1,a)};a.prototype.v=function(a,b){if(0!=this.a)throw Error("Cannot settle("+a+", "+b|"): Promise already settled in state"+this.a);this.a=a;this.h=b;this.A()};a.prototype.A=function(){if(null!=this.g){for(var a=this.g,b=0;b<a.length;++b)a[b].call(),a[b]=null;
	this.g=null}};var e=new b;a.prototype.H=function(a){var b=this.j();a.ya(b.resolve,b.reject)};a.prototype.J=function(a,b){var c=this.j();try{a.call(b,c.resolve,c.reject)}catch(q){c.reject(q)}};a.prototype.then=function(b,c){function d(a,b){return"function"==typeof a?function(b){try{e(a(b))}catch(Cj){f(Cj)}}:b}var e,f,g=new a(function(a,b){e=a;f=b});this.ya(d(b,e),d(c,f));return g};a.prototype.catch=function(a){return this.then(void 0,a)};a.prototype.ya=function(a,b){function c(){switch(d.a){case 1:a(d.h);
	break;case 2:b(d.h);break;default:throw Error("Unexpected state: "+d.a);}}var d=this;null==this.g?e.g(c):this.g.push(function(){e.g(c)})};a.resolve=c;a.reject=function(b){return new a(function(a,c){c(b)})};a.race=function(b){return new a(function(a,d){for(var e=ia(b),f=e.next();!f.done;f=e.next())c(f.value).ya(a,d)})};a.all=function(b){var d=ia(b),e=d.next();return e.done?c([]):new a(function(a,b){function f(b){return function(c){g[b]=c;k--;0==k&&a(g)}}var g=[],k=0;do g.push(void 0),k++,c(e.value).ya(f(g.length-
	1),b),e=d.next();while(!e.done)})};return a}();pa!=oa&&null!=pa&&aa(ja,na,{configurable:!0,writable:!0,value:pa});var l=this;function qa(a){return void 0!==a}function m(a){return"string"==typeof a}function ra(){}function sa(a){a.S=void 0;a.Ia=function(){return a.S?a.S:a.S=new a}}function ta(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||
	"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ua(a){return null!=a}function va(a){return"array"==ta(a)}function wa(a){var b=ta(a);return"array"==b||"object"==
	b&&"number"==typeof a.length}function xa(a){return"function"==ta(a)}function za(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var Aa="closure_uid_"+(1E9*Math.random()>>>0),Ba=0;function Ca(a,b,c){return a.call.apply(a.bind,arguments)}function Da(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,
	arguments)}}function n(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?n=Ca:n=Da;return n.apply(null,arguments)}function Ea(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}function p(a,b){for(var c in b)a[c]=b[c]}var Fa=Date.now||function(){return+new Date};function r(a,b){a=a.split(".");var c=l;a[0]in c||!c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&
	(d=a.shift());)!a.length&&qa(b)?c[d]=b:c[d]&&c[d]!==Object.prototype[d]?c=c[d]:c=c[d]={}}function t(a,b){function c(){}c.prototype=b.prototype;a.m=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Mb=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}}function Ga(a){if(Error.captureStackTrace)Error.captureStackTrace(this,Ga);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(Ga,Error);Ga.prototype.name=
	"CustomError";var Ha;function Ia(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var Ja=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};function Ka(a){if(!La.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(Ma,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(Na,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(Oa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(Pa,
	"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(Qa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(Ra,"&#0;"));return a}var Ma=/&/g,Na=/</g,Oa=/>/g,Pa=/"/g,Qa=/'/g,Ra=/\x00/g,La=/[\x00&<>"']/;function Sa(a,b){return a<b?-1:a>b?1:0}function Ta(a,b){b.unshift(a);Ga.call(this,Ia.apply(null,b));b.shift()}t(Ta,Ga);Ta.prototype.name="AssertionError";function Ua(a,b){throw new Ta("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));}var Va=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,
	b,void 0)}:function(a,b){if(m(a))return m(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},Wa=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Xa(a,b){var c=a.length,d=m(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}var Ya=Array.prototype.filter?function(a,b){return Array.prototype.filter.call(a,
	b,void 0)}:function(a,b){for(var c=a.length,d=[],e=0,f=m(a)?a.split(""):a,g=0;g<c;g++)if(g in f){var k=f[g];b.call(void 0,k,g,a)&&(d[e++]=k)}return d},Za=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=m(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},$a=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<
	c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};function ab(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function bb(a,b){return 0<=Va(a,b)}function cb(a,b){b=Va(a,b);var c;(c=0<=b)&&db(a,b);return c}function db(a,b){return 1==Array.prototype.splice.call(a,b,1).length}function eb(a,b){b=ab(a,b,void 0);0<=b&&db(a,b)}function fb(a,b){var c=0;Xa(a,function(d,e){b.call(void 0,d,e,a)&&db(a,e)&&c++})}function gb(a){return Array.prototype.concat.apply([],
	arguments)}function hb(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]}var ib;a:{var jb=l.navigator;if(jb){var kb=jb.userAgent;if(kb){ib=kb;break a}}ib=""}function u(a){return-1!=ib.indexOf(a)}function lb(a,b,c){for(var d in a)b.call(c,a[d],d,a)}function mb(a){var b={},c;for(c in a)b[c]=a[c];return b}var nb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function ob(a,b){for(var c,d,e=1;e<arguments.length;e++){d=
	arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<nb.length;f++)c=nb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}}function pb(){return(u("Chrome")||u("CriOS"))&&!u("Edge")}function qb(a){qb[" "](a);return a}qb[" "]=ra;function rb(a,b){var c=sb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)}var tb=u("Opera"),v=u("Trident")||u("MSIE"),ub=u("Edge"),vb=ub||v,wb=u("Gecko")&&!(-1!=ib.toLowerCase().indexOf("webkit")&&!u("Edge"))&&!(u("Trident")||u("MSIE"))&&!u("Edge"),w=-1!=
	ib.toLowerCase().indexOf("webkit")&&!u("Edge"),xb=w&&u("Mobile"),yb=u("Macintosh");function zb(){var a=l.document;return a?a.documentMode:void 0}var Ab;a:{var Bb="",Cb=function(){var a=ib;if(wb)return/rv:([^\);]+)(\)|;)/.exec(a);if(ub)return/Edge\/([\d\.]+)/.exec(a);if(v)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(w)return/WebKit\/(\S+)/.exec(a);if(tb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Cb&&(Bb=Cb?Cb[1]:"");if(v){var Db=zb();if(null!=Db&&Db>parseFloat(Bb)){Ab=String(Db);break a}}Ab=
	Bb}var sb={};function Eb(a){return rb(a,function(){for(var b=0,c=Ja(String(Ab)).split("."),d=Ja(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==g[0].length&&0==k[0].length)break;b=Sa(0==g[1].length?0:parseInt(g[1],10),0==k[1].length?0:parseInt(k[1],10))||Sa(0==g[2].length,0==k[2].length)||Sa(g[2],k[2]);g=g[3];k=k[3]}while(0==b)}return 0<=b})}var Fb;var Gb=l.document;
	Fb=Gb&&v?zb()||("CSS1Compat"==Gb.compatMode?parseInt(Ab,10):5):void 0;function Hb(){this.a="";this.g=Ib}Hb.prototype.ka=!0;Hb.prototype.ia=function(){return this.a};Hb.prototype.toString=function(){return"Const{"+this.a+"}"};function Jb(a){if(a instanceof Hb&&a.constructor===Hb&&a.g===Ib)return a.a;Ua("expected object of type Const, got '"+a+"'");return"type_error:Const"}var Ib={};function Kb(a){var b=new Hb;b.a=a;return b}Kb("");function Lb(){this.a="";this.h=Mb}Lb.prototype.ka=!0;Lb.prototype.ia=
	function(){return this.a};Lb.prototype.g=function(){return 1};Lb.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function Nb(a){if(a instanceof Lb&&a.constructor===Lb&&a.h===Mb)return a.a;Ua("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ta(a));return"type_error:TrustedResourceUrl"}var Mb={};function Ob(a){var b=new Lb;b.a=a;return b}function Pb(){this.a="";this.h=Qb}Pb.prototype.ka=!0;Pb.prototype.ia=function(){return this.a};Pb.prototype.g=function(){return 1};
	Pb.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Rb(a){if(a instanceof Pb&&a.constructor===Pb&&a.h===Qb)return a.a;Ua("expected object of type SafeUrl, got '"+a+"' of type "+ta(a));return"type_error:SafeUrl"}var Sb=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;function Tb(a){if(a instanceof Pb)return a;a=a.ka?a.ia():String(a);Sb.test(a)||(a="about:invalid#zClosurez");return Ub(a)}var Qb={};function Ub(a){var b=new Pb;b.a=a;return b}Ub("about:blank");function Vb(){this.a=
	"";this.j=Wb;this.h=null}Vb.prototype.g=function(){return this.h};Vb.prototype.ka=!0;Vb.prototype.ia=function(){return this.a};Vb.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Xb(a){if(a instanceof Vb&&a.constructor===Vb&&a.j===Wb)return a.a;Ua("expected object of type SafeHtml, got '"+a+"' of type "+ta(a));return"type_error:SafeHtml"}var Wb={};function Yb(a,b){var c=new Vb;c.a=a;c.h=b;return c}Yb("<!DOCTYPE html>",0);Yb("",0);Yb("<br>",0);function Zb(a,b){this.a=qa(a)?a:0;
	this.g=qa(b)?b:0}Zb.prototype.toString=function(){return"("+this.a+", "+this.g+")"};Zb.prototype.ceil=function(){this.a=Math.ceil(this.a);this.g=Math.ceil(this.g);return this};Zb.prototype.floor=function(){this.a=Math.floor(this.a);this.g=Math.floor(this.g);return this};Zb.prototype.round=function(){this.a=Math.round(this.a);this.g=Math.round(this.g);return this};function $b(a,b){this.width=a;this.height=b}h=$b.prototype;h.toString=function(){return"("+this.width+" x "+this.height+")"};h.aspectRatio=
	function(){return this.width/this.height};h.ceil=function(){this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this};h.floor=function(){this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this};h.round=function(){this.width=Math.round(this.width);this.height=Math.round(this.height);return this};function ac(a){return a?new bc(cc(a)):Ha||(Ha=new bc)}function dc(a,b){var c=b||document;return c.querySelectorAll&&c.querySelector?c.querySelectorAll("."+a):
	ec(document,a,b)}function fc(a,b){var c=b||document;if(c.getElementsByClassName)a=c.getElementsByClassName(a)[0];else{c=document;var d=b||c;a=d.querySelectorAll&&d.querySelector&&a?d.querySelector(""+(a?"."+a:"")):ec(c,a,b)[0]||null}return a||null}function ec(a,b,c){var d;a=c||a;if(a.querySelectorAll&&a.querySelector&&b)return a.querySelectorAll(""+(b?"."+b:""));if(b&&a.getElementsByClassName){var e=a.getElementsByClassName(b);return e}e=a.getElementsByTagName("*");if(b){var f={};for(c=d=0;a=e[c];c++){var g=
	a.className;"function"==typeof g.split&&bb(g.split(/\s+/),b)&&(f[d++]=a)}f.length=d;return f}return e}function gc(a,b){lb(b,function(b,d){b&&b.ka&&(b=b.ia());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:hc.hasOwnProperty(d)?a.setAttribute(hc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}var hc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",
	nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};function ic(a){return a.scrollingElement?a.scrollingElement:w||"CSS1Compat"!=a.compatMode?a.body||a.documentElement:a.documentElement}function jc(a){a&&a.parentNode&&a.parentNode.removeChild(a)}function cc(a){return 9==a.nodeType?a:a.ownerDocument||a.document}function kc(a,b){if("textContent"in a)a.textContent=b;else if(3==a.nodeType)a.data=String(b);else if(a.firstChild&&3==a.firstChild.nodeType){for(;a.lastChild!=
	a.firstChild;)a.removeChild(a.lastChild);a.firstChild.data=String(b)}else{for(var c;c=a.firstChild;)a.removeChild(c);a.appendChild(cc(a).createTextNode(String(b)))}}function lc(a,b){return b?mc(a,function(a){return!b||m(a.className)&&bb(a.className.split(/\s+/),b)}):null}function mc(a,b){for(var c=0;a;){if(b(a))return a;a=a.parentNode;c++}return null}function bc(a){this.a=a||l.document||document}bc.prototype.K=function(){return m(void 0)?this.a.getElementById(void 0):void 0};var nc="StopIteration"in
	l?l.StopIteration:{message:"StopIteration",stack:""};function oc(){}oc.prototype.next=function(){throw nc;};oc.prototype.ba=function(){return this};function pc(a){if(a instanceof oc)return a;if("function"==typeof a.ba)return a.ba(!1);if(wa(a)){var b=0,c=new oc;c.next=function(){for(;;){if(b>=a.length)throw nc;if(b in a)return a[b++];b++}};return c}throw Error("Not implemented");}function qc(a,b){if(wa(a))try{Wa(a,b,void 0)}catch(c){if(c!==nc)throw c;}else{a=pc(a);try{for(;;)b.call(void 0,a.next(),
	void 0,a)}catch(c$1){if(c$1!==nc)throw c$1;}}}function rc(a){if(wa(a))return hb(a);a=pc(a);var b=[];qc(a,function(a){b.push(a)});return b}function sc(a,b){this.g={};this.a=[];this.j=this.h=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){if(a instanceof sc){var e=a.ha();d=a.ca()}else{c=[];var f=0;for(e in a)c[f++]=e;e=c;c=[];f=0;for(d in a)c[f++]=a[d];d=c}for(c=0;c<e.length;c++)this.set(e[c],d[c])}}
	h=sc.prototype;h.ca=function(){tc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.g[this.a[b]]);return a};h.ha=function(){tc(this);return this.a.concat()};h.clear=function(){this.g={};this.j=this.h=this.a.length=0};function tc(a){if(a.h!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];uc(a.g,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.h!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],uc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}h.get=function(a,b){return uc(this.g,a)?this.g[a]:
	b};h.set=function(a,b){uc(this.g,a)||(this.h++,this.a.push(a),this.j++);this.g[a]=b};h.forEach=function(a,b){for(var c=this.ha(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.ba=function(a){tc(this);var b=0,c=this.j,d=this,e=new oc;e.next=function(){if(c!=d.j)throw Error("The map has changed since the iterator was created");if(b>=d.a.length)throw nc;var e=d.a[b++];return a?e:d.g[e]};return e};function uc(a,b){return Object.prototype.hasOwnProperty.call(a,b)}var vc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
	function wc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}}function xc(a,b,c,d){for(var e=c.length;0<=(b=a.indexOf(c,b))&&b<d;){var f=a.charCodeAt(b-1);if(38==f||63==f)if(f=a.charCodeAt(b+e),!f||61==f||38==f||35==f)return b;b+=e+1}return-1}var yc=/#|$/;function zc(a,b){var c=a.search(yc),d=xc(a,0,b,c);if(0>d)return null;var e=a.indexOf("&",
	d);if(0>e||e>c)e=c;d+=b.length+1;return decodeURIComponent(a.substr(d,e-d).replace(/\+/g," "))}var Ac=/[?&]($|#)/;function Bc(a,b){this.g=this.v=this.h="";this.A=null;this.j=this.a="";this.i=!1;var c;a instanceof Bc?(this.i=qa(b)?b:a.i,Cc(this,a.h),this.v=a.v,this.g=a.g,Dc(this,a.A),this.a=a.a,Ec(this,Fc(a.u)),this.j=a.j):a&&(c=String(a).match(vc))?(this.i=!!b,Cc(this,c[1]||"",!0),this.v=Gc(c[2]||""),this.g=Gc(c[3]||"",!0),Dc(this,c[4]),this.a=Gc(c[5]||"",!0),Ec(this,c[6]||"",!0),this.j=Gc(c[7]||
	"")):(this.i=!!b,this.u=new Hc(null,this.i))}Bc.prototype.toString=function(){var a=[],b=this.h;b&&a.push(Ic(b,Jc,!0),":");var c=this.g;if(c||"file"==b)a.push("//"),(b=this.v)&&a.push(Ic(b,Jc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.A,null!=c&&a.push(":",String(c));if(c=this.a)this.g&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ic(c,"/"==c.charAt(0)?Kc:Lc,!0));(c=this.u.toString())&&a.push("?",c);(c=this.j)&&a.push("#",Ic(c,Mc));return a.join("")};Bc.prototype.resolve=
	function(a){var b=new Bc(this),c=!!a.h;c?Cc(b,a.h):c=!!a.v;c?b.v=a.v:c=!!a.g;c?b.g=a.g:c=null!=a.A;var d=a.a;if(c)Dc(b,a.A);else if(c=!!a.a){if("/"!=d.charAt(0))if(this.g&&!this.a)d="/"+d;else{var e=b.a.lastIndexOf("/");-1!=e&&(d=b.a.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(-1!=e.indexOf("./")||-1!=e.indexOf("/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var k=e[g++];"."==k?d&&g==e.length&&f.push(""):".."==k?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),
	d&&g==e.length&&f.push("")):(f.push(k),d=!0)}d=f.join("/")}else d=e}c?b.a=d:c=""!==a.u.toString();c?Ec(b,Fc(a.u)):c=!!a.j;c&&(b.j=a.j);return b};function Cc(a,b,c){a.h=c?Gc(b,!0):b;a.h&&(a.h=a.h.replace(/:$/,""))}function Dc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.A=b}else a.A=null}function Ec(a,b,c){b instanceof Hc?(a.u=b,Nc(a.u,a.i)):(c||(b=Ic(b,Oc)),a.u=new Hc(b,a.i))}function Pc(a){return a instanceof Bc?new Bc(a):new Bc(a,void 0)}function Qc(a){var b=window.location.href;
	b instanceof Bc||(b=Pc(b));a instanceof Bc||(a=Pc(a));return b.resolve(a)}function Gc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Ic(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Rc),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Rc(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Jc=/[#\/\?@]/g,Lc=/[#\?:]/g,Kc=/[#\?]/g,Oc=/[#\?@]/g,Mc=/#/g;function Hc(a,b){this.g=this.a=null;this.h=a||null;this.j=!!b}function Sc(a){a.a||
	(a.a=new sc,a.g=0,a.h&&wc(a.h,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}h=Hc.prototype;h.add=function(a,b){Sc(this);this.h=null;a=Tc(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.g+=1;return this};function Uc(a,b){Sc(a);b=Tc(a,b);uc(a.a.g,b)&&(a.h=null,a.g-=a.a.get(b).length,a=a.a,uc(a.g,b)&&(delete a.g[b],a.h--,a.j++,a.a.length>2*a.h&&tc(a)))}h.clear=function(){this.a=this.h=null;this.g=0};function Vc(a,b){Sc(a);b=Tc(a,b);return uc(a.a.g,b)}h.forEach=function(a,
	b){Sc(this);this.a.forEach(function(c,d){Wa(c,function(c){a.call(b,c,d,this)},this)},this)};h.ha=function(){Sc(this);for(var a=this.a.ca(),b=this.a.ha(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};h.ca=function(a){Sc(this);var b=[];if(m(a))Vc(this,a)&&(b=gb(b,this.a.get(Tc(this,a))));else{a=this.a.ca();for(var c=0;c<a.length;c++)b=gb(b,a[c])}return b};h.set=function(a,b){Sc(this);this.h=null;a=Tc(this,a);Vc(this,a)&&(this.g-=this.a.get(a).length);this.a.set(a,
	[b]);this.g+=1;return this};h.get=function(a,b){a=a?this.ca(a):[];return 0<a.length?String(a[0]):b};h.toString=function(){if(this.h)return this.h;if(!this.a)return"";for(var a=[],b=this.a.ha(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.ca(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.h=a.join("&")};function Fc(a){var b=new Hc;b.h=a.h;a.a&&(b.a=new sc(a.a),b.g=a.g);return b}function Tc(a,b){b=String(b);
	a.j&&(b=b.toLowerCase());return b}function Nc(a,b){b&&!a.j&&(Sc(a),a.h=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(Uc(this,b),Uc(this,c),0<a.length&&(this.h=null,this.a.set(Tc(this,c),hb(a)),this.g+=a.length))},a));a.j=b}var Wc={Yb:!0},Xc={$b:!0},Yc={Zb:!0};function x(){throw Error("Do not instantiate directly");}x.prototype.Y=null;x.prototype.toString=function(){return this.content};function Zc(a,b,c,d){a=a(b||$c,void 0,c);d=(d||ac()).a.createElement("DIV");a=ad(a);a.match(bd);d.innerHTML=
	a;1==d.childNodes.length&&(a=d.firstChild,1==a.nodeType&&(d=a));return d}function ad(a){if(!za(a))return String(a);if(a instanceof x){if(a.P===Wc)return a.content;if(a.P===Yc)return Ka(a.content)}Ua("Soy template output is unsafe for use as HTML: "+a);return"zSoyz"}var bd=/^<(body|caption|col|colgroup|head|html|tr|td|th|tbody|thead|tfoot)>/i,$c={};function cd(a){if(null!=a)switch(a.Y){case 1:return 1;case -1:return-1;case 0:return 0}return null}function dd(){x.call(this)}t(dd,x);dd.prototype.P=Wc;
	function y(a){return null!=a&&a.P===Wc?a:a instanceof Vb?z(Xb(a),a.g()):z(Ka(String(String(a))),cd(a))}function ed(){x.call(this)}t(ed,x);ed.prototype.P={Xb:!0};ed.prototype.Y=1;function fd(){x.call(this)}t(fd,x);fd.prototype.P=Xc;fd.prototype.Y=1;function gd(){x.call(this)}t(gd,x);gd.prototype.P={Wb:!0};gd.prototype.Y=1;function hd(){x.call(this)}t(hd,x);hd.prototype.P={Vb:!0};hd.prototype.Y=1;function id(a,b){this.content=String(a);this.Y=null!=b?b:null}t(id,x);id.prototype.P=Yc;function jd(a){function b(a){this.content=
	a}b.prototype=a.prototype;return function(a){return new b(String(a))}}function A(a){return new id(a,void 0)}var z=function(a){function b(a){this.content=a}b.prototype=a.prototype;return function(a,d){a=new b(String(a));void 0!==d&&(a.Y=d);return a}}(dd);jd(ed);var kd=jd(fd);jd(gd);jd(hd);function ld(a){var b={label:md("New password")};function c(){}c.prototype=a;a=new c;for(var d in b)a[d]=b[d];return a}function md(a){return(a=String(a))?new id(a,void 0):""}var nd=function(a){function b(a){this.content=
	a}b.prototype=a.prototype;return function(a,d){a=String(a);if(!a)return"";a=new b(a);void 0!==d&&(a.Y=d);return a}}(dd);function od(a){return null!=a&&a.P===Wc?String(String(a.content).replace(pd,"").replace(qd,"&lt;")).replace(rd,sd):Ka(String(a))}function td(a){null!=a&&a.P===Xc?a=String(a).replace(ud,vd):a instanceof Pb?a=String(Rb(a)).replace(ud,vd):(a=String(a),wd.test(a)?a=a.replace(ud,vd):(Ua("Bad value `%s` for |filterNormalizeUri",[a]),a="#zSoyz"));return a}var xd={"\x00":"&#0;","\t":"&#9;",
	"\n":"&#10;","\x0B":"&#11;","\f":"&#12;","\r":"&#13;"," ":"&#32;",'"':"&quot;","&":"&amp;","'":"&#39;","-":"&#45;","/":"&#47;","<":"&lt;","=":"&#61;",">":"&gt;","`":"&#96;","\u0085":"&#133;","\u00a0":"&#160;","\u2028":"&#8232;","\u2029":"&#8233;"};function sd(a){return xd[a]}var yd={"\x00":"%00","\u0001":"%01","\u0002":"%02","\u0003":"%03","\u0004":"%04","\u0005":"%05","\u0006":"%06","\u0007":"%07","\b":"%08","\t":"%09","\n":"%0A","\x0B":"%0B","\f":"%0C","\r":"%0D","\u000e":"%0E","\u000f":"%0F","\u0010":"%10",
	"\u0011":"%11","\u0012":"%12","\u0013":"%13","\u0014":"%14","\u0015":"%15","\u0016":"%16","\u0017":"%17","\u0018":"%18","\u0019":"%19","\u001a":"%1A","\u001b":"%1B","\u001c":"%1C","\u001d":"%1D","\u001e":"%1E","\u001f":"%1F"," ":"%20",'"':"%22","'":"%27","(":"%28",")":"%29","<":"%3C",">":"%3E","\\":"%5C","{":"%7B","}":"%7D","\u007f":"%7F","\u0085":"%C2%85","\u00a0":"%C2%A0","\u2028":"%E2%80%A8","\u2029":"%E2%80%A9","\uff01":"%EF%BC%81","\uff03":"%EF%BC%83","\uff04":"%EF%BC%84","\uff06":"%EF%BC%86",
	"\uff07":"%EF%BC%87","\uff08":"%EF%BC%88","\uff09":"%EF%BC%89","\uff0a":"%EF%BC%8A","\uff0b":"%EF%BC%8B","\uff0c":"%EF%BC%8C","\uff0f":"%EF%BC%8F","\uff1a":"%EF%BC%9A","\uff1b":"%EF%BC%9B","\uff1d":"%EF%BC%9D","\uff1f":"%EF%BC%9F","\uff20":"%EF%BC%A0","\uff3b":"%EF%BC%BB","\uff3d":"%EF%BC%BD"};function vd(a){return yd[a]}var rd=/[\x00\x22\x27\x3c\x3e]/g,ud=/[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,
	wd=/^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,pd=/<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,qd=/</g;function zd(){return A("Enter a valid phone number")}function Ad(){return A("Something went wrong. Please try again.")}function Bd(){return A("This email already exists without any means of sign-in. Please reset the password to recover.")}function Cd(){return A("Please login again to perform this operation")}function Dd(a,b,c){this.code=
	Ed+a;if(!(a=b)){a="";switch(this.code){case "firebaseui/merge-conflict":a+="The current anonymous user failed to upgrade. The non-anonymous credential is already associated with a different user account.";break;default:a+=Ad()}a=A(a).toString()}this.message=a||"";this.credential=c||null}t(Dd,Error);Dd.prototype.fa=function(){return{code:this.code,message:this.message}};Dd.prototype.toJSON=function(){return this.fa()};var Ed="firebaseui/";function Fd(){0!=Gd&&(Hd[this[Aa]||(this[Aa]=++Ba)]=this);this.J=
	this.J;this.H=this.H}var Gd=0,Hd={};Fd.prototype.J=!1;Fd.prototype.s=function(){if(!this.J&&(this.J=!0,this.l(),0!=Gd)){var a=this[Aa]||(this[Aa]=++Ba);delete Hd[a]}};function Id(a,b){a.J?qa(void 0)?b.call(void 0):b():(a.H||(a.H=[]),a.H.push(qa(void 0)?n(b,void 0):b))}Fd.prototype.l=function(){if(this.H)for(;this.H.length;)this.H.shift()()};function Jd(a){a&&"function"==typeof a.s&&a.s()}var Kd=Object.freeze||function(a){return a};var Ld=!v||9<=Number(Fb),Md=v&&!Eb("9"),Nd=function(){if(!l.addEventListener||
	!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});l.addEventListener("test",ra,b);l.removeEventListener("test",ra,b);return a}();function Od(a,b){this.type=a;this.g=this.target=b;this.h=!1;this.Va=!0}Od.prototype.stopPropagation=function(){this.h=!0};Od.prototype.preventDefault=function(){this.Va=!1};function B(a,b){Od.call(this,a?a.type:"");this.relatedTarget=this.g=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=
	0;this.key="";this.j=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.g=b;if(b=a.relatedTarget){if(wb){a:{try{qb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=
	void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.j=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=m(a.pointerType)?
	a.pointerType:Pd[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}t(B,Od);var Pd=Kd({2:"touch",3:"pen",4:"mouse"});B.prototype.stopPropagation=function(){B.m.stopPropagation.call(this);this.a.stopPropagation?this.a.stopPropagation():this.a.cancelBubble=!0};B.prototype.preventDefault=function(){B.m.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Md)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};
	var Qd="closure_listenable_"+(1E6*Math.random()|0);function Rd(a){return!(!a||!a[Qd])}var Sd=0;function Td(a,b,c,d,e){this.listener=a;this.a=null;this.src=b;this.type=c;this.capture=!!d;this.Aa=e;this.key=++Sd;this.la=this.xa=!1}function Ud(a){a.la=!0;a.listener=null;a.a=null;a.src=null;a.Aa=null}function Vd(a){this.src=a;this.a={};this.g=0}Vd.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.g++);var g=Wd(a,b,d,e);-1<g?(b=a[g],c||(b.xa=!1)):(b=new Td(b,this.src,
	f,!!d,e),b.xa=c,a.push(b));return b};function Xd(a,b){var c=b.type;c in a.a&&cb(a.a[c],b)&&(Ud(b),0==a.a[c].length&&(delete a.a[c],a.g--))}function Yd(a,b,c,d,e){a=a.a[b.toString()];b=-1;a&&(b=Wd(a,c,d,e));return-1<b?a[b]:null}function Wd(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.la&&f.listener==b&&f.capture==!!c&&f.Aa==d)return e}return-1}var Zd="closure_lm_"+(1E6*Math.random()|0),$d={},ae=0;function be(a,b,c,d,e){if(d&&d.once)return ce(a,b,c,d,e);if(va(b)){for(var f=0;f<b.length;f++)be(a,
	b[f],c,d,e);return null}c=de(c);return Rd(a)?a.$(b,c,za(d)?!!d.capture:!!d,e):ee(a,b,c,!1,d,e)}function ee(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=za(e)?!!e.capture:!!e,k=fe(a);k||(a[Zd]=k=new Vd(a));c=k.add(b,c,d,g,f);if(c.a)return c;d=ge();c.a=d;d.src=a;d.listener=c;if(a.addEventListener)Nd||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(he(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");
	ae++;return c}function ge(){var a=ie,b=Ld?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function ce(a,b,c,d,e){if(va(b)){for(var f=0;f<b.length;f++)ce(a,b[f],c,d,e);return null}c=de(c);return Rd(a)?a.A.add(String(b),c,!0,za(d)?!!d.capture:!!d,e):ee(a,b,c,!0,d,e)}function je(a,b,c,d,e){if(va(b))for(var f=0;f<b.length;f++)je(a,b[f],c,d,e);else d=za(d)?!!d.capture:!!d,c=de(c),Rd(a)?a.La(b,c,d,e):a&&(a=fe(a))&&(b=Yd(a,b,c,d,e))&&ke(b)}
	function ke(a){if("number"!=typeof a&&a&&!a.la){var b=a.src;if(Rd(b))Xd(b.A,a);else{var c=a.type,d=a.a;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(he(c),d):b.addListener&&b.removeListener&&b.removeListener(d);ae--;(c=fe(b))?(Xd(c,a),0==c.g&&(c.src=null,b[Zd]=null)):Ud(a)}}}function he(a){return a in $d?$d[a]:$d[a]="on"+a}function le(a,b,c,d){var e=!0;if(a=fe(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.la&&
	(f=me(f,d),e=e&&!1!==f)}return e}function me(a,b){var c=a.listener,d=a.Aa||a.src;a.xa&&ke(a);return c.call(d,b)}function ie(a,b){if(a.la)return!0;if(!Ld){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new B(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.g;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-
	1;!b.h&&0<=e;e--){b.g=d[e];var f=le(d[e],a,!0,b);c=c&&f}for(e=0;!b.h&&e<d.length;e++)b.g=d[e],f=le(d[e],a,!1,b),c=c&&f}return c}return me(a,new B(b,this))}function fe(a){a=a[Zd];return a instanceof Vd?a:null}var ne="__closure_events_fn_"+(1E9*Math.random()>>>0);function de(a){if(xa(a))return a;a[ne]||(a[ne]=function(b){return a.handleEvent(b)});return a[ne]}function C(){Fd.call(this);this.A=new Vd(this);this.Za=this;this.ta=null}t(C,Fd);C.prototype[Qd]=!0;h=C.prototype;h.Ka=function(a){this.ta=a};
	h.removeEventListener=function(a,b,c,d){je(this,a,b,c,d)};function oe(a,b){var c,d=a.ta;if(d)for(c=[];d;d=d.ta)c.push(d);a=a.Za;d=b.type||b;if(m(b))b=new Od(b,a);else if(b instanceof Od)b.target=b.target||a;else{var e=b;b=new Od(d,a);ob(b,e)}e=!0;if(c)for(var f=c.length-1;!b.h&&0<=f;f--){var g=b.g=c[f];e=pe(g,d,!0,b)&&e}b.h||(g=b.g=a,e=pe(g,d,!0,b)&&e,b.h||(e=pe(g,d,!1,b)&&e));if(c)for(f=0;!b.h&&f<c.length;f++)g=b.g=c[f],e=pe(g,d,!1,b)&&e;return e}h.l=function(){C.m.l.call(this);if(this.A){var a=
	this.A,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,Ud(d[e]);delete a.a[c];a.g--}}this.ta=null};h.$=function(a,b,c,d){return this.A.add(String(a),b,!1,c,d)};h.La=function(a,b,c,d){var e=this.A;a=String(a).toString();if(a in e.a){var f=e.a[a];b=Wd(f,b,c,d);-1<b&&(Ud(f[b]),db(f,b),0==f.length&&(delete e.a[a],e.g--))}};function pe(a,b,c,d){b=a.A.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.la&&g.capture==c){var k=g.listener,q=g.Aa||g.src;
	g.xa&&Xd(a.A,g);e=!1!==k.call(q,d)&&e}}return e&&0!=d.Va}var qe={},re=0;function se(a,b){if(!a)throw Error("Event target element must be provided!");a=te(a);if(qe[a]&&qe[a].length)for(var c=0;c<qe[a].length;c++)oe(qe[a][c],b)}function ue(a){var b=te(a.K());qe[b]?bb(qe[b],a)||qe[b].push(a):qe[b]=[a]}function ve(a){var b=te(a.K());qe[b]&&qe[b].length&&(eb(qe[b],function(b){return b==a}),qe[b].length||delete qe[b])}function te(a){"undefined"===typeof a.a&&(a.a=re,re++);return a.a}function we(a){if(!a)throw Error("Event target element must be provided!");
	this.a=a;C.call(this)}t(we,C);we.prototype.K=function(){return this.a};function xe(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function ye(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}}function ze(a,b){this.h=a;this.j=b;this.g=0;this.a=null}ze.prototype.get=function(){if(0<this.g){this.g--;var a=this.a;this.a=a.next;a.next=null}else a=this.h();return a};function Ae(a,b){a.j(b);100>a.g&&(a.g++,b.next=a.a,a.a=b)}function Be(){this.g=this.a=null}var De=new ze(function(){return new Ce},
	function(a){a.reset()});Be.prototype.add=function(a,b){var c=De.get();c.set(a,b);this.g?this.g.next=c:this.a=c;this.g=c};function Ee(){var a=Fe,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.g=null),b.next=null);return b}function Ce(){this.next=this.g=this.a=null}Ce.prototype.set=function(a,b){this.a=a;this.g=b;this.next=null};Ce.prototype.reset=function(){this.next=this.g=this.a=null};function Ge(a){l.setTimeout(function(){throw a;},0)}var He;function Ie(){var a=l.MessageChannel;"undefined"===typeof a&&
	"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!u("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=n(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",
	a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!u("Trident")&&!u("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(qa(c.next)){c=c.next;var a=c.Sa;c.Sa=null;a()}};return function(a){d.next={Sa:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;
	b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){l.setTimeout(a,0)}}function Je(a,b){Ke||Le();Me||(Ke(),Me=!0);Fe.add(a,b)}var Ke;function Le(){if(-1!=String(l.Promise).indexOf("[native code]")){var a=l.Promise.resolve(void 0);Ke=function(){a.then(Ne)}}else Ke=function(){var a=Ne;!xa(l.setImmediate)||l.Window&&l.Window.prototype&&!u("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(He||(He=Ie()),He(a)):l.setImmediate(a)}}var Me=!1,Fe=new Be;
	function Ne(){for(var a;a=Ee();){try{a.a.call(a.g)}catch(b){Ge(b)}Ae(De,a)}Me=!1}function D(a,b){this.a=Oe;this.v=void 0;this.j=this.g=this.h=null;this.i=this.u=!1;if(a!=ra)try{var c=this;a.call(b,function(a){Pe(c,Qe,a)},function(a){if(!(a instanceof Re))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}Pe(c,Se,a)})}catch(d){Pe(this,Se,d)}}var Oe=0,Qe=2,Se=3;function Te(){this.next=this.context=this.g=this.h=this.a=null;this.j=!1}Te.prototype.reset=function(){this.context=
	this.g=this.h=this.a=null;this.j=!1};var Ue=new ze(function(){return new Te},function(a){a.reset()});function Ve(a,b,c){var d=Ue.get();d.h=a;d.g=b;d.context=c;return d}function E(a){if(a instanceof D)return a;var b=new D(ra);Pe(b,Qe,a);return b}function We(a){return new D(function(b,c){c(a)})}D.prototype.then=function(a,b,c){return Xe(this,xa(a)?a:null,xa(b)?b:null,c)};xe(D);function Ye(a,b){return Xe(a,null,b,void 0)}D.prototype.cancel=function(a){this.a==Oe&&Je(function(){var b=new Re(a);Ze(this,
	b)},this)};function Ze(a,b){if(a.a==Oe)if(a.h){var c=a.h;if(c.g){for(var d=0,e=null,f=null,g=c.g;g&&(g.j||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==Oe&&1==d?Ze(c,b):(f?(d=f,d.next==c.j&&(c.j=d),d.next=d.next.next):$e(c),af(c,e,Se,b)))}a.h=null}else Pe(a,Se,b)}function bf(a,b){a.g||a.a!=Qe&&a.a!=Se||cf(a);a.j?a.j.next=b:a.g=b;a.j=b}function Xe(a,b,c,d){var e=Ve(null,null,null);e.a=new D(function(a,g){e.h=b?function(c){try{var e=b.call(d,c);a(e)}catch(J){g(J)}}:a;e.g=c?function(b){try{var e=
	c.call(d,b);!qa(e)&&b instanceof Re?g(b):a(e)}catch(J){g(J)}}:g});e.a.h=a;bf(a,e);return e.a}D.prototype.D=function(a){this.a=Oe;Pe(this,Qe,a)};D.prototype.F=function(a){this.a=Oe;Pe(this,Se,a)};function Pe(a,b,c){if(a.a==Oe){a===c&&(b=Se,c=new TypeError("Promise cannot resolve to itself"));a.a=1;a:{var d=c,e=a.D,f=a.F;if(d instanceof D){bf(d,Ve(e||ra,f||null,a));var g=!0}else if(ye(d))d.then(e,f,a),g=!0;else{if(za(d))try{var k=d.then;if(xa(k)){df(d,k,e,f,a);g=!0;break a}}catch(q){f.call(a,q);g=!0;
	break a}g=!1}}g||(a.v=c,a.a=b,a.h=null,cf(a),b!=Se||c instanceof Re||ef(a,c))}}function df(a,b,c,d,e){function f(a){k||(k=!0,d.call(e,a))}function g(a){k||(k=!0,c.call(e,a))}var k=!1;try{b.call(a,g,f)}catch(q){f(q)}}function cf(a){a.u||(a.u=!0,Je(a.A,a))}function $e(a){var b=null;a.g&&(b=a.g,a.g=b.next,b.next=null);a.g||(a.j=null);return b}D.prototype.A=function(){for(var a;a=$e(this);)af(this,a,this.a,this.v);this.u=!1};function af(a,b,c,d){if(c==Se&&b.g&&!b.j)for(;a&&a.i;a=a.h)a.i=!1;if(b.a)b.a.h=
	null,ff(b,c,d);else try{b.j?b.h.call(b.context):ff(b,c,d)}catch(e){gf.call(null,e)}Ae(Ue,b)}function ff(a,b,c){b==Qe?a.h.call(a.context,c):a.g&&a.g.call(a.context,c)}function ef(a,b){a.i=!0;Je(function(){a.i&&gf.call(null,b)})}var gf=Ge;function Re(a){Ga.call(this,a)}t(Re,Ga);Re.prototype.name="cancel";function hf(a){window.location.assign(Rb(Tb(a)))}function jf(){try{return!!(window.opener&&window.opener.location&&window.opener.location.assign&&window.opener.location.hostname===window.location.hostname&&
	window.opener.location.protocol===window.location.protocol)}catch(a){}return!1}function kf(a){a=za(a)&&1==a.nodeType?a:document.querySelector(String(a));if(null==a)throw Error("Could not find the FirebaseUI widget element on the page.");return a}function lf(){var a=null;return Ye(new D(function(b){"complete"==l.document.readyState?b():(a=function(){b()},ce(window,"load",a))}),function(b){je(window,"load",a);throw b;})}function mf(a,b){this.i=[];this.J=a;this.H=b||null;this.j=this.a=!1;this.h=void 0;
	this.D=this.o=this.v=!1;this.u=0;this.g=null;this.A=0}mf.prototype.cancel=function(a){if(this.a)this.h instanceof mf&&this.h.cancel();else{if(this.g){var b=this.g;delete this.g;a?b.cancel(a):(b.A--,0>=b.A&&b.cancel())}this.J?this.J.call(this.H,this):this.D=!0;this.a||(a=new nf(this),of(this),pf(this,!1,a))}};mf.prototype.F=function(a,b){this.v=!1;pf(this,a,b)};function pf(a,b,c){a.a=!0;a.h=c;a.j=!b;qf(a)}function of(a){if(a.a){if(!a.D)throw new rf(a);a.D=!1}}function sf(a,b,c){a.i.push([b,c,void 0]);
	a.a&&qf(a)}mf.prototype.then=function(a,b,c){var d,e,f=new D(function(a,b){d=a;e=b});sf(this,d,function(a){a instanceof nf?f.cancel():e(a)});return f.then(a,b,c)};xe(mf);function tf(a){return $a(a.i,function(a){return xa(a[1])})}function qf(a){if(a.u&&a.a&&tf(a)){var b=a.u,c=uf[b];c&&(l.clearTimeout(c.a),delete uf[b]);a.u=0}a.g&&(a.g.A--,delete a.g);b=a.h;for(var d=c=!1;a.i.length&&!a.v;){var e=a.i.shift(),f=e[0],g=e[1];e=e[2];if(f=a.j?g:f)try{var k=f.call(e||a.H,b);qa(k)&&(a.j=a.j&&(k==b||k instanceof
	Error),a.h=b=k);if(ye(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.v=!0}catch(q){b=q,a.j=!0,tf(a)||(c=!0)}}a.h=b;d&&(k=n(a.F,a,!0),d=n(a.F,a,!1),b instanceof mf?(sf(b,k,d),b.o=!0):b.then(k,d));c&&(b=new vf(b),uf[b.a]=b,a.u=b.a)}function rf(){Ga.call(this)}t(rf,Ga);rf.prototype.message="Deferred has already fired";rf.prototype.name="AlreadyCalledError";function nf(){Ga.call(this)}t(nf,Ga);nf.prototype.message="Deferred was canceled";nf.prototype.name="CanceledError";function vf(a){this.a=
	l.setTimeout(n(this.h,this),0);this.g=a}vf.prototype.h=function(){delete uf[this.a];throw this.g;};var uf={};function wf(a){var b={},c=b.document||document,d=Nb(a),e=document.createElement("SCRIPT"),f={Wa:e,Xa:void 0},g=new mf(xf,f),k=null,q=null!=b.timeout?b.timeout:5E3;0<q&&(k=window.setTimeout(function(){yf(e,!0);var a=new zf(Af,"Timeout reached for loading script "+d);of(g);pf(g,!1,a)},q),f.Xa=k);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||
	(yf(e,b.Pb||!1,k),of(g),pf(g,!0,null))};e.onerror=function(){yf(e,!0,k);var a=new zf(Bf,"Error while loading script "+d);of(g);pf(g,!1,a)};f=b.attributes||{};ob(f,{type:"text/javascript",charset:"UTF-8"});gc(e,f);e.src=Nb(a);Cf(c).appendChild(e);return g}function Cf(a){var b=(a||document).getElementsByTagName("HEAD");return b&&0!=b.length?b[0]:a.documentElement}function xf(){if(this&&this.Wa){var a=this.Wa;a&&"SCRIPT"==a.tagName&&yf(a,!0,this.Xa)}}function yf(a,b,c){null!=c&&l.clearTimeout(c);a.onload=
	ra;a.onerror=ra;a.onreadystatechange=ra;b&&window.setTimeout(function(){jc(a)},0)}var Bf=0,Af=1;function zf(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);Ga.call(this,c);this.code=a}t(zf,Ga);function Df(a){this.a=a||l.googleyolo;this.g=null;this.h=!1}sa(Df);var Ef=Kb("https://smartlock.google.com/client");Df.prototype.cancel=function(){this.a&&this.h&&(this.g=this.a.cancelLastOperation().catch(function(){}))};function Ff(a,b,c){if(a.a&&b){var d=function(){a.h=!0;var d=Promise.resolve(null);
	c||(d=a.a.retrieve(b).catch(function(a){if("userCanceled"===a.type||"illegalConcurrentRequest"===a.type)throw a;return null}));return d.then(function(c){return c?c:a.a.hint(b)}).catch(function(d){if("userCanceled"===d.type)a.g=Promise.resolve();else if("illegalConcurrentRequest"===d.type)return a.cancel(),Ff(a,b,c);return null})};return a.g?a.g.then(d):d()}if(b)return d=Ye(Gf.Ia().load().then(function(){a.a=l.googleyolo;return Ff(a,b,c)}),function(){return null}),Promise.resolve(d);if("undefined"!==
	typeof Promise)return Promise.resolve(null);throw Error("One-Tap sign in not supported in the current browser!");}function Gf(){this.a=null}sa(Gf);Gf.prototype.load=function(){var a=this;if(this.a)return this.a;var b=Ob(Jb(Ef));return l.googleyolo?E():this.a=lf().then(function(){if(!l.googleyolo)return new D(function(c,d){var e=setTimeout(function(){a.a=null;d(Error("Network error!"))},1E4);l.onGoogleYoloLoad=function(){clearTimeout(e);c()};Ye(E(wf(b)),function(b){clearTimeout(e);a.a=null;d(b)})})})};
	function Hf(a,b){this.a=a;this.g=b||function(a){throw a;}}Hf.prototype.confirm=function(a){return Ye(E(this.a.confirm(a)),this.g)};function If(a,b,c){this.reset(a,b,c,void 0,void 0)}If.prototype.a=null;var Jf=0;If.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Jf++;this.h=d||Fa();this.j=a;this.i=b;this.g=c;delete this.a};function Kf(a){this.i=a;this.a=this.h=this.j=this.g=null}function Lf(a,b){this.name=a;this.value=b}Lf.prototype.toString=function(){return this.name};var Mf=new Lf("SHOUT",
	1200),Nf=new Lf("SEVERE",1E3),Of=new Lf("WARNING",900),Pf=new Lf("CONFIG",700);function Qf(a){if(a.j)return a.j;if(a.g)return Qf(a.g);Ua("Root logger has no level set.");return null}Kf.prototype.log=function(a,b,c){if(a.value>=Qf(this).value)for(xa(b)&&(b=b()),a=new If(a,String(b),this.i),c&&(a.a=c),c=this;c;){var d=c,e=a;if(d.a)for(var f=0;b=d.a[f];f++)b(e);c=c.g}};function Rf(a){Sf.log(Of,a,void 0)}var Tf={},Uf=null;function Vf(){Uf||(Uf=new Kf(""),Tf[""]=Uf,Uf.j=Pf)}function Wf(a){Vf();var b;if(!(b=
	Tf[a])){b=new Kf(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Wf(a.substr(0,c));c.h||(c.h={});c.h[d]=b;b.g=c;Tf[a]=b}return b}function Xf(){this.a=Fa()}var Yf=null;Xf.prototype.set=function(a){this.a=a};Xf.prototype.reset=function(){this.set(Fa())};Xf.prototype.get=function(){return this.a};function Zf(a){this.j=a||"";Yf||(Yf=new Xf);this.i=Yf}Zf.prototype.a=!0;Zf.prototype.g=!0;Zf.prototype.h=!1;function $f(a){return 10>a?"0"+a:String(a)}function ag(a,b){a=(a.h-b)/1E3;b=a.toFixed(3);var c=0;if(1>
	a)c=2;else for(;100>a;)c++,a*=10;for(;0<c--;)b=" "+b;return b}function bg(a){Zf.call(this,a)}t(bg,Zf);function cg(){this.i=n(this.h,this);this.a=new bg;this.a.g=!1;this.a.h=!1;this.g=this.a.a=!1;this.j={}}cg.prototype.h=function(a){if(!this.j[a.g]){var b=this.a;var c=[];c.push(b.j," ");if(b.g){var d=new Date(a.h);c.push("[",$f(d.getFullYear()-2E3)+$f(d.getMonth()+1)+$f(d.getDate())+" "+$f(d.getHours())+":"+$f(d.getMinutes())+":"+$f(d.getSeconds())+"."+$f(Math.floor(d.getMilliseconds()/10)),"] ")}c.push("[",
	ag(a,b.i.get()),"s] ");c.push("[",a.g,"] ");c.push(a.i);b.h&&(d=a.a)&&c.push("\n",d instanceof Error?d.message:d.toString());b.a&&c.push("\n");b=c.join("");if(c=dg)switch(a.j){case Mf:eg(c,"info",b);break;case Nf:eg(c,"error",b);break;case Of:eg(c,"warn",b);break;default:eg(c,"log",b)}}};var dg=l.console;function eg(a,b,c){if(a[b])a[b](c);else a.log(c)}var Sf;Sf=Wf("firebaseui");var fg=new cg;if(1!=fg.g){var gg;Vf();gg=Uf;var hg=fg.i;gg.a||(gg.a=[]);gg.a.push(hg);fg.g=!0}function ig(a){Sf&&Sf.log(Nf,
	a,void 0)}function jg(a,b,c,d){this.a=a;this.h=b||null;this.j=c||null;this.g=d||null}jg.prototype.fa=function(){return{email:this.a,displayName:this.h,photoUrl:this.j,providerId:this.g}};function kg(a){return a.email?new jg(a.email,a.displayName,a.photoUrl,a.providerId):null}var lg={"facebook.com":"FacebookAuthProvider","github.com":"GithubAuthProvider","google.com":"GoogleAuthProvider",password:"EmailAuthProvider","twitter.com":"TwitterAuthProvider",phone:"PhoneAuthProvider"};function mg(a,b){this.g=
	a;this.a=b||null}mg.prototype.fa=function(){return{email:this.g,credential:this.a&&mb(this.a)}};function ng(a){if(a&&a.email){var b;if(b=a.credential){var c=(b=a.credential)&&b.providerId;b=lg[c]&&firebase.auth[lg[c]]?b.secret&&b.accessToken?firebase.auth[lg[c]].credential(b.accessToken,b.secret):c==firebase.auth.GoogleAuthProvider.PROVIDER_ID?firebase.auth[lg[c]].credential(b.idToken,b.accessToken):firebase.auth[lg[c]].credential(b.accessToken):null}return new mg(a.email,b)}return null}function og(a){var b=
	[];pg(new qg,a,b);return b.join("")}function qg(){}function pg(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(va(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),pg(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),rg(d,c),c.push(":"),pg(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":rg(b,
	c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var sg={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},tg=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;function rg(a,b){b.push('"',a.replace(tg,function(a){var b=sg[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),
	sg[a]=b);return b}),'"')}function ug(a){this.a=a}ug.prototype.set=function(a,b){qa(b)?this.a.set(a,og(b)):this.a.na(a)};ug.prototype.get=function(a){try{var b=this.a.get(a)}catch(c){return}if(null!==b)try{return JSON.parse(b)}catch(c$2){throw"Storage: Invalid value was encountered";}};function vg(){}function wg(){}t(wg,vg);wg.prototype.clear=function(){var a=rc(this.ba(!0)),b=this;Wa(a,function(a){b.na(a)})};function xg(a){this.a=a}t(xg,wg);function yg(a){if(!a.a)return!1;try{return a.a.setItem("__sak",
	"1"),a.a.removeItem("__sak"),!0}catch(b){return!1}}h=xg.prototype;h.set=function(a,b){try{this.a.setItem(a,b)}catch(c){if(0==this.a.length)throw"Storage mechanism: Storage disabled";throw"Storage mechanism: Quota exceeded";}};h.get=function(a){a=this.a.getItem(a);if(!m(a)&&null!==a)throw"Storage mechanism: Invalid value was encountered";return a};h.na=function(a){this.a.removeItem(a)};h.ba=function(a){var b=0,c=this.a,d=new oc;d.next=function(){if(b>=c.length)throw nc;var d=c.key(b++);if(a)return d;
	d=c.getItem(d);if(!m(d))throw"Storage mechanism: Invalid value was encountered";return d};return d};h.clear=function(){this.a.clear()};h.key=function(a){return this.a.key(a)};function zg(){var a=null;try{a=window.localStorage||null}catch(b){}this.a=a}t(zg,xg);function Ag(){var a=null;try{a=window.sessionStorage||null}catch(b){}this.a=a}t(Ag,xg);function Bg(a,b){this.g=a;this.a=b+"::"}t(Bg,wg);Bg.prototype.set=function(a,b){this.g.set(this.a+a,b)};Bg.prototype.get=function(a){return this.g.get(this.a+
	a)};Bg.prototype.na=function(a){this.g.na(this.a+a)};Bg.prototype.ba=function(a){var b=this.g.ba(!0),c=this,d=new oc;d.next=function(){for(var d=b.next();d.substr(0,c.a.length)!=c.a;)d=b.next();return a?d.substr(c.a.length):c.g.get(d)};return d};var Cg,Dg=new zg;Cg=yg(Dg)?new Bg(Dg,"firebaseui"):null;var Eg=new ug(Cg),Fg,Gg=new Ag;Fg=yg(Gg)?new Bg(Gg,"firebaseui"):null;var Hg=new ug(Fg),Ig={name:"pendingEmailCredential",ea:!1},Jg={name:"pendingRedirect",ea:!1},Kg={name:"redirectUrl",ea:!1},Lg={name:"rememberAccount",
	ea:!1},Mg={name:"rememberedAccounts",ea:!0};function Ng(a,b){return(a.ea?Eg:Hg).get(b?a.name+":"+b:a.name)}function F(a,b){(a.ea?Eg:Hg).a.na(b?a.name+":"+b:a.name)}function Og(a,b,c){(a.ea?Eg:Hg).set(c?a.name+":"+c:a.name,b)}function Pg(a){return Ng(Kg,a)||null}function Qg(a,b){Og(Kg,a,b)}function Rg(a,b){Og(Lg,a,b)}function Sg(a){a=Ng(Mg,a)||[];a=Za(a,function(a){return kg(a)});return Ya(a,ua)}function Tg(a,b){var c=Sg(b),d=ab(c,function(b){return b.a==a.a&&(b.g||null)==(a.g||null)});-1<d&&db(c,
	d);c.unshift(a);Og(Mg,Za(c,function(a){return a.fa()}),b)}function Ug(a){a=Ng(Ig,a)||null;return ng(a)}function Vg(a){Og(Jg,"pending",a)}function Wg(){this.S={}}function Xg(a,b,c){if(b.toLowerCase()in a.S)throw Error("Configuration "+b+" has already been defined.");a.S[b.toLowerCase()]=c}function Yg(a,b,c){if(!(b.toLowerCase()in a.S))throw Error("Configuration "+b+" is not defined.");a.S[b.toLowerCase()]=c}Wg.prototype.get=function(a){if(!(a.toLowerCase()in this.S))throw Error("Configuration "+a+
	" is not defined.");return this.S[a.toLowerCase()]};function Zg(a,b){a=a.get(b);if(!a)throw Error("Configuration "+b+" is required.");return a}function $g(){this.g=void 0;this.a={}}h=$g.prototype;h.set=function(a,b){ah(this,a,b,!1)};h.add=function(a,b){ah(this,a,b,!0)};function ah(a,b,c,d){for(var e=0;e<b.length;e++){var f=b.charAt(e);a.a[f]||(a.a[f]=new $g);a=a.a[f]}if(d&&void 0!==a.g)throw Error('The collection already contains the key "'+b+'"');a.g=c}h.get=function(a){a:{for(var b=this,c=0;c<a.length;c++)if(b=
	b.a[a.charAt(c)],!b){a=void 0;break a}a=b}return a?a.g:void 0};h.ca=function(){var a=[];bh(this,a);return a};function bh(a,b){void 0!==a.g&&b.push(a.g);for(var c in a.a)bh(a.a[c],b)}h.ha=function(){var a=[];ch(this,"",a);return a};function ch(a,b,c){void 0!==a.g&&c.push(b);for(var d in a.a)ch(a.a[d],b+d,c)}h.clear=function(){this.a={};this.g=void 0};function dh(a){var b=eh.g,c={},d=0;void 0!==b.g&&(c[d]=b.g);for(;d<a.length;d++){var e=a.charAt(d);if(!(e in b.a))break;b=b.a[e];void 0!==b.g&&(c[d]=
	b.g)}for(var f in c)if(c.hasOwnProperty(f))return c[f];return[]}function fh(a){for(var b=0;b<gh.length;b++)if(gh[b].c===a)return gh[b];return null}var gh=[{name:"Afghanistan",c:"93-AF-0",b:"93",f:"AF"},{name:"\u00c5land Islands",c:"358-AX-0",b:"358",f:"AX"},{name:"Albania",c:"355-AL-0",b:"355",f:"AL"},{name:"Algeria",c:"213-DZ-0",b:"213",f:"DZ"},{name:"American Samoa",c:"1-AS-0",b:"1",f:"AS"},{name:"Andorra",c:"376-AD-0",b:"376",f:"AD"},{name:"Angola",c:"244-AO-0",b:"244",f:"AO"},{name:"Anguilla",
	c:"1-AI-0",b:"1",f:"AI"},{name:"Antigua and Barbuda",c:"1-AG-0",b:"1",f:"AG"},{name:"Argentina",c:"54-AR-0",b:"54",f:"AR"},{name:"Armenia",c:"374-AM-0",b:"374",f:"AM"},{name:"Aruba",c:"297-AW-0",b:"297",f:"AW"},{name:"Ascension Island",c:"247-AC-0",b:"247",f:"AC"},{name:"Australia",c:"61-AU-0",b:"61",f:"AU"},{name:"Austria",c:"43-AT-0",b:"43",f:"AT"},{name:"Azerbaijan",c:"994-AZ-0",b:"994",f:"AZ"},{name:"Bahamas",c:"1-BS-0",b:"1",f:"BS"},{name:"Bahrain",c:"973-BH-0",b:"973",f:"BH"},{name:"Bangladesh",
	c:"880-BD-0",b:"880",f:"BD"},{name:"Barbados",c:"1-BB-0",b:"1",f:"BB"},{name:"Belarus",c:"375-BY-0",b:"375",f:"BY"},{name:"Belgium",c:"32-BE-0",b:"32",f:"BE"},{name:"Belize",c:"501-BZ-0",b:"501",f:"BZ"},{name:"Benin",c:"229-BJ-0",b:"229",f:"BJ"},{name:"Bermuda",c:"1-BM-0",b:"1",f:"BM"},{name:"Bhutan",c:"975-BT-0",b:"975",f:"BT"},{name:"Bolivia",c:"591-BO-0",b:"591",f:"BO"},{name:"Bosnia and Herzegovina",c:"387-BA-0",b:"387",f:"BA"},{name:"Botswana",c:"267-BW-0",b:"267",f:"BW"},{name:"Brazil",c:"55-BR-0",
	b:"55",f:"BR"},{name:"British Indian Ocean Territory",c:"246-IO-0",b:"246",f:"IO"},{name:"British Virgin Islands",c:"1-VG-0",b:"1",f:"VG"},{name:"Brunei",c:"673-BN-0",b:"673",f:"BN"},{name:"Bulgaria",c:"359-BG-0",b:"359",f:"BG"},{name:"Burkina Faso",c:"226-BF-0",b:"226",f:"BF"},{name:"Burundi",c:"257-BI-0",b:"257",f:"BI"},{name:"Cambodia",c:"855-KH-0",b:"855",f:"KH"},{name:"Cameroon",c:"237-CM-0",b:"237",f:"CM"},{name:"Canada",c:"1-CA-0",b:"1",f:"CA"},{name:"Cape Verde",c:"238-CV-0",b:"238",f:"CV"},
	{name:"Caribbean Netherlands",c:"599-BQ-0",b:"599",f:"BQ"},{name:"Cayman Islands",c:"1-KY-0",b:"1",f:"KY"},{name:"Central African Republic",c:"236-CF-0",b:"236",f:"CF"},{name:"Chad",c:"235-TD-0",b:"235",f:"TD"},{name:"Chile",c:"56-CL-0",b:"56",f:"CL"},{name:"China",c:"86-CN-0",b:"86",f:"CN"},{name:"Christmas Island",c:"61-CX-0",b:"61",f:"CX"},{name:"Cocos [Keeling] Islands",c:"61-CC-0",b:"61",f:"CC"},{name:"Colombia",c:"57-CO-0",b:"57",f:"CO"},{name:"Comoros",c:"269-KM-0",b:"269",f:"KM"},{name:"Democratic Republic Congo",
	c:"243-CD-0",b:"243",f:"CD"},{name:"Republic of Congo",c:"242-CG-0",b:"242",f:"CG"},{name:"Cook Islands",c:"682-CK-0",b:"682",f:"CK"},{name:"Costa Rica",c:"506-CR-0",b:"506",f:"CR"},{name:"C\u00f4te d'Ivoire",c:"225-CI-0",b:"225",f:"CI"},{name:"Croatia",c:"385-HR-0",b:"385",f:"HR"},{name:"Cuba",c:"53-CU-0",b:"53",f:"CU"},{name:"Cura\u00e7ao",c:"599-CW-0",b:"599",f:"CW"},{name:"Cyprus",c:"357-CY-0",b:"357",f:"CY"},{name:"Czech Republic",c:"420-CZ-0",b:"420",f:"CZ"},{name:"Denmark",c:"45-DK-0",b:"45",
	f:"DK"},{name:"Djibouti",c:"253-DJ-0",b:"253",f:"DJ"},{name:"Dominica",c:"1-DM-0",b:"1",f:"DM"},{name:"Dominican Republic",c:"1-DO-0",b:"1",f:"DO"},{name:"East Timor",c:"670-TL-0",b:"670",f:"TL"},{name:"Ecuador",c:"593-EC-0",b:"593",f:"EC"},{name:"Egypt",c:"20-EG-0",b:"20",f:"EG"},{name:"El Salvador",c:"503-SV-0",b:"503",f:"SV"},{name:"Equatorial Guinea",c:"240-GQ-0",b:"240",f:"GQ"},{name:"Eritrea",c:"291-ER-0",b:"291",f:"ER"},{name:"Estonia",c:"372-EE-0",b:"372",f:"EE"},{name:"Ethiopia",c:"251-ET-0",
	b:"251",f:"ET"},{name:"Falkland Islands [Islas Malvinas]",c:"500-FK-0",b:"500",f:"FK"},{name:"Faroe Islands",c:"298-FO-0",b:"298",f:"FO"},{name:"Fiji",c:"679-FJ-0",b:"679",f:"FJ"},{name:"Finland",c:"358-FI-0",b:"358",f:"FI"},{name:"France",c:"33-FR-0",b:"33",f:"FR"},{name:"French Guiana",c:"594-GF-0",b:"594",f:"GF"},{name:"French Polynesia",c:"689-PF-0",b:"689",f:"PF"},{name:"Gabon",c:"241-GA-0",b:"241",f:"GA"},{name:"Gambia",c:"220-GM-0",b:"220",f:"GM"},{name:"Georgia",c:"995-GE-0",b:"995",f:"GE"},
	{name:"Germany",c:"49-DE-0",b:"49",f:"DE"},{name:"Ghana",c:"233-GH-0",b:"233",f:"GH"},{name:"Gibraltar",c:"350-GI-0",b:"350",f:"GI"},{name:"Greece",c:"30-GR-0",b:"30",f:"GR"},{name:"Greenland",c:"299-GL-0",b:"299",f:"GL"},{name:"Grenada",c:"1-GD-0",b:"1",f:"GD"},{name:"Guadeloupe",c:"590-GP-0",b:"590",f:"GP"},{name:"Guam",c:"1-GU-0",b:"1",f:"GU"},{name:"Guatemala",c:"502-GT-0",b:"502",f:"GT"},{name:"Guernsey",c:"44-GG-0",b:"44",f:"GG"},{name:"Guinea Conakry",c:"224-GN-0",b:"224",f:"GN"},{name:"Guinea-Bissau",
	c:"245-GW-0",b:"245",f:"GW"},{name:"Guyana",c:"592-GY-0",b:"592",f:"GY"},{name:"Haiti",c:"509-HT-0",b:"509",f:"HT"},{name:"Heard Island and McDonald Islands",c:"672-HM-0",b:"672",f:"HM"},{name:"Honduras",c:"504-HN-0",b:"504",f:"HN"},{name:"Hong Kong",c:"852-HK-0",b:"852",f:"HK"},{name:"Hungary",c:"36-HU-0",b:"36",f:"HU"},{name:"Iceland",c:"354-IS-0",b:"354",f:"IS"},{name:"India",c:"91-IN-0",b:"91",f:"IN"},{name:"Indonesia",c:"62-ID-0",b:"62",f:"ID"},{name:"Iran",c:"98-IR-0",b:"98",f:"IR"},{name:"Iraq",
	c:"964-IQ-0",b:"964",f:"IQ"},{name:"Ireland",c:"353-IE-0",b:"353",f:"IE"},{name:"Isle of Man",c:"44-IM-0",b:"44",f:"IM"},{name:"Israel",c:"972-IL-0",b:"972",f:"IL"},{name:"Italy",c:"39-IT-0",b:"39",f:"IT"},{name:"Jamaica",c:"1-JM-0",b:"1",f:"JM"},{name:"Japan",c:"81-JP-0",b:"81",f:"JP"},{name:"Jersey",c:"44-JE-0",b:"44",f:"JE"},{name:"Jordan",c:"962-JO-0",b:"962",f:"JO"},{name:"Kazakhstan",c:"7-KZ-0",b:"7",f:"KZ"},{name:"Kenya",c:"254-KE-0",b:"254",f:"KE"},{name:"Kiribati",c:"686-KI-0",b:"686",f:"KI"},
	{name:"Kosovo",c:"377-XK-0",b:"377",f:"XK"},{name:"Kosovo",c:"381-XK-0",b:"381",f:"XK"},{name:"Kosovo",c:"386-XK-0",b:"386",f:"XK"},{name:"Kuwait",c:"965-KW-0",b:"965",f:"KW"},{name:"Kyrgyzstan",c:"996-KG-0",b:"996",f:"KG"},{name:"Laos",c:"856-LA-0",b:"856",f:"LA"},{name:"Latvia",c:"371-LV-0",b:"371",f:"LV"},{name:"Lebanon",c:"961-LB-0",b:"961",f:"LB"},{name:"Lesotho",c:"266-LS-0",b:"266",f:"LS"},{name:"Liberia",c:"231-LR-0",b:"231",f:"LR"},{name:"Libya",c:"218-LY-0",b:"218",f:"LY"},{name:"Liechtenstein",
	c:"423-LI-0",b:"423",f:"LI"},{name:"Lithuania",c:"370-LT-0",b:"370",f:"LT"},{name:"Luxembourg",c:"352-LU-0",b:"352",f:"LU"},{name:"Macau",c:"853-MO-0",b:"853",f:"MO"},{name:"Macedonia",c:"389-MK-0",b:"389",f:"MK"},{name:"Madagascar",c:"261-MG-0",b:"261",f:"MG"},{name:"Malawi",c:"265-MW-0",b:"265",f:"MW"},{name:"Malaysia",c:"60-MY-0",b:"60",f:"MY"},{name:"Maldives",c:"960-MV-0",b:"960",f:"MV"},{name:"Mali",c:"223-ML-0",b:"223",f:"ML"},{name:"Malta",c:"356-MT-0",b:"356",f:"MT"},{name:"Marshall Islands",
	c:"692-MH-0",b:"692",f:"MH"},{name:"Martinique",c:"596-MQ-0",b:"596",f:"MQ"},{name:"Mauritania",c:"222-MR-0",b:"222",f:"MR"},{name:"Mauritius",c:"230-MU-0",b:"230",f:"MU"},{name:"Mayotte",c:"262-YT-0",b:"262",f:"YT"},{name:"Mexico",c:"52-MX-0",b:"52",f:"MX"},{name:"Micronesia",c:"691-FM-0",b:"691",f:"FM"},{name:"Moldova",c:"373-MD-0",b:"373",f:"MD"},{name:"Monaco",c:"377-MC-0",b:"377",f:"MC"},{name:"Mongolia",c:"976-MN-0",b:"976",f:"MN"},{name:"Montenegro",c:"382-ME-0",b:"382",f:"ME"},{name:"Montserrat",
	c:"1-MS-0",b:"1",f:"MS"},{name:"Morocco",c:"212-MA-0",b:"212",f:"MA"},{name:"Mozambique",c:"258-MZ-0",b:"258",f:"MZ"},{name:"Myanmar [Burma]",c:"95-MM-0",b:"95",f:"MM"},{name:"Namibia",c:"264-NA-0",b:"264",f:"NA"},{name:"Nauru",c:"674-NR-0",b:"674",f:"NR"},{name:"Nepal",c:"977-NP-0",b:"977",f:"NP"},{name:"Netherlands",c:"31-NL-0",b:"31",f:"NL"},{name:"New Caledonia",c:"687-NC-0",b:"687",f:"NC"},{name:"New Zealand",c:"64-NZ-0",b:"64",f:"NZ"},{name:"Nicaragua",c:"505-NI-0",b:"505",f:"NI"},{name:"Niger",
	c:"227-NE-0",b:"227",f:"NE"},{name:"Nigeria",c:"234-NG-0",b:"234",f:"NG"},{name:"Niue",c:"683-NU-0",b:"683",f:"NU"},{name:"Norfolk Island",c:"672-NF-0",b:"672",f:"NF"},{name:"North Korea",c:"850-KP-0",b:"850",f:"KP"},{name:"Northern Mariana Islands",c:"1-MP-0",b:"1",f:"MP"},{name:"Norway",c:"47-NO-0",b:"47",f:"NO"},{name:"Oman",c:"968-OM-0",b:"968",f:"OM"},{name:"Pakistan",c:"92-PK-0",b:"92",f:"PK"},{name:"Palau",c:"680-PW-0",b:"680",f:"PW"},{name:"Palestinian Territories",c:"970-PS-0",b:"970",f:"PS"},
	{name:"Panama",c:"507-PA-0",b:"507",f:"PA"},{name:"Papua New Guinea",c:"675-PG-0",b:"675",f:"PG"},{name:"Paraguay",c:"595-PY-0",b:"595",f:"PY"},{name:"Peru",c:"51-PE-0",b:"51",f:"PE"},{name:"Philippines",c:"63-PH-0",b:"63",f:"PH"},{name:"Poland",c:"48-PL-0",b:"48",f:"PL"},{name:"Portugal",c:"351-PT-0",b:"351",f:"PT"},{name:"Puerto Rico",c:"1-PR-0",b:"1",f:"PR"},{name:"Qatar",c:"974-QA-0",b:"974",f:"QA"},{name:"R\u00e9union",c:"262-RE-0",b:"262",f:"RE"},{name:"Romania",c:"40-RO-0",b:"40",f:"RO"},{name:"Russia",
	c:"7-RU-0",b:"7",f:"RU"},{name:"Rwanda",c:"250-RW-0",b:"250",f:"RW"},{name:"Saint Barth\u00e9lemy",c:"590-BL-0",b:"590",f:"BL"},{name:"Saint Helena",c:"290-SH-0",b:"290",f:"SH"},{name:"St. Kitts",c:"1-KN-0",b:"1",f:"KN"},{name:"St. Lucia",c:"1-LC-0",b:"1",f:"LC"},{name:"Saint Martin",c:"590-MF-0",b:"590",f:"MF"},{name:"Saint Pierre and Miquelon",c:"508-PM-0",b:"508",f:"PM"},{name:"St. Vincent",c:"1-VC-0",b:"1",f:"VC"},{name:"Samoa",c:"685-WS-0",b:"685",f:"WS"},{name:"San Marino",c:"378-SM-0",b:"378",
	f:"SM"},{name:"S\u00e3o Tom\u00e9 and Pr\u00edncipe",c:"239-ST-0",b:"239",f:"ST"},{name:"Saudi Arabia",c:"966-SA-0",b:"966",f:"SA"},{name:"Senegal",c:"221-SN-0",b:"221",f:"SN"},{name:"Serbia",c:"381-RS-0",b:"381",f:"RS"},{name:"Seychelles",c:"248-SC-0",b:"248",f:"SC"},{name:"Sierra Leone",c:"232-SL-0",b:"232",f:"SL"},{name:"Singapore",c:"65-SG-0",b:"65",f:"SG"},{name:"Sint Maarten",c:"1-SX-0",b:"1",f:"SX"},{name:"Slovakia",c:"421-SK-0",b:"421",f:"SK"},{name:"Slovenia",c:"386-SI-0",b:"386",f:"SI"},
	{name:"Solomon Islands",c:"677-SB-0",b:"677",f:"SB"},{name:"Somalia",c:"252-SO-0",b:"252",f:"SO"},{name:"South Africa",c:"27-ZA-0",b:"27",f:"ZA"},{name:"South Georgia and the South Sandwich Islands",c:"500-GS-0",b:"500",f:"GS"},{name:"South Korea",c:"82-KR-0",b:"82",f:"KR"},{name:"South Sudan",c:"211-SS-0",b:"211",f:"SS"},{name:"Spain",c:"34-ES-0",b:"34",f:"ES"},{name:"Sri Lanka",c:"94-LK-0",b:"94",f:"LK"},{name:"Sudan",c:"249-SD-0",b:"249",f:"SD"},{name:"Suriname",c:"597-SR-0",b:"597",f:"SR"},{name:"Svalbard and Jan Mayen",
	c:"47-SJ-0",b:"47",f:"SJ"},{name:"Swaziland",c:"268-SZ-0",b:"268",f:"SZ"},{name:"Sweden",c:"46-SE-0",b:"46",f:"SE"},{name:"Switzerland",c:"41-CH-0",b:"41",f:"CH"},{name:"Syria",c:"963-SY-0",b:"963",f:"SY"},{name:"Taiwan",c:"886-TW-0",b:"886",f:"TW"},{name:"Tajikistan",c:"992-TJ-0",b:"992",f:"TJ"},{name:"Tanzania",c:"255-TZ-0",b:"255",f:"TZ"},{name:"Thailand",c:"66-TH-0",b:"66",f:"TH"},{name:"Togo",c:"228-TG-0",b:"228",f:"TG"},{name:"Tokelau",c:"690-TK-0",b:"690",f:"TK"},{name:"Tonga",c:"676-TO-0",
	b:"676",f:"TO"},{name:"Trinidad/Tobago",c:"1-TT-0",b:"1",f:"TT"},{name:"Tunisia",c:"216-TN-0",b:"216",f:"TN"},{name:"Turkey",c:"90-TR-0",b:"90",f:"TR"},{name:"Turkmenistan",c:"993-TM-0",b:"993",f:"TM"},{name:"Turks and Caicos Islands",c:"1-TC-0",b:"1",f:"TC"},{name:"Tuvalu",c:"688-TV-0",b:"688",f:"TV"},{name:"U.S. Virgin Islands",c:"1-VI-0",b:"1",f:"VI"},{name:"Uganda",c:"256-UG-0",b:"256",f:"UG"},{name:"Ukraine",c:"380-UA-0",b:"380",f:"UA"},{name:"United Arab Emirates",c:"971-AE-0",b:"971",f:"AE"},
	{name:"United Kingdom",c:"44-GB-0",b:"44",f:"GB"},{name:"United States",c:"1-US-0",b:"1",f:"US"},{name:"Uruguay",c:"598-UY-0",b:"598",f:"UY"},{name:"Uzbekistan",c:"998-UZ-0",b:"998",f:"UZ"},{name:"Vanuatu",c:"678-VU-0",b:"678",f:"VU"},{name:"Vatican City",c:"379-VA-0",b:"379",f:"VA"},{name:"Venezuela",c:"58-VE-0",b:"58",f:"VE"},{name:"Vietnam",c:"84-VN-0",b:"84",f:"VN"},{name:"Wallis and Futuna",c:"681-WF-0",b:"681",f:"WF"},{name:"Western Sahara",c:"212-EH-0",b:"212",f:"EH"},{name:"Yemen",c:"967-YE-0",
	b:"967",f:"YE"},{name:"Zambia",c:"260-ZM-0",b:"260",f:"ZM"},{name:"Zimbabwe",c:"263-ZW-0",b:"263",f:"ZW"}];(function(a,b){a.sort(function(a,d){return a.name.localeCompare(d.name,b)})})(gh,"en");var eh=new function(){this.a=gh;this.g=new $g;for(var a=0;a<this.a.length;a++){var b=this.g.get("+"+this.a[a].b);b?b.push(this.a[a]):this.g.add("+"+this.a[a].b,[this.a[a]])}};function hh(a,b){this.a=a;this.oa=b}function ih(a){a=Ja(a);var b=dh(a);return 0<b.length?new hh("1"==b[0].b?"1-US-0":b[0].c,Ja(a.substr(b[0].b.length+
	1))):null}function jh(a){var b=fh(a.a);if(!b)throw Error("Country ID "+a.a+" not found.");return"+"+b.b+a.oa}function kh(){this.a=new Wg;Xg(this.a,"acUiConfig");Xg(this.a,"autoUpgradeAnonymousUsers");Xg(this.a,"callbacks");Xg(this.a,"credentialHelper",lh);Xg(this.a,"popupMode",!1);Xg(this.a,"queryParameterForSignInSuccessUrl","signInSuccessUrl");Xg(this.a,"queryParameterForWidgetMode","mode");Xg(this.a,"signInFlow");Xg(this.a,"signInOptions");Xg(this.a,"signInSuccessUrl");Xg(this.a,"siteName");Xg(this.a,
	"tosUrl");Xg(this.a,"widgetUrl")}var lh="accountchooser.com",mh={Db:lh,Fb:"googleyolo",NONE:"none"},nh={Gb:"popup",Ib:"redirect"};function oh(a){return a.a.get("acUiConfig")||null}var ph={Eb:"callback",Hb:"recoverEmail",Jb:"resetPassword",Kb:"select",Lb:"verifyEmail"},qh=["sitekey","tabindex","callback","expired-callback"];function rh(a){var b=a.a.get("widgetUrl")||window.location.href;return sh(a,b)}function sh(a,b){a=th(a);for(var c=b.search(yc),d=0,e,f=[];0<=(e=xc(b,d,a,c));)f.push(b.substring(d,
	e)),d=Math.min(b.indexOf("&",e)+1||c,c);f.push(b.substr(d));b=f.join("").replace(Ac,"$1");c="="+encodeURIComponent("select");(a+=c)?(c=b.indexOf("#"),0>c&&(c=b.length),d=b.indexOf("?"),0>d||d>c?(d=c,e=""):e=b.substring(d+1,c),b=[b.substr(0,d),e,b.substr(c)],c=b[1],b[1]=a?c?c+"&"+a:a:c,a=b[0]+(b[1]?"?"+b[1]:"")+b[2]):a=b;return a}function uh(a){var b=!!a.a.get("autoUpgradeAnonymousUsers");b&&!vh(a)&&ig('Missing "signInFailure" callback: "signInFailure" callback needs to be provided when "autoUpgradeAnonymousUsers" is set to true.');
	return b}function wh(a){a=a.a.get("signInOptions")||[];for(var b=[],c=0;c<a.length;c++){var d=a[c];d=za(d)?d:{provider:d};lg[d.provider]&&b.push(d)}return b}function xh(a,b){a=wh(a);for(var c=0;c<a.length;c++)if(a[c].provider===b)return a[c];return null}function yh(a){return Za(wh(a),function(a){return a.provider})}function zh(a){var b=[],c=[];Wa(wh(a),function(a){a.authMethod&&(b.push(a.authMethod),a.clientId&&c.push({uri:a.authMethod,clientId:a.clientId}))});var d=null;"googleyolo"===Ah(a)&&b.length&&
	(d={supportedIdTokenProviders:c,supportedAuthMethods:b});return d}function Bh(a,b){var c=null;Wa(wh(a),function(a){a.authMethod===b&&(c=a.provider)});return c}function Ch(a){var b=null;Wa(wh(a),function(a){a.provider==firebase.auth.PhoneAuthProvider.PROVIDER_ID&&za(a.recaptchaParameters)&&!va(a.recaptchaParameters)&&(b=mb(a.recaptchaParameters))});if(b){var c=[];Wa(qh,function(a){"undefined"!==typeof b[a]&&(c.push(a),delete b[a])});c.length&&Sf&&Rf('The following provided "recaptchaParameters" keys are not allowed: '+
	c.join(", "))}return b}function Dh(a,b){a=(a=xh(a,b))&&a.scopes;return va(a)?a:[]}function Eh(a,b){a=(a=xh(a,b))&&a.customParameters;return za(a)?(a=mb(a),b===firebase.auth.GoogleAuthProvider.PROVIDER_ID&&delete a.login_hint,a):null}function Fh(a){a=xh(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID);var b=null;a&&m(a.loginHint)&&(b=ih(a.loginHint));return a&&a.defaultNationalNumber||b&&b.oa||null}function Gh(a){var b=(a=xh(a,firebase.auth.PhoneAuthProvider.PROVIDER_ID))&&a.defaultCountry||null,c;if(c=
	b){b=b.toUpperCase();c=[];for(var d=0;d<gh.length;d++)gh[d].f===b&&c.push(gh[d])}b=c;c=null;a&&m(a.loginHint)&&(c=ih(a.loginHint));return b&&b[0]||c&&fh(c.a)||null}function th(a){return Zg(a.a,"queryParameterForWidgetMode")}function Hh(a){return a.a.get("tosUrl")||null}function Ih(a){return(a=xh(a,firebase.auth.EmailAuthProvider.PROVIDER_ID))&&"undefined"!==typeof a.requireDisplayName?!!a.requireDisplayName:!0}function Jh(a){a=a.a.get("signInFlow");for(var b in nh)if(nh[b]==a)return nh[b];return"redirect"}
	function Kh(a){return Lh(a).uiShown||null}function Mh(a){return Lh(a).signInSuccess||null}function Nh(a){return Lh(a).signInSuccessWithAuthResult||null}function vh(a){return Lh(a).signInFailure||null}function Lh(a){return a.a.get("callbacks")||{}}function Ah(a){if("http:"!==(window.location&&window.location.protocol)&&"https:"!==(window.location&&window.location.protocol))return"none";a=a.a.get("credentialHelper");for(var b in mh)if(mh[b]==a)return mh[b];return lh}var Oh=null;function Ph(a){return!(!a||
	-32E3!=a.code||"Service unavailable"!=a.message)}function Qh(a,b,c,d){Oh||(a={callbacks:{empty:a,select:function(a,d){a&&a.account&&b?b(kg(a.account)):c&&c(!Ph(d))},store:a,update:a},language:"en",providers:void 0,ui:d},"undefined"!=typeof accountchooser&&accountchooser.Api&&accountchooser.Api.init?Oh=accountchooser.Api.init(a):(Oh=new Rh(a),Sh()))}function Th(a,b,c){function d(){var a=Qc(c).toString();Oh.select(Za(b||[],function(a){return a.fa()}),{clientCallbackUrl:a})}b&&b.length?d():Oh.checkEmpty(function(b,
	c){b||c?a(!Ph(c)):d()})}function Rh(a){this.a=a;this.a.callbacks=this.a.callbacks||{}}function Sh(){var a=Oh;xa(a.a.callbacks.empty)&&a.a.callbacks.empty()}var Uh={code:-32E3,message:"Service unavailable",data:"Service is unavailable."};h=Rh.prototype;h.store=function(){xa(this.a.callbacks.store)&&this.a.callbacks.store(void 0,Uh)};h.select=function(){xa(this.a.callbacks.select)&&this.a.callbacks.select(void 0,Uh)};h.update=function(){xa(this.a.callbacks.update)&&this.a.callbacks.update(void 0,Uh)};
	h.checkDisabled=function(a){a(!0)};h.checkEmpty=function(a){a(void 0,Uh)};h.checkAccountExist=function(a,b){b(void 0,Uh)};h.checkShouldUpdate=function(a,b){b(void 0,Uh)};var Vh,Wh,Xh,G={};function H(a,b,c,d){G[a].apply(null,Array.prototype.slice.call(arguments,1))}var Yh=/MSIE ([\d.]+).*Windows NT ([\d.]+)/,Zh=/Firefox\/([\d.]+)/,$h=/Opera[ \/]([\d.]+)(.*Version\/([\d.]+))?/,ai=/Chrome\/([\d.]+)/,bi=/((Windows NT ([\d.]+))|(Mac OS X ([\d_]+))).*Version\/([\d.]+).*Safari/,ci=/Mac OS X;.*(?!(Version)).*Safari/,
	di=/Android ([\d.]+).*Safari/,ei=/OS ([\d_]+) like Mac OS X.*Mobile.*Safari/,fi=/Konqueror\/([\d.]+)/,gi=/MSIE ([\d.]+).*Windows Phone OS ([\d.]+)/;function I(a,b){a=a.split(b||".");this.a=[];for(b=0;b<a.length;b++)this.a.push(parseInt(a[b],10))}function hi(a,b){b instanceof I||(b=new I(String(b)));for(var c=Math.max(a.a.length,b.a.length),d=0;d<c;d++){var e=a.a[d],f=b.a[d];if(void 0!==e&&void 0!==f&&e!==f)return e-f;if(void 0===e)return-1;if(void 0===f)return 1}return 0}function K(a,b){return 0<=
	hi(a,b)}function ii(){var a=window.navigator&&window.navigator.userAgent;if(a){var b;if(b=a.match($h)){var c=new I(b[3]||b[1]);return 0<=a.indexOf("Opera Mini")?!1:0<=a.indexOf("Opera Mobi")?0<=a.indexOf("Android")&&K(c,"10.1"):K(c,"8.0")}if(b=a.match(Zh))return K(new I(b[1]),"2.0");if(b=a.match(ai))return K(new I(b[1]),"6.0");if(b=a.match(bi))return c=new I(b[6]),a=b[3]&&new I(b[3]),b=b[5]&&new I(b[5],"_"),(!(!a||!K(a,"6.0"))||!(!b||!K(b,"10.5.6")))&&K(c,"3.0");if(b=a.match(di))return K(new I(b[1]),
	"3.0");if(b=a.match(ei))return K(new I(b[1],"_"),"4.0");if(b=a.match(fi))return K(new I(b[1]),"4.7");if(b=a.match(gi))return c=new I(b[1]),a=new I(b[2]),K(c,"7.0")&&K(a,"7.0");if(b=a.match(Yh))return c=new I(b[1]),a=new I(b[2]),K(c,"7.0")&&K(a,"6.0");if(a.match(ci))return!1}return!0}function ji(a){if(a.classList)return a.classList;a=a.className;return m(a)&&a.match(/\S+/g)||[]}function ki(a,b){return a.classList?a.classList.contains(b):bb(ji(a),b)}function li(a,b){a.classList?a.classList.add(b):ki(a,
	b)||(a.className+=0<a.className.length?" "+b:b)}function mi(a,b){a.classList?a.classList.remove(b):ki(a,b)&&(a.className=Ya(ji(a),function(a){return a!=b}).join(" "))}function L(a){var b=a.type;switch(m(b)&&b.toLowerCase()){case "checkbox":case "radio":return a.checked?a.value:null;case "select-one":return b=a.selectedIndex,0<=b?a.options[b].value:null;case "select-multiple":b=[];for(var c,d=0;c=a.options[d];d++)c.selected&&b.push(c.value);return b.length?b:null;default:return null!=a.value?a.value:
	null}}function ni(a){if(a.altKey&&!a.ctrlKey||a.metaKey||112<=a.keyCode&&123>=a.keyCode)return!1;switch(a.keyCode){case 18:case 20:case 93:case 17:case 40:case 35:case 27:case 36:case 45:case 37:case 224:case 91:case 144:case 12:case 34:case 33:case 19:case 255:case 44:case 39:case 145:case 16:case 38:case 252:case 224:case 92:return!1;case 0:return!wb;default:return 166>a.keyCode||183<a.keyCode}}function oi(a,b,c,d,e,f){if(!(v||ub||w&&Eb("525")))return!0;if(yb&&e)return pi(a);if(e&&!d)return!1;"number"==
	typeof b&&(b=qi(b));e=17==b||18==b||yb&&91==b;if((!c||yb)&&e||yb&&16==b&&(d||f))return!1;if((w||ub)&&d&&c)switch(a){case 220:case 219:case 221:case 192:case 186:case 189:case 187:case 188:case 190:case 191:case 192:case 222:return!1}if(v&&d&&b==a)return!1;switch(a){case 13:return!0;case 27:return!(w||ub)}return pi(a)}function pi(a){if(48<=a&&57>=a||96<=a&&106>=a||65<=a&&90>=a||(w||ub)&&0==a)return!0;switch(a){case 32:case 43:case 63:case 64:case 107:case 109:case 110:case 111:case 186:case 59:case 189:case 187:case 61:case 188:case 190:case 191:case 192:case 222:case 219:case 220:case 221:return!0;
	default:return!1}}function qi(a){if(wb)a=ri(a);else if(yb&&w)switch(a){case 93:a=91}return a}function ri(a){switch(a){case 61:return 187;case 59:return 186;case 173:return 189;case 224:return 91;case 0:return 224;default:return a}}function si(a){C.call(this);this.a=a;be(a,ti,this.g,!1,this);be(a,"click",this.h,!1,this)}t(si,C);var ti=wb?"keypress":"keydown";si.prototype.g=function(a){(13==a.keyCode||w&&3==a.keyCode)&&ui(this,a)};si.prototype.h=function(a){ui(this,a)};function ui(a,b){var c=new vi(b);
	if(oe(a,c)){c=new wi(b);try{oe(a,c)}finally{b.stopPropagation()}}}si.prototype.l=function(){si.m.l.call(this);je(this.a,ti,this.g,!1,this);je(this.a,"click",this.h,!1,this);delete this.a};function wi(a){B.call(this,a.a);this.type="action"}t(wi,B);function vi(a){B.call(this,a.a);this.type="beforeaction"}t(vi,B);function xi(a){C.call(this);this.a=a;a=v?"focusout":"blur";this.g=be(this.a,v?"focusin":"focus",this,!v);this.h=be(this.a,a,this,!v)}t(xi,C);xi.prototype.handleEvent=function(a){var b=new B(a.a);
	b.type="focusin"==a.type||"focus"==a.type?"focusin":"focusout";oe(this,b)};xi.prototype.l=function(){xi.m.l.call(this);ke(this.g);ke(this.h);delete this.a};function yi(a,b){C.call(this);this.g=a||1;this.a=b||l;this.h=n(this.Ab,this);this.j=Fa()}t(yi,C);h=yi.prototype;h.za=!1;h.R=null;h.Ab=function(){if(this.za){var a=Fa()-this.j;0<a&&a<.8*this.g?this.R=this.a.setTimeout(this.h,this.g-a):(this.R&&(this.a.clearTimeout(this.R),this.R=null),oe(this,"tick"),this.za&&(this.R=this.a.setTimeout(this.h,this.g),
	this.j=Fa()))}};h.start=function(){this.za=!0;this.R||(this.R=this.a.setTimeout(this.h,this.g),this.j=Fa())};function zi(a){a.za=!1;a.R&&(a.a.clearTimeout(a.R),a.R=null)}h.l=function(){yi.m.l.call(this);zi(this);delete this.a};function Ai(a,b){if(xa(a))b&&(a=n(a,b));else if(a&&"function"==typeof a.handleEvent)a=n(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(0)?-1:l.setTimeout(a,0)}function Bi(a){Fd.call(this);this.g=a;this.a={}}t(Bi,Fd);var Ci=[];Bi.prototype.$=
	function(a,b,c,d){va(b)||(b&&(Ci[0]=b.toString()),b=Ci);for(var e=0;e<b.length;e++){var f=be(a,b[e],c||this.handleEvent,d||!1,this.g||this);if(!f)break;this.a[f.key]=f}return this};Bi.prototype.La=function(a,b,c,d,e){if(va(b))for(var f=0;f<b.length;f++)this.La(a,b[f],c,d,e);else c=c||this.handleEvent,d=za(d)?!!d.capture:!!d,e=e||this.g||this,c=de(c),d=!!d,b=Rd(a)?Yd(a.A,String(b),c,d,e):a?(a=fe(a))?Yd(a,b,c,d,e):null:null,b&&(ke(b),delete this.a[b.key])};function Di(a){lb(a.a,function(a,c){this.a.hasOwnProperty(c)&&
	ke(a)},a);a.a={}}Bi.prototype.l=function(){Bi.m.l.call(this);Di(this)};Bi.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function Ei(a){C.call(this);this.a=null;this.g=a;a=v||ub||w&&!Eb("531")&&"TEXTAREA"==a.tagName;this.h=new Bi(this);this.h.$(this.g,a?["keydown","paste","cut","drop","input"]:"input",this)}t(Ei,C);Ei.prototype.handleEvent=function(a){if("input"==a.type)v&&Eb(10)&&0==a.keyCode&&0==a.j||(Fi(this),oe(this,Gi(a)));else if("keydown"!=a.type||
	ni(a)){var b="keydown"==a.type?this.g.value:null;v&&229==a.keyCode&&(b=null);var c=Gi(a);Fi(this);this.a=Ai(function(){this.a=null;this.g.value!=b&&oe(this,c)},this)}};function Fi(a){null!=a.a&&(l.clearTimeout(a.a),a.a=null)}function Gi(a){a=new B(a.a);a.type="input";return a}Ei.prototype.l=function(){Ei.m.l.call(this);this.h.s();Fi(this);delete this.g};function Hi(a,b){C.call(this);a&&(this.Da&&Ii(this),this.ja=a,this.Ca=be(this.ja,"keypress",this,b),this.Ja=be(this.ja,"keydown",this.jb,b,this),
	this.Da=be(this.ja,"keyup",this.lb,b,this))}t(Hi,C);h=Hi.prototype;h.ja=null;h.Ca=null;h.Ja=null;h.Da=null;h.O=-1;h.Z=-1;h.Ha=!1;var Ji={3:13,12:144,63232:38,63233:40,63234:37,63235:39,63236:112,63237:113,63238:114,63239:115,63240:116,63241:117,63242:118,63243:119,63244:120,63245:121,63246:122,63247:123,63248:44,63272:46,63273:36,63275:35,63276:33,63277:34,63289:144,63302:45},Ki={Up:38,Down:40,Left:37,Right:39,Enter:13,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,
	F12:123,"U+007F":46,Home:36,End:35,PageUp:33,PageDown:34,Insert:45},Li=v||ub||w&&Eb("525"),Mi=yb&&wb;h=Hi.prototype;h.jb=function(a){if(w||ub)if(17==this.O&&!a.ctrlKey||18==this.O&&!a.altKey||yb&&91==this.O&&!a.metaKey)this.Z=this.O=-1;-1==this.O&&(a.ctrlKey&&17!=a.keyCode?this.O=17:a.altKey&&18!=a.keyCode?this.O=18:a.metaKey&&91!=a.keyCode&&(this.O=91));Li&&!oi(a.keyCode,this.O,a.shiftKey,a.ctrlKey,a.altKey,a.metaKey)?this.handleEvent(a):(this.Z=qi(a.keyCode),Mi&&(this.Ha=a.altKey))};h.lb=function(a){this.Z=
	this.O=-1;this.Ha=a.altKey};h.handleEvent=function(a){var b=a.a,c=b.altKey;if(v&&"keypress"==a.type){var d=this.Z;var e=13!=d&&27!=d?b.keyCode:0}else(w||ub)&&"keypress"==a.type?(d=this.Z,e=0<=b.charCode&&63232>b.charCode&&pi(d)?b.charCode:0):tb&&!w?(d=this.Z,e=pi(d)?b.keyCode:0):(d=b.keyCode||this.Z,e=b.charCode||0,Mi&&(c=this.Ha),yb&&63==e&&224==d&&(d=191));var f=d=qi(d);d?63232<=d&&d in Ji?f=Ji[d]:25==d&&a.shiftKey&&(f=9):b.keyIdentifier&&b.keyIdentifier in Ki&&(f=Ki[b.keyIdentifier]);a=f==this.O;
	this.O=f;b=new Ni(f,e,a,b);b.altKey=c;oe(this,b)};h.K=function(){return this.ja};function Ii(a){a.Ca&&(ke(a.Ca),ke(a.Ja),ke(a.Da),a.Ca=null,a.Ja=null,a.Da=null);a.ja=null;a.O=-1;a.Z=-1}h.l=function(){Hi.m.l.call(this);Ii(this)};function Ni(a,b,c,d){B.call(this,d);this.type="key";this.keyCode=a;this.j=b;this.repeat=c}t(Ni,B);function Oi(a,b,c,d){this.top=a;this.right=b;this.bottom=c;this.left=d}Oi.prototype.toString=function(){return"("+this.top+"t, "+this.right+"r, "+this.bottom+"b, "+this.left+"l)"};
	Oi.prototype.ceil=function(){this.top=Math.ceil(this.top);this.right=Math.ceil(this.right);this.bottom=Math.ceil(this.bottom);this.left=Math.ceil(this.left);return this};Oi.prototype.floor=function(){this.top=Math.floor(this.top);this.right=Math.floor(this.right);this.bottom=Math.floor(this.bottom);this.left=Math.floor(this.left);return this};Oi.prototype.round=function(){this.top=Math.round(this.top);this.right=Math.round(this.right);this.bottom=Math.round(this.bottom);this.left=Math.round(this.left);
	return this};function Pi(a,b){var c=cc(a);return c.defaultView&&c.defaultView.getComputedStyle&&(a=c.defaultView.getComputedStyle(a,null))?a[b]||a.getPropertyValue(b)||"":""}function Qi(a){try{var b=a.getBoundingClientRect()}catch(c){return{left:0,top:0,right:0,bottom:0}}v&&a.ownerDocument.body&&(a=a.ownerDocument,b.left-=a.documentElement.clientLeft+a.body.clientLeft,b.top-=a.documentElement.clientTop+a.body.clientTop);return b}function Ri(a,b){b=b||ic(document);var c=b||ic(document);var d=Si(a),
	e=Si(c);if(!v||9<=Number(Fb)){g=Pi(c,"borderLeftWidth");var f=Pi(c,"borderRightWidth");k=Pi(c,"borderTopWidth");q=Pi(c,"borderBottomWidth");f=new Oi(parseFloat(k),parseFloat(f),parseFloat(q),parseFloat(g))}else{var g=Ti(c,"borderLeft");f=Ti(c,"borderRight");var k=Ti(c,"borderTop"),q=Ti(c,"borderBottom");f=new Oi(k,f,q,g)}c==ic(document)?(g=d.a-c.scrollLeft,d=d.g-c.scrollTop,!v||10<=Number(Fb)||(g+=f.left,d+=f.top)):(g=d.a-e.a-f.left,d=d.g-e.g-f.top);e=a.offsetWidth;f=a.offsetHeight;k=w&&!e&&!f;qa(e)&&
	!k||!a.getBoundingClientRect?a=new $b(e,f):(a=Qi(a),a=new $b(a.right-a.left,a.bottom-a.top));e=c.clientHeight-a.height;f=c.scrollLeft;k=c.scrollTop;f+=Math.min(g,Math.max(g-(c.clientWidth-a.width),0));k+=Math.min(d,Math.max(d-e,0));c=new Zb(f,k);b.scrollLeft=c.a;b.scrollTop=c.g}function Si(a){var b=cc(a),c=new Zb(0,0);var d=b?cc(b):document;d=!v||9<=Number(Fb)||"CSS1Compat"==ac(d).a.compatMode?d.documentElement:d.body;if(a==d)return c;a=Qi(a);d=ac(b).a;b=ic(d);d=d.parentWindow||d.defaultView;b=v&&
	Eb("10")&&d.pageYOffset!=b.scrollTop?new Zb(b.scrollLeft,b.scrollTop):new Zb(d.pageXOffset||b.scrollLeft,d.pageYOffset||b.scrollTop);c.a=a.left+b.a;c.g=a.top+b.g;return c}var Ui={thin:2,medium:4,thick:6};function Ti(a,b){if("none"==(a.currentStyle?a.currentStyle[b+"Style"]:null))return 0;var c=a.currentStyle?a.currentStyle[b+"Width"]:null;if(c in Ui)a=Ui[c];else if(/^\d+px?$/.test(c))a=parseInt(c,10);else{b=a.style.left;var d=a.runtimeStyle.left;a.runtimeStyle.left=a.currentStyle.left;a.style.left=
	c;c=a.style.pixelLeft;a.style.left=b;a.runtimeStyle.left=d;a=+c}return a}function Vi(){}sa(Vi);Vi.prototype.a=0;function Wi(a){C.call(this);this.v=a||ac();this.Na=null;this.da=!1;this.h=null;this.D=void 0;this.ga=this.ra=this.U=null}t(Wi,C);h=Wi.prototype;h.mb=Vi.Ia();h.K=function(){return this.h};function M(a,b){return a.h?fc(b,a.h||a.v.a):null}function Xi(a){a.D||(a.D=new Bi(a));return a.D}h.Ka=function(a){if(this.U&&this.U!=a)throw Error("Method not supported");Wi.m.Ka.call(this,a)};h.Ua=function(){this.h=
	this.v.a.createElement("DIV")};h.render=function(a){if(this.da)throw Error("Component already rendered");this.h||this.Ua();a?a.insertBefore(this.h,null):this.v.a.body.appendChild(this.h);this.U&&!this.U.da||this.w()};h.w=function(){this.da=!0;Yi(this,function(a){!a.da&&a.K()&&a.w()})};h.ma=function(){Yi(this,function(a){a.da&&a.ma()});this.D&&Di(this.D);this.da=!1};h.l=function(){this.da&&this.ma();this.D&&(this.D.s(),delete this.D);Yi(this,function(a){a.s()});this.h&&jc(this.h);this.U=this.h=this.ga=
	this.ra=null;Wi.m.l.call(this)};function Yi(a,b){a.ra&&Wa(a.ra,b,void 0)}h.removeChild=function(a,b){if(a){var c=m(a)?a:a.Na||(a.Na=":"+(a.mb.a++).toString(36));this.ga&&c?(a=this.ga,a=(null!==a&&c in a?a[c]:void 0)||null):a=null;if(c&&a){var d=this.ga;c in d&&delete d[c];cb(this.ra,a);b&&(a.ma(),a.h&&jc(a.h));b=a;if(null==b)throw Error("Unable to set parent component");b.U=null;Wi.m.Ka.call(b,null)}}if(!a)throw Error("Child is not in parent component");return a};function N(a,b){var c=lc(a,"firebaseui-textfield");
	b?(mi(a,"firebaseui-input-invalid"),li(a,"firebaseui-input"),c&&mi(c,"firebaseui-textfield-invalid")):(mi(a,"firebaseui-input"),li(a,"firebaseui-input-invalid"),c&&li(c,"firebaseui-textfield-invalid"))}function Zi(a,b,c){b=new Ei(b);Id(a,Ea(Jd,b));Xi(a).$(b,"input",c)}function $i(a,b,c){b=new Hi(b);Id(a,Ea(Jd,b));Xi(a).$(b,"key",function(a){13==a.keyCode&&(a.stopPropagation(),a.preventDefault(),c(a))})}function aj(a,b,c){b=new xi(b);Id(a,Ea(Jd,b));Xi(a).$(b,"focusin",c)}function bj(a,b,c){b=new xi(b);
	Id(a,Ea(Jd,b));Xi(a).$(b,"focusout",c)}function cj(a,b,c){b=new si(b);Id(a,Ea(Jd,b));Xi(a).$(b,"action",function(a){a.stopPropagation();a.preventDefault();c(a)})}function dj(a){li(a,"firebaseui-hidden")}function O(a,b){b&&kc(a,b);mi(a,"firebaseui-hidden")}function ej(a){return!ki(a,"firebaseui-hidden")&&"none"!=a.style.display}function fj(a){a=a||{};var b=a.email,c=a.disabled,d='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="email">';
	d=a.Ob?d+"Enter new email address":d+"Email";d+='</label><input type="email" name="email" autocomplete="username" class="mdl-textfield__input firebaseui-input firebaseui-id-email" value="'+od(null!=b?b:"")+'"'+(c?"disabled":"")+'></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-email-error"></p></div>';return z(d)}function gj(a){a=a||{};a=a.label;var b='<button type="submit" class="firebaseui-id-submit firebaseui-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored">';
	b=a?b+y(a):b+"Next";return z(b+"</button>")}function hj(){var a=""+gj({label:md("Sign In")});return z(a)}function ij(){var a=""+gj({label:md("Save")});return z(a)}function jj(){var a=""+gj({label:md("Continue")});return z(a)}function kj(a){a=a||{};a=a.label;var b='<div class="firebaseui-new-password-component"><div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="newPassword">';b=a?b+y(a):b+"Choose password";
	return z(b+'</label><input type="password" name="newPassword" autocomplete="new-password" class="mdl-textfield__input firebaseui-input firebaseui-id-new-password"></div><a href="javascript:void(0)" class="firebaseui-input-floating-button firebaseui-id-password-toggle firebaseui-input-toggle-on firebaseui-input-toggle-blur"></a><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-new-password-error"></p></div></div>')}function lj(){var a=
	{};var b='<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="password">';b=a.current?b+"Current password":b+"Password";return z(b+'</label><input type="password" name="password" autocomplete="current-password" class="mdl-textfield__input firebaseui-input firebaseui-id-password"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-password-error"></p></div>')}
	function mj(){return z('<a class="firebaseui-link firebaseui-id-secondary-link" href="javascript:void(0)">Trouble signing in?</a>')}function nj(){return z('<button class="firebaseui-id-secondary-link firebaseui-button mdl-button mdl-js-button mdl-button--primary">Cancel</button>')}function oj(a){a=""+('<div class="firebaseui-info-bar firebaseui-id-info-bar"><p class="firebaseui-info-bar-message">'+y(a.message)+'&nbsp;&nbsp;<a href="javascript:void(0)" class="firebaseui-link firebaseui-id-dismiss-info-bar">Dismiss</a></p></div>');
	return z(a)}oj.a="firebaseui.auth.soy2.element.infoBar";function pj(a){var b=a.content;a=a.$a;return z('<dialog class="mdl-dialog firebaseui-dialog firebaseui-id-dialog'+(a?" "+od(a):"")+'">'+y(b)+"</dialog>")}function qj(a){var b=a.message;return z(pj({content:nd('<div class="firebaseui-dialog-icon-wrapper"><div class="'+od(a.Ba)+' firebaseui-dialog-icon"></div></div><div class="firebaseui-progress-dialog-message">'+y(b)+"</div>")}))}qj.a="firebaseui.auth.soy2.element.progressDialog";function rj(a){var b=
	'<div class="firebaseui-list-box-actions">';a=a.items;for(var c=a.length,d=0;d<c;d++){var e=a[d];b+='<button type="button" data-listboxid="'+od(e.id)+'" class="mdl-button firebaseui-id-list-box-dialog-button firebaseui-list-box-dialog-button">'+(e.Ba?'<div class="firebaseui-list-box-icon-wrapper"><div class="firebaseui-list-box-icon '+od(e.Ba)+'"></div></div>':"")+'<div class="firebaseui-list-box-label-wrapper">'+y(e.label)+"</div></button>"}b=""+pj({$a:md("firebaseui-list-box-dialog"),content:nd(b+
	"</div>")});return z(b)}rj.a="firebaseui.auth.soy2.element.listBoxDialog";function sj(){return z('<div class="mdl-progress mdl-js-progress mdl-progress__indeterminate firebaseui-busy-indicator firebaseui-id-busy-indicator"></div>')}sj.a="firebaseui.auth.soy2.element.busyIndicator";function tj(a){a=a||{};var b="";switch(a.providerId){case "google.com":b+="Google";break;case "github.com":b+="Github";break;case "facebook.com":b+="Facebook";break;case "twitter.com":b+="Twitter";break;default:b+="Password"}return A(b)}
	function uj(a){vj(a,"upgradeElement")}function wj(a){vj(a,"downgradeElements")}var xj=["mdl-js-textfield","mdl-js-progress","mdl-js-spinner","mdl-js-button"];function vj(a,b){a&&window.componentHandler&&window.componentHandler[b]&&Wa(xj,function(c){if(ki(a,c))window.componentHandler[b](a);Wa(dc(c,a),function(a){window.componentHandler[b](a)})})}function yj(a,b,c){zj.call(this);document.body.appendChild(a);a.showModal||window.dialogPolyfill.registerDialog(a);a.showModal();uj(a);b&&cj(this,a,function(b){var c=
	a.getBoundingClientRect();(b.clientX<c.left||c.left+c.width<b.clientX||b.clientY<c.top||c.top+c.height<b.clientY)&&zj.call(this)});if(!c){var d=this.K().parentElement||this.K().parentNode;if(d){var e=this;this.V=function(){if(a.open){var b=a.getBoundingClientRect().height,c=d.getBoundingClientRect().height,k=d.getBoundingClientRect().top-document.body.getBoundingClientRect().top,q=d.getBoundingClientRect().left-document.body.getBoundingClientRect().left,J=a.getBoundingClientRect().width,ya=d.getBoundingClientRect().width;
	a.style.top=(k+(c-b)/2).toString()+"px";b=q+(ya-J)/2;a.style.left=b.toString()+"px";a.style.right=(document.body.getBoundingClientRect().width-b-J).toString()+"px"}else window.removeEventListener("resize",e.V)};this.V();window.addEventListener("resize",this.V,!1)}}}function zj(){var a=Aj.call(this);a&&(wj(a),a.open&&a.close(),jc(a),this.V&&window.removeEventListener("resize",this.V))}function Aj(){return fc("firebaseui-id-dialog")}function Bj(){jc(Dj.call(this))}function Dj(){return M(this,"firebaseui-id-info-bar")}
	function Ej(){return M(this,"firebaseui-id-dismiss-info-bar")}var Fj={kb:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",ib:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/github.svg",gb:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg",Bb:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/twitter.svg",ob:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg",qb:"https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/phone.svg"};
	function Gj(a,b,c){Od.call(this,a,b);for(var d in c)this[d]=c[d]}t(Gj,Od);function P(a,b,c,d){Wi.call(this,c);this.Qa=a;this.Pa=b;this.sa=!1;this.Oa=d||null;this.u=this.W=null}t(P,Wi);P.prototype.Ua=function(){var a=Zc(this.Qa,this.Pa,Fj,this.v);uj(a);this.h=a};P.prototype.w=function(){P.m.w.call(this);se(Q(this),new Gj("pageEnter",Q(this),{pageId:this.Oa}))};P.prototype.ma=function(){se(Q(this),new Gj("pageExit",Q(this),{pageId:this.Oa}));P.m.ma.call(this)};P.prototype.l=function(){window.clearTimeout(this.W);
	this.Pa=this.Qa=this.W=null;this.sa=!1;this.u=null;wj(this.K());P.m.l.call(this)};function Hj(a){a.sa=!0;a.W=window.setTimeout(function(){a.K()&&null===a.u&&(a.u=Zc(sj,null,null,a.v),a.K().appendChild(a.u),uj(a.u))},500)}function Ij(a,b,c,d,e){function f(){if(a.J)return null;a.sa=!1;window.clearTimeout(a.W);a.W=null;a.u&&(wj(a.u),jc(a.u),a.u=null)}if(a.sa)return null;Hj(a);return b.apply(null,c).then(d,e).then(f,f)}function Q(a){return a.K().parentElement||a.K().parentNode}function Jj(a,b,c){$i(a,
	b,function(){c.focus()})}function Kj(a,b,c){$i(a,b,function(){c()})}p(P.prototype,{g:function(a){Bj.call(this);var b=Zc(oj,{message:a},null,this.v);this.K().appendChild(b);cj(this,Ej.call(this),function(){jc(b)})},Nb:Bj,Tb:Dj,Sb:Ej,ua:function(a,b){a=Zc(qj,{Ba:a,message:b},null,this.v);yj.call(this,a)},j:zj,Rb:Aj});function Lj(a){a=a||{};var b=a.bb;a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in with email</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+
	fj(a)+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?nj():"")+gj(null)+"</div></div></form></div>");return z(a)}Lj.a="firebaseui.auth.soy2.page.signIn";function Mj(a){a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-in"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content">'+fj(a)+lj()+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+
	mj()+'</div><div class="firebaseui-form-actions">'+hj()+"</div></div></form></div>");return z(a)}Mj.a="firebaseui.auth.soy2.page.passwordSignIn";function Nj(a){a=a||{};var b=a.sb,c=a.qa,d=a.Ga,e='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-sign-up"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Create account</h1></div><div class="firebaseui-card-content">'+fj(a);b?(b=a||{},b=b.name,b=""+('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="name">First &amp; last name</label><input type="text" name="name" autocomplete="name" class="mdl-textfield__input firebaseui-input firebaseui-id-name" value="'+
	od(null!=b?b:"")+'"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-name-error"></p></div>'),b=z(b)):b="";e=e+b+kj(null);c?(a=a||{},a="By tapping SAVE, you are indicating that you agree to the "+('<a href="'+od(td(a.qa))+'" class="firebaseui-link" target="_blank">Terms of Service</a>'),a=z(""+('<p class="firebaseui-tos">'+a+"</p>"))):a="";d=""+(e+a+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	(d?nj():"")+ij()+"</div></div></form></div>");return z(d)}Nj.a="firebaseui.auth.soy2.page.passwordSignUp";function Oj(a){a=a||{};var b=a.Ga;a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Recover password</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Get instructions sent to this email that explain how to reset your password</p>'+
	fj(a)+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+(b?nj():"")+gj({label:md("Send")})+"</div></div></form></div>");return z(a)}Oj.a="firebaseui.auth.soy2.page.passwordRecovery";function Pj(a){var b=a.N,c="";a="Follow the instructions sent to <strong>"+(y(a.email)+"</strong> to recover your password");c+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-recovery-email-sent"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Check your email</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p></div><div class="firebaseui-card-actions">';b&&(c+='<div class="firebaseui-form-actions">'+gj({label:md("Done")})+"</div>");return z(c+"</div></div>")}Pj.a="firebaseui.auth.soy2.page.passwordRecoveryEmailSent";function Qj(a,b,c){return z('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-callback"><div class="firebaseui-callback-indicator-container">'+sj(null,null,c)+"</div></div>")}Qj.a="firebaseui.auth.soy2.page.callback";function Rj(a){var b="";a="You\u2019ve already used <strong>"+
	(y(a.email)+"</strong> to sign in. Enter your password for that account.");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">'+a+"</p>"+lj()+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-links">'+
	mj()+'</div><div class="firebaseui-form-actions">'+hj()+"</div></div></form></div>";return z(b)}Rj.a="firebaseui.auth.soy2.page.passwordLinking";function Sj(a){var b=a.email,c="";a=""+tj(a);a=md(a);b="You\u2019ve already used <strong>"+(y(b)+("</strong>. Sign in with "+(y(a)+" to continue.")));c+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-federated-linking"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">You already have an account</h2><p class="firebaseui-text">'+
	b+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+gj({label:md("Sign in with "+a)})+"</div></div></form></div>";return z(c)}Sj.a="firebaseui.auth.soy2.page.federatedLinking";function Tj(a){var b="",c='<p class="firebaseui-text">for <strong>'+(y(a.email)+"</strong></p>");b+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Reset your password</h1></div><div class="firebaseui-card-content">'+
	c+kj(ld(a))+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+ij()+"</div></div></form></div>";return z(b)}Tj.a="firebaseui.auth.soy2.page.passwordReset";function Uj(a){a=a||{};a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Password changed</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new password</p></div><div class="firebaseui-card-actions">'+
	(a.N?'<div class="firebaseui-form-actions">'+jj()+"</div>":"")+"</div></div>");return z(a)}Uj.a="firebaseui.auth.soy2.page.passwordResetSuccess";function Vj(a){a=a||{};a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-password-reset-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try resetting your password again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to reset your password has expired or the link has already been used</p></div><div class="firebaseui-card-actions">'+
	(a.N?'<div class="firebaseui-form-actions">'+gj(null)+"</div>":"")+"</div></div>");return z(a)}Vj.a="firebaseui.auth.soy2.page.passwordResetFailure";function Wj(a){var b=a.N,c="";a="Your sign-in email address has been changed back to <strong>"+(y(a.email)+"</strong>.");c+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-success"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Updated email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+
	a+'</p><p class="firebaseui-text">If you didn\u2019t ask to change your sign-in email, it\u2019s possible someone is trying to access your account and you should <a class="firebaseui-link firebaseui-id-reset-password-link" href="javascript:void(0)">change your password right away</a>.</p></div><div class="firebaseui-card-actions">'+(b?'<div class="firebaseui-form-actions">'+gj(null)+"</div>":"")+"</div></form></div>";return z(c)}Wj.a="firebaseui.auth.soy2.page.emailChangeRevokeSuccess";function Xj(a){a=
	a||{};a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-change-revoke-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Unable to update your email address</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">There was a problem changing your sign-in email back.</p><p class="firebaseui-text">If you try again and still can\u2019t reset your email, try asking your administrator for help.</p></div><div class="firebaseui-card-actions">'+
	(a.N?'<div class="firebaseui-form-actions">'+gj(null)+"</div>":"")+"</div></div>");return z(a)}Xj.a="firebaseui.auth.soy2.page.emailChangeRevokeFailure";function Yj(a){a=a||{};a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Your email has been verified</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">You can now sign in with your new account</p></div><div class="firebaseui-card-actions">'+
	(a.N?'<div class="firebaseui-form-actions">'+jj()+"</div>":"")+"</div></div>");return z(a)}Yj.a="firebaseui.auth.soy2.page.emailVerificationSuccess";function Zj(a){a=a||{};a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-failure"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Try verifying your email again</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">Your request to verify your email has expired or the link has already been used</p></div><div class="firebaseui-card-actions">'+
	(a.N?'<div class="firebaseui-form-actions">'+gj(null)+"</div>":"")+"</div></div>");return z(a)}Zj.a="firebaseui.auth.soy2.page.emailVerificationFailure";function ak(a){a=""+('<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-unrecoverable-error"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Error encountered</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+y(a.fb)+"</p></div></div>");return z(a)}ak.a="firebaseui.auth.soy2.page.unrecoverableError";
	function bk(a){var b=a.pb,c="";a="Continue with "+(y(a.Cb)+"?");b="You originally wanted to sign in with "+y(b);c+='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-mismatch"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Sign in</h1></div><div class="firebaseui-card-content"><h2 class="firebaseui-subtitle">'+a+'</h2><p class="firebaseui-text">'+b+'</p></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+
	nj()+gj({label:md("Continue")})+"</div></div></form></div>";return z(c)}bk.a="firebaseui.auth.soy2.page.emailMismatch";function ck(a,b,c){var d='<div class="firebaseui-container firebaseui-page-provider-sign-in firebaseui-id-page-provider-sign-in"><div class="firebaseui-card-content"><form onsubmit="return false;"><ul class="firebaseui-idp-list">';a=a.rb;b=a.length;for(var e=0;e<b;e++){var f={providerId:a[e]};var g=c,k=f.providerId,q=f;q=q||{};var J="";switch(q.providerId){case "google.com":J+="firebaseui-idp-google";
	break;case "github.com":J+="firebaseui-idp-github";break;case "facebook.com":J+="firebaseui-idp-facebook";break;case "twitter.com":J+="firebaseui-idp-twitter";break;case "phone":J+="firebaseui-idp-phone";break;default:J+="firebaseui-idp-password"}q='<button class="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised '+od(A(J))+' firebaseui-id-idp-button" data-provider-id="'+od(k)+'"><span class="firebaseui-idp-icon-wrapper"><img class="firebaseui-idp-icon" alt="" src="';J=(J=f)||{};var ya=
	"";switch(J.providerId){case "google.com":ya+=td(g.kb);break;case "github.com":ya+=td(g.ib);break;case "facebook.com":ya+=td(g.gb);break;case "twitter.com":ya+=td(g.Bb);break;case "phone":ya+=td(g.qb);break;default:ya+=td(g.ob)}g=kd(ya);q=q+od(td(g))+'"></span>';"password"==k?q+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Email</span>':"phone"==k?q+='<span class="firebaseui-idp-text firebaseui-idp-text-long">Sign in with phone</span><span class="firebaseui-idp-text firebaseui-idp-text-short">Phone</span>':
	(k="Sign in with "+y(tj(f)),q+='<span class="firebaseui-idp-text firebaseui-idp-text-long">'+k+'</span><span class="firebaseui-idp-text firebaseui-idp-text-short">'+y(tj(f))+"</span>");f=z(q+"</button>");d+='<li class="firebaseui-list-item">'+f+"</li>"}return z(d+"</ul></form></div></div>")}ck.a="firebaseui.auth.soy2.page.providerSignIn";function dk(a){a=a||{};var b=a.eb;a=a||{};a=a.oa;a=""+('<div class="firebaseui-phone-number"><button class="firebaseui-id-country-selector firebaseui-country-selector mdl-button mdl-js-button"><span class="firebaseui-flag firebaseui-country-selector-flag firebaseui-id-country-selector-flag"></span><span class="firebaseui-id-country-selector-code"></span></button><div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label firebaseui-textfield firebaseui-phone-input-wrapper"><label class="mdl-textfield__label firebaseui-label" for="phoneNumber">Phone number</label><input type="tel" name="phoneNumber" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-number" value="'+
	od(null!=a?a:"")+'"></div></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-phone-number-error firebaseui-id-phone-number-error"></p></div>');a='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-start"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Enter your phone number</h1></div><div class="firebaseui-card-content"><div class="firebaseui-relative-wrapper">'+
	z(a);b=b?z('<div class="firebaseui-recaptcha-wrapper"><div class="firebaseui-recaptcha-container"></div><div class="firebaseui-error-wrapper firebaseui-recaptcha-error-wrapper"><p class="firebaseui-error firebaseui-hidden firebaseui-id-recaptcha-error"></p></div></div>'):"";b=a+b+'</div></div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+nj()+gj({label:md("Verify")})+'</div></div><div class="firebaseui-card-footer">';a=z('<p class="firebaseui-tos">By tapping Verify, an SMS may be sent. Message &amp; data rates may apply.</p>');
	return z(""+(b+a+"</div></form></div>"))}dk.a="firebaseui.auth.soy2.page.phoneSignInStart";function ek(a){a=a||{};var b=a.phoneNumber,c=a.qa,d="",e='Enter the 6-digit code we sent to <a class="firebaseui-link firebaseui-change-phone-number-link firebaseui-id-change-phone-number-link" href="javascript:void(0)">&lrm;'+(y(b)+"</a>");y(b);b=d;d=z('<div class="firebaseui-textfield mdl-textfield mdl-js-textfield mdl-textfield--floating-label"><label class="mdl-textfield__label firebaseui-label" for="phoneConfirmationCode">6-digit code</label><input type="number" name="phoneConfirmationCode" class="mdl-textfield__input firebaseui-input firebaseui-id-phone-confirmation-code"></div><div class="firebaseui-error-wrapper"><p class="firebaseui-error firebaseui-text-input-error firebaseui-hidden firebaseui-id-phone-confirmation-code-error"></p></div>');
	e='<div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-phone-sign-in-finish"><form onsubmit="return false;"><div class="firebaseui-card-header"><h1 class="firebaseui-title">Verify your phone number</h1></div><div class="firebaseui-card-content"><p class="firebaseui-text">'+e+"</p>"+d+'</div><div class="firebaseui-card-actions"><div class="firebaseui-form-actions">'+nj()+gj({label:md("Continue")})+"</div></div>";c?(a=a||{},a="By tapping Continue you are indicating that you agree to the "+
	('<a href="'+od(td(a.qa))+'" class="firebaseui-link" target="_blank">Terms of Service</a>'),a='<div class="firebaseui-card-footer">'+z(""+('<p class="firebaseui-tos">'+a+"</p>"))+"</div>"):a="";a=e+a+"</form>";c=z('<div class="firebaseui-resend-container"><span class="firebaseui-id-resend-countdown"></span><a href="javascript:void(0)" class="firebaseui-id-resend-link firebaseui-hidden firebaseui-link">Resend</a></div>');return z(b+(a+c+"</div>"))}ek.a="firebaseui.auth.soy2.page.phoneSignInFinish";
	function fk(){return M(this,"firebaseui-id-submit")}function gk(){return M(this,"firebaseui-id-secondary-link")}function hk(a,b){cj(this,fk.call(this),function(b){a(b)});var c=gk.call(this);c&&b&&cj(this,c,function(a){b(a)})}function ik(){return M(this,"firebaseui-id-password")}function jk(){return M(this,"firebaseui-id-password-error")}function kk(){var a=ik.call(this),b=jk.call(this);Zi(this,a,function(){ej(b)&&(N(a,!0),dj(b))})}function lk(){var a=ik.call(this);var b=jk.call(this);L(a)?(N(a,!0),
	dj(b),b=!0):(N(a,!1),O(b,A("Enter your password").toString()),b=!1);return b?L(a):null}function mk(a,b,c,d){P.call(this,Rj,{email:a},d,"passwordLinking");this.a=b;this.I=c}t(mk,P);mk.prototype.w=function(){this.M();this.L(this.a,this.I);Kj(this,this.i(),this.a);this.i().focus();mk.m.w.call(this)};mk.prototype.l=function(){this.a=null;mk.m.l.call(this)};mk.prototype.G=function(){return L(M(this,"firebaseui-id-email"))};p(mk.prototype,{i:ik,C:jk,M:kk,B:lk,aa:fk,X:gk,L:hk});var nk=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;
	function ok(){return M(this,"firebaseui-id-email")}function pk(){return M(this,"firebaseui-id-email-error")}function qk(a){var b=ok.call(this),c=pk.call(this);Zi(this,b,function(){ej(c)&&(N(b,!0),dj(c))});a&&$i(this,b,function(){a()})}function rk(){return Ja(L(ok.call(this))||"")}function sk(){var a=ok.call(this);var b=pk.call(this);var c=L(a)||"";c?nk.test(c)?(N(a,!0),dj(b),b=!0):(N(a,!1),O(b,A("That email address isn't correct").toString()),b=!1):(N(a,!1),O(b,A("Enter your email address to continue").toString()),
	b=!1);return b?Ja(L(a)):null}function tk(a,b,c,d){P.call(this,Mj,{email:c},d,"passwordSignIn");this.a=a;this.I=b}t(tk,P);tk.prototype.w=function(){this.M();this.aa();this.X(this.a,this.I);Jj(this,this.o(),this.i());Kj(this,this.i(),this.a);L(this.o())?this.i().focus():this.o().focus();tk.m.w.call(this)};tk.prototype.l=function(){this.I=this.a=null;tk.m.l.call(this)};p(tk.prototype,{o:ok,T:pk,M:qk,L:rk,G:sk,i:ik,C:jk,aa:kk,B:lk,wa:fk,va:gk,X:hk});function R(a,b,c,d,e){P.call(this,a,b,d,e||"notice");
	this.a=c||null}t(R,P);R.prototype.w=function(){this.a&&(this.o(this.a),this.i().focus());R.m.w.call(this)};R.prototype.l=function(){this.a=null;R.m.l.call(this)};p(R.prototype,{i:fk,B:gk,o:hk});function uk(a,b,c){R.call(this,Pj,{email:a,N:!!b},b,c,"passwordRecoveryEmailSent")}t(uk,R);function vk(a,b){R.call(this,Yj,{N:!!a},a,b,"emailVerificationSuccess")}t(vk,R);function wk(a,b){R.call(this,Zj,{N:!!a},a,b,"emailVerificationFailure")}t(wk,R);function xk(a,b){R.call(this,Uj,{N:!!a},a,b,"passwordResetSuccess")}
	t(xk,R);function yk(a,b){R.call(this,Vj,{N:!!a},a,b,"passwordResetFailure")}t(yk,R);function zk(a,b){R.call(this,Xj,{N:!!a},a,b,"emailChangeRevokeFailure")}t(zk,R);function Ak(a,b){R.call(this,ak,{fb:a},void 0,b,"unrecoverableError")}t(Ak,R);var Bk=!1,Ck=null;function Dk(a,b){Bk=!!b;Ck||("undefined"==typeof accountchooser&&ii()?(b=Ob(Jb(Kb("//www.gstatic.com/accountchooser/client.js"))),Ck=Ye(E(wf(b)),function(){})):Ck=E());Ck.then(a,a)}function Ek(a,b){a=S(a);(a=Lh(a).accountChooserInvoked||null)?
	a(b):b()}function Fk(a,b,c){a=S(a);(a=Lh(a).accountChooserResult||null)?a(b,c):c()}function Gk(a,b,c,d,e){d?(H("callback",a,b),Bk&&c()):Ek(a,function(){Vg(T(a));Th(function(d){F(Jg,T(a));Fk(a,d?"empty":"unavailable",function(){H("signIn",a,b);(d||Bk)&&c()})},Sg(T(a)),e)})}function Hk(a,b,c,d){function e(a){a=U(a);V(b,c,void 0,a);d()}Fk(b,"accountSelected",function(){Rg(!1,T(b));W(b,X(b).fetchSignInMethodsForEmail(a.a).then(function(e){Ik(b,c,e,a.a,a.h||void 0);d()},e))})}function Jk(a,b,c,d){Fk(b,
	a?"addAccount":"unavailable",function(){H("signIn",b,c);(a||Bk)&&d()})}function Kk(a,b,c,d){function e(){var b=a();b&&(b=Kh(S(b)))&&b()}Qh(function(){var f=a();f&&Gk(f,b,e,c,d)},function(c){var d=a();d&&Hk(c,d,b,e)},function(c){var d=a();d&&Jk(c,d,b,e)},a()&&oh(S(a())))}function Lk(a,b,c,d){function e(c){if(!c.name||"cancel"!=c.name){a:{var d=c.message;try{var e=((JSON.parse(d).error||{}).message||"").toLowerCase().match(/invalid.+(access|id)_token/);if(e&&e.length){var f=!0;break a}}catch(J){}f=
	!1}if(f)c=Q(b),b.s(),V(a,c,void 0,A("Your sign-in session has expired. Please try again.").toString());else{f=c&&c.message||"";if(c.code){if("auth/email-already-in-use"==c.code||"auth/credential-already-in-use"==c.code)return;f=U(c)}b.g(f)}}}if(d)return Mk(a,c),E();if(!c.credential)throw Error("No credential found!");d=X(a).currentUser||c.user;if(!d)throw Error("User not logged in.");d=new jg(d.email,d.displayName,d.photoURL,"password"==c.credential.providerId?null:c.credential.providerId);null!=
	Ng(Lg,T(a))&&!Ng(Lg,T(a))||Tg(d,T(a));F(Lg,T(a));c=Nk(a,c);d=c.then(function(b){Mk(a,b)},e).then(void 0,e);W(a,c);return E(d)}function Mk(a,b){if(!b.user)throw Error("No user found");var c=Nh(S(a));Mh(S(a))&&c&&Sf&&Rf("Both signInSuccess and signInSuccessWithAuthResult callbacks are provided. Only signInSuccessWithAuthResult callback will be invoked.");if(c){c=Nh(S(a));var d=Pg(T(a))||void 0;F(Kg,T(a));var e=!1;if(jf()){if(!c||c(b,d))e=!0,window.opener.location.assign(Rb(Tb(Ok(a,d))));c||window.close()}else if(!c||
	c(b,d))e=!0,hf(Ok(a,d));e||a.reset()}else{c=b.user;b=b.credential;d=Mh(S(a));e=Pg(T(a))||void 0;F(Kg,T(a));var f=!1;if(jf()){if(!d||d(c,b,e))f=!0,window.opener.location.assign(Rb(Tb(Ok(a,e))));d||window.close()}else if(!d||d(c,b,e))f=!0,hf(Ok(a,e));f||a.reset()}}function Ok(a,b){a=b||S(a).a.get("signInSuccessUrl");if(!a)throw Error("No redirect URL has been found. You must either specify a signInSuccessUrl in the configuration, pass in a redirect URL to the widget URL, or return false from the callback.");
	return a}function U(a){var b="";switch(a.code){case "auth/email-already-in-use":b+="The email address is already used by another account";break;case "auth/requires-recent-login":b+=Cd();break;case "auth/too-many-requests":b+="You have entered an incorrect password too many times. Please try again in a few minutes.";break;case "auth/user-cancelled":b+="Please authorize the required permissions to sign in to the application";break;case "auth/user-not-found":b+="That email address doesn't match an existing account";
	break;case "auth/user-token-expired":b+=Cd();break;case "auth/weak-password":b+="Strong passwords have at least 6 characters and a mix of letters and numbers";break;case "auth/wrong-password":b+="The email and password you entered don't match";break;case "auth/network-request-failed":b+="A network error has occurred";break;case "auth/invalid-phone-number":b+=zd();break;case "auth/invalid-verification-code":b+=A("Wrong code. Try again.");break;case "auth/code-expired":b+="This code is no longer valid"}if(b=
	A(b).toString())return b;try{return JSON.parse(a.message),ig("Internal error: "+a.message),Ad().toString()}catch(c){return a.message}}function Pk(a,b,c){var d=lg[b]&&firebase.auth[lg[b]]?new firebase.auth[lg[b]]:null;if(!d)throw Error("Invalid Firebase Auth provider!");var e=Dh(S(a),b);if(d&&d.addScope)for(var f=0;f<e.length;f++)d.addScope(e[f]);a=Eh(S(a),b);b==firebase.auth.GoogleAuthProvider.PROVIDER_ID&&c&&(a=a||{},a.login_hint=c);a&&d&&d.setCustomParameters&&d.setCustomParameters(a);return d}
	function Qk(a,b,c,d){function e(){Vg(T(a));W(a,Ij(b,n(a.zb,a),[q],function(){if("file:"===(window.location&&window.location.protocol))return W(a,Rk(a).then(function(c){b.s();F(Jg,T(a));H("callback",a,k,E(c))},f))},g))}function f(c){F(Jg,T(a));if(!c.name||"cancel"!=c.name)switch(c.code){case "auth/popup-blocked":e();break;case "auth/popup-closed-by-user":case "auth/cancelled-popup-request":break;case "auth/credential-already-in-use":break;case "auth/network-request-failed":case "auth/too-many-requests":case "auth/user-cancelled":b.g(U(c));
	break;default:b.s(),H("callback",a,k,We(c))}}function g(c){F(Jg,T(a));c.name&&"cancel"==c.name||(ig("signInWithRedirect: "+c.code),c=U(c),b.g(c))}var k=Q(b),q=Pk(a,c,d);"redirect"==Jh(S(a))?e():W(a,Sk(a,q).then(function(c){b.s();H("callback",a,k,E(c))},f))}function Tk(a,b,c){function d(c){var d=!1;c=Ij(b,n(a.wb,a),[c],function(c){var e=Q(b);b.s();H("callback",a,e,E(c));d=!0},function(c){if(!c.name||"cancel"!=c.name)if(!c||"auth/credential-already-in-use"!=c.code)if(c&&"auth/email-already-in-use"==
	c.code&&c.email&&c.credential){var d=Q(b);b.s();H("callback",a,d,We(c))}else c=U(c),b.g(c)});W(a,c);return c.then(function(){return d},function(){return!1})}var e=Bh(S(a),c&&c.authMethod||null);if(c&&c.idToken&&e===firebase.auth.GoogleAuthProvider.PROVIDER_ID)return Dh(S(a),firebase.auth.GoogleAuthProvider.PROVIDER_ID).length?(Qk(a,b,e,c.id),c=E(!0)):c=d(firebase.auth.GoogleAuthProvider.credential(c.idToken)),c;c&&b.g(A("The selected credential for the authentication provider is not supported!").toString());
	return E(!1)}function Uk(a,b){var c=b.G(),d=b.B();if(c)if(d){var e=firebase.auth.EmailAuthProvider.credential(c,d);W(a,Ij(b,n(a.xb,a),[c,d],function(c){return Lk(a,b,{user:c.user,credential:e,operationType:c.operationType,additionalUserInfo:c.additionalUserInfo})},function(a){if(!a.name||"cancel"!=a.name)switch(a.code){case "auth/email-already-in-use":break;case "auth/email-exists":N(b.o(),!1);O(b.T(),U(a));break;case "auth/too-many-requests":case "auth/wrong-password":N(b.i(),!1);O(b.C(),U(a));break;
	default:ig("verifyPassword: "+a.message),b.g(U(a))}}))}else b.i().focus();else b.o().focus()}function Vk(a){a=yh(S(a));return 1==a.length&&a[0]==firebase.auth.EmailAuthProvider.PROVIDER_ID}function Wk(a){a=yh(S(a));return 1==a.length&&a[0]==firebase.auth.PhoneAuthProvider.PROVIDER_ID}function V(a,b,c,d){Vk(a)?d?H("signIn",a,b,c,d):Xk(a,b,c):a&&Wk(a)&&!d?H("phoneSignInStart",a,b):H("providerSignIn",a,b,d)}function Yk(a,b,c,d){var e=Q(b);W(a,Ij(b,n(X(a).fetchSignInMethodsForEmail,X(a)),[c],function(f){Rg(Ah(S(a))==
	lh,T(a));b.s();Ik(a,e,f,c,void 0,d)},function(a){a=U(a);b.g(a)}))}function Ik(a,b,c,d,e,f){if(c.length)if(bb(c,firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)||bb(c,firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD))H("passwordSignIn",a,b,d);else{e=new mg(d);var g=T(a);Og(Ig,e.fa(),g);H("federatedSignIn",a,b,d,c[0],f)}else H("passwordSignUp",a,b,d,e)}function Xk(a,b,c){Ah(S(a))==lh?Dk(function(){Oh?Ek(a,function(){Vg(T(a));Th(function(d){F(Jg,T(a));Fk(a,d?"empty":"unavailable",
	function(){H("signIn",a,b,c)})},Sg(T(a)),rh(S(a)))}):(Y(a),Kk(Zk,b,!1,rh(S(a))))},!1):(Bk=!1,Ek(a,function(){Fk(a,"unavailable",function(){H("signIn",a,b,c)})}))}function $k(a){var b=window.location.href;a=th(S(a));b=zc(b,a)||"";for(var c in ph)if(ph[c].toLowerCase()==b.toLowerCase())return ph[c];return"callback"}function al(a){var b=window.location.href;a=Zg(S(a).a,"queryParameterForSignInSuccessUrl");return(b=zc(b,a))?Rb(Tb(b)):null}function bl(){return zc(window.location.href,"oobCode")}function cl(){var a=
	zc(window.location.href,"continueUrl");return a?function(){hf(a)}:null}function dl(a,b){var c=kf(b);switch($k(a)){case "callback":(b=al(a))&&Qg(b,T(a));H("callback",a,c);break;case "resetPassword":H("passwordReset",a,c,bl(),cl());break;case "recoverEmail":H("emailChangeRevocation",a,c,bl());break;case "verifyEmail":H("emailVerification",a,c,bl(),cl());break;case "select":if((b=al(a))&&Qg(b,T(a)),Oh){V(a,c);break}else{Dk(function(){Y(a);Kk(Zk,c,!0)},!0);return}default:throw Error("Unhandled widget operation.");
	}(b=Kh(S(a)))&&b()}function el(a){P.call(this,Qj,void 0,a,"callback")}t(el,P);function fl(a,b,c){if(c.user){var d={user:c.user,credential:c.credential,operationType:c.operationType,additionalUserInfo:c.additionalUserInfo},e=Ug(T(a)),f=e&&e.g;if(f&&!gl(c.user,f))hl(a,b,d);else{var g=e&&e.a;g?W(a,c.user.linkAndRetrieveDataWithCredential(g).then(function(c){d={user:c.user,credential:g,operationType:c.operationType,additionalUserInfo:c.additionalUserInfo};il(a,b,d)},function(c){jl(a,b,c)})):il(a,b,d)}}else c=
	Q(b),b.s(),F(Ig,T(a)),V(a,c)}function il(a,b,c){F(Ig,T(a));Lk(a,b,c)}function jl(a,b,c){var d=Q(b);F(Ig,T(a));c=U(c);b.s();V(a,d,void 0,c)}function kl(a,b,c,d){var e=Q(b);W(a,X(a).fetchSignInMethodsForEmail(c).then(function(f){b.s();f.length?bb(f,firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD)||bb(f,firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD)?H("passwordLinking",a,e,c):H("federatedLinking",a,e,c,f[0],d):(F(Ig,T(a)),H("passwordRecovery",a,e,c,!1,Bd().toString()))},function(c){jl(a,
	b,c)}))}function hl(a,b,c){var d=Q(b);W(a,ll(a).then(function(){b.s();H("emailMismatch",a,d,c)},function(a){a.name&&"cancel"==a.name||(a=U(a.code),b.g(a))}))}function gl(a,b){if(b==a.email)return!0;if(a.providerData)for(var c=0;c<a.providerData.length;c++)if(b==a.providerData[c].email)return!0;return!1}G.callback=function(a,b,c){var d=new el;d.render(b);Z(a,d);b=c||Rk(a);W(a,b.then(function(b){fl(a,d,b)},function(b){if(b&&("auth/account-exists-with-different-credential"==b.code||"auth/email-already-in-use"==
	b.code)&&b.email&&b.credential){var c=ng(b),e=T(a);Og(Ig,c.fa(),e);kl(a,d,b.email)}else b&&"auth/user-cancelled"==b.code?(c=Ug(T(a)),e=U(b),c&&c.a?kl(a,d,c.g,e):c?Yk(a,d,c.g,e):jl(a,d,b)):b&&"auth/credential-already-in-use"==b.code||(b&&"auth/operation-not-supported-in-this-environment"==b.code&&Vk(a)?fl(a,d,{user:null,credential:null}):jl(a,d,b))}))};function ml(a,b,c,d){P.call(this,Wj,{email:a,N:!!c},d,"emailChangeRevoke");this.i=b;this.a=c||null}t(ml,P);ml.prototype.w=function(){var a=this;cj(this,
	M(this,"firebaseui-id-reset-password-link"),function(){a.i()});this.a&&(this.B(this.a),this.o().focus());ml.m.w.call(this)};ml.prototype.l=function(){this.i=this.a=null;ml.m.l.call(this)};p(ml.prototype,{o:fk,C:gk,B:hk});function nl(){return M(this,"firebaseui-id-new-password")}function ol(){return M(this,"firebaseui-id-password-toggle")}function pl(){this.Ea=!this.Ea;var a=ol.call(this),b=nl.call(this);this.Ea?(b.type="text",li(a,"firebaseui-input-toggle-off"),mi(a,"firebaseui-input-toggle-on")):
	(b.type="password",li(a,"firebaseui-input-toggle-on"),mi(a,"firebaseui-input-toggle-off"));b.focus()}function ql(){return M(this,"firebaseui-id-new-password-error")}function rl(){this.Ea=!1;var a=nl.call(this);a.type="password";var b=ql.call(this);Zi(this,a,function(){ej(b)&&(N(a,!0),dj(b))});var c=ol.call(this);li(c,"firebaseui-input-toggle-on");mi(c,"firebaseui-input-toggle-off");aj(this,a,function(){li(c,"firebaseui-input-toggle-focus");mi(c,"firebaseui-input-toggle-blur")});bj(this,a,function(){li(c,
	"firebaseui-input-toggle-blur");mi(c,"firebaseui-input-toggle-focus")});cj(this,c,n(pl,this))}function sl(){var a=nl.call(this);var b=ql.call(this);L(a)?(N(a,!0),dj(b),b=!0):(N(a,!1),O(b,A("Enter your password").toString()),b=!1);return b?L(a):null}function tl(a,b,c){P.call(this,Tj,{email:a},c,"passwordReset");this.a=b}t(tl,P);tl.prototype.w=function(){this.G();this.C(this.a);Kj(this,this.i(),this.a);this.i().focus();tl.m.w.call(this)};tl.prototype.l=function(){this.a=null;tl.m.l.call(this)};p(tl.prototype,
	{i:nl,B:ql,I:ol,G:rl,o:sl,M:fk,L:gk,C:hk});function ul(a,b,c,d,e){var f=c.o();f&&W(a,Ij(c,n(X(a).confirmPasswordReset,X(a)),[d,f],function(){c.s();var d=new xk(e);d.render(b);Z(a,d)},function(d){vl(a,b,c,d)}))}function vl(a,b,c,d){"auth/weak-password"==(d&&d.code)?(a=U(d),N(c.i(),!1),O(c.B(),a),c.i().focus()):(c&&c.s(),c=new yk,c.render(b),Z(a,c))}function wl(a,b,c){var d=new ml(c,function(){W(a,Ij(d,n(X(a).sendPasswordResetEmail,X(a)),[c],function(){d.s();d=new uk(c);d.render(b);Z(a,d)},function(){d.g(A("Unable to send password reset code to specified email").toString())}))});
	d.render(b);Z(a,d)}G.passwordReset=function(a,b,c,d){W(a,X(a).verifyPasswordResetCode(c).then(function(e){var f=new tl(e,function(){ul(a,b,f,c,d)});f.render(b);Z(a,f)},function(){vl(a,b)}))};G.emailChangeRevocation=function(a,b,c){var d=null;W(a,X(a).checkActionCode(c).then(function(b){d=b.data.email;return X(a).applyActionCode(c)}).then(function(){wl(a,b,d)},function(){var c=new zk;c.render(b);Z(a,c)}))};G.emailVerification=function(a,b,c,d){W(a,X(a).applyActionCode(c).then(function(){var c=new vk(d);
	c.render(b);Z(a,c)},function(){var c=new wk;c.render(b);Z(a,c)}))};function xl(a,b,c,d,e){P.call(this,bk,{Cb:a,pb:b},e,"emailMismatch");this.o=c;this.i=d}t(xl,P);xl.prototype.w=function(){this.C(this.o,this.i);this.B().focus();xl.m.w.call(this)};xl.prototype.l=function(){this.i=this.a=null;xl.m.l.call(this)};p(xl.prototype,{B:fk,G:gk,C:hk});G.emailMismatch=function(a,b,c){var d=Ug(T(a));if(d){var e=new xl(c.user.email,d.g,function(){var b=e;F(Ig,T(a));Lk(a,b,c)},function(){var b=c.credential.providerId,
	g=Q(e);e.s();d.a?H("federatedLinking",a,g,d.g,b):H("federatedSignIn",a,g,d.g,b)});e.render(b);Z(a,e)}else V(a,b)};function yl(a,b,c,d){P.call(this,Sj,{email:a,providerId:b},d,"federatedLinking");this.a=c}t(yl,P);yl.prototype.w=function(){this.o(this.a);this.i().focus();yl.m.w.call(this)};yl.prototype.l=function(){this.a=null;yl.m.l.call(this)};p(yl.prototype,{i:fk,o:hk});G.federatedLinking=function(a,b,c,d,e){var f=Ug(T(a));if(f&&f.a){var g=new yl(c,d,function(){Qk(a,g,d,c)});g.render(b);Z(a,g);e&&
	g.g(e)}else V(a,b)};G.federatedSignIn=function(a,b,c,d,e){var f=new yl(c,d,function(){Qk(a,f,d,c)});f.render(b);Z(a,f);e&&f.g(e)};function zl(a,b,c,d){var e=b.B();e?W(a,Ij(b,n(a.ub,a),[c,e],function(c){c=c.user.linkAndRetrieveDataWithCredential(d).then(function(c){return Lk(a,b,{user:c.user,credential:d,operationType:c.operationType,additionalUserInfo:c.additionalUserInfo})});W(a,c);return c},function(a){if(!a.name||"cancel"!=a.name)switch(a.code){case "auth/wrong-password":N(b.i(),!1);O(b.C(),U(a));
	break;case "auth/too-many-requests":b.g(U(a));break;default:ig("signInWithEmailAndPassword: "+a.message),b.g(U(a))}})):b.i().focus()}G.passwordLinking=function(a,b,c){var d=Ug(T(a));F(Ig,T(a));var e=d&&d.a;if(e){var f=new mk(c,function(){zl(a,f,c,e)},function(){f.s();H("passwordRecovery",a,b,c)});f.render(b);Z(a,f)}else V(a,b)};function Al(a,b,c,d){P.call(this,Oj,{email:c,Ga:!!b},d,"passwordRecovery");this.a=a;this.o=b}t(Al,P);Al.prototype.w=function(){this.G();this.I(this.a,this.o);L(this.i())||
	this.i().focus();Kj(this,this.i(),this.a);Al.m.w.call(this)};Al.prototype.l=function(){this.o=this.a=null;Al.m.l.call(this)};p(Al.prototype,{i:ok,C:pk,G:qk,L:rk,B:sk,T:fk,M:gk,I:hk});function Bl(a,b){var c=b.B();if(c){var d=Q(b);W(a,Ij(b,n(X(a).sendPasswordResetEmail,X(a)),[c],function(){b.s();var e=new uk(c,function(){e.s();V(a,d)});e.render(d);Z(a,e)},function(a){N(b.i(),!1);O(b.C(),U(a))}))}else b.i().focus()}G.passwordRecovery=function(a,b,c,d,e){var f=new Al(function(){Bl(a,f)},d?void 0:function(){f.s();
	V(a,b)},c);f.render(b);Z(a,f);e&&f.g(e)};G.passwordSignIn=function(a,b,c){var d=new tk(function(){Uk(a,d)},function(){var c=d.L();d.s();H("passwordRecovery",a,b,c)},c);d.render(b);Z(a,d)};function Cl(){return M(this,"firebaseui-id-name")}function Dl(){return M(this,"firebaseui-id-name-error")}function El(a,b,c,d,e,f,g){P.call(this,Nj,{email:e,sb:b,name:f,qa:a,Ga:!!d},g,"passwordSignUp");this.a=c;this.G=d;this.C=b}t(El,P);El.prototype.w=function(){this.aa();this.C&&this.Fa();this.wa();this.va(this.a,
	this.G);this.C?(Jj(this,this.i(),this.B()),Jj(this,this.B(),this.o())):Jj(this,this.i(),this.o());this.a&&Kj(this,this.o(),this.a);L(this.i())?this.C&&!L(this.B())?this.B().focus():this.o().focus():this.i().focus();El.m.w.call(this)};El.prototype.l=function(){this.G=this.a=null;El.m.l.call(this)};p(El.prototype,{i:ok,T:pk,aa:qk,Ra:rk,L:sk,B:Cl,Ub:Dl,Fa:function(){var a=Cl.call(this),b=Dl.call(this);Zi(this,a,function(){ej(b)&&(N(a,!0),dj(b))})},I:function(){var a=Cl.call(this);var b=Dl.call(this);
	var c=L(a);c=!/^[\s\xa0]*$/.test(null==c?"":String(c));N(a,c);c?(dj(b),b=!0):(O(b,A("Enter your account name").toString()),b=!1);return b?Ja(L(a)):null},o:nl,X:ql,ab:ol,wa:rl,M:sl,Qb:fk,cb:gk,va:hk});function Fl(a,b){var c=Ih(S(a)),d=b.L(),e=null;c&&(e=b.I());var f=b.M();if(d){if(c)if(e)e=Ka(e);else{b.B().focus();return}if(f){var g=firebase.auth.EmailAuthProvider.credential(d,f);W(a,Ij(b,n(a.vb,a),[d,f],function(d){var f={user:d.user,credential:g,operationType:d.operationType,additionalUserInfo:d.additionalUserInfo};
	return c?(d=d.user.updateProfile({displayName:e}).then(function(){return Lk(a,b,f)}),W(a,d),d):Lk(a,b,f)},function(c){if(!c.name||"cancel"!=c.name){var e=U(c);switch(c.code){case "auth/email-already-in-use":return Gl(a,b,d,c);case "auth/too-many-requests":e=A("Too many account requests are coming from your IP address. Try again in a few minutes.").toString();case "auth/operation-not-allowed":case "auth/weak-password":N(b.o(),!1);O(b.X(),e);break;default:ig("setAccountInfo: "+og(c)),b.g(e)}}}))}else b.o().focus()}else b.i().focus()}
	function Gl(a,b,c,d){function e(){var a=U(d);N(b.i(),!1);O(b.T(),a);b.i().focus()}var f=X(a).fetchSignInMethodsForEmail(c).then(function(d){d.length?e():(d=Q(b),b.s(),H("passwordRecovery",a,d,c,!1,Bd().toString()))},function(){e()});W(a,f);return f}G.passwordSignUp=function(a,b,c,d,e){function f(){g.s();V(a,b)}var g=new El(Hh(S(a)),Ih(S(a)),function(){Fl(a,g)},e?void 0:f,c,d);g.render(b);Z(a,g)};function Hl(){return M(this,"firebaseui-id-phone-confirmation-code")}function Il(){return M(this,"firebaseui-id-phone-confirmation-code-error")}
	function Jl(){return M(this,"firebaseui-id-resend-countdown")}function Kl(a,b,c,d,e,f,g,k){P.call(this,ek,{phoneNumber:e,qa:g},k,"phoneSignInFinish");this.Fa=f;this.i=new yi(1E3);this.C=f;this.I=a;this.a=b;this.G=c;this.L=d}t(Kl,P);Kl.prototype.w=function(){var a=this;this.M(this.Fa);be(this.i,"tick",this.B,!1,this);this.i.start();cj(this,M(this,"firebaseui-id-change-phone-number-link"),function(){a.I()});cj(this,this.Ma(),function(){a.L()});this.wa(this.a);this.X(this.a,this.G);this.o().focus();
	Kl.m.w.call(this)};Kl.prototype.l=function(){this.L=this.G=this.a=this.I=null;zi(this.i);je(this.i,"tick",this.B);this.i=null;Kl.m.l.call(this)};Kl.prototype.B=function(){--this.C;0<this.C?this.M(this.C):(zi(this.i),je(this.i,"tick",this.B),this.va(),this.Ra())};p(Kl.prototype,{o:Hl,aa:Il,wa:function(a){var b=Hl.call(this),c=Il.call(this);Zi(this,b,function(){ej(c)&&(N(b,!0),dj(c))});a&&$i(this,b,function(){a()})},T:function(){var a=Ja(L(Hl.call(this))||"");return/^\d{6}$/.test(a)?a:null},Ya:Jl,M:function(a){kc(Jl.call(this),
	A("Resend code in "+((9<a?"0:":"0:0")+a)).toString())},va:function(){var a=this.Ya();dj(a)},Ma:function(){return M(this,"firebaseui-id-resend-link")},Ra:function(){O(this.Ma())},cb:fk,ab:gk,X:hk});function Ll(a,b,c,d){function e(a){b.o().focus();N(b.o(),!1);O(b.aa(),a)}var f=b.T();f?(b.ua("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",A("Verifying...").toString()),W(a,Ij(b,n(d.confirm,d),[f],function(c){b.j();b.ua("firebaseui-icon-done",A("Verified!").toString());
	var d=setTimeout(function(){b.j();b.s();var d={user:Ml(a).currentUser,credential:null,operationType:c.operationType,additionalUserInfo:c.additionalUserInfo};Lk(a,b,d,!0)},1E3);W(a,function(){b&&b.j();clearTimeout(d)})},function(d){if(d.name&&"cancel"==d.name)b.j();else{var f=U(d);switch(d.code){case "auth/credential-already-in-use":b.j();break;case "auth/code-expired":d=Q(b);b.j();b.s();H("phoneSignInStart",a,d,c,f);break;case "auth/missing-verification-code":case "auth/invalid-verification-code":b.j();
	e(f);break;default:b.j(),b.g(f)}}}))):e(A("Wrong code. Try again.").toString())}G.phoneSignInFinish=function(a,b,c,d,e,f){var g=new Kl(function(){g.s();H("phoneSignInStart",a,b,c)},function(){Ll(a,g,c,e)},function(){g.s();V(a,b)},function(){g.s();H("phoneSignInStart",a,b,c)},jh(c),d,Hh(S(a)));g.render(b);Z(a,g);f&&g.g(f)};var Nl=!v&&!(u("Safari")&&!(pb()||u("Coast")||u("Opera")||u("Edge")||u("Silk")||u("Android")));function Ol(a,b){if(/-[a-z]/.test(b))return null;if(Nl&&a.dataset){if(!(!u("Android")||
	pb()||u("Firefox")||u("Opera")||u("Silk")||b in a.dataset))return null;a=a.dataset[b];return void 0===a?null:a}return a.getAttribute("data-"+String(b).replace(/([A-Z])/g,"-$1").toLowerCase())}function Pl(a,b,c){a=Zc(rj,{items:a},null,this.v);yj.call(this,a,!0,!0);c&&(c=Ql(a,c))&&(c.focus(),Ri(c,a));cj(this,a,function(a){if(a=(a=lc(a.target,"firebaseui-id-list-box-dialog-button"))&&Ol(a,"listboxid"))zj(),b(a)})}function Ql(a,b){a=(a||document).getElementsByTagName("BUTTON");for(var c=0;c<a.length;c++)if(Ol(a[c],
	"listboxid")===b)return a[c];return null}function Rl(){return M(this,"firebaseui-id-phone-number")}function Sl(){return M(this,"firebaseui-id-phone-number-error")}function Tl(){return Za(gh,function(a){return{id:a.c,Ba:"firebaseui-flag "+Ul(a),label:a.name+" "+("\u200e+"+a.b)}})}function Ul(a){return"firebaseui-flag-"+a.f}function Vl(){var a=this;Pl.call(this,Tl(),function(b){Wl.call(a,b,!0);a.F().focus()},this.pa)}function Wl(a,b){var c=fh(a);if(c){if(b){var d=Ja(L(Rl.call(this))||"");b=dh(d);if(b.length&&
	b[0].b!=c.b){d="+"+c.b+d.substr(b[0].b.length+1);b=Rl.call(this);var e=b.type;switch(m(e)&&e.toLowerCase()){case "checkbox":case "radio":b.checked=d;break;case "select-one":b.selectedIndex=-1;if(m(d))for(var f=0;e=b.options[f];f++)if(e.value==d){e.selected=!0;break}break;case "select-multiple":m(d)&&(d=[d]);for(f=0;e=b.options[f];f++)if(e.selected=!1,d)for(var g,k=0;g=d[k];k++)e.value==g&&(e.selected=!0);break;default:b.value=null!=d?d:""}}}b=fh(this.pa);this.pa=a;a=M(this,"firebaseui-id-country-selector-flag");
	b&&mi(a,Ul(b));li(a,Ul(c));kc(M(this,"firebaseui-id-country-selector-code"),"\u200e+"+c.b)}}function Xl(a,b){try{var c="number"==typeof a.selectionStart}catch(d){c=!1}c?(a.selectionStart=b,a.selectionEnd=b):v&&!Eb("9")&&("textarea"==a.type&&(b=a.value.substring(0,b).replace(/(\r\n|\r|\n)/g,"\n").length),a=a.createTextRange(),a.collapse(!0),a.move("character",b),a.select())}function Yl(a,b,c,d,e,f){P.call(this,dk,{eb:c,oa:e||null},f,"phoneSignInStart");this.G=d||null;this.I=c;this.a=a;this.B=b}t(Yl,
	P);Yl.prototype.w=function(){this.X(this.G);this.L(this.a,this.B);this.I||Jj(this,this.F(),this.i());Kj(this,this.i(),this.a);this.F().focus();Xl(this.F(),(this.F().value||"").length);Yl.m.w.call(this)};Yl.prototype.l=function(){this.B=this.a=null;Yl.m.l.call(this)};p(Yl.prototype,{F:Rl,C:Sl,X:function(a,b){var c=this,d=Rl.call(this),e=M(this,"firebaseui-id-country-selector"),f=Sl.call(this);Wl.call(this,a||"1-US-0");cj(this,e,function(){Vl.call(c)});Zi(this,d,function(){ej(f)&&(N(d,!0),dj(f));var a=
	Ja(L(d)||""),b=fh(this.pa);a=dh(a);a.length&&a[0].b!=b.b&&(b=a[0],Wl.call(c,"1"==b.b?"1-US-0":b.c))});b&&$i(this,d,function(){b()})},M:function(){var a=Ja(L(Rl.call(this))||""),b=dh(a),c=fh(this.pa);b.length&&b[0].b!=c.b&&Wl.call(this,b[0].c);b.length&&(a=a.substr(b[0].b.length+1));return a?new hh(this.pa,a):null},T:function(){return M(this,"firebaseui-recaptcha-container")},o:function(){return M(this,"firebaseui-id-recaptcha-error")},i:fk,aa:gk,L:hk});function Zl(a,b,c,d){var e=b.M();e?Vh?(b.ua("mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active firebaseui-progress-dialog-loading-icon",
	A("Verifying...").toString()),W(a,Ij(b,n(a.yb,a),[jh(e),c],function(c){var d=Q(b);b.ua("firebaseui-icon-done",A("Code sent!").toString());var f=setTimeout(function(){b.j();b.s();H("phoneSignInFinish",a,d,e,15,c)},1E3);W(a,function(){b&&b.j();clearTimeout(f)})},function(a){b.j();if(!a.name||"cancel"!=a.name){grecaptcha.reset(Xh);Vh=null;var c=a&&a.message||"";if(a.code)switch(a.code){case "auth/too-many-requests":c=A("This phone number has been used too many times").toString();break;case "auth/invalid-phone-number":case "auth/missing-phone-number":b.F().focus();
	O(b.C(),zd().toString());return;default:c=U(a)}b.g(c)}}))):Wh?O(b.o(),A("Solve the reCAPTCHA").toString()):!Wh&&d&&b.i().click():(b.F().focus(),O(b.C(),zd().toString()))}G.phoneSignInStart=function(a,b,c,d){var e=Ch(S(a))||{};Vh=null;Wh=!(e&&"invisible"===e.size);var f=Gh(S(a)),g=Wk(a)?Fh(S(a)):null,k=new Yl(function(b){Zl(a,k,q,!(!b||!b.keyCode))},function(){q.clear();k.s();V(a,b)},Wh,c&&c.a||f&&f.c||null,c&&c.oa||g);k.render(b);Z(a,k);d&&k.g(d);e.callback=function(b){k.o()&&dj(k.o());Vh=b;Wh||Zl(a,
	k,q)};e["expired-callback"]=function(){Vh=null};var q=new firebase.auth.RecaptchaVerifier(Wh?k.T():k.i(),e,Ml(a).app);W(a,Ij(k,n(q.render,q),[],function(a){Xh=a},function(c){c.name&&"cancel"==c.name||(c=U(c),k.s(),V(a,b,void 0,c))}))};function $l(a,b,c){P.call(this,ck,{rb:b},c,"providerSignIn");this.a=a}t($l,P);$l.prototype.w=function(){this.i(this.a);$l.m.w.call(this)};$l.prototype.l=function(){this.a=null;$l.m.l.call(this)};p($l.prototype,{i:function(a){function b(b){a(b)}for(var c=this.h?dc("firebaseui-id-idp-button",
	this.h||this.v.a):[],d=0;d<c.length;d++){var e=c[d],f=Ol(e,"providerId");cj(this,e,Ea(b,f))}}});G.providerSignIn=function(a,b,c){var d=new $l(function(c){c==firebase.auth.EmailAuthProvider.PROVIDER_ID?(d.s(),Xk(a,b)):c==firebase.auth.PhoneAuthProvider.PROVIDER_ID?(d.s(),H("phoneSignInStart",a,b)):Qk(a,d,c);Y(a);a.J.cancel()},yh(S(a)));d.render(b);Z(a,d);c&&d.g(c);am(a)};function bm(a,b,c,d){P.call(this,Lj,{email:c,bb:!!b},d,"signIn");this.i=a;this.o=b}t(bm,P);bm.prototype.w=function(){this.C(this.i);
	this.G(this.i,this.o||void 0);this.a().focus();Xl(this.a(),(this.a().value||"").length);bm.m.w.call(this)};bm.prototype.l=function(){this.o=this.i=null;bm.m.l.call(this)};p(bm.prototype,{a:ok,L:pk,C:qk,I:rk,B:sk,T:fk,M:gk,G:hk});G.signIn=function(a,b,c,d){var e=Vk(a)&&Ah(S(a))!=lh,f=new bm(function(){var b=f,c=b.B()||"";c&&Yk(a,b,c)},e?null:function(){f.s();V(a,b,c)},c);f.render(b);Z(a,f);d&&f.g(d)};function cm(a,b){this.U=!1;var c=dm(b);if(em[c])throw Error('An AuthUI instance already exists for the key "'+
	c+'"');em[c]=this;this.g=a;this.V=null;fm(this.g);this.u=firebase.initializeApp({apiKey:a.app.options.apiKey,authDomain:a.app.options.authDomain},a.app.name+"-firebaseui-temp").auth();fm(this.u);this.u.setPersistence&&this.u.setPersistence(firebase.auth.Auth.Persistence.SESSION);this.ga=b;this.B=new kh;this.a=this.H=this.i=this.D=null;this.j=[];this.o=!1;this.J=Df.Ia();this.h=this.A=null;this.W=this.v=!1}function fm(a){a&&a.INTERNAL&&a.INTERNAL.logFramework&&a.INTERNAL.logFramework("FirebaseUI-web")}
	var em={};function dm(a){return a||"[DEFAULT]"}function Rk(a){Y(a);a.i||(a.i=gm(a,function(b){return b&&!Ug(T(a))?E(Ml(a).getRedirectResult().then(function(a){return a},function(b){if(b&&"auth/email-already-in-use"==b.code&&b.email&&b.credential)throw b;return hm(a,b)})):E(X(a).getRedirectResult().then(function(b){return uh(S(a))&&!b.user&&a.h&&!a.h.isAnonymous?Ml(a).getRedirectResult():b}))}));return a.i}function Z(a,b){Y(a);a.a=b}var im=null;function Zk(){return im}function X(a){Y(a);return a.u}
	function Ml(a){Y(a);return a.g}function T(a){Y(a);return a.ga}h=cm.prototype;h.nb=function(){Y(this);return"pending"===Ng(Jg,T(this))};h.start=function(a,b){Y(this);var c=this;"undefined"!==typeof this.g.languageCode&&(this.V=this.g.languageCode);var d="en".replace(/_/g,"-");this.g.languageCode=d;this.u.languageCode=d;this.Ta(b);F(Jg,T(this));var e=l.document;this.A?this.A.then(function(){"complete"==e.readyState?jm(c,a):ce(window,"load",function(){jm(c,a)})}):"complete"==e.readyState?jm(c,a):ce(window,
	"load",function(){jm(c,a)})};function jm(a,b){var c=kf(b);c.setAttribute("lang","en".replace(/_/g,"-"));if(im){var d=im;Y(d);Ug(T(d))&&Sf&&Rf("UI Widget is already rendered on the page and is pending some user interaction. Only one widget instance can be rendered per page. The previous instance has been automatically reset.");im.reset()}im=a;a.H=c;km(a,c);yg(new zg)&&yg(new Ag)?dl(a,b):(b=kf(b),c=new Ak(A("The browser you are using does not support Web Storage. Please try again in a different browser.").toString()),
	c.render(b),Z(a,c))}function gm(a,b){if(a.v)return b(lm(a));W(a,function(){a.v=!1});if(uh(S(a))){var c=new D(function(c){W(a,a.g.onAuthStateChanged(function(d){a.h=d;a.v||(a.v=!0,c(b(lm(a))))}))});W(a,c);return c}a.v=!0;return b(null)}function lm(a){Y(a);return uh(S(a))&&a.h&&a.h.isAnonymous?a.h:null}function W(a,b){Y(a);if(b){a.j.push(b);var c=function(){fb(a.j,function(a){return a==b})};"function"!=typeof b&&b.then(c,c)}}h.disableAutoSignIn=function(){Y(this);this.o=!0};function mm(a){Y(a);var b;
	(b=a.o)||(a=S(a),a=Eh(a,firebase.auth.GoogleAuthProvider.PROVIDER_ID),b=!(!a||"select_account"!==a.prompt));return b}h.reset=function(){Y(this);var a=this;this.H&&this.H.removeAttribute("lang");this.D&&ve(this.D);"undefined"!==typeof this.g.languageCode&&(this.g.languageCode=this.V);F(Jg,T(this));Y(this);this.J.cancel();this.i=E({user:null,credential:null});im==this&&(im=null);this.H=null;for(var b=0;b<this.j.length;b++)if("function"==typeof this.j[b])this.j[b]();else this.j[b].cancel&&this.j[b].cancel();
	this.j=[];F(Ig,T(this));this.a&&(this.a.s(),this.a=null);this.F=null;this.u&&(this.A=ll(this).then(function(){a.A=null},function(){a.A=null}))};function km(a,b){a.F=null;a.D=new we(b);ue(a.D);be(a.D,"pageEnter",function(b){b=b&&b.pageId;if(a.F!=b){var c=S(a);(c=Lh(c).uiChanged||null)&&c(a.F,b);a.F=b}})}h.Ta=function(a){Y(this);var b=this.B,c;for(c in a)try{Yg(b.a,c,a[c])}catch(d){ig('Invalid config: "'+c+'"')}xb&&Yg(b.a,"popupMode",!1);!this.W&&Mh(S(this))&&(Sf&&Rf("signInSuccess callback is deprecated. Please use signInSuccessWithAuthResult callback instead."),
	this.W=!0)};function S(a){Y(a);return a.B}h.tb=function(){Y(this);var a=S(this),b=Zg(a.a,"widgetUrl");var c=sh(a,b);if(S(this).a.get("popupMode")){a=(window.screen.availHeight-600)/2;b=(window.screen.availWidth-500)/2;var d=c||"about:blank";a={width:500,height:600,top:0<a?a:0,left:0<b?b:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};a.target=a.target||d.target||"google_popup";a.width=a.width||690;a.height=a.height||500;a||(a={});b=window;c=d instanceof Pb?d:Tb("undefined"!=typeof d.href?d.href:
	String(d));d=a.target||d.target;var e=[];for(f in a)switch(f){case "width":case "height":case "top":case "left":e.push(f+"="+a[f]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(f+"="+(a[f]?1:0))}var f=e.join(",");(u("iPhone")&&!u("iPod")&&!u("iPad")||u("iPad")||u("iPod"))&&b.navigator&&b.navigator.standalone&&d&&"_self"!=d?(f=b.document.createElement("A"),c instanceof Pb||c instanceof Pb||(c=c.ka?c.ia():String(c),Sb.test(c)||(c="about:invalid#zClosurez"),c=Ub(c)),f.href=
	Rb(c),f.setAttribute("target",d),a.noreferrer&&f.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,b,1),f.dispatchEvent(a),f={}):a.noreferrer?(f=b.open("",d,f),a=Rb(c),f&&(vb&&-1!=a.indexOf(";")&&(a="'"+a.replace(/'/g,"%27")+"'"),f.opener=null,Kb("b/12014412, meta tag with sanitized URL"),a='<META HTTP-EQUIV="refresh" content="0; url='+Ka(a)+'">',a=Yb(a,null),f.document.write(Xb(a)),f.document.close())):(f=b.open(Rb(c),d,f))&&a.noopener&&(f.opener=
	null);f&&f.focus()}else hf(c)};function Y(a){if(a.U)throw Error("AuthUI instance is deleted!");}h.hb=function(){var a=this;Y(this);return this.u.app.delete().then(function(){var b=dm(T(a));delete em[b];a.reset();a.U=!0})};function am(a){Y(a);try{Ff(a.J,zh(S(a)),mm(a)).then(function(b){return a.a?Tk(a,a.a,b):!1})}catch(b){}}h.xb=function(a,b){Y(this);var c=this;return X(this).signInWithEmailAndPassword(a,b).then(function(d){return gm(c,function(e){return e?ll(c).then(function(){return hm(c,{code:"auth/email-already-in-use"},
	firebase.auth.EmailAuthProvider.credential(a,b))}):d})})};h.vb=function(a,b){Y(this);var c=this;return gm(this,function(d){if(d){var e=firebase.auth.EmailAuthProvider.credential(a,b);return d.linkAndRetrieveDataWithCredential(e)}return X(c).createUserWithEmailAndPassword(a,b)})};h.wb=function(a){Y(this);var b=this;return gm(this,function(c){return c?c.linkAndRetrieveDataWithCredential(a).then(function(a){return a},function(c){if(c&&"auth/email-already-in-use"==c.code&&c.email&&c.credential)throw c;
	return hm(b,c,a)}):X(b).signInAndRetrieveDataWithCredential(a)})};function Sk(a,b){Y(a);return gm(a,function(c){return c&&!Ug(T(a))?c.linkWithPopup(b).then(function(a){return a},function(b){if(b&&"auth/email-already-in-use"==b.code&&b.email&&b.credential)throw b;return hm(a,b)}):X(a).signInWithPopup(b)})}h.zb=function(a){Y(this);var b=this,c=this.i;this.i=null;return gm(this,function(c){return c&&!Ug(T(b))?c.linkWithRedirect(a):X(b).signInWithRedirect(a)}).then(function(){},function(a){b.i=c;throw a;
	})};h.yb=function(a,b){Y(this);var c=this;return gm(this,function(d){return d?d.linkWithPhoneNumber(a,b).then(function(a){return new Hf(a,function(a){if("auth/credential-already-in-use"==a.code)return hm(c,a);throw a;})}):Ml(c).signInWithPhoneNumber(a,b).then(function(a){return new Hf(a)})})};function Nk(a,b){Y(a);return gm(a,function(c){if(a.h&&!a.h.isAnonymous&&uh(S(a))&&!X(a).currentUser)return ll(a).then(function(){"password"==b.credential.providerId&&(b.credential=null);return b});if(c)return ll(a).then(function(){return c.linkAndRetrieveDataWithCredential(b.credential)}).then(function(a){b.user=
	a.user;b.credential=a.credential;b.operationType=a.operationType;b.additionalUserInfo=a.additionalUserInfo;return b},function(c){if(c&&"auth/email-already-in-use"==c.code&&c.email&&c.credential)throw c;return hm(a,c,b.credential)});if(!b.credential)throw Error("No credential found!");return ll(a).then(function(){return Ml(a).signInAndRetrieveDataWithCredential(b.credential)}).then(function(a){b.user=a.user;b.credential=a.credential;b.operationType=a.operationType;return b})})}h.ub=function(a,b){Y(this);
	return X(this).signInWithEmailAndPassword(a,b)};function ll(a){Y(a);return X(a).signOut()}function hm(a,b,c){Y(a);if(b&&b.code&&("auth/email-already-in-use"==b.code||"auth/credential-already-in-use"==b.code)){var d=vh(S(a));return E().then(function(){return d(new Dd("anonymous-upgrade-merge-conflict",null,c||b.credential))}).then(function(){a.a&&(a.a.s(),a.a=null);throw b;})}return We(b)}r("firebaseui.auth.AuthUI",cm);r("firebaseui.auth.AuthUI.getInstance",function(a){a=dm(a);return em[a]?em[a]:null});
	r("firebaseui.auth.AuthUI.prototype.disableAutoSignIn",cm.prototype.disableAutoSignIn);r("firebaseui.auth.AuthUI.prototype.start",cm.prototype.start);r("firebaseui.auth.AuthUI.prototype.setConfig",cm.prototype.Ta);r("firebaseui.auth.AuthUI.prototype.signIn",cm.prototype.tb);r("firebaseui.auth.AuthUI.prototype.reset",cm.prototype.reset);r("firebaseui.auth.AuthUI.prototype.delete",cm.prototype.hb);r("firebaseui.auth.AuthUI.prototype.isPendingRedirect",cm.prototype.nb);r("firebaseui.auth.AuthUIError",
	Dd);r("firebaseui.auth.AuthUIError.prototype.toJSON",Dd.prototype.toJSON);r("firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM",lh);r("firebaseui.auth.CredentialHelper.GOOGLE_YOLO","googleyolo");r("firebaseui.auth.CredentialHelper.NONE","none")})(); if(typeof window!=='undefined'){window.dialogPolyfill=__webpack_require__(894);}})();module.exports=firebaseui;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(112)(module), (function() { return this; }())))

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var util = __webpack_require__(922);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	// An array to capture listeners before the true auth functions
	// exist
	var tokenListeners = [];
	/**
	 * Global context object for a collection of services using
	 * a shared authentication state.
	 */
	var FirebaseAppImpl = /** @class */ (function () {
	    function FirebaseAppImpl(options, config, firebase_) {
	        this.firebase_ = firebase_;
	        this.isDeleted_ = false;
	        this.services_ = {};
	        this.name_ = config.name;
	        this._automaticDataCollectionEnabled =
	            config.automaticDataCollectionEnabled || false;
	        this.options_ = util.deepCopy(options);
	        this.INTERNAL = {
	            getUid: function () { return null; },
	            getToken: function () { return Promise.resolve(null); },
	            addAuthTokenListener: function (callback) {
	                tokenListeners.push(callback);
	                // Make sure callback is called, asynchronously, in the absence of the auth module
	                setTimeout(function () { return callback(null); }, 0);
	            },
	            removeAuthTokenListener: function (callback) {
	                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
	            }
	        };
	    }
	    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
	        get: function () {
	            this.checkDestroyed_();
	            return this._automaticDataCollectionEnabled;
	        },
	        set: function (val) {
	            this.checkDestroyed_();
	            this._automaticDataCollectionEnabled = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.name_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.options_;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FirebaseAppImpl.prototype.delete = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.checkDestroyed_();
	            resolve();
	        })
	            .then(function () {
	            _this.firebase_.INTERNAL.removeApp(_this.name_);
	            var services = [];
	            Object.keys(_this.services_).forEach(function (serviceKey) {
	                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
	                    services.push(_this.services_[serviceKey][instanceKey]);
	                });
	            });
	            return Promise.all(services.map(function (service) {
	                return service.INTERNAL.delete();
	            }));
	        })
	            .then(function () {
	            _this.isDeleted_ = true;
	            _this.services_ = {};
	        });
	    };
	    /**
	     * Return a service instance associated with this app (creating it
	     * on demand), identified by the passed instanceIdentifier.
	     *
	     * NOTE: Currently storage is the only one that is leveraging this
	     * functionality. They invoke it by calling:
	     *
	     * ```javascript
	     * firebase.app().storage('STORAGE BUCKET ID')
	     * ```
	     *
	     * The service name is passed to this already
	     * @internal
	     */
	    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        this.checkDestroyed_();
	        if (!this.services_[name]) {
	            this.services_[name] = {};
	        }
	        if (!this.services_[name][instanceIdentifier]) {
	            /**
	             * If a custom instance has been defined (i.e. not '[DEFAULT]')
	             * then we will pass that instance on, otherwise we pass `null`
	             */
	            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
	                ? instanceIdentifier
	                : undefined;
	            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
	            this.services_[name][instanceIdentifier] = service;
	        }
	        return this.services_[name][instanceIdentifier];
	    };
	    /**
	     * Callback function used to extend an App instance at the time
	     * of service instance creation.
	     */
	    FirebaseAppImpl.prototype.extendApp = function (props) {
	        var _this = this;
	        // Copy the object onto the FirebaseAppImpl prototype
	        util.deepExtend(this, props);
	        /**
	         * If the app has overwritten the addAuthTokenListener stub, forward
	         * the active token listeners on to the true fxn.
	         *
	         * TODO: This function is required due to our current module
	         * structure. Once we are able to rely strictly upon a single module
	         * implementation, this code should be refactored and Auth should
	         * provide these stubs and the upgrade logic
	         */
	        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
	            tokenListeners.forEach(function (listener) {
	                _this.INTERNAL.addAuthTokenListener(listener);
	            });
	            tokenListeners = [];
	        }
	    };
	    /**
	     * This function will throw an Error if the App has already been deleted -
	     * use before performing API actions on the App.
	     */
	    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
	        if (this.isDeleted_) {
	            error('app-deleted', { name: this.name_ });
	        }
	    };
	    return FirebaseAppImpl;
	}());
	// Prevent dead-code elimination of these methods w/o invalid property
	// copying.
	(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
	    FirebaseAppImpl.prototype.delete ||
	    console.log('dc');
	/**
	 * Return a firebase namespace object.
	 *
	 * In production, this will be called exactly once and the result
	 * assigned to the 'firebase' global.  It may be called multiple times
	 * in unit tests.
	 */
	function createFirebaseNamespace() {
	    var apps_ = {};
	    var factories = {};
	    var appHooks = {};
	    // A namespace is a plain JavaScript Object.
	    var namespace = {
	        // Hack to prevent Babel from modifying the object returned
	        // as the firebase namespace.
	        __esModule: true,
	        initializeApp: initializeApp,
	        app: app,
	        apps: null,
	        Promise: Promise,
	        SDK_VERSION: '5.0.3',
	        INTERNAL: {
	            registerService: registerService,
	            createFirebaseNamespace: createFirebaseNamespace,
	            extendNamespace: extendNamespace,
	            createSubscribe: util.createSubscribe,
	            ErrorFactory: util.ErrorFactory,
	            removeApp: removeApp,
	            factories: factories,
	            useAsService: useAsService,
	            Promise: Promise,
	            deepExtend: util.deepExtend
	        }
	    };
	    // Inject a circular default export to allow Babel users who were previously
	    // using:
	    //
	    //   import firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase').default;
	    //
	    // instead of
	    //
	    //   import * as firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase');
	    util.patchProperty(namespace, 'default', namespace);
	    // firebase.apps is a read-only getter.
	    Object.defineProperty(namespace, 'apps', {
	        get: getApps
	    });
	    /**
	     * Called by App.delete() - but before any services associated with the App
	     * are deleted.
	     */
	    function removeApp(name) {
	        var app = apps_[name];
	        callAppHooks(app, 'delete');
	        delete apps_[name];
	    }
	    /**
	     * Get the App object for a given name (or DEFAULT).
	     */
	    function app(name) {
	        name = name || DEFAULT_ENTRY_NAME;
	        if (!contains(apps_, name)) {
	            error('no-app', { name: name });
	        }
	        return apps_[name];
	    }
	    util.patchProperty(app, 'App', FirebaseAppImpl);
	    function initializeApp(options, rawConfig) {
	        if (rawConfig === void 0) { rawConfig = {}; }
	        if (typeof rawConfig !== 'object' || rawConfig === null) {
	            var name_1 = rawConfig;
	            rawConfig = { name: name_1 };
	        }
	        var config = rawConfig;
	        if (config.name === undefined) {
	            config.name = DEFAULT_ENTRY_NAME;
	        }
	        var name = config.name;
	        if (typeof name !== 'string' || !name) {
	            error('bad-app-name', { name: name + '' });
	        }
	        if (contains(apps_, name)) {
	            error('duplicate-app', { name: name });
	        }
	        var app = new FirebaseAppImpl(options, config, namespace);
	        apps_[name] = app;
	        callAppHooks(app, 'create');
	        return app;
	    }
	    /*
	     * Return an array of all the non-deleted FirebaseApps.
	     */
	    function getApps() {
	        // Make a copy so caller cannot mutate the apps list.
	        return Object.keys(apps_).map(function (name) { return apps_[name]; });
	    }
	    /*
	     * Register a Firebase Service.
	     *
	     * firebase.INTERNAL.registerService()
	     *
	     * TODO: Implement serviceProperties.
	     */
	    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
	        // Cannot re-register a service that already exists
	        if (factories[name]) {
	            error('duplicate-service', { name: name });
	        }
	        // Capture the service factory for later service instantiation
	        factories[name] = createService;
	        // Capture the appHook, if passed
	        if (appHook) {
	            appHooks[name] = appHook;
	            // Run the **new** app hook on all existing apps
	            getApps().forEach(function (app) {
	                appHook('create', app);
	            });
	        }
	        // The Service namespace is an accessor function ...
	        var serviceNamespace = function (appArg) {
	            if (appArg === void 0) { appArg = app(); }
	            if (typeof appArg[name] !== 'function') {
	                // Invalid argument.
	                // This happens in the following case: firebase.storage('gs:/')
	                error('invalid-app-argument', { name: name });
	            }
	            // Forward service instance lookup to the FirebaseApp.
	            return appArg[name]();
	        };
	        // ... and a container for service-level properties.
	        if (serviceProperties !== undefined) {
	            util.deepExtend(serviceNamespace, serviceProperties);
	        }
	        // Monkey-patch the serviceNamespace onto the firebase namespace
	        namespace[name] = serviceNamespace;
	        // Patch the FirebaseAppImpl prototype
	        FirebaseAppImpl.prototype[name] = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var serviceFxn = this._getService.bind(this, name);
	            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
	        };
	        return serviceNamespace;
	    }
	    /**
	     * Patch the top-level firebase namespace with additional properties.
	     *
	     * firebase.INTERNAL.extendNamespace()
	     */
	    function extendNamespace(props) {
	        util.deepExtend(namespace, props);
	    }
	    function callAppHooks(app, eventName) {
	        Object.keys(factories).forEach(function (serviceName) {
	            // Ignore virtual services
	            var factoryName = useAsService(app, serviceName);
	            if (factoryName === null) {
	                return;
	            }
	            if (appHooks[factoryName]) {
	                appHooks[factoryName](eventName, app);
	            }
	        });
	    }
	    // Map the requested service to a registered service name
	    // (used to map auth to serverAuth service when needed).
	    function useAsService(app, name) {
	        if (name === 'serverAuth') {
	            return null;
	        }
	        var useService = name;
	        var options = app.options;
	        return useService;
	    }
	    return namespace;
	}
	function error(code, args) {
	    throw appErrors.create(code, args);
	}
	// TypeScript does not support non-string indexes!
	// let errors: {[code: AppError: string} = {
	var errors = {
	    'no-app': "No Firebase App '{$name}' has been created - " +
	        'call Firebase App.initializeApp()',
	    'bad-app-name': "Illegal App name: '{$name}",
	    'duplicate-app': "Firebase App named '{$name}' already exists",
	    'app-deleted': "Firebase App named '{$name}' already deleted",
	    'duplicate-service': "Firebase service named '{$name}' already registered",
	    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
	        'account is only allowed in a Node.js environment. On client ' +
	        'devices, you should instead initialize the SDK with an api key and ' +
	        'auth domain',
	    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
	        'Firebase App instance.'
	};
	var appErrors = new util.ErrorFactory('app', 'Firebase', errors);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var firebase = createFirebaseNamespace();
	
	exports.firebase = firebase;
	exports.default = firebase;


/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {
	  var firebase = __webpack_require__(428).default;
	  var g,aa=aa||{},k=this;function l(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
	function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function n(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
	function la(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=la;return r.apply(null,arguments)}
	function ma(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var na=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.lb=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.cd=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function oa(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function pa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function qa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");u.call(this,c+a[d])}t(qa,u);qa.prototype.name="AssertionError";function ra(a,b){throw new qa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function sa(a,b){this.c=a;this.f=b;this.b=0;this.a=null}sa.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function ta(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function ua(){this.b=this.a=null}var wa=new sa(function(){return new va},function(a){a.reset()});ua.prototype.add=function(a,b){var c=wa.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function xa(){var a=ya,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function va(){this.next=this.b=this.a=null}va.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};va.prototype.reset=function(){this.next=this.b=this.a=null};var za=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(l(a))return l(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},v=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=l(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function Aa(a,b){var c=a.length,d=l(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}
	var Ba=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=l(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Ca=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
	function Da(a){a:{var b=Ea;for(var c=a.length,d=l(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:l(a)?a.charAt(b):a[b]}function Fa(a,b){return 0<=za(a,b)}function Ga(a,b){b=za(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Ha(a,b){var c=0;Aa(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ia(a){return Array.prototype.concat.apply([],arguments)}
	function Ja(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};function Ka(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var La=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};
	function Ma(a){if(!Na.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(Oa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(Pa,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(Qa,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(Ra,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(Sa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(Ta,"&#0;"));return a}var Oa=/&/g,Pa=/</g,Qa=/>/g,Ra=/"/g,Sa=/'/g,Ta=/\x00/g,Na=/[\x00&<>"']/;function w(a,b){return-1!=a.indexOf(b)}function Ua(a,b){return a<b?-1:a>b?1:0};var Va;a:{var Wa=k.navigator;if(Wa){var Xa=Wa.userAgent;if(Xa){Va=Xa;break a}}Va=""}function x(a){return w(Va,a)};function Ya(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Za(a){for(var b in a)return!1;return!0}function $a(a){var b={},c;for(c in a)b[c]=a[c];return b}var ab="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function bb(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<ab.length;f++)c=ab[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function cb(a){k.setTimeout(function(){throw a;},0)}var db;
	function eb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
	c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.tb;c.tb=null;a()}};return function(a){d.next={tb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
	b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function fb(a,b){gb||hb();ib||(gb(),ib=!0);ya.add(a,b)}var gb;function hb(){if(k.Promise&&k.Promise.resolve){var a=k.Promise.resolve(void 0);gb=function(){a.then(jb)}}else gb=function(){var a=jb;!n(k.setImmediate)||k.Window&&k.Window.prototype&&!x("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(db||(db=eb()),db(a)):k.setImmediate(a)}}var ib=!1,ya=new ua;function jb(){for(var a;a=xa();){try{a.a.call(a.b)}catch(b){cb(b)}ta(wa,a)}ib=!1};function y(a,b){this.a=kb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){lb(c,mb,a)},function(a){if(!(a instanceof nb))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}lb(c,ob,a)})}catch(d){lb(this,ob,d)}}var kb=0,mb=2,ob=3;function pb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}pb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var qb=new sa(function(){return new pb},function(a){a.reset()});
	function rb(a,b,c){var d=qb.get();d.g=a;d.b=b;d.f=c;return d}function A(a){if(a instanceof y)return a;var b=new y(ca);lb(b,mb,a);return b}function B(a){return new y(function(b,c){c(a)})}function sb(a,b,c){tb(a,b,c,null)||fb(ma(b,a))}function ub(a){return new y(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},h=function(a){c(a)},m=0,p;m<a.length;m++)p=a[m],sb(p,ma(f,m),h);else b(e)})}
	function vb(a){return new y(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Zb:!0,value:f}:{Zb:!1,reason:f};0==c&&b(d)},f=0,h;f<a.length;f++)h=a[f],sb(h,ma(e,f,!0),ma(e,f,!1));else b(d)})}y.prototype.then=function(a,b,c){return wb(this,n(a)?a:null,n(b)?b:null,c)};oa(y);g=y.prototype;g.ia=function(a,b){a=rb(a,a,b);a.c=!0;xb(this,a);return this};g.s=function(a,b){return wb(this,null,a,b)};g.cancel=function(a){this.a==kb&&fb(function(){var b=new nb(a);yb(this,b)},this)};
	function yb(a,b){if(a.a==kb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,h=c.b;h&&(h.c||(d++,h.a==a&&(e=h),!(e&&1<d)));h=h.next)e||(f=h);e&&(c.a==kb&&1==d?yb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):zb(c),Ab(c,e,ob,b)))}a.c=null}else lb(a,ob,b)}function xb(a,b){a.b||a.a!=mb&&a.a!=ob||Bb(a);a.f?a.f.next=b:a.b=b;a.f=b}
	function wb(a,b,c,d){var e=rb(null,null,null);e.a=new y(function(a,h){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(z){h(z)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof nb?h(b):a(e)}catch(z){h(z)}}:h});e.a.c=a;xb(a,e);return e.a}g.Lc=function(a){this.a=kb;lb(this,mb,a)};g.Mc=function(a){this.a=kb;lb(this,ob,a)};
	function lb(a,b,c){a.a==kb&&(a===c&&(b=ob,c=new TypeError("Promise cannot resolve to itself")),a.a=1,tb(c,a.Lc,a.Mc,a)||(a.i=c,a.a=b,a.c=null,Bb(a),b!=ob||c instanceof nb||Cb(a,c)))}function tb(a,b,c,d){if(a instanceof y)return xb(a,rb(b||ca,c||null,d)),!0;if(pa(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(n(e))return Db(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
	function Db(a,b,c,d,e){function f(a){m||(m=!0,d.call(e,a))}function h(a){m||(m=!0,c.call(e,a))}var m=!1;try{b.call(a,h,f)}catch(p){f(p)}}function Bb(a){a.h||(a.h=!0,fb(a.Ub,a))}function zb(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}g.Ub=function(){for(var a;a=zb(this);)Ab(this,a,this.a,this.i);this.h=!1};
	function Ab(a,b,c,d){if(c==ob&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Eb(b,c,d);else try{b.c?b.g.call(b.f):Eb(b,c,d)}catch(e){Fb.call(null,e)}ta(qb,b)}function Eb(a,b,c){b==mb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Cb(a,b){a.g=!0;fb(function(){a.g&&Fb.call(null,b)})}var Fb=cb;function nb(a){u.call(this,a)}t(nb,u);nb.prototype.name="cancel";function Gb(){0!=Hb&&(Ib[this[ia]||(this[ia]=++ja)]=this);this.pa=this.pa;this.ja=this.ja}var Hb=0,Ib={};Gb.prototype.pa=!1;function Jb(a){if(!a.pa&&(a.pa=!0,a.ua(),0!=Hb)){var b=a[ia]||(a[ia]=++ja);if(0!=Hb&&a.ja&&0<a.ja.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Ib[b]}}Gb.prototype.ua=function(){if(this.ja)for(;this.ja.length;)this.ja.shift()()};function Kb(a){Kb[" "](a);return a}Kb[" "]=ca;function Lb(a,b){var c=Mb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Nb=x("Opera"),Ob=x("Trident")||x("MSIE"),Pb=x("Edge"),Qb=Pb||Ob,Rb=x("Gecko")&&!(w(Va.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),Sb=w(Va.toLowerCase(),"webkit")&&!x("Edge");function Tb(){var a=k.document;return a?a.documentMode:void 0}var Ub;
	a:{var Vb="",Wb=function(){var a=Va;if(Rb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Pb)return/Edge\/([\d\.]+)/.exec(a);if(Ob)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Sb)return/WebKit\/(\S+)/.exec(a);if(Nb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();Wb&&(Vb=Wb?Wb[1]:"");if(Ob){var Xb=Tb();if(null!=Xb&&Xb>parseFloat(Vb)){Ub=String(Xb);break a}}Ub=Vb}var Mb={};
	function Yb(a){return Lb(a,function(){for(var b=0,c=La(String(Ub)).split("."),d=La(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",m=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];m=/(\d*)(\D*)(.*)/.exec(m)||["","","",""];if(0==h[0].length&&0==m[0].length)break;b=Ua(0==h[1].length?0:parseInt(h[1],10),0==m[1].length?0:parseInt(m[1],10))||Ua(0==h[2].length,0==m[2].length)||Ua(h[2],m[2]);h=h[3];m=m[3]}while(0==b)}return 0<=b})}var Zb;var $b=k.document;
	Zb=$b&&Ob?Tb()||("CSS1Compat"==$b.compatMode?parseInt(Ub,10):5):void 0;var ac=Object.freeze||function(a){return a};var bc=!Ob||9<=Number(Zb),cc=Ob&&!Yb("9"),dc=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function C(a,b){this.type=a;this.b=this.target=b;this.Gb=!0}C.prototype.preventDefault=function(){this.Gb=!1};function ec(a,b){C.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Rb){a:{try{Kb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
	a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=l(a.pointerType)?a.pointerType:fc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}t(ec,C);var fc=ac({2:"touch",3:"pen",4:"mouse"});ec.prototype.preventDefault=function(){ec.lb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,cc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};ec.prototype.f=function(){return this.a};var gc="closure_listenable_"+(1E6*Math.random()|0),hc=0;function ic(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++hc;this.na=this.Ia=!1}function jc(a){a.na=!0;a.listener=null;a.proxy=null;a.src=null;a.La=null};function kc(a){this.src=a;this.a={};this.b=0}kc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=lc(a,b,d,e);-1<h?(b=a[h],c||(b.Ia=!1)):(b=new ic(b,this.src,f,!!d,e),b.Ia=c,a.push(b));return b};function mc(a,b){var c=b.type;c in a.a&&Ga(a.a[c],b)&&(jc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function lc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.na&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var nc="closure_lm_"+(1E6*Math.random()|0),oc={},qc=0;function rc(a,b,c,d,e){if(d&&d.once)sc(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)rc(a,b[f],c,d,e);else c=tc(c),a&&a[gc]?uc(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!1,d,e)}
	function vc(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=q(e)?!!e.capture:!!e,m=wc(a);m||(a[nc]=m=new kc(a));c=m.add(b,c,d,h,f);if(!c.proxy){d=xc();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)dc||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(yc(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");qc++}}
	function xc(){var a=zc,b=bc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function sc(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)sc(a,b[f],c,d,e);else c=tc(c),a&&a[gc]?Ac(a,b,c,q(d)?!!d.capture:!!d,e):vc(a,b,c,!0,d,e)}
	function D(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)D(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=tc(c),a&&a[gc])?(a=a.m,b=String(b).toString(),b in a.a&&(f=a.a[b],c=lc(f,c,d,e),-1<c&&(jc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=wc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=lc(b,c,d,e)),(c=-1<a?b[a]:null)&&Bc(c))}
	function Bc(a){if("number"!=typeof a&&a&&!a.na){var b=a.src;if(b&&b[gc])mc(b.m,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(yc(c),d):b.addListener&&b.removeListener&&b.removeListener(d);qc--;(c=wc(b))?(mc(c,a),0==c.b&&(c.src=null,b[nc]=null)):jc(a)}}}function yc(a){return a in oc?oc[a]:oc[a]="on"+a}
	function Cc(a,b,c,d){var e=!0;if(a=wc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.na&&(f=Dc(f,d),e=e&&!1!==f)}return e}function Dc(a,b){var c=a.listener,d=a.La||a.src;a.Ia&&Bc(a);return c.call(d,b)}
	function zc(a,b){if(a.na)return!0;if(!bc){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new ec(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(h){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=Cc(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=Cc(d[e],a,!1,b),c=c&&f}return c}return Dc(a,
	new ec(b,this))}function wc(a){a=a[nc];return a instanceof kc?a:null}var Ec="__closure_events_fn_"+(1E9*Math.random()>>>0);function tc(a){if(n(a))return a;a[Ec]||(a[Ec]=function(b){return a.handleEvent(b)});return a[Ec]};function E(){Gb.call(this);this.m=new kc(this);this.Nb=this;this.Ua=null}t(E,Gb);E.prototype[gc]=!0;E.prototype.addEventListener=function(a,b,c,d){rc(this,a,b,c,d)};E.prototype.removeEventListener=function(a,b,c,d){D(this,a,b,c,d)};
	E.prototype.dispatchEvent=function(a){var b,c=this.Ua;if(c)for(b=[];c;c=c.Ua)b.push(c);c=this.Nb;var d=a.type||a;if(l(a))a=new C(a,c);else if(a instanceof C)a.target=a.target||c;else{var e=a;a=new C(d,c);bb(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.b=b[f];e=Fc(h,d,!0,a)&&e}h=a.b=c;e=Fc(h,d,!0,a)&&e;e=Fc(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.b=b[f],e=Fc(h,d,!1,a)&&e;return e};
	E.prototype.ua=function(){E.lb.ua.call(this);if(this.m){var a=this.m,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,jc(d[e]);delete a.a[c];a.b--}}this.Ua=null};function uc(a,b,c,d,e){a.m.add(String(b),c,!1,d,e)}function Ac(a,b,c,d,e){a.m.add(String(b),c,!0,d,e)}
	function Fc(a,b,c,d){b=a.m.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.na&&h.capture==c){var m=h.listener,p=h.La||h.src;h.Ia&&mc(a.m,h);e=!1!==m.call(p,d)&&e}}return e&&0!=d.Gb};function Gc(a,b,c){if(n(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function Hc(a){var b=null;return(new y(function(c,d){b=Gc(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(a){k.clearTimeout(b);throw a;})};function Ic(a){if(a.S&&"function"==typeof a.S)return a.S();if(l(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Jc(a){if(a.U&&"function"==typeof a.U)return a.U();if(!a.S||"function"!=typeof a.S){if(ha(a)||l(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
	function Kc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||l(a))v(a,b,void 0);else for(var c=Jc(a),d=Ic(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Lc(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Lc)for(c=a.U(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}g=Lc.prototype;g.S=function(){Mc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.U=function(){Mc(this);return this.a.concat()};
	g.clear=function(){this.b={};this.c=this.a.length=0};function Mc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Nc(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Nc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}g.get=function(a,b){return Nc(this.b,a)?this.b[a]:b};g.set=function(a,b){Nc(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	g.forEach=function(a,b){for(var c=this.U(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Nc(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Oc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Qc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Rc(a,b){this.b=this.m=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof Rc){this.f=void 0!==b?b:a.f;Sc(this,a.c);this.m=a.m;this.b=a.b;Tc(this,a.i);this.g=a.g;b=a.a;var c=new Uc;c.c=b.c;b.a&&(c.a=new Lc(b.a),c.b=b.b);Vc(this,c);this.h=a.h}else a&&(c=String(a).match(Oc))?(this.f=!!b,Sc(this,c[1]||"",!0),this.m=Wc(c[2]||""),this.b=Wc(c[3]||"",!0),Tc(this,c[4]),this.g=Wc(c[5]||"",!0),Vc(this,c[6]||"",!0),this.h=Wc(c[7]||"")):(this.f=!!b,this.a=new Uc(null,this.f))}
	Rc.prototype.toString=function(){var a=[],b=this.c;b&&a.push(Xc(b,Yc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.m)&&a.push(Xc(b,Yc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Xc(c,"/"==c.charAt(0)?Zc:$c,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",Xc(c,ad));return a.join("")};
	function Sc(a,b,c){a.c=c?Wc(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function Tc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function Vc(a,b,c){b instanceof Uc?(a.a=b,bd(a.a,a.f)):(c||(b=Xc(b,cd)),a.a=new Uc(b,a.f))}function F(a,b,c){a.a.set(b,c)}function dd(a,b){return a.a.get(b)}function ed(a){return a instanceof Rc?new Rc(a):new Rc(a,void 0)}function fd(a,b){var c=new Rc(null,void 0);Sc(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
	function Wc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Xc(a,b,c){return l(a)?(a=encodeURI(a).replace(b,gd),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function gd(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Yc=/[#\/\?@]/g,$c=/[#\?:]/g,Zc=/[#\?]/g,cd=/[#\?@]/g,ad=/#/g;function Uc(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}
	function hd(a){a.a||(a.a=new Lc,a.b=0,a.c&&Qc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function id(a){var b=Jc(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Uc(null,void 0);a=Ic(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?jd(c,e,f):c.add(e,f)}return c}g=Uc.prototype;g.add=function(a,b){hd(this);this.c=null;a=kd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};
	function ld(a,b){hd(a);b=kd(a,b);Nc(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Nc(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Mc(a)))}g.clear=function(){this.a=this.c=null;this.b=0};function md(a,b){hd(a);b=kd(a,b);return Nc(a.a.b,b)}g.forEach=function(a,b){hd(this);this.a.forEach(function(c,d){v(c,function(c){a.call(b,c,d,this)},this)},this)};g.U=function(){hd(this);for(var a=this.a.S(),b=this.a.U(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
	g.S=function(a){hd(this);var b=[];if(l(a))md(this,a)&&(b=Ia(b,this.a.get(kd(this,a))));else{a=this.a.S();for(var c=0;c<a.length;c++)b=Ia(b,a[c])}return b};g.set=function(a,b){hd(this);this.c=null;a=kd(this,a);md(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};g.get=function(a,b){a=a?this.S(a):[];return 0<a.length?String(a[0]):b};function jd(a,b,c){ld(a,b);0<c.length&&(a.c=null,a.a.set(kd(a,b),Ja(c)),a.b+=c.length)}
	g.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.U(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.S(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h)}}return this.c=a.join("&")};function kd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function bd(a,b){b&&!a.f&&(hd(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(ld(this,b),jd(this,c,a))},a));a.f=b};var nd=!Ob||9<=Number(Zb);function od(){this.a="";this.b=pd}od.prototype.ma=!0;od.prototype.la=function(){return this.a};od.prototype.toString=function(){return"Const{"+this.a+"}"};function qd(a){if(a instanceof od&&a.constructor===od&&a.b===pd)return a.a;ra("expected object of type Const, got '"+a+"'");return"type_error:Const"}var pd={};function rd(a){var b=new od;b.a=a;return b}rd("");function sd(){this.a="";this.b=td}sd.prototype.ma=!0;sd.prototype.la=function(){return this.a};sd.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function ud(a){if(a instanceof sd&&a.constructor===sd&&a.b===td)return a.a;ra("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}
	function vd(a,b){var c=qd(a);if(!wd.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(xd,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof od?qd(a):encodeURIComponent(String(a))});return yd(a)}var xd=/%{(\w+)}/g,wd=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank#/i,td={};
	function yd(a){var b=new sd;b.a=a;return b};function zd(){this.a="";this.b=Ad}zd.prototype.ma=!0;zd.prototype.la=function(){return this.a};zd.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Bd(a){if(a instanceof zd&&a.constructor===zd&&a.b===Ad)return a.a;ra("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var Cd=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
	function Dd(a){if(a instanceof zd)return a;a=a.ma?a.la():String(a);Cd.test(a)||(a="about:invalid#zClosurez");return Ed(a)}var Ad={};function Ed(a){var b=new zd;b.a=a;return b}Ed("about:blank");function Fd(){this.a="";this.b=Gd}Fd.prototype.ma=!0;Fd.prototype.la=function(){return this.a};Fd.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Hd(a){if(a instanceof Fd&&a.constructor===Fd&&a.b===Gd)return a.a;ra("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var Gd={};function Id(a){var b=new Fd;b.a=a;return b}Id("<!DOCTYPE html>");Id("");Id("<br>");function Jd(a){var b=document;return l(a)?b.getElementById(a):a}function Kd(a,b){Ya(b,function(b,d){b&&b.ma&&(b=b.la());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Ld.hasOwnProperty(d)?a.setAttribute(Ld[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
	var Ld={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function Md(a,b,c){var d=arguments,e=document,f=String(d[0]),h=d[1];if(!nd&&h&&(h.name||h.type)){f=["<",f];h.name&&f.push(' name="',Ma(h.name),'"');if(h.type){f.push(' type="',Ma(h.type),'"');var m={};bb(m,h);delete m.type;h=m}f.push(">");f=f.join("")}f=e.createElement(f);h&&(l(h)?f.className=h:fa(h)?f.className=h.join(" "):Kd(f,h));2<d.length&&Nd(e,f,d);return f}
	function Nd(a,b,c){function d(c){c&&b.appendChild(l(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):v(Od(f)?Ja(f):f,d)}}function Od(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(n(a))return"function"==typeof a.item}return!1};function Pd(a){var b=[];Qd(new Rd,a,b);return b.join("")}function Rd(){}
	function Qd(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Qd(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Sd(d,c),c.push(":"),Qd(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Sd(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Td={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ud=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function Sd(a,b){b.push('"',a.replace(Ud,function(a){var b=Td[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Td[a]=b);return b}),'"')};function Vd(){var a=G();return Ob&&!!Zb&&11==Zb||/Edge\/\d+/.test(a)}function Wd(){return k.window&&k.window.location.href||self&&self.location&&self.location.href||""}function Xd(a,b){b=b||k.window;var c="about:blank";a&&(c=Bd(Dd(a)));b.location.href=c}function Yd(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Yd(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
	function Zd(){var a=G();a=$d(a)!=ae?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Ob||!Zb||9<Zb}function be(a){a=(a||G()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function ce(a){a=a||k.window;try{a.close()}catch(b){}}
	function de(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=G().toLowerCase();d&&(b.target=d,w(c,"crios/")&&(b.target="_blank"));$d(G())==ee&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof zd?c:Dd("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
	for(h in a)switch(h){case "width":case "height":case "top":case "left":e.push(h+"="+a[h]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(h+"="+(a[h]?1:0))}var h=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(h=d.document.createElement("A"),b instanceof zd||b instanceof zd||(b=b.ma?b.la():String(b),Cd.test(b)||(b="about:invalid#zClosurez"),b=Ed(b)),h.href=Bd(b),h.setAttribute("target",c),a.noreferrer&&
	h.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),h.dispatchEvent(a),h={}):a.noreferrer?(h=d.open("",c,h),a=Bd(b),h&&(Qb&&w(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),h.opener=null,rd("b/12014412, meta tag with sanitized URL"),a='<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Ma(a)+'">',a=Id(a),h.document.write(Hd(a)),h.document.close())):(h=d.open(Bd(b),c,h))&&a.noopener&&(h.opener=null);if(h)try{h.focus()}catch(m){}return h}
	function fe(a){return new y(function(b){function c(){Hc(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var ge=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;function he(){var a=null;return(new y(function(b){"complete"==k.document.readyState?b():(a=function(){b()},sc(window,"load",a))})).s(function(b){D(window,"load",a);throw b;})}
	function ie(){return je(void 0)?he().then(function(){return new y(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):B(Error("Cordova must run in an Android or iOS file scheme."))}function je(a){a=a||G();return!("file:"!==ke()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function le(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
	function me(){return"object"!==typeof k.window&&"function"===typeof k.importScripts}function ne(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":me()?"Worker":"Browser"}function oe(){var a=ne();return"ReactNative"===a||"Node"===a}function pe(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}var ee="Firefox",ae="Chrome";
	function $d(a){var b=a.toLowerCase();if(w(b,"opera/")||w(b,"opr/")||w(b,"opios/"))return"Opera";if(w(b,"iemobile"))return"IEMobile";if(w(b,"msie")||w(b,"trident/"))return"IE";if(w(b,"edge/"))return"Edge";if(w(b,"firefox/"))return ee;if(w(b,"silk/"))return"Silk";if(w(b,"blackberry"))return"Blackberry";if(w(b,"webos"))return"Webos";if(!w(b,"safari/")||w(b,"chrome/")||w(b,"crios/")||w(b,"android"))if(!w(b,"chrome/")&&!w(b,"crios/")||w(b,"edge/")){if(w(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
	2==a.length)return a[1]}else return ae;else return"Safari";return"Other"}var qe={Sc:"FirebaseCore-web",Uc:"FirebaseUI-web"};function re(a,b){b=b||[];var c=[],d={},e;for(e in qe)d[qe[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=ne();"Browser"===c?(d=G(),c=$d(d)):"Worker"===c&&(d=G(),c=$d(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function G(){return k.navigator&&k.navigator.userAgent||""}
	function H(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function se(){try{var a=k.localStorage,b=te();if(a)return a.setItem(b,"1"),a.removeItem(b),Vd()?!!k.indexedDB:!0}catch(c){return me()&&!!k.indexedDB}return!1}function ue(){return(ve()||"chrome-extension:"===ke()||je())&&!oe()&&se()&&!me()}function ve(){return"http:"===ke()||"https:"===ke()}function ke(){return k.location&&k.location.protocol||null}
	function we(a){a=a||G();return be(a)||$d(a)==ee?!1:!0}function xe(a){return"undefined"===typeof a?null:Pd(a)}function ye(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function ze(a){if(null!==a)return JSON.parse(a)}function te(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ae(a){a=a||G();return"Safari"==$d(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
	function Be(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Ce(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=G();b=ne();this.b=be(a)||"ReactNative"===b}
	Ce.prototype.get=function(){var a=k.navigator;return(a&&"boolean"===typeof a.onLine&&(ve()||"chrome-extension:"===ke()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function De(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
	function Ee(){var a=k.document,b=null;return De()||!a?A():(new y(function(c){b=function(){De()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Fe(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Ge(){return!(!H("fireauth.oauthhelper",k)&&!H("fireauth.iframe",k))};var He={};function Ie(a){He[a]||(He[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Je;try{var Ke={};Object.defineProperty(Ke,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Ke,"abcd",{configurable:!0,enumerable:!0,value:2});Je=2==Ke.abcd}catch(a){Je=!1}function I(a,b,c){Je?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function J(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&I(a,c,b[c])}function Le(a){var b={};J(b,a);return b}function Me(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
	function Ne(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function Oe(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)I(b,c,Oe(a[c]))}return b};function Pe(a){var b={},c=a[Qe],d=a[Re];a=a[Se];if(!a||a!=Te&&!c)throw Error("Invalid provider user info!");b[Ue]=d||null;b[Ve]=c||null;I(this,We,a);I(this,Xe,Oe(b))}var Te="EMAIL_SIGNIN",Qe="email",Re="newEmail",Se="requestType",Ve="email",Ue="fromEmail",Xe="data",We="operation";function K(a,b){this.code=Ye+a;this.message=b||Ze[a]||""}t(K,Error);K.prototype.D=function(){return{code:this.code,message:this.message}};K.prototype.toJSON=function(){return this.D()};function $e(a){var b=a&&a.code;return b?new K(b.substring(Ye.length),a.message):null}
	var Ye="auth/",Ze={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
	"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
	"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
	"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
	"invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.",
	"invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
	"invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
	"invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
	"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
	"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
	"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
	"operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.",
	"quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.",
	"unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.",
	"user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function af(a){var b=a[bf];if("undefined"===typeof b)throw new K("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new K("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[cf];if(c&&"object"===typeof c){b=c[df];var d=c[ef];c=c[ff];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new K("argument-error",ef+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
	typeof c||"string"===typeof c&&!c.length))throw new K("argument-error",ff+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new K("argument-error",df+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new K("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new K("argument-error",cf+" property must be a non null object when specified.");this.f=null;if((b=a[gf])&&"object"===
	typeof b)if(b=b[hf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new K("argument-error",hf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new K("argument-error",gf+" property must be a non null object when specified.");a=a[jf];if("undefined"!==typeof a&&"boolean"!==typeof a)throw new K("argument-error",jf+" property must be a boolean when specified.");this.c=!!a}
	var cf="android",jf="handleCodeInApp",gf="iOS",bf="url",ef="installApp",ff="minimumVersion",df="packageName",hf="bundleId";function kf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;for(var c in b)null===b[c]&&delete b[c];return b};function lf(a){return Ba(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var mf=null,nf=null;function of(a){var b="";pf(a,function(a){b+=String.fromCharCode(a)});return b}function pf(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=nf[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}qf();for(var d=0;;){var e=c(-1),f=c(0),h=c(64),m=c(64);if(64===m&&-1===e)break;b(e<<2|f>>4);64!=h&&(b(f<<4&240|h>>2),64!=m&&b(h<<6&192|m))}}
	function qf(){if(!mf){mf={};nf={};for(var a=0;65>a;a++)mf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),nf[mf[a]]=a,62<=a&&(nf["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function rf(a){this.c=a.sub;na();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.b=!!a.is_anonymous||"anonymous"==this.a}rf.prototype.f=function(){return this.b};function sf(a){return(a=tf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new rf(a):null}function tf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(of(a))}catch(d){}return null};var uf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),vf=["client_id","response_type","scope","redirect_uri","state"],wf={Tc:{Ma:"locale",Ba:500,Aa:600,Na:"facebook.com",eb:vf},Vc:{Ma:null,Ba:500,Aa:620,Na:"github.com",eb:vf},Wc:{Ma:"hl",Ba:515,Aa:680,Na:"google.com",eb:vf},bd:{Ma:"lang",Ba:485,Aa:705,Na:"twitter.com",eb:uf}};function xf(a){for(var b in wf)if(wf[b].Na==a)return wf[b];return null};function yf(a){var b={};b["facebook.com"]=zf;b["google.com"]=Af;b["github.com"]=Bf;b["twitter.com"]=Cf;var c=a&&a[Df];try{if(c)return b[c]?new b[c](a):new Ef(a);if("undefined"!==typeof a[Ff])return new Gf(a)}catch(d){}return null}var Ff="idToken",Df="providerId";
	function Gf(a){var b=a[Df];if(!b&&a[Ff]){var c=sf(a[Ff]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);I(this,"providerId",b);I(this,"isNewUser",c)}function Ef(a){Gf.call(this,a);a=ze(a.rawUserInfo||"{}");I(this,"profile",Oe(a||{}))}t(Ef,Gf);
	function zf(a){Ef.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(zf,Ef);function Bf(a){Ef.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");I(this,"username",this.profile&&this.profile.login||null)}t(Bf,Ef);function Af(a){Ef.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Af,Ef);
	function Cf(a){Ef.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");I(this,"username",a.screenName||null)}t(Cf,Ef);function Hf(a){this.a=ed(a)};function If(a){var b=ed(a),c=dd(b,"link"),d=dd(ed(c),"link");b=dd(b,"deep_link_id");return dd(ed(b),"link")||b||d||c||a};function Jf(a,b){return a.then(function(a){if(a[L]){var c=sf(a[L]);if(!c||b!=c.c)throw new K("user-mismatch");return a}throw new K("user-mismatch");}).s(function(a){throw a&&a.code&&a.code==Ye+"user-not-found"?new K("user-mismatch"):a;})}
	function Kf(a,b,c){if(b.idToken||b.accessToken)b.idToken&&I(this,"idToken",b.idToken),b.accessToken&&I(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)I(this,"accessToken",b.oauthToken),I(this,"secret",b.oauthTokenSecret);else throw new K("internal-error","failed to construct a credential");I(this,"providerId",a);I(this,"signInMethod",c)}Kf.prototype.ya=function(a){return Lf(a,Mf(this))};Kf.prototype.c=function(a,b){var c=Mf(this);c.idToken=b;return Nf(a,c)};
	Kf.prototype.f=function(a,b){var c=Mf(this);return Jf(Of(a,c),b)};function Mf(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:id(b).toString(),requestUri:"http://localhost"}}
	Kf.prototype.D=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};function Pf(a,b){this.Ac=b||[];J(this,{providerId:a,isOAuthProvider:!0});this.vb={};this.$a=(xf(a)||{}).Ma||null;this.Ya=null}Pf.prototype.Da=function(a){this.vb=$a(a);return this};function M(a){Pf.call(this,a,vf);this.a=[]}t(M,Pf);
	M.prototype.ta=function(a){Fa(this.a,a)||this.a.push(a);return this};M.prototype.Ab=function(){return Ja(this.a)};M.prototype.credential=function(a,b){if(!a&&!b)throw new K("argument-error","credential failed: must provide the ID token and/or the access token.");return new Kf(this.providerId,{idToken:a||null,accessToken:b||null},this.providerId)};function Qf(){M.call(this,"facebook.com")}t(Qf,M);I(Qf,"PROVIDER_ID","facebook.com");I(Qf,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
	function Rf(a){if(!a)throw new K("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Qf).credential(null,b)}function Sf(){M.call(this,"github.com")}t(Sf,M);I(Sf,"PROVIDER_ID","github.com");I(Sf,"GITHUB_SIGN_IN_METHOD","github.com");function Tf(a){if(!a)throw new K("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new Sf).credential(null,b)}
	function Uf(){M.call(this,"google.com");this.ta("profile")}t(Uf,M);I(Uf,"PROVIDER_ID","google.com");I(Uf,"GOOGLE_SIGN_IN_METHOD","google.com");function Vf(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new Uf).credential(c,b)}function Wf(){Pf.call(this,"twitter.com",uf)}t(Wf,Pf);I(Wf,"PROVIDER_ID","twitter.com");I(Wf,"TWITTER_SIGN_IN_METHOD","twitter.com");
	function Xf(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new K("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Kf("twitter.com",c,"twitter.com")}function Yf(a,b,c){this.a=a;this.b=b;I(this,"providerId","password");I(this,"signInMethod",c===N.EMAIL_LINK_SIGN_IN_METHOD?N.EMAIL_LINK_SIGN_IN_METHOD:N.EMAIL_PASSWORD_SIGN_IN_METHOD)}
	Yf.prototype.ya=function(a){return this.signInMethod==N.EMAIL_LINK_SIGN_IN_METHOD?O(a,Zf,{email:this.a,oobCode:this.b}):O(a,$f,{email:this.a,password:this.b})};Yf.prototype.c=function(a,b){return this.signInMethod==N.EMAIL_LINK_SIGN_IN_METHOD?O(a,ag,{idToken:b,email:this.a,oobCode:this.b}):O(a,bg,{idToken:b,email:this.a,password:this.b})};Yf.prototype.f=function(a,b){return Jf(this.ya(a),b)};Yf.prototype.D=function(){return{email:this.a,password:this.b,signInMethod:this.signInMethod}};
	function N(){J(this,{providerId:"password",isOAuthProvider:!1})}function cg(a,b){b=dg(b);if(!b)throw new K("argument-error","Invalid email link!");return new Yf(a,b,N.EMAIL_LINK_SIGN_IN_METHOD)}function dg(a){a=If(a);a=new Hf(a);var b=dd(a.a,"oobCode")||null;return"signIn"===(dd(a.a,"mode")||null)&&b?b:null}J(N,{PROVIDER_ID:"password"});J(N,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});J(N,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});
	function eg(a){if(!(a.Sa&&a.Ra||a.Fa&&a.$))throw new K("internal-error");this.a=a;I(this,"providerId","phone");I(this,"signInMethod","phone")}eg.prototype.ya=function(a){return a.Ta(fg(this))};eg.prototype.c=function(a,b){var c=fg(this);c.idToken=b;return O(a,gg,c)};eg.prototype.f=function(a,b){var c=fg(this);c.operation="REAUTH";a=O(a,hg,c);return Jf(a,b)};
	eg.prototype.D=function(){var a={providerId:"phone"};this.a.Sa&&(a.verificationId=this.a.Sa);this.a.Ra&&(a.verificationCode=this.a.Ra);this.a.Fa&&(a.temporaryProof=this.a.Fa);this.a.$&&(a.phoneNumber=this.a.$);return a};function fg(a){return a.a.Fa&&a.a.$?{temporaryProof:a.a.Fa,phoneNumber:a.a.$}:{sessionInfo:a.a.Sa,code:a.a.Ra}}
	function ig(a){try{this.a=a||firebase.auth()}catch(b){throw new K("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}J(this,{providerId:"phone",isOAuthProvider:!1})}
	ig.prototype.Ta=function(a,b){var c=this.a.b;return A(b.verify()).then(function(d){if(!l(d))throw new K("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return jg(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new K("argument-error",
	'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function kg(a,b){if(!a)throw new K("missing-verification-id");if(!b)throw new K("missing-verification-code");return new eg({Sa:a,Ra:b})}J(ig,{PROVIDER_ID:"phone"});J(ig,{PHONE_SIGN_IN_METHOD:"phone"});
	function lg(a){if(a.temporaryProof&&a.phoneNumber)return new eg({Fa:a.temporaryProof,$:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return Vf(a,c);case "facebook.com":return Rf(c);case "github.com":return Tf(c);case "twitter.com":return Xf(c,d);default:return(new M(b)).credential(a,c)}}catch(e){return null}}
	function mg(a){if(!a.isOAuthProvider)throw new K("invalid-oauth-provider");};function ng(a,b,c,d,e){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new K("invalid-auth-event");if(this.f&&!this.g)throw new K("invalid-auth-event");}else throw new K("invalid-auth-event");}ng.prototype.D=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,error:this.a&&this.a.D()}};function og(a){a=a||{};return a.type?new ng(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&$e(a.error)):null};function pg(){this.b=null;this.a=[]}var qg=null;pg.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(a){for(var c=0;c<b.a.length;c++)b.a[c](a)},a=H("universalLinks.subscribe",k),"function"===typeof a&&a(null,this.b))};pg.prototype.unsubscribe=function(a){Ha(this.a,function(b){return b==a})};function rg(a){var b="unauthorized-domain",c=void 0,d=ed(a);a=d.b;d=d.c;"chrome-extension"==d?c=Ka("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Ka("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
	K.call(this,b,c)}t(rg,K);function sg(a,b,c){K.call(this,a,c);a=b||{};a.wb&&I(this,"email",a.wb);a.$&&I(this,"phoneNumber",a.$);a.credential&&I(this,"credential",a.credential)}t(sg,K);sg.prototype.D=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.D();b&&bb(a,b);return a};sg.prototype.toJSON=function(){return this.D()};
	function tg(a){if(a.code){var b=a.code||"";0==b.indexOf(Ye)&&(b=b.substring(Ye.length));var c={credential:lg(a)};if(a.email)c.wb=a.email;else if(a.phoneNumber)c.$=a.phoneNumber;else return new K(b,a.message||void 0);return new sg(b,c,a.message)}return null};var ug=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function vg(){}vg.prototype.c=null;function wg(a){return a.c||(a.c=a.b())};var xg;function yg(){}t(yg,vg);yg.prototype.a=function(){var a=zg(this);return a?new ActiveXObject(a):new XMLHttpRequest};yg.prototype.b=function(){var a={};zg(this)&&(a[0]=!0,a[1]=!0);return a};
	function zg(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}xg=new yg;function Ag(){}t(Ag,vg);Ag.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Bg;throw Error("Unsupported browser");};Ag.prototype.b=function(){return{}};
	function Bg(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText="";this.a.onload=r(this.bc,this);this.a.onerror=r(this.Bb,this);this.a.onprogress=r(this.cc,this);this.a.ontimeout=r(this.fc,this)}g=Bg.prototype;g.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
	g.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};g.abort=function(){this.a.abort()};g.setRequestHeader=function(){};g.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};g.bc=function(){this.status=200;this.responseText=this.a.responseText;Cg(this,4)};g.Bb=function(){this.status=500;this.responseText="";Cg(this,4)};g.fc=function(){this.Bb()};
	g.cc=function(){this.status=200;Cg(this,1)};function Cg(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}g.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Dg(a,b,c){this.reset(a,b,c,void 0,void 0)}Dg.prototype.a=null;var Eg=0;Dg.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Eg++;d||na();delete this.a};function Fg(a){this.f=a;this.b=this.c=this.a=null}function Gg(a,b){this.name=a;this.value=b}Gg.prototype.toString=function(){return this.name};var Hg=new Gg("SEVERE",1E3),Ig=new Gg("WARNING",900),Jg=new Gg("CONFIG",700),Kg=new Gg("FINE",500);function Lg(a){if(a.c)return a.c;if(a.a)return Lg(a.a);ra("Root logger has no level set.");return null}Fg.prototype.log=function(a,b,c){if(a.value>=Lg(this).value)for(n(b)&&(b=b()),a=new Dg(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Mg={},Ng=null;
	function Og(a){Ng||(Ng=new Fg(""),Mg[""]=Ng,Ng.c=Jg);var b;if(!(b=Mg[a])){b=new Fg(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Og(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Mg[a]=b}return b};function P(a,b){a&&a.log(Kg,b,void 0)};function Pg(a){this.f=a}t(Pg,vg);Pg.prototype.a=function(){return new Qg(this.f)};Pg.prototype.b=function(a){return function(){return a}}({});function Qg(a){E.call(this);this.i=a;this.readyState=Rg;this.status=0;this.responseText=this.statusText="";this.onreadystatechange=null;this.g=new Headers;this.b=null;this.h="GET";this.c="";this.a=!1;this.f=Og("goog.net.FetchXmlHttp")}t(Qg,E);var Rg=0;g=Qg.prototype;
	g.open=function(a,b){if(this.readyState!=Rg)throw this.abort(),Error("Error reopening a connection");this.h=a;this.c=b;this.readyState=1;Sg(this)};g.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.g,method:this.h,credentials:void 0,cache:void 0};a&&(b.body=a);this.i.fetch(new Request(this.c,b)).then(this.ec.bind(this),this.Cb.bind(this))};
	g.abort=function(){this.responseText="";this.g=new Headers;this.status=0;1<=this.readyState&&this.a&&4!=this.readyState&&(this.readyState=4,this.a=!1,Sg(this));this.readyState=Rg};g.ec=function(a){this.a&&(this.b||(this.b=a.headers,this.readyState=2,Sg(this)),this.a&&(this.readyState=3,Sg(this),this.a&&a.text().then(this.dc.bind(this,a),this.Cb.bind(this))))};g.dc=function(a,b){this.a&&(this.status=a.status,this.statusText=a.statusText,this.responseText=b,this.readyState=4,Sg(this))};
	g.Cb=function(a){var b=this.f;b&&b.log(Ig,"Failed to fetch url "+this.c,a instanceof Error?a:Error(a));this.a&&(this.readyState=4,Sg(this))};g.setRequestHeader=function(a,b){this.g.append(a,b)};g.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.f)&&a.log(Ig,"Attempting to get response header but no headers have been received for url: "+this.c,void 0),"")};
	g.getAllResponseHeaders=function(){if(!this.b){var a=this.f;a&&a.log(Ig,"Attempting to get all response headers but no headers have been received for url: "+this.c,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Sg(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function Tg(a){E.call(this);this.headers=new Lc;this.C=a||null;this.c=!1;this.w=this.a=null;this.h=this.N=this.l="";this.f=this.I=this.i=this.G=!1;this.g=0;this.u=null;this.o=Ug;this.v=this.O=!1}t(Tg,E);var Ug="";Tg.prototype.b=Og("goog.net.XhrIo");var Vg=/^https?$/i,Wg=["POST","PUT"];
	function Xg(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.N=c;a.G=!1;a.c=!0;a.a=a.C?a.C.a():xg.a();a.w=a.C?wg(a.C):wg(xg);a.a.onreadystatechange=r(a.Fb,a);try{P(a.b,Yg(a,"Opening Xhr")),a.I=!0,a.a.open(c,String(b),!0),a.I=!1}catch(h){P(a.b,Yg(a,"Error opening Xhr: "+h.message));Zg(a,h);return}b=d||"";var f=new Lc(a.headers);e&&Kc(e,function(a,b){f.set(b,a)});e=Da(f.U());d=k.FormData&&b instanceof
	k.FormData;!Fa(Wg,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.o&&(a.a.responseType=a.o);"withCredentials"in a.a&&a.a.withCredentials!==a.O&&(a.a.withCredentials=a.O);try{$g(a),0<a.g&&(a.v=ah(a.a),P(a.b,Yg(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=r(a.Ga,a)):a.u=Gc(a.Ga,a.g,a)),P(a.b,Yg(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(h){P(a.b,Yg(a,
	"Send error: "+h.message)),Zg(a,h)}}function ah(a){return Ob&&Yb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ea(a){return"content-type"==a.toLowerCase()}g=Tg.prototype;g.Ga=function(){"undefined"!=typeof aa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",P(this.b,Yg(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function Zg(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;bh(a);ch(a)}
	function bh(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}g.abort=function(){this.a&&this.c&&(P(this.b,Yg(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),ch(this))};g.ua=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),ch(this,!0));Tg.lb.ua.call(this)};g.Fb=function(){this.pa||(this.I||this.i||this.f?dh(this):this.tc())};g.tc=function(){dh(this)};
	function dh(a){if(a.c&&"undefined"!=typeof aa)if(a.w[1]&&4==eh(a)&&2==fh(a))P(a.b,Yg(a,"Local request error detected and ignored"));else if(a.i&&4==eh(a))Gc(a.Fb,0,a);else if(a.dispatchEvent("readystatechange"),4==eh(a)){P(a.b,Yg(a,"Request complete"));a.c=!1;try{var b=fh(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Oc)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;
	f=h.substr(0,h.length-1)}e=!Vg.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var m=2<eh(a)?a.a.statusText:""}catch(p){P(a.b,"Can not get status: "+p.message),m=""}a.h=m+" ["+fh(a)+"]";bh(a)}}finally{ch(a)}}}function ch(a,b){if(a.a){$g(a);var c=a.a,d=a.w[0]?ca:null;a.a=null;a.w=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Hg,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
	function $g(a){a.a&&a.v&&(a.a.ontimeout=null);a.u&&(k.clearTimeout(a.u),a.u=null)}function eh(a){return a.a?a.a.readyState:0}function fh(a){try{return 2<eh(a)?a.a.status:-1}catch(b){return-1}}function gh(a){try{return a.a?a.a.responseText:""}catch(b){return P(a.b,"Can not get responseText: "+b.message),""}}
	g.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.o){case Ug:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Hg,"Response type "+this.o+" is not supported on this browser",void 0);return null}catch(b){return P(this.b,"Can not get response: "+b.message),null}};function Yg(a,b){return b+" ["+a.N+" "+a.l+" "+fh(a)+"]"};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	function hh(a,b){this.g=[];this.v=a;this.u=b||null;this.f=this.a=!1;this.c=void 0;this.l=this.w=this.i=!1;this.h=0;this.b=null;this.m=0}hh.prototype.cancel=function(a){if(this.a)this.c instanceof hh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.m--,0>=b.m&&b.cancel())}this.v?this.v.call(this.u,this):this.l=!0;this.a||(a=new ih(this),jh(this),kh(this,!1,a))}};hh.prototype.o=function(a,b){this.i=!1;kh(this,a,b)};function kh(a,b,c){a.a=!0;a.c=c;a.f=!b;lh(a)}
	function jh(a){if(a.a){if(!a.l)throw new mh(a);a.l=!1}}hh.prototype.C=function(){jh(this);kh(this,!0,null)};function nh(a,b){oh(a,null,b,void 0)}function oh(a,b,c,d){a.g.push([b,c,d]);a.a&&lh(a)}hh.prototype.then=function(a,b,c){var d,e,f=new y(function(a,b){d=a;e=b});oh(this,d,function(a){a instanceof ih?f.cancel():e(a)});return f.then(a,b,c)};oa(hh);function ph(a){return Ca(a.g,function(a){return n(a[1])})}
	function lh(a){if(a.h&&a.a&&ph(a)){var b=a.h,c=qh[b];c&&(k.clearTimeout(c.a),delete qh[b]);a.h=0}a.b&&(a.b.m--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],h=e[1];e=e[2];if(f=a.f?h:f)try{var m=f.call(e||a.u,b);void 0!==m&&(a.f=a.f&&(m==b||m instanceof Error),a.c=b=m);if(pa(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.i=!0}catch(p){b=p,a.f=!0,ph(a)||(c=!0)}}a.c=b;d&&(m=r(a.o,a,!0),d=r(a.o,a,!1),b instanceof hh?(oh(b,m,d),b.w=!0):b.then(m,d));c&&(b=
	new rh(b),qh[b.a]=b,a.h=b.a)}function mh(){u.call(this)}t(mh,u);mh.prototype.message="Deferred has already fired";mh.prototype.name="AlreadyCalledError";function ih(){u.call(this)}t(ih,u);ih.prototype.message="Deferred was canceled";ih.prototype.name="CanceledError";function rh(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}rh.prototype.c=function(){delete qh[this.a];throw this.b;};var qh={};function sh(a){var b={},c=b.document||document,d=ud(a),e=document.createElement("SCRIPT"),f={Hb:e,Ga:void 0},h=new hh(th,f),m=null,p=null!=b.timeout?b.timeout:5E3;0<p&&(m=window.setTimeout(function(){uh(e,!0);var a=new vh(wh,"Timeout reached for loading script "+d);jh(h);kh(h,!1,a)},p),f.Ga=m);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(uh(e,b.dd||!1,m),h.C())};e.onerror=function(){uh(e,!0,m);var a=new vh(xh,"Error while loading script "+
	d);jh(h);kh(h,!1,a)};f=b.attributes||{};bb(f,{type:"text/javascript",charset:"UTF-8"});Kd(e,f);e.src=ud(a);yh(c).appendChild(e);return h}function yh(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function th(){if(this&&this.Hb){var a=this.Hb;a&&"SCRIPT"==a.tagName&&uh(a,!0,this.Ga)}}
	function uh(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var xh=0,wh=1;function vh(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(vh,u);function zh(a){this.f=a}t(zh,vg);zh.prototype.a=function(){return new this.f};zh.prototype.b=function(){return{}};
	function Ah(a,b,c){this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.m=a.secureTokenTimeout||Bh;this.f=$a(a.secureTokenHeaders||Ch);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Dh;this.a=$a(a.firebaseHeaders||Eh);c&&(this.a["X-Client-Version"]=c,this.f["X-Client-Version"]=c);c="Node"==ne();c=k.XMLHttpRequest||c&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!c&&
	!me())throw new K("internal-error","The XMLHttpRequest compatibility library was not found.");this.c=void 0;me()?this.c=new Pg(self):oe()?this.c=new zh(c):this.c=new Ag}var Fh,L="idToken",Bh=new Ce(3E4,6E4),Ch={"Content-Type":"application/x-www-form-urlencoded"},Dh=new Ce(3E4,6E4),Eh={"Content-Type":"application/json"};function Gh(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
	function Hh(a,b){b?(a.a["X-Client-Version"]=b,a.f["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.f["X-Client-Version"])}function Ih(a,b,c,d,e,f,h){Zd()||me()?a=r(a.o,a):(Fh||(Fh=new y(function(a,b){Jh(a,b)})),a=r(a.l,a));a(b,c,d,e,f,h)}
	Ah.prototype.o=function(a,b,c,d,e,f){if(me()&&("undefined"===typeof k.fetch||"undefined"===typeof k.Headers||"undefined"===typeof k.Request))throw new K("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var h=new Tg(this.c);if(f){h.g=Math.max(0,f);var m=setTimeout(function(){h.dispatchEvent("timeout")},f)}uc(h,"complete",function(){m&&clearTimeout(m);var a=null;try{a=
	JSON.parse(gh(this))||null}catch(z){a=null}b&&b(a)});Ac(h,"ready",function(){m&&clearTimeout(m);Jb(this)});Ac(h,"timeout",function(){m&&clearTimeout(m);Jb(this);b&&b(null)});Xg(h,a,c,d,e)};var Kh=rd("https://apis.google.com/js/client.js?onload=%{onload}"),Lh="__fcb"+Math.floor(1E6*Math.random()).toString();
	function Jh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Lh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=vd(Kh,{onload:Lh});nh(sh(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
	Ah.prototype.l=function(a,b,c,d,e){var f=this;Fh.then(function(){window.gapi.client.setApiKey(f.b);var h=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(h);b&&b(a)}})}).s(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
	function Mh(a,b){return new y(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Ih(a,a.i+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Nh(a)):a.access_token&&a.refresh_token?c(a):d(new K("internal-error")):d(new K("network-request-failed"))},"POST",id(b).toString(),a.f,a.m.get()):d(new K("internal-error"))})}
	function Oh(a,b,c,d,e,f){var h=ed(a.g+b);F(h,"key",a.b);f&&F(h,"cb",na().toString());var m="GET"==c;if(m)for(var p in d)d.hasOwnProperty(p)&&F(h,p,d[p]);return new y(function(b,f){Ih(a,h.toString(),function(a){a?a.error?f(Nh(a,e||{})):b(a):f(new K("network-request-failed"))},c,m?void 0:Pd(ye(d)),a.a,a.h.get())})}function Ph(a){if(!ug.test(a.email))throw new K("invalid-email");}function Qh(a){"email"in a&&Ph(a)}
	function Rh(a,b){return O(a,Sh,{identifier:b,continueUri:ve()?Wd():"http://localhost"}).then(function(a){return a.allProviders||[]})}function Th(a,b){return O(a,Sh,{identifier:b,continueUri:ve()?Wd():"http://localhost"}).then(function(a){return a.signinMethods||[]})}function Uh(a){return O(a,Vh,{}).then(function(a){return a.authorizedDomains||[]})}function Wh(a){if(!a[L])throw new K("internal-error");}
	function Xh(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new K("internal-error");}else{if(!a.sessionInfo)throw new K("missing-verification-id");if(!a.code)throw new K("missing-verification-code");}}Ah.prototype.Pa=function(){return O(this,Yh,{})};Ah.prototype.mb=function(a,b){return O(this,Zh,{idToken:a,email:b})};Ah.prototype.nb=function(a,b){return O(this,bg,{idToken:a,password:b})};var $h={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};g=Ah.prototype;
	g.ob=function(a,b){var c={idToken:a},d=[];Ya($h,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return O(this,Zh,c)};g.hb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};bb(a,b);return O(this,ai,a)};g.ib=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};bb(a,b);return O(this,bi,a)};g.gb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};bb(a,b);return O(this,ci,a)};function jg(a,b){return O(a,di,b)}g.Ta=function(a){return O(this,ei,a)};
	function fi(a,b,c){return O(a,gi,{idToken:b,deleteProvider:c})}function hi(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new K("internal-error");}
	function ii(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=tg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=tg(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=tg(a)):a.errorMessage&&(b=ji(a.errorMessage));if(b)throw b;if(!a[L])throw new K("internal-error");}function Lf(a,b){b.returnIdpCredential=!0;return O(a,ki,b)}function Nf(a,b){b.returnIdpCredential=!0;return O(a,li,b)}
	function Of(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return O(a,mi,b)}function ni(a){if(!a.oobCode)throw new K("invalid-action-code");}g.Xa=function(a,b){return O(this,oi,{oobCode:a,newPassword:b})};g.Ja=function(a){return O(this,pi,{oobCode:a})};g.Va=function(a){return O(this,qi,{oobCode:a})};
	var qi={endpoint:"setAccountInfo",B:ni,da:"email"},pi={endpoint:"resetPassword",B:ni,J:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new K("internal-error");}},ri={endpoint:"signupNewUser",B:function(a){Ph(a);if(!a.password)throw new K("weak-password");},J:Wh,R:!0},Sh={endpoint:"createAuthUri"},si={endpoint:"deleteAccount",T:["idToken"]},gi={endpoint:"setAccountInfo",T:["idToken","deleteProvider"],B:function(a){if(!fa(a.deleteProvider))throw new K("internal-error");}},Zf=
	{endpoint:"emailLinkSignin",T:["email","oobCode"],B:Ph,J:Wh,R:!0},ag={endpoint:"emailLinkSignin",T:["idToken","email","oobCode"],B:Ph,J:Wh,R:!0},ti={endpoint:"getAccountInfo"},bi={endpoint:"getOobConfirmationCode",T:["requestType"],B:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new K("internal-error");Ph(a)},da:"email"},ci={endpoint:"getOobConfirmationCode",T:["idToken","requestType"],B:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new K("internal-error");},da:"email"},ai={endpoint:"getOobConfirmationCode",
	T:["requestType"],B:function(a){if("PASSWORD_RESET"!=a.requestType)throw new K("internal-error");Ph(a)},da:"email"},Vh={rb:!0,endpoint:"getProjectConfig",Eb:"GET"},ui={rb:!0,endpoint:"getRecaptchaParam",Eb:"GET",J:function(a){if(!a.recaptchaSiteKey)throw new K("internal-error");}},oi={endpoint:"resetPassword",B:ni,da:"email"},di={endpoint:"sendVerificationCode",T:["phoneNumber","recaptchaToken"],da:"sessionInfo"},Zh={endpoint:"setAccountInfo",T:["idToken"],B:Qh,R:!0},bg={endpoint:"setAccountInfo",
	T:["idToken"],B:function(a){Qh(a);if(!a.password)throw new K("weak-password");},J:Wh,R:!0},Yh={endpoint:"signupNewUser",J:Wh,R:!0},ki={endpoint:"verifyAssertion",B:hi,J:ii,R:!0},mi={endpoint:"verifyAssertion",B:hi,J:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new K("user-not-found");if(a.errorMessage)throw ji(a.errorMessage);if(!a[L])throw new K("internal-error");},R:!0},li={endpoint:"verifyAssertion",B:function(a){hi(a);if(!a.idToken)throw new K("internal-error");},J:ii,
	R:!0},vi={endpoint:"verifyCustomToken",B:function(a){if(!a.token)throw new K("invalid-custom-token");},J:Wh,R:!0},$f={endpoint:"verifyPassword",B:function(a){Ph(a);if(!a.password)throw new K("wrong-password");},J:Wh,R:!0},ei={endpoint:"verifyPhoneNumber",B:Xh,J:Wh},gg={endpoint:"verifyPhoneNumber",B:function(a){if(!a.idToken)throw new K("internal-error");Xh(a)},J:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",tg(a);Wh(a)}},hg={Tb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",
	B:Xh,J:Wh};function O(a,b,c){if(!Ne(c,b.T))return B(new K("internal-error"));var d=b.Eb||"POST",e;return A(c).then(b.B).then(function(){b.R&&(c.returnSecureToken=!0);return Oh(a,b.endpoint,d,c,b.Tb,b.rb||!1)}).then(function(a){return e=a}).then(b.J).then(function(){if(!b.da)return e;if(!(b.da in e))throw new K("internal-error");return e[b.da]})}function ji(a){return Nh({error:{errors:[{message:a}],code:400,message:a}})}
	function Nh(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new K(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
	MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
	INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
	INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",
	UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};bb(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new K(d[e],b);!b&&a&&(b=xe(a));return new K("internal-error",b)};var wi={Yc:{Za:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",fb:"https://securetoken.googleapis.com/v1/token",id:"p"},$c:{Za:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",fb:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},ad:{Za:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",fb:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
	function xi(a){for(var b in wi)if(wi[b].id===a)return a=wi[b],{firebaseEndpoint:a.Za,secureTokenEndpoint:a.fb};return null}var yi;yi=xi("__EID__")?"__EID__":void 0;function zi(a){this.b=a;this.a=null;this.bb=Ai(this)}
	function Ai(a){return Bi().then(function(){return new y(function(b,c){H("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:H("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Ci.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
	function Di(a,b){return a.bb.then(function(){return new y(function(c){a.a.send(b.type,b,c,H("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Ei(a,b){a.bb.then(function(){a.a.register("authEvent",b,H("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Fi=rd("https://apis.google.com/js/api.js?onload=%{onload}"),Gi=new Ce(3E4,6E4),Ci=new Ce(5E3,15E3),Hi=null;
	function Bi(){return Hi?Hi:Hi=(new y(function(a,b){function c(){Be();H("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Be();b(Error("Network Error"))},timeout:Gi.get()})}if(H("gapi.iframes.Iframe"))a();else if(H("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){H("gapi.load")?c():b(Error("Network Error"))};d=vd(Fi,{onload:d});A(sh(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){Hi=null;throw a;})};function Ii(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=fd(this.i,"/__/auth/iframe");F(this.a,"apiKey",this.g);F(this.a,"appName",this.h);this.b=null;this.c=[]}Ii.prototype.toString=function(){this.f?F(this.a,"v",this.f):ld(this.a.a,"v");this.b?F(this.a,"eid",this.b):ld(this.a.a,"eid");this.c.length?F(this.a,"fw",this.c.join(",")):ld(this.a.a,"fw");return this.a.toString()};function Ji(a,b,c,d,e){this.o=a;this.l=b;this.c=c;this.m=d;this.h=this.g=this.i=null;this.a=e;this.f=null}
	Ji.prototype.toString=function(){var a=fd(this.o,"/__/auth/handler");F(a,"apiKey",this.l);F(a,"appName",this.c);F(a,"authType",this.m);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().ea()}catch(m){c=null}b.Ya=c;F(a,"providerId",this.a.providerId);b=this.a;c=ye(b.vb);for(var d in c)c[d]=c[d].toString();d=b.Ac;c=$a(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.$a&&b.Ya&&!c[b.$a]&&(c[b.$a]=b.Ya);Za(c)||F(a,"customParameters",xe(c))}"function"===typeof this.a.Ab&&
	(b=this.a.Ab(),b.length&&F(a,"scopes",b.join(",")));this.i?F(a,"redirectUrl",this.i):ld(a.a,"redirectUrl");this.g?F(a,"eventId",this.g):ld(a.a,"eventId");this.h?F(a,"v",this.h):ld(a.a,"v");if(this.b)for(var h in this.b)this.b.hasOwnProperty(h)&&!dd(a,h)&&F(a,h,this.b[h]);this.f?F(a,"eid",this.f):ld(a.a,"eid");h=Ki(this.c);h.length&&F(a,"fw",h.join(","));return a.toString()};function Ki(a){try{return firebase.app(a).auth().xa()}catch(b){return[]}}
	function Li(a,b,c,d,e){this.l=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.o=this.u=this.v=null;this.g=[];this.m=this.a=null}
	function Mi(a){var b=Wd();return Uh(a).then(function(a){a:{var c=ed(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var h=a[f];var m=c;var p=e;0==h.indexOf("chrome-extension://")?m=ed(h).b==m&&"chrome-extension"==p:"http"!=p&&"https"!=p?m=!1:ge.test(h)?m=m==h:(h=h.split(".").join("\\."),m=(new RegExp("^(.+\\."+h+"|"+h+")$","i")).test(m));if(m){a=!0;break a}}a=!1}if(!a)throw new rg(Wd());})}
	function Ni(a){if(a.m)return a.m;a.m=he().then(function(){if(!a.u){var b=a.c,c=a.h,d=Ki(a.b),e=new Ii(a.l,a.f,a.b);e.f=b;e.b=c;e.c=Ja(d||[]);a.u=e.toString()}a.i=new zi(a.u);Oi(a)});return a.m}g=Li.prototype;g.Ea=function(a,b,c){var d=new K("popup-closed-by-user"),e=new K("web-storage-unsupported"),f=this,h=!1;return this.ga().then(function(){Pi(f).then(function(c){c||(a&&ce(a),b(e),h=!0)})}).s(function(){}).then(function(){if(!h)return fe(a)}).then(function(){if(!h)return Hc(c).then(function(){b(d)})})};
	g.Ib=function(){var a=G();return!we(a)&&!Ae(a)};g.Db=function(){return!1};
	g.zb=function(a,b,c,d,e,f,h){if(!a)return B(new K("popup-blocked"));if(h&&!we())return this.ga().s(function(b){ce(a);e(b)}),d(),A();this.a||(this.a=Mi(Qi(this)));var m=this;return this.a.then(function(){var b=m.ga().s(function(b){ce(a);e(b);throw b;});d();return b}).then(function(){mg(c);if(!h){var d=Ri(m.l,m.f,m.b,b,c,null,f,m.c,void 0,m.h);Xd(d,a)}}).s(function(a){"auth/network-request-failed"==a.code&&(m.a=null);throw a;})};
	function Qi(a){a.o||(a.v=a.c?re(a.c,Ki(a.b)):null,a.o=new Ah(a.f,xi(a.h),a.v));return a.o}g.Ca=function(a,b,c){this.a||(this.a=Mi(Qi(this)));var d=this;return this.a.then(function(){mg(b);var e=Ri(d.l,d.f,d.b,a,b,Wd(),c,d.c,void 0,d.h);Xd(e)}).s(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};g.ga=function(){var a=this;return Ni(this).then(function(){return a.i.bb}).s(function(){a.a=null;throw new K("network-request-failed");})};g.Mb=function(){return!0};
	function Ri(a,b,c,d,e,f,h,m,p,z){a=new Ji(a,b,c,d,e);a.i=f;a.g=h;a.h=m;a.b=$a(p||null);a.f=z;return a.toString()}function Oi(a){if(!a.i)throw Error("IfcHandler must be initialized!");Ei(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=og(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return A(c)}c.status="ERROR";return A(c)})}
	function Pi(a){var b={type:"webStorageSupport"};return Ni(a).then(function(){return Di(a.i,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}g.va=function(a){this.g.push(a)};g.Ka=function(a){Ha(this.g,function(b){return b==a})};function Si(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new K("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}g=Si.prototype;g.get=function(a){return A(this.a.getItem(a)).then(function(a){return a&&ze(a)})};g.set=function(a,b){return A(this.a.setItem(a,xe(b)))};g.P=function(a){return A(this.a.removeItem(a))};g.Y=function(){};g.ca=function(){};function Ti(){if(!Ui())throw new K("web-storage-unsupported");this.f={};this.a=[];this.b=0;this.g=k.indexedDB;this.type="indexedDB"}var Vi;function Wi(a){return new y(function(b,c){var d=a.g.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(a){c(Error(a.target.error))}})}
	function Xi(a){return new y(function(b,c){var d=a.g.open("firebaseLocalStorageDb",1);d.onerror=function(a){try{a.preventDefault()}catch(f){}c(Error(a.target.error))};d.onupgradeneeded=function(a){a=a.target.result;try{a.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(d){d=d.target.result;d.objectStoreNames.contains("firebaseLocalStorage")?b(d):Wi(a).then(function(){return Xi(a)}).then(function(a){b(a)}).s(function(a){c(a)})}})}
	function Yi(a){a.h||(a.h=Xi(a));return a.h}function Ui(){try{return!!k.indexedDB}catch(a){return!1}}function Zi(a){return a.objectStore("firebaseLocalStorage")}function $i(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function aj(a){return new y(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})}g=Ti.prototype;
	g.set=function(a,b){var c=!1,d,e=this;return Yi(this).then(function(b){d=b;b=Zi($i(d,!0));return aj(b.get(a))}).then(function(f){var h=Zi($i(d,!0));if(f)return f.value=b,aj(h.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return aj(h.add(f))}).then(function(){e.f[a]=b}).ia(function(){c&&e.b--})};g.get=function(a){return Yi(this).then(function(b){return aj(Zi($i(b,!1)).get(a))}).then(function(a){return a&&a.value})};
	g.P=function(a){var b=!1,c=this;return Yi(this).then(function(d){b=!0;c.b++;return aj(Zi($i(d,!0))["delete"](a))}).then(function(){delete c.f[a]}).ia(function(){b&&c.b--})};
	g.Kc=function(){var a=this;return Yi(this).then(function(a){var b=Zi($i(a,!1));return b.getAll?aj(b.getAll()):new y(function(a,c){var d=[],e=b.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){c(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=Yd(a.f,c);a.f=c}return d})};g.Y=function(a){0==this.a.length&&bj(this);this.a.push(a)};
	g.ca=function(a){Ha(this.a,function(b){return b==a});0==this.a.length&&this.c&&this.c.cancel("STOP_EVENT")};function bj(a){function b(){a.c=Hc(800).then(r(a.Kc,a)).then(function(b){0<b.length&&v(a.a,function(a){a(b)})}).then(b).s(function(a){"STOP_EVENT"!=a.message&&b()});return a.c}a.c&&a.c.cancel("STOP_EVENT");b()};function cj(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=A().then(function(){return Ui()?(Vi||(Vi=new Ti),c=Vi,c.set("__sak","!").then(function(){return c.get("__sak")}).then(function(a){if("!"!==a)throw Error("indexedDB not supported!");return c.P("__sak")}).then(function(){return c}).s(function(){return b.c})):b.c}).then(function(a){b.type=a.type;a.Y(function(a){v(b.a,function(b){b(a)})});return a})}g=cj.prototype;g.get=function(a){return this.b.then(function(b){return b.get(a)})};
	g.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};g.P=function(a){return this.b.then(function(b){return b.P(a)})};g.Y=function(a){this.a.push(a)};g.ca=function(a){Ha(this.a,function(b){return b==a})};function dj(){this.a={};this.type="inMemory"}g=dj.prototype;g.get=function(a){return A(this.a[a])};g.set=function(a,b){this.a[a]=b;return A()};g.P=function(a){delete this.a[a];return A()};g.Y=function(){};g.ca=function(){};function ej(){if(!fj()){if("Node"==ne())throw new K("internal-error","The LocalStorage compatibility library was not found.");throw new K("web-storage-unsupported");}this.a=gj()||firebase.INTERNAL.node.localStorage;this.type="localStorage"}function gj(){try{var a=k.localStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function fj(){var a="Node"==ne();a=gj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=ej.prototype;g.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return A().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};
	g.Y=function(a){k.window&&rc(k.window,"storage",a)};g.ca=function(a){k.window&&D(k.window,"storage",a)};function hj(){this.type="nullStorage"}g=hj.prototype;g.get=function(){return A(null)};g.set=function(){return A()};g.P=function(){return A()};g.Y=function(){};g.ca=function(){};function ij(){if(!jj()){if("Node"==ne())throw new K("internal-error","The SessionStorage compatibility library was not found.");throw new K("web-storage-unsupported");}this.a=kj()||firebase.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function kj(){try{var a=k.sessionStorage,b=te();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function jj(){var a="Node"==ne();a=kj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}g=ij.prototype;g.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return ze(c)})};g.set=function(a,b){var c=this;return A().then(function(){var d=xe(b);null===d?c.P(a):c.a.setItem(a,d)})};g.P=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};g.Y=function(){};
	g.ca=function(){};function lj(){var a={};a.Browser=mj;a.Node=nj;a.ReactNative=oj;a.Worker=pj;this.a=a[ne()]}var qj,mj={A:ej,Qa:ij},nj={A:ej,Qa:ij},oj={A:Si,Qa:hj},pj={A:ej,Qa:hj};var rj={Xc:"local",NONE:"none",Zc:"session"};function sj(a){var b=new K("invalid-persistence-type"),c=new K("unsupported-persistence-type");a:{for(d in rj)if(rj[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(ne()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!se()&&"none"!==a)throw c;}}
	function tj(){var a=!Ae(G())&&le()?!0:!1,b=we(),c=se();this.o=a;this.h=b;this.m=c;this.a={};qj||(qj=new lj);a=qj;try{this.g=!Vd()&&Ge()||!k.indexedDB?new a.a.A:new cj(me()?new dj:new a.a.A)}catch(d){this.g=new dj,this.h=!0}try{this.i=new a.a.Qa}catch(d){this.i=new dj}this.l=new dj;this.f=r(this.Lb,this);this.b={}}var uj;function vj(){uj||(uj=new tj);return uj}function wj(a,b){switch(b){case "session":return a.i;case "none":return a.l;default:return a.g}}
	function xj(a,b){return"firebase:"+a.name+(b?":"+b:"")}function yj(a,b,c){var d=xj(b,c),e=wj(a,b.A);return a.get(b,c).then(function(f){var h=null;try{h=ze(k.localStorage.getItem(d))}catch(m){}if(h&&!f)return k.localStorage.removeItem(d),a.set(b,h,c);h&&f&&"localStorage"!=e.type&&k.localStorage.removeItem(d)})}g=tj.prototype;g.get=function(a,b){return wj(this,a.A).get(xj(a,b))};function zj(a,b,c){c=xj(b,c);"local"==b.A&&(a.b[c]=null);return wj(a,b.A).P(c)}
	g.set=function(a,b,c){var d=xj(a,c),e=this,f=wj(this,a.A);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.A&&(e.b[d]=b)})};g.addListener=function(a,b,c){a=xj(a,b);this.m&&(this.b[a]=k.localStorage.getItem(a));Za(this.a)&&(wj(this,"local").Y(this.f),this.h||(Vd()||!Ge())&&k.indexedDB||!this.m||Aj(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
	g.removeListener=function(a,b,c){a=xj(a,b);this.a[a]&&(Ha(this.a[a],function(a){return a==c}),0==this.a[a].length&&delete this.a[a]);Za(this.a)&&(wj(this,"local").ca(this.f),Bj(this))};function Aj(a){Bj(a);a.c=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new ec({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Lb(c))}},1E3)}function Bj(a){a.c&&(clearInterval(a.c),a.c=null)}
	g.Lb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.Wa(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?wj(this,"local").ca(this.f):Bj(this);if(this.o)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
	typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.Wa(b)};Ob&&Zb&&10==Zb&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else v(a,r(this.Wa,this))};g.Wa=function(a){this.a[a]&&v(this.a[a],function(a){a()})};function Cj(a){this.a=a;this.b=vj()}var Dj={name:"authEvent",A:"local"};function Ej(a){return a.b.get(Dj,a.a).then(function(a){return og(a)})};function Fj(){this.a=vj()};function Gj(){this.b=-1};function Hj(a,b){this.b=-1;this.b=Ij;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.m=k.Int32Array?new Int32Array(64):Array(64);void 0!==Jj||(k.Int32Array?Jj=new Int32Array(Kj):Jj=Kj);this.reset()}var Jj;t(Hj,Gj);for(var Ij=64,Lj=Ij-1,Mj=[],Nj=0;Nj<Lj;Nj++)Mj[Nj]=0;var Oj=Ia(128,Mj);Hj.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):Ja(this.h)};
	function Pj(a){for(var b=a.f,c=a.m,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,h=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+h|0}d=a.a[0]|0;e=a.a[1]|0;var m=a.a[2]|0,p=a.a[3]|0,z=a.a[4]|0,pc=a.a[5]|0,Pc=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var Rl=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&m^e&m)|0;h=z&pc^~z&Pc;f=f+((z>>>6|z<<26)^(z>>>11|z<<21)^(z>>>
	25|z<<7))|0;h=h+(Jj[b]|0)|0;h=f+(h+(c[b]|0)|0)|0;f=Pc;Pc=pc;pc=z;z=p+h|0;p=m;m=e;e=d;d=h+Rl|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+m|0;a.a[3]=a.a[3]+p|0;a.a[4]=a.a[4]+z|0;a.a[5]=a.a[5]+pc|0;a.a[6]=a.a[6]+Pc|0;a.a[7]=a.a[7]+f|0}
	function Qj(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(l(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(Pj(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(Pj(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
	var Kj=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function Rj(){Hj.call(this,8,Sj)}t(Rj,Hj);var Sj=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function Tj(a,b,c,d,e){this.l=a;this.i=b;this.m=c;this.o=d||null;this.u=e||null;this.h=b+":"+c;this.v=new Fj;this.g=new Cj(this.h);this.f=null;this.b=[];this.a=this.c=null}function Uj(a){return new K("invalid-cordova-configuration",a)}g=Tj.prototype;
	g.ga=function(){return this.za?this.za:this.za=ie().then(function(){if("function"!==typeof H("universalLinks.subscribe",k))throw Uj("cordova-universal-links-plugin is not installed");if("undefined"===typeof H("BuildInfo.packageName",k))throw Uj("cordova-plugin-buildinfo is not installed");if("function"!==typeof H("cordova.plugins.browsertab.openUrl",k))throw Uj("cordova-plugin-browsertab is not installed");if("function"!==typeof H("cordova.InAppBrowser.open",k))throw Uj("cordova-plugin-inappbrowser is not installed");
	},function(){throw new K("cordova-not-ready");})};function Vj(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Wj(a){var b=new Rj;Qj(b,a);a=[];var c=8*b.g;56>b.c?Qj(b,Oj,56-b.c):Qj(b,Oj,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;Pj(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return lf(a)}
	g.Ea=function(a,b){b(new K("operation-not-supported-in-this-environment"));return A()};g.zb=function(){return B(new K("operation-not-supported-in-this-environment"))};g.Mb=function(){return!1};g.Ib=function(){return!0};g.Db=function(){return!0};
	g.Ca=function(a,b,c){if(this.c)return B(new K("redirect-operation-pending"));var d=this,e=k.document,f=null,h=null,m=null,p=null;return this.c=A().then(function(){mg(b);return Xj(d)}).then(function(){return Yj(d,a,b,c)}).then(function(){return(new y(function(a,b){h=function(){var b=H("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.va(h);m=function(){f||(f=Hc(2E3).then(function(){b(new K("redirect-cancelled-by-user"))}))};
	p=function(){De()&&m()};e.addEventListener("resume",m,!1);G().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",p,!1)})).s(function(a){return Zj(d).then(function(){throw a;})})}).ia(function(){m&&e.removeEventListener("resume",m,!1);p&&e.removeEventListener("visibilitychange",p,!1);f&&f.cancel();h&&d.Ka(h);d.c=null})};
	function Yj(a,b,c,d){var e=Vj(),f=new ng(b,d,null,e,new K("no-auth-event")),h=H("BuildInfo.packageName",k);if("string"!==typeof h)throw new K("invalid-cordova-configuration");var m=H("BuildInfo.displayName",k),p={};if(G().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(G().toLowerCase().match(/android/))p.apn=h;else return B(new K("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);e=Wj(e);p.sessionId=e;var z=Ri(a.l,a.i,a.m,b,c,null,d,a.o,p,a.u);return a.ga().then(function(){var b=
	a.h;return a.v.a.set(Dj,f.D(),b)}).then(function(){var b=H("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new K("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=H("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new K("invalid-cordova-configuration");c(z)}else{c=H("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new K("invalid-cordova-configuration");b=G();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
	a.a=c(z,b?"_blank":"_system","location=yes")}})})}function ak(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Xj(a){a.f||(a.f=a.ga().then(function(){return new y(function(b){function c(d){b(d);a.Ka(c);return!1}a.va(c);bk(a)})}));return a.f}function Zj(a){var b=null;return Ej(a.g).then(function(c){b=c;c=a.g;return zj(c.b,Dj,c.a)}).then(function(){return b})}
	function bk(a){function b(b){d=!0;e&&e.cancel();Zj(a).then(function(d){var e=c;if(d&&b&&b.url){var f=null;e=If(b.url);-1!=e.indexOf("/__/auth/callback")&&(f=ed(e),f=ze(dd(f,"firebaseError")||null),f=(f="object"===typeof f?$e(f):null)?new ng(d.b,d.c,null,null,f):new ng(d.b,d.c,e,d.g));e=f||c}ak(a,e)})}var c=new ng("unknown",null,null,null,new K("no-auth-event")),d=!1,e=Hc(500).then(function(){return Zj(a).then(function(){d||ak(a,c)})}),f=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(H("BuildInfo.packageName",
	k).toLowerCase()+"://")&&b({url:a});if("function"===typeof f)try{f(a)}catch(m){console.error(m)}};qg||(qg=new pg);qg.subscribe(b)}g.va=function(a){this.b.push(a);Xj(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new ng("unknown",null,null,null,new K("no-auth-event")),a(b))})};g.Ka=function(a){Ha(this.b,function(b){return b==a})};function ck(a){this.a=a;this.b=vj()}var dk={name:"pendingRedirect",A:"session"};function ek(a){return a.b.set(dk,"pending",a.a)}function fk(a){return zj(a.b,dk,a.a)}function gk(a){return a.b.get(dk,a.a).then(function(a){return"pending"==a})};function hk(a,b,c){this.v=a;this.m=b;this.l=c;this.h=[];this.f=!1;this.i=r(this.o,this);this.c=new ik;this.u=new jk;this.g=new ck(this.m+":"+this.l);this.b={};this.b.unknown=this.c;this.b.signInViaRedirect=this.c;this.b.linkViaRedirect=this.c;this.b.reauthViaRedirect=this.c;this.b.signInViaPopup=this.u;this.b.linkViaPopup=this.u;this.b.reauthViaPopup=this.u;this.a=kk(this.v,this.m,this.l,yi)}function kk(a,b,c,d){var e=firebase.SDK_VERSION||null;return je()?new Tj(a,b,c,e,d):new Li(a,b,c,e,d)}
	hk.prototype.reset=function(){this.f=!1;this.a.Ka(this.i);this.a=kk(this.v,this.m,this.l)};function lk(a){a.f||(a.f=!0,a.a.va(a.i));var b=a.a;return a.a.ga().s(function(c){a.a==b&&a.reset();throw c;})}function mk(a){a.a.Ib()&&lk(a).s(function(b){var c=new ng("unknown",null,null,null,new K("operation-not-supported-in-this-environment"));nk(b)&&a.o(c)});a.a.Db()||ok(a.c)}
	hk.prototype.subscribe=function(a){Fa(this.h,a)||this.h.push(a);if(!this.f){var b=this;gk(this.g).then(function(a){a?fk(b.g).then(function(){lk(b).s(function(a){var c=new ng("unknown",null,null,null,new K("operation-not-supported-in-this-environment"));nk(a)&&b.o(c)})}):mk(b)}).s(function(){mk(b)})}};hk.prototype.unsubscribe=function(a){Ha(this.h,function(b){return b==a})};
	hk.prototype.o=function(a){if(!a)throw new K("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.sb(a.b,a.c)){(b=this.b[a.b])&&b.h(a,d);b=!0;break}}ok(this.c);return b};var pk=new Ce(2E3,1E4),qk=new Ce(3E4,6E4);hk.prototype.fa=function(){return this.c.fa()};function rk(a,b,c,d,e,f){return a.a.zb(b,c,d,function(){a.f||(a.f=!0,a.a.va(a.i))},function(){a.reset()},e,f)}function nk(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
	hk.prototype.Ca=function(a,b,c){var d=this,e;return ek(this.g).then(function(){return d.a.Ca(a,b,c).s(function(a){if(nk(a))throw new K("operation-not-supported-in-this-environment");e=a;return fk(d.g).then(function(){throw e;})}).then(function(){return d.a.Mb()?new y(function(){}):fk(d.g).then(function(){return d.fa()}).then(function(){}).s(function(){})})})};hk.prototype.Ea=function(a,b,c,d){return this.a.Ea(c,function(c){a.ha(b,null,c,d)},pk.get())};var sk={};
	function tk(a,b,c){var d=b+":"+c;sk[d]||(sk[d]=new hk(a,b,c));return sk[d]}function ik(){this.b=null;this.f=[];this.c=[];this.a=null;this.g=!1}ik.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
	ik.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;"unknown"!=c||e||f?a.a?(uk(this,!0,null,a.a),A()):b.wa(c,d)?vk(this,a,b):B(new K("invalid-auth-event")):(uk(this,!1,null,null),A())}else B(new K("invalid-auth-event"))};function ok(a){a.g||(a.g=!0,uk(a,!1,null,null))}
	function vk(a,b,c){c=c.wa(b.b,b.c);var d=b.f,e=b.g,f=!!b.b.match(/Redirect$/);c(d,e).then(function(b){uk(a,f,b,null)}).s(function(b){uk(a,f,null,b)})}function wk(a,b){a.b=function(){return B(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function xk(a,b){a.b=function(){return A(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function uk(a,b,c,d){b?d?wk(a,d):xk(a,c):xk(a,{user:null});a.f=[];a.c=[]}
	ik.prototype.fa=function(){var a=this;return new y(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),yk(a))})};function yk(a){var b=new K("timeout");a.a&&a.a.cancel();a.a=Hc(qk.get()).then(function(){a.b||uk(a,!0,null,b)})}function jk(){}jk.prototype.h=function(a,b){if(a){var c=a.b,d=a.c;a.a?(b.ha(a.b,null,a.a,a.c),A()):b.wa(c,d)?zk(a,b):B(new K("invalid-auth-event"))}else B(new K("invalid-auth-event"))};
	function zk(a,b){var c=a.c,d=a.b;b.wa(d,c)(a.f,a.g).then(function(a){b.ha(d,a,null,c)}).s(function(a){b.ha(d,null,a,c)})};function Ak(){this.pb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.pb},set:function(a){this.pb=a},enumerable:!1})};function Bk(a,b){this.a=b;I(this,"verificationId",a)}Bk.prototype.confirm=function(a){a=kg(this.verificationId,a);return this.a(a)};function Ck(a,b,c,d){return(new ig(a)).Ta(b,c).then(function(a){return new Bk(a,d)})};function Dk(a){var b=tf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new K("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");J(this,{token:a,expirationTime:Fe(1E3*b.exp),authTime:Fe(1E3*b.auth_time),issuedAtTime:Fe(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function Ek(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}Ek.prototype.start=function(){this.a=this.c;Fk(this,!0)};function Gk(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function Fk(a,b){a.stop();a.b=Hc(Gk(a,b)).then(function(){return Ee()}).then(function(){return a.h()}).then(function(){Fk(a,!0)}).s(function(b){a.i(b)&&Fk(a,!1)})}
	Ek.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function Hk(a){this.f=a;this.b=this.a=null;this.c=0}Hk.prototype.D=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function Ik(a,b){var c=b[L],d=b.refreshToken;b=Jk(b.expiresIn);a.b=c;a.c=b;a.a=d}function Kk(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function Jk(a){return na()+1E3*parseInt(a,10)}
	function Lk(a,b){return Mh(a.f,b).then(function(b){a.b=b.access_token;a.c=Jk(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}Hk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?B(new K("user-token-expired")):a||!this.b||na()>this.c-3E4?this.a?Lk(this,{grant_type:"refresh_token",refresh_token:this.a}):A(null):A({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function Mk(a,b){this.a=a||null;this.b=b||null;J(this,{lastSignInTime:Fe(b||null),creationTime:Fe(a||null)})}function Nk(a){return new Mk(a.a,a.b)}Mk.prototype.D=function(){return{lastLoginAt:this.b,createdAt:this.a}};function Ok(a,b,c,d,e,f){J(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Pk(a,b){C.call(this,a);for(var c in b)this[c]=b[c]}t(Pk,C);
	function Q(a,b,c){this.G=[];this.l=a.apiKey;this.o=a.appName;this.u=a.authDomain||null;a=firebase.SDK_VERSION?re(firebase.SDK_VERSION):null;this.b=new Ah(this.l,xi(yi),a);this.h=new Hk(this.b);Qk(this,b[L]);Ik(this.h,b);I(this,"refreshToken",this.h.a);Rk(this,c||{});E.call(this);this.I=!1;this.u&&ue()&&(this.a=tk(this.u,this.l,this.o));this.N=[];this.i=null;this.w=Sk(this);this.V=r(this.Ha,this);var d=this;this.ka=null;this.sa=function(a){d.oa(a.g)};this.X=null;this.O=[];this.ra=function(a){Tk(d,
	a.c)};this.W=null}t(Q,E);Q.prototype.oa=function(a){this.ka=a;Gh(this.b,a)};Q.prototype.ea=function(){return this.ka};function Uk(a,b){a.X&&D(a.X,"languageCodeChanged",a.sa);(a.X=b)&&rc(b,"languageCodeChanged",a.sa)}function Tk(a,b){a.O=b;Hh(a.b,firebase.SDK_VERSION?re(firebase.SDK_VERSION,a.O):null)}Q.prototype.xa=function(){return Ja(this.O)};function Vk(a,b){a.W&&D(a.W,"frameworkChanged",a.ra);(a.W=b)&&rc(b,"frameworkChanged",a.ra)}Q.prototype.Ha=function(){this.w.b&&(this.w.stop(),this.w.start())};
	function Wk(a){try{return firebase.app(a.o).auth()}catch(b){throw new K("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function Sk(a){return new Ek(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-na()-3E5;return 0<b?b:0})}function Xk(a){a.C||a.w.b||(a.w.start(),D(a,"tokenChanged",a.V),rc(a,"tokenChanged",a.V))}function Yk(a){D(a,"tokenChanged",a.V);a.w.stop()}
	function Qk(a,b){a.qa=b;I(a,"_lat",b)}function Zk(a,b){Ha(a.N,function(a){return a==b})}function $k(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return vb(b).then(function(){return a})}function al(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
	function Rk(a,b){J(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new Mk(b.createdAt,b.lastLoginAt),providerData:[]})}I(Q.prototype,"providerId","firebase");function bl(){}function cl(a){return A().then(function(){if(a.C)throw new K("app-deleted");})}function dl(a){return Ba(a.providerData,function(a){return a.providerId})}
	function el(a,b){b&&(fl(a,b.providerId),a.providerData.push(b))}function fl(a,b){Ha(a.providerData,function(a){return a.providerId==b})}function gl(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&I(a,b,c)}
	function hl(a,b){a!=b&&(J(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?I(a,"metadata",Nk(b.metadata)):I(a,"metadata",new Mk),v(b.providerData,function(b){el(a,b)}),Kk(a.h,b.h),I(a,"refreshToken",a.h.a))}g=Q.prototype;g.reload=function(){var a=this;return R(this,cl(this).then(function(){return il(a).then(function(){return $k(a)}).then(bl)}))};
	function il(a){return a.F().then(function(b){var c=a.isAnonymous;return jl(a,b).then(function(){c||gl(a,"isAnonymous",!1);return b})})}g.ac=function(a){return this.F(a).then(function(a){return new Dk(a)})};g.F=function(a){var b=this;return R(this,cl(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new K("internal-error");a.accessToken!=b.qa&&(Qk(b,a.accessToken),b.dispatchEvent(new Pk("tokenChanged")));gl(b,"refreshToken",a.refreshToken);return a.accessToken}))};
	function kl(a,b){b[L]&&a.qa!=b[L]&&(Ik(a.h,b),a.dispatchEvent(new Pk("tokenChanged")),Qk(a,b[L]),gl(a,"refreshToken",a.h.a))}function jl(a,b){return O(a.b,ti,{idToken:b}).then(r(a.uc,a))}
	g.uc=function(a){a=a.users;if(!a||!a.length)throw new K("internal-error");a=a[0];Rk(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=ll(a),c=0;c<b.length;c++)el(this,b[c]);gl(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
	function ll(a){return(a=a.providerUserInfo)&&a.length?Ba(a,function(a){return new Ok(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}g.cb=function(a){var b=this,c=null;return R(this,a.f(this.b,this.uid).then(function(a){kl(b,a);c=ml(b,a,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};
	g.vc=function(a){Ie("firebase.User.prototype.reauthenticateWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential instead.");return this.cb(a).then(function(){})};function nl(a,b){return il(a).then(function(){if(Fa(dl(a),b))return $k(a).then(function(){throw new K("provider-already-linked");})})}
	g.ab=function(a){var b=this,c=null;return R(this,nl(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.c(b.b,c)}).then(function(a){c=ml(b,a,"link");return ol(b,a)}).then(function(){return c}))};g.mc=function(a){Ie("firebase.User.prototype.linkWithCredential is deprecated. Please use firebase.User.prototype.linkAndRetrieveDataWithCredential instead.");return this.ab(a).then(function(a){return a.user})};
	g.nc=function(a,b){var c=this;return R(this,nl(this,"phone").then(function(){return Ck(Wk(c),a,b,r(c.ab,c))}))};g.wc=function(a,b){var c=this;return R(this,A().then(function(){return Ck(Wk(c),a,b,r(c.cb,c))}),!0)};function ml(a,b,c){var d=lg(b);b=yf(b);return Le({user:a,credential:d,additionalUserInfo:b,operationType:c})}function ol(a,b){kl(a,b);return a.reload().then(function(){return a})}
	g.mb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.mb(c,a)}).then(function(a){kl(b,a);return b.reload()}))};g.Pc=function(a){var b=this;return R(this,this.F().then(function(c){return a.c(b.b,c)}).then(function(a){kl(b,a);return b.reload()}))};g.nb=function(a){var b=this;return R(this,this.F().then(function(c){return b.b.nb(c,a)}).then(function(a){kl(b,a);return b.reload()}))};
	g.ob=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return cl(this);var b=this;return R(this,this.F().then(function(c){return b.b.ob(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){kl(b,a);gl(b,"displayName",a.displayName||null);gl(b,"photoURL",a.photoUrl||null);v(b.providerData,function(a){"password"===a.providerId&&(I(a,"displayName",b.displayName),I(a,"photoURL",b.photoURL))});return $k(b)}).then(bl))};
	g.Nc=function(a){var b=this;return R(this,il(this).then(function(c){return Fa(dl(b),a)?fi(b.b,c,[a]).then(function(a){var c={};v(a.providerUserInfo||[],function(a){c[a.providerId]=!0});v(dl(b),function(a){c[a]||fl(b,a)});c[ig.PROVIDER_ID]||I(b,"phoneNumber",null);return $k(b)}):$k(b).then(function(){throw new K("no-such-provider");})}))};
	g.delete=function(){var a=this;return R(this,this.F().then(function(b){return O(a.b,si,{idToken:b})}).then(function(){a.dispatchEvent(new Pk("userDeleted"))})).then(function(){for(var b=0;b<a.G.length;b++)a.G[b].cancel("app-deleted");Uk(a,null);Vk(a,null);a.G=[];a.C=!0;Yk(a);I(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
	g.sb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.aa||null)==b||"reauthViaRedirect"==a&&(this.aa||null)==b?!0:!1};g.ha=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};
	g.wa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.xb,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.yb,this):"linkViaRedirect"==a&&(this.aa||null)==b?r(this.xb,this):"reauthViaRedirect"==a&&(this.aa||null)==b?r(this.yb,this):null};g.oc=function(a){var b=this;return pl(this,"linkViaPopup",a,function(){return nl(b,a.providerId).then(function(){return $k(b)})},!1)};g.xc=function(a){return pl(this,"reauthViaPopup",a,function(){return A()},!0)};
	function pl(a,b,c,d,e){if(!ue())return B(new K("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=xf(c.providerId),h=te(a.uid+":::"),m=null;(!we()||le())&&a.u&&c.isOAuthProvider&&(m=Ri(a.u,a.l,a.o,b,c,null,h,firebase.SDK_VERSION||null));var p=de(m,f&&f.Ba,f&&f.Aa);d=d().then(function(){ql(a);if(!e)return a.F().then(function(){})}).then(function(){return rk(a.a,p,b,c,h,!!m)}).then(function(){return new y(function(c,d){a.ha(b,null,new K("cancelled-popup-request"),a.g||null);
	a.f=c;a.v=d;a.g=h;a.c=a.a.Ea(a,b,p,h)})}).then(function(a){p&&ce(p);return a?Le(a):null}).s(function(a){p&&ce(p);throw a;});return R(a,d,e)}g.pc=function(a){var b=this;return rl(this,"linkViaRedirect",a,function(){return nl(b,a.providerId)},!1)};g.yc=function(a){return rl(this,"reauthViaRedirect",a,function(){return A()},!0)};
	function rl(a,b,c,d,e){if(!ue())return B(new K("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=null,h=te(a.uid+":::");d=d().then(function(){ql(a);if(!e)return a.F().then(function(){})}).then(function(){a.aa=h;return $k(a)}).then(function(b){a.ba&&(b=a.ba,b=b.b.set(sl,a.D(),b.a));return b}).then(function(){return a.a.Ca(b,c,h)}).s(function(b){f=b;if(a.ba)return tl(a.ba);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
	function ql(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new K("internal-error");throw new K("auth-domain-config-required");}}g.xb=function(a,b){var c=this;this.c&&(this.c.cancel(),this.c=null);var d=null,e=this.F().then(function(d){return Nf(c.b,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=ml(c,a,"link");return ol(c,a)}).then(function(){return d});return R(this,e)};
	g.yb=function(a,b){var c=this;this.c&&(this.c.cancel(),this.c=null);var d=null,e=A().then(function(){return Jf(Of(c.b,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=ml(c,a,"reauthenticate");kl(c,a);c.i=null;return c.reload()}).then(function(){return d});return R(this,e,!0)};g.gb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Za(a)?{}:kf(new af(a))}).then(function(a){return b.b.gb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
	function R(a,b,c){var d=ul(a,b,c);a.G.push(d);d.ia(function(){Ga(a.G,d)});return d}function ul(a,b,c){return a.i&&!c?(b.cancel(),B(a.i)):b.s(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.i||a.dispatchEvent(new Pk("userInvalidated")),a.i=b);throw b;})}g.toJSON=function(){return this.D()};
	g.D=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.l,appName:this.o,authDomain:this.u,stsTokenManager:this.h.D(),redirectEventId:this.aa||null};this.metadata&&bb(a,this.metadata.D());v(this.providerData,function(b){a.providerData.push(Me(b))});return a};
	function vl(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[L]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-na())/1E3;else return null;var d=new Q(b,c,a);a.providerData&&v(a.providerData,function(a){a&&el(d,Le(a))});a.redirectEventId&&(d.aa=a.redirectEventId);return d}
	function wl(a,b,c,d){var e=new Q(a,b);c&&(e.ba=c);d&&Tk(e,d);return e.reload().then(function(){return e})}function xl(a,b,c,d){b=b||{apiKey:a.l,authDomain:a.u,appName:a.o};var e=a.h,f={};f[L]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-na())/1E3;b=new Q(b,f);c&&(b.ba=c);d&&Tk(b,d);hl(b,a);return b};function yl(a){this.a=a;this.b=vj()}var sl={name:"redirectUser",A:"session"};function tl(a){return zj(a.b,sl,a.a)}function zl(a,b){return a.b.get(sl,a.a).then(function(a){a&&b&&(a.authDomain=b);return vl(a||{})})};function Al(a){this.a=a;this.b=vj();this.c=null;this.f=Bl(this);this.b.addListener(Cl("local"),this.a,r(this.g,this))}Al.prototype.g=function(){var a=this,b=Cl("local");Dl(this,function(){return A().then(function(){return a.c&&"local"!=a.c.A?a.b.get(b,a.a):null}).then(function(c){if(c)return El(a,"local").then(function(){a.c=b})})})};function El(a,b){var c=[],d;for(d in rj)rj[d]!==b&&c.push(zj(a.b,Cl(rj[d]),a.a));c.push(zj(a.b,Fl,a.a));return ub(c)}
	function Bl(a){var b=Cl("local"),c=Cl("session"),d=Cl("none");return yj(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(Fl,a.a).then(function(a){return a?Cl(a):b})})})}).then(function(b){a.c=b;return El(a,b.A)}).s(function(){a.c||(a.c=b)})}var Fl={name:"persistence",A:"session"};function Cl(a){return{name:"authUser",A:a}}
	Al.prototype.jb=function(a){var b=null,c=this;sj(a);return Dl(this,function(){return a!=c.c.A?c.b.get(c.c,c.a).then(function(d){b=d;return El(c,a)}).then(function(){c.c=Cl(a);if(b)return c.b.set(c.c,b,c.a)}):A()})};function Gl(a){return Dl(a,function(){return a.b.set(Fl,a.c.A,a.a)})}function Hl(a,b){return Dl(a,function(){return a.b.set(a.c,b.D(),a.a)})}function Il(a){return Dl(a,function(){return zj(a.b,a.c,a.a)})}
	function Jl(a,b){return Dl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return vl(a||{})})})}function Dl(a,b){a.f=a.f.then(b,b);return a.f};function Kl(a){this.l=!1;I(this,"settings",new Ak);I(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?re(firebase.SDK_VERSION):null,this.b=new Ah(S(this).options&&S(this).options.apiKey,xi(yi),a);else throw new K("invalid-api-key");this.N=[];this.o=[];this.I=[];this.Pb=firebase.INTERNAL.createSubscribe(r(this.ic,this));this.O=void 0;this.Qb=firebase.INTERNAL.createSubscribe(r(this.jc,this));Ll(this,null);this.h=new Al(S(this).options.apiKey+":"+S(this).name);this.w=
	new yl(S(this).options.apiKey+":"+S(this).name);this.V=T(this,Ml(this));this.i=T(this,Nl(this));this.X=!1;this.ka=r(this.Jc,this);this.Ha=r(this.Z,this);this.qa=r(this.Yb,this);this.ra=r(this.gc,this);this.sa=r(this.hc,this);Ol(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.qc,this);this.u=0;E.call(this);Pl(this);this.G=[]}t(Kl,E);function Ql(a){C.call(this,"languageCodeChanged");this.g=a}t(Ql,C);
	function Sl(a){C.call(this,"frameworkChanged");this.c=a}t(Sl,C);g=Kl.prototype;g.jb=function(a){a=this.h.jb(a);return T(this,a)};g.oa=function(a){this.W===a||this.l||(this.W=a,Gh(this.b,this.W),this.dispatchEvent(new Ql(this.ea())))};g.ea=function(){return this.W};g.Qc=function(){var a=k.navigator;this.oa(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};g.qc=function(a){this.G.push(a);Hh(this.b,firebase.SDK_VERSION?re(firebase.SDK_VERSION,this.G):null);this.dispatchEvent(new Sl(this.G))};
	g.xa=function(){return Ja(this.G)};function Pl(a){Object.defineProperty(a,"lc",{get:function(){return this.ea()},set:function(a){this.oa(a)},enumerable:!1});a.W=null}g.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).D()}};function Tl(a){return a.Ob||B(new K("auth-domain-config-required"))}
	function Ol(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&ue()&&(a.Ob=a.V.then(function(){if(!a.l){a.a=tk(b,c,S(a).name);a.a.subscribe(a);U(a)&&al(U(a));if(a.C){al(a.C);var d=a.C;d.oa(a.ea());Uk(d,a);d=a.C;Tk(d,a.G);Vk(d,a);a.C=null}return a.a}}))}g.sb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
	g.ha=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.v)};g.wa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.Xb,this):null};
	g.Xb=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.c&&(this.c.cancel(),this.c=null);var d=null,e=null,f=Lf(c.b,a).then(function(a){d=lg(a);e=yf(a);return a});a=c.V.then(function(){return f}).then(function(a){return Ul(c,a)}).then(function(){return Le({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return T(this,a)};
	g.Hc=function(a){if(!ue())return B(new K("operation-not-supported-in-this-environment"));var b=this,c=xf(a.providerId),d=te(),e=null;(!we()||le())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Ri(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=de(e,c&&c.Ba,c&&c.Aa);c=Tl(this).then(function(b){return rk(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new y(function(a,c){b.ha("signInViaPopup",null,new K("cancelled-popup-request"),
	b.g);b.f=a;b.v=c;b.g=d;b.c=b.a.Ea(b,"signInViaPopup",f,d)})}).then(function(a){f&&ce(f);return a?Le(a):null}).s(function(a){f&&ce(f);throw a;});return T(this,c)};g.Ic=function(a){if(!ue())return B(new K("operation-not-supported-in-this-environment"));var b=this,c=Tl(this).then(function(){return Gl(b.h)}).then(function(){return b.a.Ca("signInViaRedirect",a)});return T(this,c)};
	g.fa=function(){if(!ue())return B(new K("operation-not-supported-in-this-environment"));var a=this,b=Tl(this).then(function(){return a.a.fa()}).then(function(a){return a?Le(a):null});return T(this,b)};
	g.Oc=function(a){if(!a)return B(new K("null-user"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=xl(a,c,b.w,b.xa());return T(this,this.i.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return hl(U(b),a),b.Z(a);Ll(b,d);al(d);return b.Z(d)}).then(function(){Vl(b)}))};
	function Ul(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.V.then(function(){return wl(c,b,a.w,a.xa())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return hl(U(a),b),a.Z(b);Ll(a,b);al(b);return a.Z(b)}).then(function(){Vl(a)})}
	function Ll(a,b){U(a)&&(Zk(U(a),a.Ha),D(U(a),"tokenChanged",a.qa),D(U(a),"userDeleted",a.ra),D(U(a),"userInvalidated",a.sa),Yk(U(a)));b&&(b.N.push(a.Ha),rc(b,"tokenChanged",a.qa),rc(b,"userDeleted",a.ra),rc(b,"userInvalidated",a.sa),0<a.u&&Xk(b));I(a,"currentUser",b);b&&(b.oa(a.ea()),Uk(b,a),Tk(b,a.G),Vk(b,a))}g.kb=function(){var a=this,b=this.i.then(function(){if(!U(a))return A();Ll(a,null);return Il(a.h).then(function(){Vl(a)})});return T(this,b)};
	function Wl(a){var b=zl(a.w,S(a).options.authDomain).then(function(b){if(a.C=b)b.ba=a.w;return tl(a.w)});return T(a,b)}function Ml(a){var b=S(a).options.authDomain,c=Wl(a).then(function(){return Jl(a.h,b)}).then(function(b){return b?(b.ba=a.w,a.C&&(a.C.aa||null)==(b.aa||null)?b:b.reload().then(function(){return Hl(a.h,b).then(function(){return b})}).s(function(c){return"auth/network-request-failed"==c.code?b:Il(a.h)})):null}).then(function(b){Ll(a,b||null)});return T(a,c)}
	function Nl(a){return a.V.then(function(){return a.fa()}).s(function(){}).then(function(){if(!a.l)return a.ka()}).s(function(){}).then(function(){if(!a.l){a.X=!0;var b=a.h;b.b.addListener(Cl("local"),b.a,a.ka)}})}
	g.Jc=function(){var a=this;return Jl(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return hl(U(a),b),U(a).F();if(U(a)||b)Ll(a,b),b&&(al(b),b.ba=a.w),a.a&&a.a.subscribe(a),Vl(a)}})};g.Z=function(a){return Hl(this.h,a)};g.Yb=function(){Vl(this);this.Z(U(this))};g.gc=function(){this.kb()};g.hc=function(){this.kb()};
	function Xl(a,b){var c=null,d=null;return T(a,b.then(function(b){c=lg(b);d=yf(b);return Ul(a,b)}).then(function(){return Le({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}g.ic=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};g.jc=function(a){var b=this;Yl(this,function(){a.next(U(b))})};g.sc=function(a,b,c){var d=this;this.X&&firebase.Promise.resolve().then(function(){n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Pb(a,b,c)};
	g.rc=function(a,b,c){var d=this;this.X&&firebase.Promise.resolve().then(function(){d.O=d.getUid();n(a)?a(U(d)):n(a.next)&&a.next(U(d))});return this.Qb(a,b,c)};g.$b=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};g.Jb=function(a){var b=this;return this.i.then(function(){return Xl(b,O(b.b,vi,{token:a}))}).then(function(a){var c=a.user;gl(c,"isAnonymous",!1);b.Z(c);return a})};
	g.Bc=function(a){Ie("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCustomToken is deprecated. Please use firebase.auth.Auth.prototype.signInWithCustomToken instead.");return this.Jb(a)};g.Cc=function(a,b){Ie("firebase.auth.Auth.prototype.signInAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.signInWithEmailAndPassword instead.");return this.Kb(a,b)};g.Kb=function(a,b){var c=this;return this.i.then(function(){return Xl(c,O(c.b,$f,{email:a,password:b}))})};
	g.ub=function(a,b){var c=this;return this.i.then(function(){return Xl(c,O(c.b,ri,{email:a,password:b}))})};g.Sb=function(a,b){Ie("firebase.auth.Auth.prototype.createUserAndRetrieveDataWithEmailAndPassword is deprecated. Please use firebase.auth.Auth.prototype.createUserWithEmailAndPassword instead.");return this.ub(a,b)};g.Ec=function(a){Ie("firebase.auth.Auth.prototype.signInWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential instead.");return this.Oa(a).then(function(a){return a.user})};
	g.Oa=function(a){var b=this;return this.i.then(function(){return Xl(b,a.ya(b.b))})};g.Pa=function(){var a=this;return this.i.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=Le({providerId:null,isNewUser:!1});return Le({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Xl(a,a.b.Pa()).then(function(b){var c=b.user;gl(c,"isAnonymous",!0);a.Z(c);return b})})};
	g.Dc=function(){Ie("firebase.auth.Auth.prototype.signInAnonymouslyAndRetrieveData is deprecated. Please use firebase.auth.Auth.prototype.signInAnonymously instead.");return this.Pa()};function S(a){return a.app}function U(a){return a.currentUser}g.getUid=function(){return U(this)&&U(this).uid||null};function Zl(a){return U(a)&&U(a)._lat||null}
	function Vl(a){if(a.X){for(var b=0;b<a.o.length;b++)if(a.o[b])a.o[b](Zl(a));if(a.O!==a.getUid()&&a.I.length)for(a.O=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](Zl(a))}}g.Rb=function(a){this.addAuthTokenListener(a);this.u++;0<this.u&&U(this)&&Xk(U(this))};g.zc=function(a){var b=this;v(this.o,function(c){c==a&&b.u--});0>this.u&&(this.u=0);0==this.u&&U(this)&&Yk(U(this));this.removeAuthTokenListener(a)};
	g.addAuthTokenListener=function(a){var b=this;this.o.push(a);T(this,this.i.then(function(){b.l||Fa(b.o,a)&&a(Zl(b))}))};g.removeAuthTokenListener=function(a){Ha(this.o,function(b){return b==a})};function Yl(a,b){a.I.push(b);T(a,a.i.then(function(){!a.l&&Fa(a.I,b)&&a.O!==a.getUid()&&(a.O=a.getUid(),b(Zl(a)))}))}
	g.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,a.b.removeListener(Cl("local"),a.a,this.ka));this.a&&this.a.unsubscribe(this);return firebase.Promise.resolve()};function T(a,b){a.N.push(b);b.ia(function(){Ga(a.N,b)});return b}g.Vb=function(a){Ie("firebase.auth.Auth.prototype.fetchProvidersForEmail is deprecated. Please use firebase.auth.Auth.prototype.fetchSignInMethodsForEmail instead.");return T(this,Rh(this.b,a))};
	g.Wb=function(a){return T(this,Th(this.b,a))};g.kc=function(a){return!!dg(a)};g.ib=function(a,b){var c=this;return T(this,A().then(function(){var a=new af(b);if(!a.c)throw new K("argument-error",jf+" must be true when sending sign in link to email");return kf(a)}).then(function(b){return c.b.ib(a,b)}).then(function(){}))};g.Rc=function(a){return this.Ja(a).then(function(a){return a.data.email})};g.Xa=function(a,b){return T(this,this.b.Xa(a,b).then(function(){}))};g.Ja=function(a){return T(this,this.b.Ja(a).then(function(a){return new Pe(a)}))};
	g.Va=function(a){return T(this,this.b.Va(a).then(function(){}))};g.hb=function(a,b){var c=this;return T(this,A().then(function(){return"undefined"===typeof b||Za(b)?{}:kf(new af(b))}).then(function(b){return c.b.hb(a,b)}).then(function(){}))};g.Gc=function(a,b){return T(this,Ck(this,a,b,r(this.Oa,this)))};g.Fc=function(a,b){var c=this;return T(this,A().then(function(){var d=cg(a,b||Wd());return c.Oa(d)}))};function $l(){}$l.prototype.render=function(){};$l.prototype.reset=function(){};$l.prototype.getResponse=function(){};$l.prototype.execute=function(){};function am(){this.a={};this.b=1E12}var bm=null;am.prototype.render=function(a,b){this.a[this.b.toString()]=new cm(a,b);return this.b++};am.prototype.reset=function(a){var b=dm(this,a);a=em(a);b&&a&&(b.delete(),delete this.a[a])};am.prototype.getResponse=function(a){return(a=dm(this,a))?a.getResponse():null};am.prototype.execute=function(a){(a=dm(this,a))&&a.execute()};function dm(a,b){return(b=em(b))?a.a[b]||null:null}function em(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
	function cm(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Jd(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():rc(this.f,"click",this.i)}cm.prototype.getResponse=function(){fm(this);return this.b};
	cm.prototype.execute=function(){fm(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=pe();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};cm.prototype.delete=function(){fm(this);this.g=!0;clearTimeout(this.a);this.a=null;D(this.f,"click",this.i)};function fm(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function gm(){}gm.prototype.g=function(){bm||(bm=new am);return A(bm)};gm.prototype.c=function(){};var hm=null;function im(){this.b=k.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var jm=rd("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),km=new Ce(3E4,6E4);
	im.prototype.g=function(a){var b=this;return new y(function(c,d){var e=setTimeout(function(){d(new K("network-request-failed"))},km.get());if(!k.grecaptcha||a!==b.f&&!b.b){k[b.a]=function(){if(k.grecaptcha){b.f=a;var f=k.grecaptcha.render;k.grecaptcha.render=function(a,c){a=f(a,c);b.b++;return a};clearTimeout(e);c(k.grecaptcha)}else clearTimeout(e),d(new K("internal-error"));delete k[b.a]};var f=vd(jm,{onload:b.a,hl:a||""});A(sh(f)).s(function(){clearTimeout(e);d(new K("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
	c(k.grecaptcha)})};im.prototype.c=function(){this.b--};var lm=null;function mm(a,b,c,d,e,f,h){I(this,"type","recaptcha");this.c=this.f=null;this.C=!1;this.l=b;this.g=null;h?(hm||(hm=new gm),h=hm):(lm||(lm=new im),h=lm);this.o=h;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[nm])throw new K("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[om];if(!k.document)throw new K("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
	if(!Jd(b)||!this.i&&Jd(b).hasChildNodes())throw new K("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Ah(a,f||null,e||null);this.v=d||function(){return null};var m=this;this.m=[];var p=this.a[pm];this.a[pm]=function(a){qm(m,a);if("function"===typeof p)p(a);else if("string"===typeof p){var b=H(p,k);"function"===typeof b&&b(a)}};var z=this.a[rm];this.a[rm]=function(){qm(m,null);if("function"===typeof z)z();else if("string"===typeof z){var a=
	H(z,k);"function"===typeof a&&a()}}}var pm="callback",rm="expired-callback",nm="sitekey",om="size";function qm(a,b){for(var c=0;c<a.m.length;c++)try{a.m[c](b)}catch(d){}}function sm(a,b){Ha(a.m,function(a){return a==b})}function tm(a,b){a.h.push(b);b.ia(function(){Ga(a.h,b)});return b}g=mm.prototype;
	g.za=function(){var a=this;return this.f?this.f:this.f=tm(this,A().then(function(){if(ve()&&!me())return he();throw new K("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.o.g(a.v())}).then(function(b){a.g=b;return O(a.u,ui,{})}).then(function(b){a.a[nm]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
	g.render=function(){um(this);var a=this;return tm(this,this.za().then(function(){if(null===a.c){var b=a.l;if(!a.i){var c=Jd(b);b=Md("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};g.verify=function(){um(this);var a=this;return tm(this,this.render().then(function(b){return new y(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(b){b&&(sm(a,e),c(b))};a.m.push(e);a.i&&a.g.execute(a.c)}})}))};g.reset=function(){um(this);null!==this.c&&this.g.reset(this.c)};
	function um(a){if(a.C)throw new K("internal-error","RecaptchaVerifier instance has been destroyed.");}g.clear=function(){um(this);this.C=!0;this.o.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Jd(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};
	function vm(a,b,c){var d=!1;try{this.b=c||firebase.app()}catch(h){throw new K("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new K("invalid-api-key");var e=this,f=null;try{f=this.b.auth().xa()}catch(h){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(h){}f=firebase.SDK_VERSION?re(firebase.SDK_VERSION,f):null;mm.call(this,c,a,b,function(){try{var a=e.b.auth().ea()}catch(m){a=
	null}return a},f,xi(yi),d)}t(vm,mm);function wm(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,h=0;h<b.length;h++)if(b[h].optional)f=!0;else{if(f)throw new K("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=xm.length)throw new K("internal-error",
	"Argument validator received an unsupported number of arguments.");c=xm[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new K("argument-error",a+" failed: "+d);}var xm="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:l}}function ym(a,b){return{name:a||"",K:"a boolean",optional:!!b,M:ba}}
	function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function zm(a,b){return{name:a||"",K:"a function",optional:!!b,M:n}}function Am(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function Bm(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function Cm(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof Kl)}}}
	function Dm(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof firebase.app.App)}}}function Em(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.ya||!c)}}}
	function Fm(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Gm(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&l(a.type)&&n(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=Hm(d,a[c],b[c].j)}}function Im(a,b){for(var c in b){var d=b[c].name;if(d!==c){var e=b[c].qb;Object.defineProperty(a,d,{get:function(){return this[c]},set:function(a){wm(d,[e],[a],!0);this[c]=a},enumerable:!0})}}}function Z(a,b,c,d){a[b]=Hm(b,c,d)}
	function Hm(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);wm(e,c,a);return b.apply(this,a)}if(!c)return b;var e=Jm(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function Jm(a){a=a.split(".");return a[a.length-1]};Y(Kl.prototype,{Va:{name:"applyActionCode",j:[V("code")]},Ja:{name:"checkActionCode",j:[V("code")]},Xa:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},ub:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},Sb:{name:"createUserAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Vb:{name:"fetchProvidersForEmail",j:[V("email")]},Wb:{name:"fetchSignInMethodsForEmail",j:[V("email")]},fa:{name:"getRedirectResult",j:[]},kc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},
	rc:{name:"onAuthStateChanged",j:[X(W(),zm(),"nextOrObserver"),zm("opt_error",!0),zm("opt_completed",!0)]},sc:{name:"onIdTokenChanged",j:[X(W(),zm(),"nextOrObserver"),zm("opt_error",!0),zm("opt_completed",!0)]},hb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Am(null,!0),"opt_actionCodeSettings",!0)]},ib:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},jb:{name:"setPersistence",j:[V("persistence")]},Oa:{name:"signInAndRetrieveDataWithCredential",
	j:[Em()]},Pa:{name:"signInAnonymously",j:[]},Dc:{name:"signInAnonymouslyAndRetrieveData",j:[]},Ec:{name:"signInWithCredential",j:[Em()]},Jb:{name:"signInWithCustomToken",j:[V("token")]},Bc:{name:"signInAndRetrieveDataWithCustomToken",j:[V("token")]},Kb:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Fc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Cc:{name:"signInAndRetrieveDataWithEmailAndPassword",j:[V("email"),V("password")]},Gc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),
	Gm()]},Hc:{name:"signInWithPopup",j:[Fm()]},Ic:{name:"signInWithRedirect",j:[Fm()]},Oc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",K:"an instance of Firebase User",optional:!!a,M:function(a){return!!(a&&a instanceof Q)}}}(),Am(),"user")]},kb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},Qc:{name:"useDeviceLanguage",j:[]},Rc:{name:"verifyPasswordResetCode",j:[V("code")]}});Im(Kl.prototype,{lc:{name:"languageCode",qb:X(V(),Am(),"languageCode")}});Kl.Persistence=rj;
	Kl.Persistence.LOCAL="local";Kl.Persistence.SESSION="session";Kl.Persistence.NONE="none";
	Y(Q.prototype,{"delete":{name:"delete",j:[]},ac:{name:"getIdTokenResult",j:[ym("opt_forceRefresh",!0)]},F:{name:"getIdToken",j:[ym("opt_forceRefresh",!0)]},ab:{name:"linkAndRetrieveDataWithCredential",j:[Em()]},mc:{name:"linkWithCredential",j:[Em()]},nc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Gm()]},oc:{name:"linkWithPopup",j:[Fm()]},pc:{name:"linkWithRedirect",j:[Fm()]},cb:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Em()]},vc:{name:"reauthenticateWithCredential",j:[Em()]},wc:{name:"reauthenticateWithPhoneNumber",
	j:[V("phoneNumber"),Gm()]},xc:{name:"reauthenticateWithPopup",j:[Fm()]},yc:{name:"reauthenticateWithRedirect",j:[Fm()]},reload:{name:"reload",j:[]},gb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Am(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Nc:{name:"unlink",j:[V("provider")]},mb:{name:"updateEmail",j:[V("email")]},nb:{name:"updatePassword",j:[V("password")]},Pc:{name:"updatePhoneNumber",j:[Em("phone")]},ob:{name:"updateProfile",j:[W("profile")]}});
	Y(am.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y($l.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(y.prototype,{ia:{name:"finally"},s:{name:"catch"},then:{name:"then"}});Im(Ak.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",qb:ym("appVerificationDisabledForTesting")}});Y(Bk.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
	Z(N,"credential",function(a,b){return new Yf(a,b)},[V("email"),V("password")]);Y(Qf.prototype,{ta:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Qf,"credential",Rf,[X(V(),W(),"token")]);Z(N,"credentialWithLink",cg,[V("email"),V("emailLink")]);Y(Sf.prototype,{ta:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Sf,"credential",Tf,[X(V(),W(),"token")]);
	Y(Uf.prototype,{ta:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Uf,"credential",Vf,[X(V(),X(W(),Am()),"idToken"),X(V(),Am(),"accessToken",!0)]);Y(Wf.prototype,{Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Wf,"credential",Xf,[X(V(),W(),"token"),V("secret",!0)]);
	Y(M.prototype,{ta:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),Am(),"idToken",!0),X(V(),Am(),"accessToken",!0)]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(ig,"credential",kg,[V("verificationId"),V("verificationCode")]);Y(ig.prototype,{Ta:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Gm()]}});Y(K.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(sg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});
	Y(rg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(vm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:Kl,Error:K};Z(a,"EmailAuthProvider",N,[]);Z(a,"FacebookAuthProvider",Qf,[]);Z(a,"GithubAuthProvider",Sf,[]);Z(a,"GoogleAuthProvider",Uf,[]);Z(a,"TwitterAuthProvider",Wf,[]);Z(a,"OAuthProvider",M,[V("providerId")]);Z(a,"PhoneAuthProvider",ig,[Cm()]);Z(a,"RecaptchaVerifier",vm,[X(V(),Bm(),"recaptchaContainer"),W("recaptchaParameters",!0),Dm()]);firebase.INTERNAL.registerService("auth",function(a,
	c){a=new Kl(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.$b,a),addAuthTokenListener:r(a.Rb,a),removeAuthTokenListener:r(a.zc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:Q})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();
	}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {'use strict';
	
	__webpack_require__(564);
	
	// Store setTimeout reference so promise-polyfill will be unaffected by
	// other code modifying setTimeout (like sinon.useFakeTimers())
	var setTimeoutFunc = setTimeout;
	
	function noop() {}
	
	// Polyfill for Function.prototype.bind
	function bind(fn, thisArg) {
	  return function() {
	    fn.apply(thisArg, arguments);
	  };
	}
	
	function Promise(fn) {
	  if (!(this instanceof Promise))
	    throw new TypeError('Promises must be constructed via new');
	  if (typeof fn !== 'function') throw new TypeError('not a function');
	  this._state = 0;
	  this._handled = false;
	  this._value = undefined;
	  this._deferreds = [];
	
	  doResolve(fn, this);
	}
	
	function handle(self, deferred) {
	  while (self._state === 3) {
	    self = self._value;
	  }
	  if (self._state === 0) {
	    self._deferreds.push(deferred);
	    return;
	  }
	  self._handled = true;
	  Promise._immediateFn(function() {
	    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	      return;
	    }
	    var ret;
	    try {
	      ret = cb(self._value);
	    } catch (e) {
	      reject(deferred.promise, e);
	      return;
	    }
	    resolve(deferred.promise, ret);
	  });
	}
	
	function resolve(self, newValue) {
	  try {
	    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	    if (newValue === self)
	      throw new TypeError('A promise cannot be resolved with itself.');
	    if (
	      newValue &&
	      (typeof newValue === 'object' || typeof newValue === 'function')
	    ) {
	      var then = newValue.then;
	      if (newValue instanceof Promise) {
	        self._state = 3;
	        self._value = newValue;
	        finale(self);
	        return;
	      } else if (typeof then === 'function') {
	        doResolve(bind(then, newValue), self);
	        return;
	      }
	    }
	    self._state = 1;
	    self._value = newValue;
	    finale(self);
	  } catch (e) {
	    reject(self, e);
	  }
	}
	
	function reject(self, newValue) {
	  self._state = 2;
	  self._value = newValue;
	  finale(self);
	}
	
	function finale(self) {
	  if (self._state === 2 && self._deferreds.length === 0) {
	    Promise._immediateFn(function() {
	      if (!self._handled) {
	        Promise._unhandledRejectionFn(self._value);
	      }
	    });
	  }
	
	  for (var i = 0, len = self._deferreds.length; i < len; i++) {
	    handle(self, self._deferreds[i]);
	  }
	  self._deferreds = null;
	}
	
	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, self) {
	  var done = false;
	  try {
	    fn(
	      function(value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      },
	      function(reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      }
	    );
	  } catch (ex) {
	    if (done) return;
	    done = true;
	    reject(self, ex);
	  }
	}
	
	Promise.prototype['catch'] = function(onRejected) {
	  return this.then(null, onRejected);
	};
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  var prom = new this.constructor(noop);
	
	  handle(this, new Handler(onFulfilled, onRejected, prom));
	  return prom;
	};
	
	Promise.prototype['finally'] = function(callback) {
	  var constructor = this.constructor;
	  return this.then(
	    function(value) {
	      return constructor.resolve(callback()).then(function() {
	        return value;
	      });
	    },
	    function(reason) {
	      return constructor.resolve(callback()).then(function() {
	        return constructor.reject(reason);
	      });
	    }
	  );
	};
	
	Promise.all = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!arr || typeof arr.length === 'undefined')
	      throw new TypeError('Promise.all accepts an array');
	    var args = Array.prototype.slice.call(arr);
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	
	    function res(i, val) {
	      try {
	        if (val && (typeof val === 'object' || typeof val === 'function')) {
	          var then = val.then;
	          if (typeof then === 'function') {
	            then.call(
	              val,
	              function(val) {
	                res(i, val);
	              },
	              reject
	            );
	            return;
	          }
	        }
	        args[i] = val;
	        if (--remaining === 0) {
	          resolve(args);
	        }
	      } catch (ex) {
	        reject(ex);
	      }
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.resolve = function(value) {
	  if (value && typeof value === 'object' && value.constructor === Promise) {
	    return value;
	  }
	
	  return new Promise(function(resolve) {
	    resolve(value);
	  });
	};
	
	Promise.reject = function(value) {
	  return new Promise(function(resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function(values) {
	  return new Promise(function(resolve, reject) {
	    for (var i = 0, len = values.length; i < len; i++) {
	      values[i].then(resolve, reject);
	    }
	  });
	};
	
	// Use polyfill for setImmediate for performance gains
	Promise._immediateFn =
	  (typeof setImmediate === 'function' &&
	    function(fn) {
	      setImmediate(fn);
	    }) ||
	  function(fn) {
	    setTimeoutFunc(fn, 0);
	  };
	
	Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	  if (typeof console !== 'undefined' && console) {
	    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	  }
	};
	
	var globalNS = (function() {
	  // the only reliable means to get the global object is
	  // `Function('return this')()`
	  // However, this causes CSP violations in Chrome apps.
	  if (typeof self !== 'undefined') {
	    return self;
	  }
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	  if (typeof global !== 'undefined') {
	    return global;
	  }
	  throw new Error('unable to locate global object');
	})();
	
	if (!globalNS.Promise) {
	  globalNS.Promise = Promise;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var _global = createCommonjsModule(function (module) {
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	});
	
	var _core = createCommonjsModule(function (module) {
	var core = module.exports = { version: '2.5.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	});
	var _core_1 = _core.version;
	
	var _isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	var _anObject = function (it) {
	  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	var _fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	var document = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document) && _isObject(document.createElement);
	var _domCreate = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function (it, S) {
	  if (!_isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	var dP = Object.defineProperty;
	
	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	var _objectDp = {
		f: f
	};
	
	var _propertyDesc = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	var id = 0;
	var px = Math.random();
	var _uid = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	var _redefine = createCommonjsModule(function (module) {
	var SRC = _uid('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	_core.inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === _global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    _hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    _hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});
	});
	
	var _aFunction = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	// optional / simple context binding
	
	var _ctx = function (fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // extend global
	    if (target) _redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) _hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	_global.core = _core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;
	
	var toString = {}.toString;
	
	var _cof = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	
	// eslint-disable-next-line no-prototype-builtins
	var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return _cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	// 7.1.13 ToObject(argument)
	
	var _toObject = function (it) {
	  return Object(_defined(it));
	};
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	// 7.1.15 ToLength
	
	var min = Math.min;
	var _toLength = function (it) {
	  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	// 7.2.2 IsArray(argument)
	
	var _isArray = Array.isArray || function isArray(arg) {
	  return _cof(arg) == 'Array';
	};
	
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});
	var _shared = function (key) {
	  return store[key] || (store[key] = {});
	};
	
	var _wks = createCommonjsModule(function (module) {
	var store = _shared('wks');
	
	var Symbol = _global.Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
	};
	
	$exports.store = store;
	});
	
	var SPECIES = _wks('species');
	
	var _arraySpeciesConstructor = function (original) {
	  var C;
	  if (_isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
	    if (_isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	
	
	var _arraySpeciesCreate = function (original, length) {
	  return new (_arraySpeciesConstructor(original))(length);
	};
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	
	
	
	
	
	var _arrayMethods = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || _arraySpeciesCreate;
	  return function ($this, callbackfn, that) {
	    var O = _toObject($this);
	    var self = _iobject(O);
	    var f = _ctx(callbackfn, that, 3);
	    var length = _toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = _wks('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
	var _addToUnscopables = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	
	var $find = _arrayMethods(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	_export(_export.P + _export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	_addToUnscopables(KEY);
	
	var find = _core.Array.find;
	
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	
	var $find$1 = _arrayMethods(6);
	var KEY$1 = 'findIndex';
	var forced$1 = true;
	// Shouldn't skip holes
	if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
	_export(_export.P + _export.F * forced$1, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	_addToUnscopables(KEY$1);
	
	var findIndex = _core.Array.findIndex;
	
	// 7.2.8 IsRegExp(argument)
	
	
	var MATCH = _wks('match');
	var _isRegexp = function (it) {
	  var isRegExp;
	  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
	};
	
	// helper for String#{startsWith, endsWith, includes}
	
	
	
	var _stringContext = function (that, searchString, NAME) {
	  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(_defined(that));
	};
	
	var MATCH$1 = _wks('match');
	var _failsIsRegexp = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH$1] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};
	
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = _stringContext(this, searchString, STARTS_WITH);
	    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});
	
	var startsWith = _core.String.startsWith;
	
	var _stringRepeat = function repeat(count) {
	  var str = String(_defined(this));
	  var res = '';
	  var n = _toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};
	
	_export(_export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: _stringRepeat
	});
	
	var repeat = _core.String.repeat;
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(562).setImmediate, (function() { return this; }())))

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib_1 = __webpack_require__(355);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
	 */
	var CONSTANTS = {
	    /**
	     * @define {boolean} Whether this is the client Node.js SDK.
	     */
	    NODE_CLIENT: false,
	    /**
	     * @define {boolean} Whether this is the Admin Node.js SDK.
	     */
	    NODE_ADMIN: false,
	    /**
	     * Firebase SDK Version
	     */
	    SDK_VERSION: '${JSCORE_VERSION}'
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws an error if the provided assertion is falsy
	 * @param {*} assertion The assertion to be tested for falsiness
	 * @param {!string} message The message to display if the check fails
	 */
	var assert = function (assertion, message) {
	    if (!assertion) {
	        throw assertionError(message);
	    }
	};
	/**
	 * Returns an Error object suitable for throwing.
	 * @param {string} message
	 * @return {!Error}
	 */
	var assertionError = function (message) {
	    return new Error('Firebase Database (' +
	        CONSTANTS.SDK_VERSION +
	        ') INTERNAL ASSERT FAILED: ' +
	        message);
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var stringToByteArray = function (str) {
	    // TODO(user): Use native implementations if/when available
	    var out = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if ((c & 0xfc00) == 0xd800 &&
	            i + 1 < str.length &&
	            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
	            // Surrogate Pair
	            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Turns an array of numbers into the string given by the concatenation of the
	 * characters to which the numbers correspond.
	 * @param {Array<number>} bytes Array of numbers representing characters.
	 * @return {string} Stringification of the array.
	 */
	var byteArrayToString = function (bytes) {
	    // TODO(user): Use native implementations if/when available
	    var out = [], pos = 0, c = 0;
	    while (pos < bytes.length) {
	        var c1 = bytes[pos++];
	        if (c1 < 128) {
	            out[c++] = String.fromCharCode(c1);
	        }
	        else if (c1 > 191 && c1 < 224) {
	            var c2 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
	        }
	        else if (c1 > 239 && c1 < 365) {
	            // Surrogate Pair
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            var c4 = bytes[pos++];
	            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
	                0x10000;
	            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
	            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
	        }
	        else {
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
	        }
	    }
	    return out.join('');
	};
	// Static lookup maps, lazily populated by init_()
	var base64 = {
	    /**
	     * Maps bytes to characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMap_: null,
	    /**
	     * Maps characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMap_: null,
	    /**
	     * Maps bytes to websafe characters.
	     * @type {Object}
	     * @private
	     */
	    byteToCharMapWebSafe_: null,
	    /**
	     * Maps websafe characters to bytes.
	     * @type {Object}
	     * @private
	     */
	    charToByteMapWebSafe_: null,
	    /**
	     * Our default alphabet, shared between
	     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
	     * @type {string}
	     */
	    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
	    /**
	     * Our default alphabet. Value 64 (=) is special; it means "nothing."
	     * @type {string}
	     */
	    get ENCODED_VALS() {
	        return this.ENCODED_VALS_BASE + '+/=';
	    },
	    /**
	     * Our websafe alphabet.
	     * @type {string}
	     */
	    get ENCODED_VALS_WEBSAFE() {
	        return this.ENCODED_VALS_BASE + '-_.';
	    },
	    /**
	     * Whether this browser supports the atob and btoa functions. This extension
	     * started at Mozilla but is now implemented by many browsers. We use the
	     * ASSUME_* variables to avoid pulling in the full useragent detection library
	     * but still allowing the standard per-browser compilations.
	     *
	     * @type {boolean}
	     */
	    HAS_NATIVE_SUPPORT: typeof atob === 'function',
	    /**
	     * Base64-encode an array of bytes.
	     *
	     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
	     *     value in [0, 255]) to encode.
	     * @param {boolean=} opt_webSafe Boolean indicating we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeByteArray: function (input, opt_webSafe) {
	        if (!Array.isArray(input)) {
	            throw Error('encodeByteArray takes an array as a parameter');
	        }
	        this.init_();
	        var byteToCharMap = opt_webSafe
	            ? this.byteToCharMapWebSafe_
	            : this.byteToCharMap_;
	        var output = [];
	        for (var i = 0; i < input.length; i += 3) {
	            var byte1 = input[i];
	            var haveByte2 = i + 1 < input.length;
	            var byte2 = haveByte2 ? input[i + 1] : 0;
	            var haveByte3 = i + 2 < input.length;
	            var byte3 = haveByte3 ? input[i + 2] : 0;
	            var outByte1 = byte1 >> 2;
	            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
	            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
	            var outByte4 = byte3 & 0x3f;
	            if (!haveByte3) {
	                outByte4 = 64;
	                if (!haveByte2) {
	                    outByte3 = 64;
	                }
	            }
	            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
	        }
	        return output.join('');
	    },
	    /**
	     * Base64-encode a string.
	     *
	     * @param {string} input A string to encode.
	     * @param {boolean=} opt_webSafe If true, we should use the
	     *     alternative alphabet.
	     * @return {string} The base64 encoded string.
	     */
	    encodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return btoa(input);
	        }
	        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * @param {string} input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the
	     *     alternative alphabet.
	     * @return {string} string representing the decoded value.
	     */
	    decodeString: function (input, opt_webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
	            return atob(input);
	        }
	        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * In base-64 decoding, groups of four characters are converted into three
	     * bytes.  If the encoder did not apply padding, the input length may not
	     * be a multiple of 4.
	     *
	     * In this case, the last group will have fewer than 4 characters, and
	     * padding will be inferred.  If the group has one or two characters, it decodes
	     * to one byte.  If the group has three characters, it decodes to two bytes.
	     *
	     * @param {string} input Input to decode.
	     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
	     * @return {!Array<number>} bytes representing the decoded value.
	     */
	    decodeStringToByteArray: function (input, opt_webSafe) {
	        this.init_();
	        var charToByteMap = opt_webSafe
	            ? this.charToByteMapWebSafe_
	            : this.charToByteMap_;
	        var output = [];
	        for (var i = 0; i < input.length;) {
	            var byte1 = charToByteMap[input.charAt(i++)];
	            var haveByte2 = i < input.length;
	            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
	            ++i;
	            var haveByte3 = i < input.length;
	            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            var haveByte4 = i < input.length;
	            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
	                throw Error();
	            }
	            var outByte1 = (byte1 << 2) | (byte2 >> 4);
	            output.push(outByte1);
	            if (byte3 != 64) {
	                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
	                output.push(outByte2);
	                if (byte4 != 64) {
	                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
	                    output.push(outByte3);
	                }
	            }
	        }
	        return output;
	    },
	    /**
	     * Lazy static initialization function. Called before
	     * accessing any of the static map variables.
	     * @private
	     */
	    init_: function () {
	        if (!this.byteToCharMap_) {
	            this.byteToCharMap_ = {};
	            this.charToByteMap_ = {};
	            this.byteToCharMapWebSafe_ = {};
	            this.charToByteMapWebSafe_ = {};
	            // We want quick mappings back and forth, so we precompute two maps.
	            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
	                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
	                this.charToByteMap_[this.byteToCharMap_[i]] = i;
	                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
	                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
	                // Be forgiving when decoding and correctly decode both encodings.
	                if (i >= this.ENCODED_VALS_BASE.length) {
	                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
	                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
	                }
	            }
	        }
	    }
	};
	/**
	 * URL-safe base64 encoding
	 * @param {!string} str
	 * @return {!string}
	 */
	var base64Encode = function (str) {
	    var utf8Bytes = stringToByteArray(str);
	    return base64.encodeByteArray(utf8Bytes, true);
	};
	/**
	 * URL-safe base64 decoding
	 *
	 * NOTE: DO NOT use the global atob() function - it does NOT support the
	 * base64Url variant encoding.
	 *
	 * @param {string} str To be decoded
	 * @return {?string} Decoded result, if possible
	 */
	var base64Decode = function (str) {
	    try {
	        return base64.decodeString(str, true);
	    }
	    catch (e) {
	        console.error('base64Decode failed: ', e);
	    }
	    return null;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Do a deep-copy of basic JavaScript Objects or Arrays.
	 */
	function deepCopy(value) {
	    return deepExtend(undefined, value);
	}
	/**
	 * Copy properties from source to target (recursively allows extension
	 * of Objects and Arrays).  Scalar values in the target are over-written.
	 * If target is undefined, an object of the appropriate type will be created
	 * (and returned).
	 *
	 * We recursively copy all child properties of plain Objects in the source- so
	 * that namespace- like dictionaries are merged.
	 *
	 * Note that the target can be a function, in which case the properties in
	 * the source Object are copied onto it as static properties of the Function.
	 */
	function deepExtend(target, source) {
	    if (!(source instanceof Object)) {
	        return source;
	    }
	    switch (source.constructor) {
	        case Date:
	            // Treat Dates like scalars; if the target date object had any child
	            // properties - they will be lost!
	            var dateValue = source;
	            return new Date(dateValue.getTime());
	        case Object:
	            if (target === undefined) {
	                target = {};
	            }
	            break;
	        case Array:
	            // Always copy the array source and overwrite the target.
	            target = [];
	            break;
	        default:
	            // Not a plain Object - treat it as a scalar.
	            return source;
	    }
	    for (var prop in source) {
	        if (!source.hasOwnProperty(prop)) {
	            continue;
	        }
	        target[prop] = deepExtend(target[prop], source[prop]);
	    }
	    return target;
	}
	// TODO: Really needed (for JSCompiler type checking)?
	function patchProperty(obj, prop, value) {
	    obj[prop] = value;
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    /**
	     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
	     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
	     * and returns a node-style callback which will resolve or reject the Deferred's promise.
	     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
	     * @return {!function(?(Error), ?=)}
	     */
	    Deferred.prototype.wrapCallback = function (callback) {
	        var _this = this;
	        return function (error, value) {
	            if (error) {
	                _this.reject(error);
	            }
	            else {
	                _this.resolve(value);
	            }
	            if (typeof callback === 'function') {
	                // Attaching noop handler just in case developer wasn't expecting
	                // promises
	                _this.promise.catch(function () { });
	                // Some of our callbacks don't expect a value and our own tests
	                // assert that the parameter length is 1
	                if (callback.length === 1) {
	                    callback(error);
	                }
	                else {
	                    callback(error, value);
	                }
	            }
	        };
	    };
	    return Deferred;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns navigator.userAgent string or '' if it's not defined.
	 * @return {string} user agent string
	 */
	var getUA = function () {
	    if (typeof navigator !== 'undefined' &&
	        typeof navigator['userAgent'] === 'string') {
	        return navigator['userAgent'];
	    }
	    else {
	        return '';
	    }
	};
	/**
	 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
	 *
	 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
	 * Cordova `onDeviceReady`, which would normally wait for a callback.
	 *
	 * @return {boolean} isMobileCordova
	 */
	var isMobileCordova = function () {
	    return (typeof window !== 'undefined' &&
	        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
	        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
	};
	/**
	 * Detect React Native.
	 *
	 * @return {boolean} True if ReactNative environment is detected.
	 */
	var isReactNative = function () {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	};
	/**
	 * Detect Node.js.
	 *
	 * @return {boolean} True if Node.js environment is detected.
	 */
	var isNodeSdk = function () {
	    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
	};
	
	var ERROR_NAME = 'FirebaseError';
	var captureStackTrace = Error
	    .captureStackTrace;
	// Export for faking in tests
	function patchCapture(captureFake) {
	    var result = captureStackTrace;
	    captureStackTrace = captureFake;
	    return result;
	}
	var FirebaseError = /** @class */ (function () {
	    function FirebaseError(code, message) {
	        this.code = code;
	        this.message = message;
	        // We want the stack value, if implemented by Error
	        if (captureStackTrace) {
	            // Patches this.stack, omitted calls above ErrorFactory#create
	            captureStackTrace(this, ErrorFactory.prototype.create);
	        }
	        else {
	            try {
	                // In case of IE11, stack will be set only after error is raised.
	                // https://docs.microsoft.com/en-us/scripting/javascript/reference/stack-property-error-javascript
	                throw Error.apply(this, arguments);
	            }
	            catch (err) {
	                this.name = ERROR_NAME;
	                // Make non-enumerable getter for the property.
	                Object.defineProperty(this, 'stack', {
	                    get: function () {
	                        return err.stack;
	                    }
	                });
	            }
	        }
	    }
	    return FirebaseError;
	}());
	// Back-door inheritance
	FirebaseError.prototype = Object.create(Error.prototype);
	FirebaseError.prototype.constructor = FirebaseError;
	FirebaseError.prototype.name = ERROR_NAME;
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	        // Matches {$name}, by default.
	        this.pattern = /\{\$([^}]+)}/g;
	        // empty
	    }
	    ErrorFactory.prototype.create = function (code, data) {
	        if (data === undefined) {
	            data = {};
	        }
	        var template = this.errors[code];
	        var fullCode = this.service + '/' + code;
	        var message;
	        if (template === undefined) {
	            message = 'Error';
	        }
	        else {
	            message = template.replace(this.pattern, function (match, key) {
	                var value = data[key];
	                return value !== undefined ? value.toString() : '<' + key + '?>';
	            });
	        }
	        // Service: Error message (service/code).
	        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
	        var err = new FirebaseError(fullCode, message);
	        // Populate the Error object with message parts for programmatic
	        // accesses (e.g., e.file).
	        for (var prop in data) {
	            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
	                continue;
	            }
	            err[prop] = data[prop];
	        }
	        return err;
	    };
	    return ErrorFactory;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Evaluates a JSON string into a javascript object.
	 *
	 * @param {string} str A string containing JSON.
	 * @return {*} The javascript object representing the specified JSON.
	 */
	function jsonEval(str) {
	    return JSON.parse(str);
	}
	/**
	 * Returns JSON representing a javascript object.
	 * @param {*} data Javascript object to be stringified.
	 * @return {string} The JSON contents of the object.
	 */
	function stringify(data) {
	    return JSON.stringify(data);
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Decodes a Firebase auth. token into constituent parts.
	 *
	 * Notes:
	 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {{header: *, claims: *, data: *, signature: string}}
	 */
	var decode = function (token) {
	    var header = {}, claims = {}, data = {}, signature = '';
	    try {
	        var parts = token.split('.');
	        header = jsonEval(base64Decode(parts[0]) || '');
	        claims = jsonEval(base64Decode(parts[1]) || '');
	        signature = parts[2];
	        data = claims['d'] || {};
	        delete claims['d'];
	    }
	    catch (e) { }
	    return {
	        header: header,
	        claims: claims,
	        data: data,
	        signature: signature
	    };
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
	 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	var isValidTimestamp = function (token) {
	    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
	    if (typeof claims === 'object') {
	        if (claims.hasOwnProperty('nbf')) {
	            validSince = claims['nbf'];
	        }
	        else if (claims.hasOwnProperty('iat')) {
	            validSince = claims['iat'];
	        }
	        if (claims.hasOwnProperty('exp')) {
	            validUntil = claims['exp'];
	        }
	        else {
	            // token will expire after 24h by default
	            validUntil = validSince + 86400;
	        }
	    }
	    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
	};
	/**
	 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
	 *
	 * Notes:
	 * - May return null if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {?number}
	 */
	var issuedAtTime = function (token) {
	    var claims = decode(token).claims;
	    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
	        return claims['iat'];
	    }
	    return null;
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
	 * signature.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	var isValidFormat = function (token) {
	    var decoded = decode(token), claims = decoded.claims;
	    return (!!decoded.signature &&
	        !!claims &&
	        typeof claims === 'object' &&
	        claims.hasOwnProperty('iat'));
	};
	/**
	 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 *
	 * @param {?string} token
	 * @return {boolean}
	 */
	var isAdmin = function (token) {
	    var claims = decode(token).claims;
	    return typeof claims === 'object' && claims['admin'] === true;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
	var contains = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	};
	var safeGet = function (obj, key) {
	    if (Object.prototype.hasOwnProperty.call(obj, key))
	        return obj[key];
	    // else return undefined.
	};
	/**
	 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
	 *
	 * @param {?Object.<K,V>} obj Object to enumerate.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	var forEach = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            fn(key, obj[key]);
	        }
	    }
	};
	/**
	 * Copies all the (own) properties from one object to another.
	 * @param {!Object} objTo
	 * @param {!Object} objFrom
	 * @return {!Object} objTo
	 */
	var extend = function (objTo, objFrom) {
	    forEach(objFrom, function (key, value) {
	        objTo[key] = value;
	    });
	    return objTo;
	};
	/**
	 * Returns a clone of the specified object.
	 * @param {!Object} obj
	 * @return {!Object} cloned obj.
	 */
	var clone = function (obj) {
	    return extend({}, obj);
	};
	/**
	 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
	 * for functions.
	 *
	 * @param obj {*} A potential object.
	 * @returns {boolean} True if it's an object.
	 */
	var isNonNullObject = function (obj) {
	    return typeof obj === 'object' && obj !== null;
	};
	var isEmpty = function (obj) {
	    for (var key in obj) {
	        return false;
	    }
	    return true;
	};
	var getCount = function (obj) {
	    var rv = 0;
	    for (var key in obj) {
	        rv++;
	    }
	    return rv;
	};
	var map = function (obj, f, opt_obj) {
	    var res = {};
	    for (var key in obj) {
	        res[key] = f.call(opt_obj, obj[key], key, obj);
	    }
	    return res;
	};
	var findKey = function (obj, fn, opt_this) {
	    for (var key in obj) {
	        if (fn.call(opt_this, obj[key], key, obj)) {
	            return key;
	        }
	    }
	    return undefined;
	};
	var findValue = function (obj, fn, opt_this) {
	    var key = findKey(obj, fn, opt_this);
	    return key && obj[key];
	};
	var getAnyKey = function (obj) {
	    for (var key in obj) {
	        return key;
	    }
	};
	var getValues = function (obj) {
	    var res = [];
	    var i = 0;
	    for (var key in obj) {
	        res[i++] = obj[key];
	    }
	    return res;
	};
	/**
	 * Tests whether every key/value pair in an object pass the test implemented
	 * by the provided function
	 *
	 * @param {?Object.<K,V>} obj Object to test.
	 * @param {!function(K, V)} fn Function to call for each key and value.
	 * @template K,V
	 */
	var every = function (obj, fn) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            if (!fn(key, obj[key])) {
	                return false;
	            }
	        }
	    }
	    return true;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
	 * object (e.g. {arg: 'val', arg2: 'val2'})
	 * Note: You must prepend it with ? when adding it to a URL.
	 *
	 * @param {!Object} querystringParams
	 * @return {string}
	 */
	var querystring = function (querystringParams) {
	    var params = [];
	    forEach(querystringParams, function (key, value) {
	        if (Array.isArray(value)) {
	            value.forEach(function (arrayVal) {
	                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
	            });
	        }
	        else {
	            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	        }
	    });
	    return params.length ? '&' + params.join('&') : '';
	};
	/**
	 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
	 *
	 * @param {string} querystring
	 * @return {!Object}
	 */
	var querystringDecode = function (querystring) {
	    var obj = {};
	    var tokens = querystring.replace(/^\?/, '').split('&');
	    tokens.forEach(function (token) {
	        if (token) {
	            var key = token.split('=');
	            obj[key[0]] = key[1];
	        }
	    });
	    return obj;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Copyright 2011 The Closure Library Authors. All Rights Reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS-IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	/**
	 * @fileoverview Abstract cryptographic hash interface.
	 *
	 * See Sha1 and Md5 for sample implementations.
	 *
	 */
	/**
	 * Create a cryptographic hash instance.
	 *
	 * @constructor
	 * @struct
	 */
	var Hash = /** @class */ (function () {
	    function Hash() {
	        /**
	         * The block size for the hasher.
	         * @type {number}
	         */
	        this.blockSize = -1;
	    }
	    return Hash;
	}());
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @extends {Hash}
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function (_super) {
	    tslib_1.__extends(Sha1, _super);
	    function Sha1() {
	        var _this = _super.call(this) || this;
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @type {!Array<number>}
	         * @private
	         */
	        _this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        _this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        _this.total_ = 0;
	        _this.blockSize = 512 / 8;
	        _this.pad_[0] = 128;
	        for (var i = 1; i < _this.blockSize; ++i) {
	            _this.pad_[i] = 0;
	        }
	        _this.reset();
	        return _this;
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
	     * @param {number=} opt_offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, opt_offset) {
	        if (!opt_offset) {
	            opt_offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(opt_offset) << 24) |
	                        (buf.charCodeAt(opt_offset + 1) << 16) |
	                        (buf.charCodeAt(opt_offset + 2) << 8) |
	                        buf.charCodeAt(opt_offset + 3);
	                opt_offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[opt_offset] << 24) |
	                        (buf[opt_offset + 1] << 16) |
	                        (buf[opt_offset + 2] << 8) |
	                        buf[opt_offset + 3];
	                opt_offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, opt_length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (opt_length === undefined) {
	            opt_length = bytes.length;
	        }
	        var lengthMinusBlock = opt_length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < opt_length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf == 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < opt_length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf == this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += opt_length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}(Hash));
	
	/**
	 * Helper to make a Subscribe function (just like Promise helps make a
	 * Thenable).
	 *
	 * @param executor Function which can make calls to a single Observer
	 *     as a proxy.
	 * @param onNoObservers Callback when count of Observers goes to zero.
	 */
	function createSubscribe(executor, onNoObservers) {
	    var proxy = new ObserverProxy(executor, onNoObservers);
	    return proxy.subscribe.bind(proxy);
	}
	/**
	 * Implement fan-out for any number of Observers attached via a subscribe
	 * function.
	 */
	var ObserverProxy = /** @class */ (function () {
	    /**
	     * @param executor Function which can make calls to a single Observer
	     *     as a proxy.
	     * @param onNoObservers Callback when count of Observers goes to zero.
	     */
	    function ObserverProxy(executor, onNoObservers) {
	        var _this = this;
	        this.observers = [];
	        this.unsubscribes = [];
	        this.observerCount = 0;
	        // Micro-task scheduling by calling task.then().
	        this.task = Promise.resolve();
	        this.finalized = false;
	        this.onNoObservers = onNoObservers;
	        // Call the executor asynchronously so subscribers that are called
	        // synchronously after the creation of the subscribe function
	        // can still receive the very first value generated in the executor.
	        this.task
	            .then(function () {
	            executor(_this);
	        })
	            .catch(function (e) {
	            _this.error(e);
	        });
	    }
	    ObserverProxy.prototype.next = function (value) {
	        this.forEachObserver(function (observer) {
	            observer.next(value);
	        });
	    };
	    ObserverProxy.prototype.error = function (error) {
	        this.forEachObserver(function (observer) {
	            observer.error(error);
	        });
	        this.close(error);
	    };
	    ObserverProxy.prototype.complete = function () {
	        this.forEachObserver(function (observer) {
	            observer.complete();
	        });
	        this.close();
	    };
	    /**
	     * Subscribe function that can be used to add an Observer to the fan-out list.
	     *
	     * - We require that no event is sent to a subscriber sychronously to their
	     *   call to subscribe().
	     */
	    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
	        var _this = this;
	        var observer;
	        if (nextOrObserver === undefined &&
	            error === undefined &&
	            complete === undefined) {
	            throw new Error('Missing Observer.');
	        }
	        // Assemble an Observer object when passed as callback functions.
	        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
	            observer = nextOrObserver;
	        }
	        else {
	            observer = {
	                next: nextOrObserver,
	                error: error,
	                complete: complete
	            };
	        }
	        if (observer.next === undefined) {
	            observer.next = noop;
	        }
	        if (observer.error === undefined) {
	            observer.error = noop;
	        }
	        if (observer.complete === undefined) {
	            observer.complete = noop;
	        }
	        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
	        // Attempt to subscribe to a terminated Observable - we
	        // just respond to the Observer with the final error or complete
	        // event.
	        if (this.finalized) {
	            this.task.then(function () {
	                try {
	                    if (_this.finalError) {
	                        observer.error(_this.finalError);
	                    }
	                    else {
	                        observer.complete();
	                    }
	                }
	                catch (e) {
	                    // nothing
	                }
	                return;
	            });
	        }
	        this.observers.push(observer);
	        return unsub;
	    };
	    // Unsubscribe is synchronous - we guarantee that no events are sent to
	    // any unsubscribed Observer.
	    ObserverProxy.prototype.unsubscribeOne = function (i) {
	        if (this.observers === undefined || this.observers[i] === undefined) {
	            return;
	        }
	        delete this.observers[i];
	        this.observerCount -= 1;
	        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
	            this.onNoObservers(this);
	        }
	    };
	    ObserverProxy.prototype.forEachObserver = function (fn) {
	        if (this.finalized) {
	            // Already closed by previous event....just eat the additional values.
	            return;
	        }
	        // Since sendOne calls asynchronously - there is no chance that
	        // this.observers will become undefined.
	        for (var i = 0; i < this.observers.length; i++) {
	            this.sendOne(i, fn);
	        }
	    };
	    // Call the Observer via one of it's callback function. We are careful to
	    // confirm that the observe has not been unsubscribed since this asynchronous
	    // function had been queued.
	    ObserverProxy.prototype.sendOne = function (i, fn) {
	        var _this = this;
	        // Execute the callback asynchronously
	        this.task.then(function () {
	            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
	                try {
	                    fn(_this.observers[i]);
	                }
	                catch (e) {
	                    // Ignore exceptions raised in Observers or missing methods of an
	                    // Observer.
	                    // Log error to console. b/31404806
	                    if (typeof console !== 'undefined' && console.error) {
	                        console.error(e);
	                    }
	                }
	            }
	        });
	    };
	    ObserverProxy.prototype.close = function (err) {
	        var _this = this;
	        if (this.finalized) {
	            return;
	        }
	        this.finalized = true;
	        if (err !== undefined) {
	            this.finalError = err;
	        }
	        // Proxy is no longer needed - garbage collect references
	        this.task.then(function () {
	            _this.observers = undefined;
	            _this.onNoObservers = undefined;
	        });
	    };
	    return ObserverProxy;
	}());
	/** Turn synchronous function into one called asynchronously. */
	function async(fn, onError) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        Promise.resolve(true)
	            .then(function () {
	            fn.apply(void 0, args);
	        })
	            .catch(function (error) {
	            if (onError) {
	                onError(error);
	            }
	        });
	    };
	}
	/**
	 * Return true if the object passed in implements any of the named methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in obj && typeof obj[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	function noop() {
	    // do nothing
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Check to make sure the appropriate number of arguments are provided for a public function.
	 * Throws an error if it fails.
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} minCount The minimum number of arguments to allow for the function call
	 * @param {!number} maxCount The maximum number of argument to allow for the function call
	 * @param {!number} argCount The actual number of arguments provided.
	 */
	var validateArgCount = function (fnName, minCount, maxCount, argCount) {
	    var argError;
	    if (argCount < minCount) {
	        argError = 'at least ' + minCount;
	    }
	    else if (argCount > maxCount) {
	        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
	    }
	    if (argError) {
	        var error = fnName +
	            ' failed: Was called with ' +
	            argCount +
	            (argCount === 1 ? ' argument.' : ' arguments.') +
	            ' Expects ' +
	            argError +
	            '.';
	        throw new Error(error);
	    }
	};
	/**
	 * Generates a string to prefix an error message about failed argument validation
	 *
	 * @param {!string} fnName The function name
	 * @param {!number} argumentNumber The index of the argument
	 * @param {boolean} optional Whether or not the argument is optional
	 * @return {!string} The prefix to add to the error thrown for validation.
	 */
	function errorPrefix(fnName, argumentNumber, optional) {
	    var argName = '';
	    switch (argumentNumber) {
	        case 1:
	            argName = optional ? 'first' : 'First';
	            break;
	        case 2:
	            argName = optional ? 'second' : 'Second';
	            break;
	        case 3:
	            argName = optional ? 'third' : 'Third';
	            break;
	        case 4:
	            argName = optional ? 'fourth' : 'Fourth';
	            break;
	        default:
	            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
	    }
	    var error = fnName + ' failed: ';
	    error += argName + ' argument ';
	    return error;
	}
	/**
	 * @param {!string} fnName
	 * @param {!number} argumentNumber
	 * @param {!string} namespace
	 * @param {boolean} optional
	 */
	function validateNamespace(fnName, argumentNumber, namespace, optional) {
	    if (optional && !namespace)
	        return;
	    if (typeof namespace !== 'string') {
	        //TODO: I should do more validation here. We only allow certain chars in namespaces.
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid firebase namespace.');
	    }
	}
	function validateCallback(fnName, argumentNumber, callback, optional) {
	    if (optional && !callback)
	        return;
	    if (typeof callback !== 'function')
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid function.');
	}
	function validateContextObject(fnName, argumentNumber, context, optional) {
	    if (optional && !context)
	        return;
	    if (typeof context !== 'object' || context === null)
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid context object.');
	}
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
	// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
	// so it's been modified.
	// Note that not all Unicode characters appear as single characters in JavaScript strings.
	// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
	// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
	// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
	// pair).
	// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
	/**
	 * @param {string} str
	 * @return {Array}
	 */
	var stringToByteArray$1 = function (str) {
	    var out = [], p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        // Is this the lead surrogate in a surrogate pair?
	        if (c >= 0xd800 && c <= 0xdbff) {
	            var high = c - 0xd800; // the high 10 bits.
	            i++;
	            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
	            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
	            c = 0x10000 + (high << 10) + low;
	        }
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if (c < 65536) {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Calculate length without actually converting; useful for doing cheaper validation.
	 * @param {string} str
	 * @return {number}
	 */
	var stringLength = function (str) {
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            p++;
	        }
	        else if (c < 2048) {
	            p += 2;
	        }
	        else if (c >= 0xd800 && c <= 0xdbff) {
	            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
	            p += 4;
	            i++; // skip trail surrogate.
	        }
	        else {
	            p += 3;
	        }
	    }
	    return p;
	};
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	exports.assert = assert;
	exports.assertionError = assertionError;
	exports.base64 = base64;
	exports.base64Decode = base64Decode;
	exports.base64Encode = base64Encode;
	exports.CONSTANTS = CONSTANTS;
	exports.deepCopy = deepCopy;
	exports.deepExtend = deepExtend;
	exports.patchProperty = patchProperty;
	exports.Deferred = Deferred;
	exports.getUA = getUA;
	exports.isMobileCordova = isMobileCordova;
	exports.isNodeSdk = isNodeSdk;
	exports.isReactNative = isReactNative;
	exports.ErrorFactory = ErrorFactory;
	exports.FirebaseError = FirebaseError;
	exports.patchCapture = patchCapture;
	exports.jsonEval = jsonEval;
	exports.stringify = stringify;
	exports.decode = decode;
	exports.isAdmin = isAdmin;
	exports.issuedAtTime = issuedAtTime;
	exports.isValidFormat = isValidFormat;
	exports.isValidTimestamp = isValidTimestamp;
	exports.clone = clone;
	exports.contains = contains;
	exports.every = every;
	exports.extend = extend;
	exports.findKey = findKey;
	exports.findValue = findValue;
	exports.forEach = forEach;
	exports.getAnyKey = getAnyKey;
	exports.getCount = getCount;
	exports.getValues = getValues;
	exports.isEmpty = isEmpty;
	exports.isNonNullObject = isNonNullObject;
	exports.map = map;
	exports.safeGet = safeGet;
	exports.querystring = querystring;
	exports.querystringDecode = querystringDecode;
	exports.Sha1 = Sha1;
	exports.async = async;
	exports.createSubscribe = createSubscribe;
	exports.errorPrefix = errorPrefix;
	exports.validateArgCount = validateArgCount;
	exports.validateCallback = validateCallback;
	exports.validateContextObject = validateContextObject;
	exports.validateNamespace = validateNamespace;
	exports.stringLength = stringLength;
	exports.stringToByteArray = stringToByteArray$1;


/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	__webpack_require__(921);
	var firebase = _interopDefault(__webpack_require__(428));
	
	/**
	 * Copyright 2018 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	module.exports = firebase;


/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(920);
	
	/**
	 * Copyright 2017 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */


/***/ }),

/***/ 958:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(22);
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionSticky: {
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionStatic: {
	      position: 'static'
	    },
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    }
	  };
	};
	
	exports.styles = styles;
	
	function AppBar(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      position = props.position,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
	  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: className
	  }, other), children);
	}
	
	AppBar.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
	} : {};
	AppBar.defaultProps = {
	  color: 'primary',
	  position: 'fixed'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(1009));

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: theme.spacing.unit * 5,
	      height: theme.spacing.unit * 5,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (childrenProp) {
	    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react.default.isValidElement(childrenProp)) {
	      var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
	      children = _react.default.cloneElement(childrenProp, {
	        className: childrenClassName
	      });
	    } else {
	      children = childrenProp;
	    }
	  } else if (src || srcSet) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Properties applied to the `img` element when the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(445));

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(22);
	
	var RADIUS = 12;
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-flex',
	      // For correct alignment with the text.
	      verticalAlign: 'middle'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: -RADIUS,
	      right: -RADIUS,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeight,
	      fontSize: theme.typography.pxToRem(RADIUS),
	      width: RADIUS * 2,
	      height: RADIUS * 2,
	      borderRadius: '50%',
	      backgroundColor: theme.palette.color,
	      color: theme.palette.textColor,
	      zIndex: 1 // Render the badge on top of potential ripples.
	
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	    colorError: {
	      backgroundColor: theme.palette.error.main,
	      color: theme.palette.error.contrastText
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Badge(props) {
	  var badgeContent = props.badgeContent,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      ComponentProp = props.component,
	      other = (0, _objectWithoutProperties2.default)(props, ["badgeContent", "children", "classes", "className", "color", "component"]);
	  var badgeClassName = (0, _classnames.default)(classes.badge, (0, _defineProperty2.default)({}, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'));
	  return _react.default.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classNameProp)
	  }, other), children, _react.default.createElement("span", {
	    className: badgeClassName
	  }, badgeContent));
	}
	
	Badge.propTypes =  false ? {
	  /**
	   * The content rendered within the badge.
	   */
	  badgeContent: _propTypes.default.node.isRequired,
	
	  /**
	   * The badge will be added relative to this node.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	Badge.defaultProps = {
	  color: 'default',
	  component: 'span'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBadge'
	})(Badge);
	
	exports.default = _default;

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	
	var _Badge = _interopRequireDefault(__webpack_require__(1011));

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'center',
	      height: 56,
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	};
	
	exports.styles = styles;
	
	function BottomNavigation(props) {
	  var childrenProp = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      onChange = props.onChange,
	      showLabels = props.showLabels,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "onChange", "showLabels", "value"]);
	  var className = (0, _classnames.default)(classes.root, classNameProp);
	
	  var children = _react.default.Children.map(childrenProp, function (child, childIndex) {
	    if (!_react.default.isValidElement(child)) {
	      return null;
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    return _react.default.cloneElement(child, {
	      selected: childValue === value,
	      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
	      value: childValue,
	      onChange: onChange
	    });
	  });
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	BottomNavigation.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, all `BottomNavigationAction`s will show their labels.
	   * By default, only the selected `BottomNavigationAction` will show its label.
	   */
	  showLabels: _propTypes.default.bool,
	
	  /**
	   * The value of the currently selected `BottomNavigationAction`.
	   */
	  value: _propTypes.default.any
	} : {};
	BottomNavigation.defaultProps = {
	  showLabels: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigation'
	})(BottomNavigation);
	
	exports.default = _default;

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    root: {
	      transition: theme.transitions.create(['color', 'padding-top'], {
	        duration: theme.transitions.duration.short
	      }),
	      paddingTop: theme.spacing.unit,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168,
	      color: theme.palette.text.secondary,
	      flex: '1',
	      '&$iconOnly': {
	        paddingTop: theme.spacing.unit * 2
	      },
	      '&$selected': {
	        paddingTop: 6,
	        color: theme.palette.primary.main
	      }
	    },
	    selected: {},
	    iconOnly: {},
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	    label: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(12),
	      opacity: 1,
	      transition: 'font-size 0.2s, opacity 0.2s',
	      transitionDelay: '0.1s',
	      '&$iconOnly': {
	        opacity: 0,
	        transitionDelay: '0s'
	      },
	      '&$selected': {
	        fontSize: theme.typography.pxToRem(14)
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var BottomNavigationAction =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(BottomNavigationAction, _React$Component);
	
	  function BottomNavigationAction() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, BottomNavigationAction);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = BottomNavigationAction.__proto__ || (0, _getPrototypeOf.default)(BottomNavigationAction)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var _this$props = _this.props,
	            onChange = _this$props.onChange,
	            value = _this$props.value,
	            onClick = _this$props.onClick;
	
	        if (onChange) {
	          onChange(event, value);
	        }
	
	        if (onClick) {
	          onClick(event);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(BottomNavigationAction, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          icon = _props.icon,
	          label = _props.label,
	          onChange = _props.onChange,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          showLabelProp = _props.showLabel,
	          value = _props.value,
	          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.selected, selected), (0, _defineProperty2.default)(_classNames, classes.iconOnly, !showLabelProp && !selected), _classNames), classNameProp);
	      var labelClassName = (0, _classnames.default)(classes.label, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.iconOnly, !showLabelProp && !selected), _classNames2));
	      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	        className: className,
	        focusRipple: true,
	        onClick: this.handleChange
	      }, other), _react.default.createElement("span", {
	        className: classes.wrapper
	      }, icon, _react.default.createElement("span", {
	        className: labelClassName
	      }, label)));
	    }
	  }]);
	  return BottomNavigationAction;
	}(_react.default.Component);
	
	BottomNavigationAction.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * If `true`, the BottomNavigationAction will show its label.
	   */
	  showLabel: _propTypes.default.bool,
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigationAction'
	})(BottomNavigationAction);
	
	exports.default = _default;

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigationAction", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	
	var _BottomNavigation = _interopRequireDefault(__webpack_require__(1013));
	
	var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(1014));

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	// @inheritedComponent Paper
	var styles = {
	  root: {
	    overflow: 'hidden'
	  }
	};
	exports.styles = styles;
	
	function Card(props) {
	  var classes = props.classes,
	      className = props.className,
	      raised = props.raised,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className),
	    elevation: raised ? 8 : 2
	  }, other));
	}
	
	Card.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the card will use raised styling.
	   */
	  raised: _propTypes.default.bool
	} : {};
	Card.defaultProps = {
	  raised: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCard'
	})(Card);
	
	exports.default = _default;

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _reactHelpers = __webpack_require__(72);
	
	__webpack_require__(38);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  return {
	    root: (0, _defineProperty2.default)({
	      display: 'flex',
	      alignItems: 'center',
	      boxSizing: 'border-box',
	      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit / 2, "px")
	    }, theme.breakpoints.up('sm'), {
	      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 1.5, "px")
	    }),
	    action: {
	      margin: "0 ".concat(theme.spacing.unit / 2, "px")
	    }
	  };
	};
	
	exports.styles = styles;
	
	function CardActions(props) {
	  var disableActionSpacing = props.disableActionSpacing,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
	}
	
	CardActions.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the card actions do not have additional margin.
	   */
	  disableActionSpacing: _propTypes.default.bool
	} : {};
	CardActions.defaultProps = {
	  disableActionSpacing: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActions'
	})(CardActions);
	
	exports.default = _default;

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: theme.mixins.gutters({
	      paddingTop: theme.spacing.unit * 2,
	      paddingBottom: theme.spacing.unit * 2,
	      '&:last-child': {
	        paddingBottom: theme.spacing.unit * 3
	      }
	    })
	  };
	};
	
	exports.styles = styles;
	
	function CardContent(props) {
	  var classes = props.classes,
	      className = props.className,
	      Component = props.component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other));
	}
	
	CardContent.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	CardContent.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    root: theme.mixins.gutters({
	      display: 'flex',
	      alignItems: 'center',
	      paddingTop: theme.spacing.unit * 2,
	      paddingBottom: theme.spacing.unit * 2
	    }),
	    avatar: {
	      flex: '0 0 auto',
	      marginRight: theme.spacing.unit * 2
	    },
	    action: {
	      flex: '0 0 auto',
	      alignSelf: 'flex-start',
	      marginTop: theme.spacing.unit * -1,
	      marginRight: theme.spacing.unit * -2
	    },
	    content: {
	      flex: '1 1 auto'
	    },
	    title: {},
	    subheader: {}
	  };
	};
	
	exports.styles = styles;
	
	function CardHeader(props) {
	  var action = props.action,
	      avatar = props.avatar,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      subheader = props.subheader,
	      title = props.title,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "subheader", "title"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classNameProp)
	  }, other), avatar && _react.default.createElement("div", {
	    className: classes.avatar
	  }, avatar), _react.default.createElement("div", {
	    className: classes.content
	  }, _react.default.createElement(_Typography.default, {
	    variant: avatar ? 'body2' : 'headline',
	    component: "span",
	    className: classes.title
	  }, title), subheader && _react.default.createElement(_Typography.default, {
	    variant: avatar ? 'body2' : 'body1',
	    component: "span",
	    color: "textSecondary",
	    className: classes.subheader
	  }, subheader)), action && _react.default.createElement("div", {
	    className: classes.action
	  }, action));
	}
	
	CardHeader.propTypes =  false ? {
	  /**
	   * The action to display in the card header.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The Avatar for the Card Header.
	   */
	  avatar: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The content of the component.
	   */
	  subheader: _propTypes.default.node,
	
	  /**
	   * The content of the Card Title.
	   */
	  title: _propTypes.default.node
	} : {};
	CardHeader.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardHeader'
	})(CardHeader);
	
	exports.default = _default;

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _warning = _interopRequireDefault(__webpack_require__(20));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = {
	  root: {
	    display: 'block',
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'center'
	  },
	  media: {
	    width: '100%'
	  }
	};
	exports.styles = styles;
	var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
	
	function CardMedia(props) {
	  var classes = props.classes,
	      className = props.className,
	      Component = props.component,
	      image = props.image,
	      src = props.src,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "image", "src", "style"]);
	   false ? (0, _warning.default)(Boolean(image || src), 'Material-UI: either `image` or `src` property must be specified.') : void 0;
	  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
	  var composedStyle = !isMediaComponent && image ? (0, _objectSpread2.default)({
	    backgroundImage: "url(\"".concat(image, "\")")
	  }, style) : style;
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.media, isMediaComponent), className),
	    style: composedStyle,
	    src: isMediaComponent ? image || src : undefined
	  }, other));
	}
	
	CardMedia.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Component for rendering image.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Image to be displayed as a background image.
	   * Either `image` or `src` prop must be specified.
	   * Note that caller must specify height otherwise the image will not be visible.
	   */
	  image: _propTypes.default.string,
	
	  /**
	   * An alias for `image` property.
	   * Available only with media components.
	   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : {};
	CardMedia.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardMedia'
	})(CardMedia);
	
	exports.default = _default;

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	Object.defineProperty(exports, "CardActions", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	Object.defineProperty(exports, "CardMedia", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	
	var _Card = _interopRequireDefault(__webpack_require__(307));
	
	var _CardContent = _interopRequireDefault(__webpack_require__(309));
	
	var _CardActions = _interopRequireDefault(__webpack_require__(308));
	
	var _CardMedia = _interopRequireDefault(__webpack_require__(311));
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(310));

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(182));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(321));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(320));
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(322));
	
	var _helpers = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.text.secondary
	    },
	    checked: {},
	    disabled: {},
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Checkbox(props) {
	  var checkedIcon = props.checkedIcon,
	      classes = props.classes,
	      color = props.color,
	      icon = props.icon,
	      indeterminate = props.indeterminate,
	      indeterminateIcon = props.indeterminateIcon,
	      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon"]);
	  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
	    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
	    classes: {
	      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    icon: indeterminate ? indeterminateIcon : icon
	  }, other));
	}
	
	Checkbox.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.checked`.
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input component property `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.string
	} : {};
	Checkbox.defaultProps = {
	  checkedIcon: _react.default.createElement(_CheckBox.default, null),
	  color: 'secondary',
	  icon: _react.default.createElement(_CheckBoxOutlineBlank.default, null),
	  indeterminate: false,
	  indeterminateIcon: _react.default.createElement(_IndeterminateCheckBox.default, null)
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCheckbox'
	})(Checkbox);
	
	exports.default = _default;

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(313));

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _keycode = _interopRequireDefault(__webpack_require__(159));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(1119));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _colorManipulator = __webpack_require__(48);
	
	__webpack_require__(445);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  var height = 32;
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: height,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: height / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0 // Remove `button` padding
	
	    },
	    clickable: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1],
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
	      }
	    },
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	    avatar: {
	      marginRight: -4,
	      width: height,
	      height: height,
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      fontSize: theme.typography.pxToRem(16)
	    },
	    avatarChildren: {
	      width: 19,
	      height: 19
	    },
	    label: {
	      display: 'flex',
	      alignItems: 'center',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap',
	      cursor: 'inherit'
	    },
	    deleteIcon: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      cursor: 'pointer',
	      height: 'auto',
	      margin: '0 4px 0 -8px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    }
	  };
	};
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	exports.styles = styles;
	
	var Chip =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Chip, _React$Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Chip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf.default)(Chip)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "chipRef", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleDeleteIconClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // Stop the event from bubbling up to the `Chip`
	        event.stopPropagation();
	        var onDelete = _this.props.onDelete;
	
	        if (onDelete) {
	          onDelete(event);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleKeyDown", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // Ignore events from children of `Chip`.
	        if (event.currentTarget !== event.target) {
	          return;
	        }
	
	        var _this$props = _this.props,
	            onClick = _this$props.onClick,
	            onDelete = _this$props.onDelete,
	            onKeyDown = _this$props.onKeyDown;
	        var key = (0, _keycode.default)(event);
	
	        if (onClick && (key === 'space' || key === 'enter')) {
	          event.preventDefault();
	          onClick(event);
	        } else if (onDelete && key === 'backspace') {
	          event.preventDefault();
	          onDelete(event);
	        } else if (key === 'esc') {
	          event.preventDefault();
	
	          if (_this.chipRef) {
	            _this.chipRef.blur();
	          }
	        }
	
	        if (onKeyDown) {
	          onKeyDown(event);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Chip, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          avatarProp = _props.avatar,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          Component = _props.component,
	          deleteIconProp = _props.deleteIcon,
	          label = _props.label,
	          onClick = _props.onClick,
	          onDelete = _props.onDelete,
	          onKeyDown = _props.onKeyDown,
	          tabIndexProp = _props.tabIndex,
	          other = (0, _objectWithoutProperties2.default)(_props, ["avatar", "classes", "className", "component", "deleteIcon", "label", "onClick", "onDelete", "onKeyDown", "tabIndex"]);
	      var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.clickable, onClick), (0, _defineProperty2.default)({}, classes.deletable, onDelete), classNameProp);
	      var deleteIcon = null;
	
	      if (onDelete) {
	        deleteIcon = deleteIconProp && _react.default.isValidElement(deleteIconProp) ? _react.default.cloneElement(deleteIconProp, {
	          className: (0, _classnames.default)(deleteIconProp.props.className, classes.deleteIcon),
	          onClick: this.handleDeleteIconClick
	        }) : _react.default.createElement(_Cancel.default, {
	          className: classes.deleteIcon,
	          onClick: this.handleDeleteIconClick
	        });
	      }
	
	      var avatar = null;
	
	      if (avatarProp && _react.default.isValidElement(avatarProp)) {
	        avatar = _react.default.cloneElement(avatarProp, {
	          className: (0, _classnames.default)(classes.avatar, avatarProp.props.className),
	          childrenClassName: (0, _classnames.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
	        });
	      }
	
	      var tabIndex = tabIndexProp;
	
	      if (!tabIndex) {
	        tabIndex = onClick || onDelete ? 0 : -1;
	      }
	
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        role: "button",
	        className: className,
	        tabIndex: tabIndex,
	        onClick: onClick,
	        onKeyDown: this.handleKeyDown,
	        ref: function ref(node) {
	          _this2.chipRef = node;
	        }
	      }, other), avatar, _react.default.createElement("span", {
	        className: classes.label
	      }, label), deleteIcon);
	    }
	  }]);
	  return Chip;
	}(_react.default.Component);
	
	Chip.propTypes =  false ? {
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	} : {};
	Chip.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(1021));

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _styles = __webpack_require__(44);
	
	var _exactProp = _interopRequireDefault(__webpack_require__(183));
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: {
	        WebkitFontSmoothing: 'antialiased',
	        // Antialiasing.
	        MozOsxFontSmoothing: 'grayscale',
	        // Antialiasing.
	        // Change from `box-sizing: content-box` so that `width`
	        // is not affected by `padding` or `border`.
	        boxSizing: 'border-box'
	      },
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      body: {
	        margin: 0,
	        // Remove the margin in all browsers.
	        backgroundColor: theme.palette.background.default,
	        '@media print': {
	          // Save printer ink.
	          backgroundColor: theme.palette.common.white
	        }
	      }
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	var CssBaseline =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(CssBaseline, _React$Component);
	
	  function CssBaseline() {
	    (0, _classCallCheck2.default)(this, CssBaseline);
	    return (0, _possibleConstructorReturn2.default)(this, (CssBaseline.__proto__ || (0, _getPrototypeOf.default)(CssBaseline)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(CssBaseline, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return CssBaseline;
	}(_react.default.Component);
	
	CssBaseline.propTypes =  false ? {
	  /**
	   * You can only provide a single element with react@15, a node with react@16.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : {};
	CssBaseline.propTypes =  false ? (0, _exactProp.default)(CssBaseline.propTypes, 'CssBaseline') : {};
	CssBaseline.defaultProps = {
	  children: null
	};
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(1023));

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(22);
	
	var _Modal = _interopRequireDefault(__webpack_require__(138));
	
	var _Fade = _interopRequireDefault(__webpack_require__(161));
	
	var _transitions = __webpack_require__(39);
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	// @inheritedComponent Modal
	var styles = function styles(theme) {
	  return {
	    root: {
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    paper: {
	      display: 'flex',
	      margin: theme.spacing.unit * 4,
	      flexDirection: 'column',
	      flex: '0 1 auto',
	      position: 'relative',
	      maxHeight: '90vh',
	      overflowY: 'auto',
	      // Fix IE11 issue, to remove at some point.
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 'none'
	    },
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 360)
	    },
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm
	    },
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md
	    },
	    paperFullWidth: {
	      width: '100%'
	    },
	    paperFullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: '100%',
	      borderRadius: 0
	    }
	  };
	};
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	
	
	exports.styles = styles;
	
	function Dialog(props) {
	  var _classNames;
	
	  var BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      disableBackdropClick = props.disableBackdropClick,
	      disableEscapeKeyDown = props.disableEscapeKeyDown,
	      fullScreen = props.fullScreen,
	      fullWidth = props.fullWidth,
	      maxWidth = props.maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      PaperProps = props.PaperProps,
	      TransitionComponent = props.TransitionComponent,
	      transitionDuration = props.transitionDuration,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperProps", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className),
	    BackdropProps: (0, _objectSpread2.default)({
	      transitionDuration: transitionDuration
	    }, BackdropProps),
	    disableBackdropClick: disableBackdropClick,
	    disableEscapeKeyDown: disableEscapeKeyDown,
	    onBackdropClick: onBackdropClick,
	    onEscapeKeyDown: onEscapeKeyDown,
	    onClose: onClose,
	    open: open,
	    role: "dialog"
	  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    "in": open,
	    timeout: transitionDuration,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited
	  }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: 24,
	    className: (0, _classnames.default)(classes.paper, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames))
	  }, PaperProps), children)));
	}
	
	Dialog.propTypes =  false ? {
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog will be full-screen
	   */
	  fullScreen: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog stretches to `maxWidth`.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determine the max width of the dialog.
	   * The dialog width grows with the size of the screen, this property is useful
	   * on the desktop where you might need some coherent different width size across your
	   * application. Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', false]),
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Transition component.
	   */
	  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Properties applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : {};
	Dialog.defaultProps = {
	  disableBackdropClick: false,
	  disableEscapeKeyDown: false,
	  fullScreen: false,
	  fullWidth: false,
	  maxWidth: 'sm',
	  TransitionComponent: _Fade.default,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialog'
	})(Dialog);
	
	exports.default = _default;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _reactHelpers = __webpack_require__(72);
	
	__webpack_require__(38);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'flex-end',
	      flex: '0 0 auto',
	      margin: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit / 2, "px")
	    },
	    action: {
	      margin: "0 ".concat(theme.spacing.unit / 2, "px"),
	      minWidth: 64
	    }
	  };
	};
	
	exports.styles = styles;
	
	function DialogActions(props) {
	  var disableActionSpacing = props.disableActionSpacing,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
	}
	
	DialogActions.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the dialog actions do not have additional margin.
	   */
	  disableActionSpacing: _propTypes.default.bool
	} : {};
	DialogActions.defaultProps = {
	  disableActionSpacing: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogActions'
	})(DialogActions);
	
	exports.default = _default;

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  var spacing = theme.spacing.unit * 3;
	  return {
	    root: {
	      flex: '1 1 auto',
	      overflowY: 'auto',
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      padding: "0 ".concat(spacing, "px ").concat(spacing, "px ").concat(spacing, "px"),
	      '&:first-child': {
	        paddingTop: spacing
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function DialogContent(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), children);
	}
	
	DialogContent.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContent'
	})(DialogContent);
	
	exports.default = _default;

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	// @inheritedComponent Typography
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.text.secondary
	    }
	  };
	};
	
	exports.styles = styles;
	
	function DialogContentText(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
	  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
	    component: "p",
	    variant: "subheading",
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), children);
	}
	
	DialogContentText.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContentText'
	})(DialogContentText);
	
	exports.default = _default;

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      margin: 0,
	      padding: "".concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 3, "px       20px ").concat(theme.spacing.unit * 3, "px"),
	      flex: '0 0 auto'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function DialogTitle(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      disableTypography = props.disableTypography,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
	    variant: "title"
	  }, children));
	}
	
	DialogTitle.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes.default.bool
	} : {};
	DialogTitle.defaultProps = {
	  disableTypography: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogTitle'
	})(DialogTitle);
	
	exports.default = _default;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	Object.defineProperty(exports, "DialogActions", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	Object.defineProperty(exports, "DialogTitle", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	Object.defineProperty(exports, "DialogContent", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	Object.defineProperty(exports, "DialogContentText", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	Object.defineProperty(exports, "withMobileDialog", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	
	var _Dialog = _interopRequireDefault(__webpack_require__(129));
	
	var _DialogActions = _interopRequireDefault(__webpack_require__(130));
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(133));
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(131));
	
	var _DialogContentText = _interopRequireDefault(__webpack_require__(132));
	
	var _withMobileDialog = _interopRequireDefault(__webpack_require__(135));

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(76);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(96));
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server side rendering.
	 */
	var withMobileDialog = function withMobileDialog() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$breakpoint = options.breakpoint,
	        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;
	
	    function WithMobileDialog(props) {
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
	      }, props));
	    }
	
	    WithMobileDialog.propTypes =  false ? {
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
	    } : {};
	    return (0, _withWidth.default)()(WithMobileDialog);
	  };
	};
	
	var _default = withMobileDialog;
	exports.default = _default;

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Modal = _interopRequireDefault(__webpack_require__(138));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Slide = _interopRequireDefault(__webpack_require__(94));
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	var _helpers = __webpack_require__(22);
	
	var _transitions = __webpack_require__(39);
	
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(props) {
	  return ['left', 'right'].indexOf(props.anchor) !== -1;
	}
	
	function getAnchor(props) {
	  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
	}
	
	var styles = function styles(theme) {
	  return {
	    docked: {
	      flex: '0 0 auto'
	    },
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100vh',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 'none'
	    },
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	    modal: {} // Just here so people can override the style.
	
	  };
	};
	/**
	 * The properties of the [Modal](/api/modal) component are available
	 * when `variant="temporary"` is set.
	 */
	
	
	exports.styles = styles;
	
	var Drawer =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Drawer, _React$Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf.default)(Drawer)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mounted", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	    } // Let's assume that the Drawer will always be rendered on user space.
	    // We use that state is order to skip the appear transition during the
	    // initial mount of the component.
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          anchorProp = _props.anchor,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          elevation = _props.elevation,
	          _props$ModalProps = _props.ModalProps;
	      _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	      var BackdropPropsProp = _props$ModalProps.BackdropProps,
	          ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	          onClose = _props.onClose,
	          open = _props.open,
	          PaperProps = _props.PaperProps,
	          SlideProps = _props.SlideProps,
	          theme = _props.theme,
	          transitionDuration = _props.transitionDuration,
	          variant = _props.variant,
	          other = (0, _objectWithoutProperties2.default)(_props, ["anchor", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
	      var anchor = getAnchor(this.props);
	
	      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        elevation: variant === 'temporary' ? elevation : 0,
	        square: true,
	        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
	      }, PaperProps), children);
	
	      if (variant === 'permanent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), drawer);
	      }
	
	      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
	        "in": open,
	        direction: oppositeDirection[anchor],
	        timeout: transitionDuration,
	        appear: this.mounted
	      }, SlideProps), drawer);
	
	      if (variant === 'persistent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), slidingDrawer);
	      } // variant === temporary
	
	
	      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	        BackdropProps: (0, _objectSpread2.default)({}, BackdropPropsProp, {
	          transitionDuration: transitionDuration
	        }),
	        className: (0, _classnames.default)(classes.modal, className),
	        open: open,
	        onClose: onClose
	      }, other, ModalProps), slidingDrawer);
	    }
	  }]);
	  return Drawer;
	}(_react.default.Component);
	
	Drawer.propTypes =  false ? {
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Properties applied to the `Modal` element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Properties applied to the `Slide` element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant of drawer.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : {};
	Drawer.defaultProps = {
	  anchor: 'left',
	  elevation: 16,
	  open: false,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  },
	  variant: 'temporary' // Mobile first.
	
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false,
	  withTheme: true
	})(Drawer);
	
	exports.default = _default;

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(315));

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(325));
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _reactHelpers = __webpack_require__(72);
	
	// @inheritedComponent Paper
	// Workaround https://github.com/jsdom/jsdom/issues/2026
	var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
	  // Fix a rendering issue on Edge
	  '@supports (-ms-ime-align: auto)': {
	    borderBottomLeftRadius: 0,
	    borderBottomRightRadius: 0
	  }
	};
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        borderTopLeftRadius: 2,
	        borderTopRightRadius: 2,
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&:last-child': (0, _objectSpread2.default)({
	        borderBottomLeftRadius: 2,
	        borderBottomRightRadius: 2
	      }, edgeFix),
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      }
	    },
	    expanded: {
	      margin: "".concat(theme.spacing.unit * 2, "px 0"),
	      '&:first-child': {
	        marginTop: 0
	      },
	      '&:last-child': {
	        marginBottom: 0
	      },
	      '&:before': {
	        opacity: 0
	      }
	    },
	    disabled: {
	      backgroundColor: theme.palette.action.disabledBackground
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanel =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ExpansionPanel, _React$Component);
	
	  function ExpansionPanel(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ExpansionPanel);
	    _this = (0, _possibleConstructorReturn2.default)(this, (ExpansionPanel.__proto__ || (0, _getPrototypeOf.default)(ExpansionPanel)).call(this, props, context));
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isControlled", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;
	
	        if (!_this.isControlled) {
	          _this.setState({
	            expanded: !expanded
	          });
	        }
	
	        if (_this.props.onChange) {
	          _this.props.onChange(event, !expanded);
	        }
	      }
	    });
	    _this.isControlled = props.expanded != null;
	
	    if (!_this.isControlled) {
	      // not controlled, use internal state
	      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ExpansionPanel, [{
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          CollapsePropsProp = _props.CollapseProps,
	          defaultExpanded = _props.defaultExpanded,
	          disabled = _props.disabled,
	          expandedProp = _props.expanded,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
	      var expanded = this.isControlled ? expandedProp : this.state.expanded;
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
	      var summary = null;
	
	      var children = _react.default.Children.map(childrenProp, function (child) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
	          summary = _react.default.cloneElement(child, {
	            disabled: disabled,
	            expanded: expanded,
	            onChange: _this2.handleChange
	          });
	          return null;
	        }
	
	        return child;
	      });
	
	      var CollapseProps = !expanded ? {
	        'aria-hidden': 'true'
	      } : null;
	      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        className: className,
	        elevation: 1,
	        square: true
	      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
	        "in": expanded,
	        timeout: "auto"
	      }, CollapseProps, CollapsePropsProp), children));
	    }
	  }]);
	  return ExpansionPanel;
	}(_react.default.Component);
	
	ExpansionPanel.propTypes =  false ? {
	  /**
	   * The content of the expansion panel.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `Collapse` element.
	   */
	  CollapseProps: _propTypes.default.object,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} expanded The `expanded` state of the panel
	   */
	  onChange: _propTypes.default.func
	} : {};
	ExpansionPanel.defaultProps = {
	  defaultExpanded: false,
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _reactHelpers = __webpack_require__(72);
	
	__webpack_require__(38);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'flex-end',
	      padding: "".concat(theme.spacing.unit * 2, "px ").concat(theme.spacing.unit, "px")
	    },
	    action: {
	      marginLeft: theme.spacing.unit
	    }
	  };
	};
	
	exports.styles = styles;
	
	function ExpansionPanelActions(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
	}
	
	ExpansionPanelActions.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelActions'
	})(ExpansionPanelActions);
	
	exports.default = _default;

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 3, "px")
	    }
	  };
	};
	
	exports.styles = styles;
	
	function ExpansionPanelDetails(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), children);
	}
	
	ExpansionPanelDetails.propTypes =  false ? {
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(70));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    root: {
	      display: 'flex',
	      minHeight: theme.spacing.unit * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: "0 ".concat(theme.spacing.unit * 3, "px 0 ").concat(theme.spacing.unit * 3, "px"),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.grey[300]
	      },
	      '&$disabled': {
	        opacity: 0.38
	      }
	    },
	    expanded: {},
	    focused: {},
	    disabled: {},
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '& > :last-child': {
	        paddingRight: theme.spacing.unit * 4
	      },
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	    expandIcon: {
	      position: 'absolute',
	      top: '50%',
	      right: theme.spacing.unit,
	      transform: 'translateY(-50%) rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'translateY(-50%) rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ExpansionPanelSummary =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);
	
	  function ExpansionPanelSummary() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ExpansionPanelSummary.__proto__ || (0, _getPrototypeOf.default)(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {
	        focused: false
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleFocus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.setState({
	          focused: true
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBlur", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.setState({
	          focused: false
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var _this$props = _this.props,
	            onChange = _this$props.onChange,
	            onClick = _this$props.onClick;
	
	        if (onChange) {
	          onChange(event);
	        }
	
	        if (onClick) {
	          onClick(event);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(ExpansionPanelSummary, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          disabled = _props.disabled,
	          expanded = _props.expanded,
	          expandIcon = _props.expandIcon,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "onChange"]);
	      var focused = this.state.focused;
	      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	        focusRipple: false,
	        disableRipple: true,
	        disabled: disabled,
	        component: "div",
	        "aria-expanded": expanded,
	        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
	      }, other, {
	        onFocusVisible: this.handleFocus,
	        onBlur: this.handleBlur,
	        onClick: this.handleChange
	      }), _react.default.createElement("div", {
	        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
	      }, children), expandIcon && _react.default.createElement(_IconButton.default, {
	        disabled: disabled,
	        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
	        component: "div",
	        tabIndex: -1,
	        "aria-hidden": "true"
	      }, expandIcon));
	    }
	  }]);
	  return ExpansionPanelSummary;
	}(_react.default.Component);
	
	ExpansionPanelSummary.propTypes =  false ? {
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * If `true`, the summary will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * If `true`, expands the summary, otherwise collapse it.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func
	} : {};
	ExpansionPanelSummary.defaultProps = {
	  disabled: false
	};
	ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelActions", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelDetails", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelSummary", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(1027));
	
	var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(1028));
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(1029));
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(1030));

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _createBreakpoints = __webpack_require__(107);
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(1139));
	
	var _Hidden = _interopRequireDefault(__webpack_require__(451));
	
	// A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	var GUTTERS = [0, 8, 16, 24, 40];
	var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  // For the auto layouting
	  var styles = (0, _defineProperty2.default)({}, "grid-".concat(breakpoint), {
	    flexBasis: 0,
	    flexGrow: 1,
	    maxWidth: '100%'
	  });
	  GRID_SIZES.forEach(function (size) {
	    if (typeof size === 'boolean') {
	      // Skip the first one as handle above.
	      return;
	    } // Only keep 6 significant numbers.
	
	
	    var width = "".concat(Math.round(size / 12 * 10e6) / 10e4, "%");
	    /* eslint-disable max-len */
	    // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
	
	    /* eslint-enable max-len */
	
	    styles["grid-".concat(breakpoint, "-").concat(size)] = {
	      flexBasis: width,
	      maxWidth: width
	    };
	  }); // No need for a media query for the first size.
	
	  if (breakpoint === 'xs') {
	    (0, _extends2.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	  GUTTERS.forEach(function (spacing, index) {
	    if (index === 0) {
	      // Skip the default style.
	      return;
	    }
	
	    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
	      margin: -spacing / 2,
	      width: "calc(100% + ".concat(spacing, "px)"),
	      '& > $item': {
	        padding: spacing / 2
	      }
	    };
	  });
	  return styles;
	} // Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	
	
	var styles = function styles(theme) {
	  return (0, _objectSpread2.default)({
	    container: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	    item: {
	      boxSizing: 'border-box',
	      flex: '0 0 auto',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	
	    },
	    zeroMinWidth: {
	      minWidth: 0
	    },
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	    'wrap-xs-wrap-reverse': {
	      flexWrap: 'wrap-reverse'
	    },
	    'align-items-xs-center': {
	      alignItems: 'center'
	    },
	    'align-items-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	    'align-items-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	    'align-items-xs-baseline': {
	      alignItems: 'baseline'
	    },
	    'align-content-xs-center': {
	      alignContent: 'center'
	    },
	    'align-content-xs-flex-start': {
	      alignContent: 'flex-start'
	    },
	    'align-content-xs-flex-end': {
	      alignContent: 'flex-end'
	    },
	    'align-content-xs-space-between': {
	      alignContent: 'space-between'
	    },
	    'align-content-xs-space-around': {
	      alignContent: 'space-around'
	    },
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    }
	  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	exports.styles = styles;
	
	function Grid(props) {
	  var _classNames;
	
	  var alignContent = props.alignContent,
	      alignItems = props.alignItems,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      container = props.container,
	      direction = props.direction,
	      hidden = props.hidden,
	      item = props.item,
	      justify = props.justify,
	      lg = props.lg,
	      md = props.md,
	      sm = props.sm,
	      spacing = props.spacing,
	      wrap = props.wrap,
	      xl = props.xl,
	      xs = props.xs,
	      zeroMinWidth = props.zeroMinWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "hidden", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
	  var className = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.container, container), (0, _defineProperty2.default)(_classNames, classes.item, item), (0, _defineProperty2.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty2.default)(_classNames, classes["spacing-xs-".concat(String(spacing))], container && spacing !== 0), (0, _defineProperty2.default)(_classNames, classes["direction-xs-".concat(String(direction))], direction !== Grid.defaultProps.direction), (0, _defineProperty2.default)(_classNames, classes["wrap-xs-".concat(String(wrap))], wrap !== Grid.defaultProps.wrap), (0, _defineProperty2.default)(_classNames, classes["align-items-xs-".concat(String(alignItems))], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty2.default)(_classNames, classes["align-content-xs-".concat(String(alignContent))], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty2.default)(_classNames, classes["justify-xs-".concat(String(justify))], justify !== Grid.defaultProps.justify), (0, _defineProperty2.default)(_classNames, classes['grid-xs'], xs === true), (0, _defineProperty2.default)(_classNames, classes["grid-xs-".concat(String(xs))], xs && xs !== true), (0, _defineProperty2.default)(_classNames, classes['grid-sm'], sm === true), (0, _defineProperty2.default)(_classNames, classes["grid-sm-".concat(String(sm))], sm && sm !== true), (0, _defineProperty2.default)(_classNames, classes['grid-md'], md === true), (0, _defineProperty2.default)(_classNames, classes["grid-md-".concat(String(md))], md && md !== true), (0, _defineProperty2.default)(_classNames, classes['grid-lg'], lg === true), (0, _defineProperty2.default)(_classNames, classes["grid-lg-".concat(String(lg))], lg && lg !== true), (0, _defineProperty2.default)(_classNames, classes['grid-xl'], xl === true), (0, _defineProperty2.default)(_classNames, classes["grid-xl-".concat(String(xl))], xl && xl !== true), _classNames), classNameProp);
	  var gridProps = (0, _objectSpread2.default)({
	    className: className
	  }, other);
	
	  if (hidden) {
	    return _react.default.createElement(_Hidden.default, hidden, _react.default.createElement(Component, gridProps));
	  }
	
	  return _react.default.createElement(Component, gridProps);
	}
	
	Grid.propTypes =  false ? {
	  /**
	   * Defines the `align-content` style property.
	   * It's applied for all screen sizes.
	   */
	  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
	
	  /**
	   * Defines the `align-items` style property.
	   * It's applied for all screen sizes.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, the component will have the flex *container* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  container: _propTypes.default.bool,
	
	  /**
	   * Defines the `flex-direction` style property.
	   * It is applied for all screen sizes.
	   */
	  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	
	  /**
	   * If provided, will wrap with [Hidden](/api/hidden) component and given properties.
	   */
	  hidden: _propTypes.default.object,
	
	  /**
	   * If `true`, the component will have the flex *item* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  item: _propTypes.default.bool,
	
	  /**
	   * Defines the `justify-content` style property.
	   * It is applied for all screen sizes.
	   */
	  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `lg` breakpoint and wider screens if not overridden.
	   */
	  lg: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `md` breakpoint and wider screens if not overridden.
	   */
	  md: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `sm` breakpoint and wider screens if not overridden.
	   */
	  sm: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the space between the type `item` component.
	   * It can only be used on a type `container` component.
	   */
	  spacing: _propTypes.default.oneOf(GUTTERS),
	
	  /**
	   * Defines the `flex-wrap` style property.
	   * It's applied for all screen sizes.
	   */
	  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `xl` breakpoint and wider screens.
	   */
	  xl: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for all the screen sizes with the lowest priority.
	   */
	  xs: _propTypes.default.oneOf([false, true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * If `true`, it sets `min-width: 0` on the item.
	   * Refer to the limitations section of the documentation to better understand the use case.
	   */
	  zeroMinWidth: _propTypes.default.bool
	} : {};
	Grid.defaultProps = {
	  alignContent: 'stretch',
	  alignItems: 'stretch',
	  component: 'div',
	  container: false,
	  direction: 'row',
	  item: false,
	  justify: 'flex-start',
	  lg: false,
	  md: false,
	  sm: false,
	  spacing: 0,
	  wrap: 'wrap',
	  xl: false,
	  xs: false,
	  zeroMinWidth: false
	}; // Add a wrapper component to generate some helper messages in the development
	// environment.
	
	/* eslint-disable react/no-multi-comp */
	// eslint-disable-next-line import/no-mutable-exports
	
	var GridWrapper = Grid;
	
	if (false) {
	  GridWrapper = function GridWrapper(props) {
	    return _react.default.createElement(Grid, props);
	  };
	
	  var requireProp = (0, _requirePropFactory.default)('Grid');
	  GridWrapper.propTypes = {
	    alignContent: requireProp('container'),
	    alignItems: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item'),
	    zeroMinWidth: requireProp('zeroMinWidth')
	  };
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGrid'
	})(GridWrapper);
	
	exports.default = _default;

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(1034));

/***/ }),

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	  }
	};
	exports.styles = styles;
	
	function GridList(props) {
	  var cellHeight = props.cellHeight,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      cols = props.cols,
	      Component = props.component,
	      spacing = props.spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classNameProp),
	    style: (0, _objectSpread2.default)({
	      margin: -spacing / 2
	    }, style)
	  }, other), _react.default.Children.map(children, function (currentChild) {
	    if (!_react.default.isValidElement(currentChild)) {
	      return null;
	    }
	
	    var childCols = currentChild.props.cols || 1;
	    var childRows = currentChild.props.rows || 1;
	    return _react.default.cloneElement(currentChild, {
	      style: (0, _extends2.default)({
	        width: "".concat(100 / cols * childCols, "%"),
	        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	        padding: spacing / 2
	      }, currentChild.props.style)
	    });
	  }));
	}
	
	GridList.propTypes =  false ? {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : {};
	GridList.defaultProps = {
	  cellHeight: 180,
	  cols: 2,
	  component: 'ul',
	  spacing: 4
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridList'
	})(GridList);
	
	exports.default = _default;

/***/ }),

/***/ 1037:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(165));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(31));
	
	var _debounce = _interopRequireDefault(__webpack_require__(56));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = {
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	  tile: {
	    position: 'relative',
	    display: 'block',
	    // In case it's not renderd with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	exports.styles = styles;
	
	var GridListTile =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(GridListTile, _React$Component);
	
	  function GridListTile() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, GridListTile);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = GridListTile.__proto__ || (0, _getPrototypeOf.default)(GridListTile)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "imgElement", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        _this.fit();
	      }, 166)
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "fit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        var imgElement = _this.imgElement;
	
	        if (!imgElement) {
	          return;
	        }
	
	        if (!imgElement.complete) {
	          return;
	        }
	
	        if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
	          var _imgElement$classList, _imgElement$classList2;
	
	          (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));
	
	          (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));
	        } else {
	          var _imgElement$classList3, _imgElement$classList4;
	
	          (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));
	
	          (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));
	        }
	
	        imgElement.removeEventListener('load', _this.fit);
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(GridListTile, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	    }
	  }, {
	    key: "ensureImageCover",
	    value: function ensureImageCover() {
	      if (!this.imgElement) {
	        return;
	      }
	
	      if (this.imgElement.complete) {
	        this.fit();
	      } else {
	        this.imgElement.addEventListener('load', this.fit);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          cols = _props.cols,
	          Component = _props.component,
	          rows = _props.rows,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "cols", "component", "rows"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, className)
	      }, other), _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }), _react.default.createElement("div", {
	        className: classes.tile
	      }, _react.default.Children.map(children, function (child) {
	        if (child && child.type === 'img') {
	          return _react.default.cloneElement(child, {
	            key: 'img',
	            ref: function ref(node) {
	              _this2.imgElement = node;
	            }
	          });
	        }
	
	        return child;
	      })));
	    }
	  }]);
	  return GridListTile;
	}(_react.default.Component);
	
	GridListTile.propTypes =  false ? {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes.default.number
	} : {};
	GridListTile.defaultProps = {
	  cols: 1,
	  component: 'li',
	  rows: 1
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTile'
	})(GridListTile);
	
	exports.default = _default;

/***/ }),

/***/ 1038:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.4)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	    titlePositionBottom: {
	      bottom: 0
	    },
	    titlePositionTop: {
	      top: 0
	    },
	    rootSubtitle: {
	      height: 68
	    },
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: theme.mixins.gutters().paddingLeft,
	      marginRight: theme.mixins.gutters().paddingRight,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	    titleWrapActionPosLeft: {
	      marginLeft: 0
	    },
	    titleWrapActionPosRight: {
	      marginRight: 0
	    },
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {},
	    actionIconActionPosLeft: {
	      order: -1
	    }
	  };
	};
	
	exports.styles = styles;
	
	function GridListTileBar(props) {
	  var _classNames, _classNames2;
	
	  var actionIcon = props.actionIcon,
	      actionPosition = props.actionPosition,
	      classes = props.classes,
	      classNameProp = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      titlePosition = props.titlePosition,
	      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
	  var actionPos = actionIcon && actionPosition;
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.titlePositionBottom, titlePosition === 'bottom'), (0, _defineProperty2.default)(_classNames, classes.titlePositionTop, titlePosition === 'top'), (0, _defineProperty2.default)(_classNames, classes.rootSubtitle, subtitle), _classNames), classNameProp); // Remove the margin between the title / subtitle wrapper, and the Action Icon
	
	  var titleWrapClassName = (0, _classnames.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosLeft, actionPos === 'left'), (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosRight, actionPos === 'right'), _classNames2));
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), _react.default.createElement("div", {
	    className: titleWrapClassName
	  }, _react.default.createElement("div", {
	    className: classes.title
	  }, title), subtitle ? _react.default.createElement("div", {
	    className: classes.subtitle
	  }, subtitle) : null), actionIcon ? _react.default.createElement("div", {
	    className: (0, _classnames.default)(classes.actionIcon, (0, _defineProperty2.default)({}, classes.actionIconActionPosLeft, actionPos === 'left'))
	  }, actionIcon) : null);
	}
	
	GridListTileBar.propTypes =  false ? {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes.default.node,
	
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes.default.node,
	
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes.default.oneOf(['top', 'bottom'])
	} : {};
	GridListTileBar.defaultProps = {
	  actionPosition: 'right',
	  titlePosition: 'bottom'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTileBar'
	})(GridListTileBar);
	
	exports.default = _default;

/***/ }),

/***/ 1039:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	Object.defineProperty(exports, "GridListTile", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	Object.defineProperty(exports, "GridListTileBar", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	
	var _GridList = _interopRequireDefault(__webpack_require__(1036));
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(1037));
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(1038));

/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _HiddenJs = _interopRequireDefault(__webpack_require__(1042));
	
	var _HiddenCss = _interopRequireDefault(__webpack_require__(1041));
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var implementation = props.implementation,
	      other = (0, _objectWithoutProperties2.default)(props, ["implementation"]);
	
	  if (implementation === 'js') {
	    return _react.default.createElement(_HiddenJs.default, other);
	  }
	
	  return _react.default.createElement(_HiddenCss.default, other);
	}
	
	Hidden.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for server
	   * side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this property when choosing the `js` implementation with server side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty componenent during the first mount.
	   * In some situation you might want to use an heristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * http://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : {};
	Hidden.defaultProps = {
	  implementation: 'js',
	  lgDown: false,
	  lgUp: false,
	  mdDown: false,
	  mdUp: false,
	  smDown: false,
	  smUp: false,
	  xlDown: false,
	  xlUp: false,
	  xsDown: false,
	  xsUp: false
	};
	var _default = Hidden;
	exports.default = _default;

/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _keys = _interopRequireDefault(__webpack_require__(88));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _warning = _interopRequireDefault(__webpack_require__(20));
	
	var _createBreakpoints = __webpack_require__(107);
	
	var _helpers = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	  return _createBreakpoints.keys.reduce(function (acc, key) {
	    acc["only".concat((0, _helpers.capitalize)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
	    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
	    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
	    return acc;
	  }, {});
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      lgDown = props.lgDown,
	      lgUp = props.lgUp,
	      mdDown = props.mdDown,
	      mdUp = props.mdUp,
	      only = props.only,
	      smDown = props.smDown,
	      smUp = props.smUp,
	      xlDown = props.xlDown,
	      xlUp = props.xlUp,
	      xsDown = props.xsDown,
	      xsUp = props.xsUp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
	   false ? (0, _warning.default)((0, _keys.default)(other).length === 0 || (0, _keys.default)(other).length === 1 && other.hasOwnProperty('ref'), "Material-UI: unsupported properties received ".concat((0, _keys.default)(other).join(', '), " by `<Hidden />`.")) : void 0;
	  var classNames = [];
	
	  if (className) {
	    classNames.push(className);
	  }
	
	  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
	    var breakpoint = _createBreakpoints.keys[i];
	    var breakpointUp = props["".concat(breakpoint, "Up")];
	    var breakpointDown = props["".concat(breakpoint, "Down")];
	
	    if (breakpointUp) {
	      classNames.push(classes["".concat(breakpoint, "Up")]);
	    }
	
	    if (breakpointDown) {
	      classNames.push(classes["".concat(breakpoint, "Down")]);
	    }
	  }
	
	  if (only) {
	    var onlyBreakpoints = Array.isArray(only) ? only : [only];
	    onlyBreakpoints.forEach(function (breakpoint) {
	      classNames.push(classes["only".concat((0, _helpers.capitalize)(breakpoint))]);
	    });
	  }
	
	  return _react.default.createElement("div", {
	    className: classNames.join(' ')
	  }, children);
	}
	
	HiddenCss.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for server
	   * side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : {};
	
	var _default = (0, _withStyles.default)(styles)(HiddenCss);
	
	exports.default = _default;

/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(76);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _createBreakpoints = __webpack_require__(107);
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(96));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(183));
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      width = props.width;
	  var visible = true; // `only` check is faster to get out sooner if used.
	
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  } // Allow `only` to be combined with other props. If already hidden, no need to check others.
	
	
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
	      var _breakpoint = _createBreakpoints.keys[_i];
	      var breakpointUp = props["".concat(_breakpoint, "Up")];
	      var breakpointDown = props["".concat(_breakpoint, "Down")];
	
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	HiddenJs.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for server
	   * side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this property when choosing the `js` implementation with server side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty componenent during the first mount.
	   * In some situation you might want to use an heristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * http://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * width prop provided by withWidth decorator.
	   */
	  width: _propTypes.default.string.isRequired,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	};
	HiddenJs.propTypes = (0, _exactProp.default)(HiddenJs.propTypes, 'HiddenJs');
	
	var _default = (0, _withWidth.default)()(HiddenJs);
	
	exports.default = _default;

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	
	var _Hidden = _interopRequireDefault(__webpack_require__(1040));

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _colorManipulator = __webpack_require__(48);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	var _helpers = __webpack_require__(22);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      width: 48,
	      height: 48,
	      padding: 0,
	      borderRadius: '50%',
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    disabled: {},
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/style/icons) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	
	function IconButton(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
	    centerRipple: true,
	    focusRipple: true,
	    disabled: disabled
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	}
	
	IconButton.propTypes =  false ? {
	  /**
	   * The icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple will be disabled.
	   */
	  disableRipple: _propTypes.default.bool
	} : {};
	IconButton.defaultProps = {
	  color: 'default',
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(136));

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(179));
	
	// @inheritedComponent ListItem
	var styles = function styles(theme) {
	  return {
	    root: (0, _objectSpread2.default)({}, theme.typography.subheading, {
	      height: theme.spacing.unit * 3,
	      boxSizing: 'content-box',
	      width: 'auto',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      paddingLeft: theme.spacing.unit * 2,
	      paddingRight: theme.spacing.unit * 2,
	      '&$selected': {
	        backgroundColor: theme.palette.action.selected
	      }
	    }),
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	
	function MenuItem(props) {
	  var classes = props.classes,
	      className = props.className,
	      component = props.component,
	      selected = props.selected,
	      role = props.role,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
	  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
	    button: true,
	    role: role,
	    tabIndex: -1,
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
	    component: component
	  }, other));
	}
	
	MenuItem.propTypes =  false ? {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : {};
	MenuItem.defaultProps = {
	  component: 'li',
	  role: 'menuitem',
	  selected: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuList", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _Menu = _interopRequireDefault(__webpack_require__(180));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(181));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(137));

/***/ }),

/***/ 1053:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(165));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	var _helpers = __webpack_require__(22);
	
	var _Progress = __webpack_require__(85);
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      background: theme.palette.background.default,
	      padding: theme.spacing.unit
	    },
	    positionBottom: {
	      position: 'fixed',
	      bottom: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	    positionTop: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	    positionStatic: {},
	    dots: {
	      display: 'flex',
	      flexDirection: 'row'
	    },
	    dot: {
	      backgroundColor: theme.palette.action.disabled,
	      borderRadius: '50%',
	      width: theme.spacing.unit,
	      height: theme.spacing.unit,
	      margin: '0 2px'
	    },
	    dotActive: {
	      backgroundColor: theme.palette.primary.main
	    },
	    progress: {
	      width: '50%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function MobileStepper(props) {
	  var activeStep = props.activeStep,
	      backButton = props.backButton,
	      classes = props.classes,
	      classNameProp = props.className,
	      nextButton = props.nextButton,
	      position = props.position,
	      steps = props.steps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "nextButton", "position", "steps", "variant"]);
	  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], classNameProp);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: className
	  }, other), backButton, variant === 'dots' && _react.default.createElement("div", {
	    className: classes.dots
	  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, step) {
	    var dotClassName = (0, _classnames.default)(classes.dot, (0, _defineProperty2.default)({}, classes.dotActive, step === activeStep)); // eslint-disable-next-line react/no-array-index-key
	
	    return _react.default.createElement("div", {
	      key: step,
	      className: dotClassName
	    });
	  })), variant === 'progress' && _react.default.createElement(_Progress.LinearProgress, {
	    className: classes.progress,
	    variant: "determinate",
	    value: Math.ceil(activeStep / (steps - 1) * 100)
	  }), nextButton);
	}
	
	MobileStepper.propTypes =  false ? {
	  /**
	   * Set the active step (zero based index).
	   * Defines which dot is highlighted when the variant is 'dots'.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * A back button element. For instance, it can be be a `Button` or a `IconButton`.
	   */
	  backButton: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A next button element. For instance, it can be be a `Button` or a `IconButton`.
	   */
	  nextButton: _propTypes.default.node,
	
	  /**
	   * Set the positioning type.
	   */
	  position: _propTypes.default.oneOf(['bottom', 'top', 'static']),
	
	  /**
	   * The total steps.
	   */
	  steps: _propTypes.default.number.isRequired,
	
	  /**
	   * The type of mobile stepper to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'dots', 'progress'])
	} : {};
	MobileStepper.defaultProps = {
	  activeStep: 0,
	  position: 'bottom',
	  variant: 'dots'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMobileStepper'
	})(MobileStepper);
	
	exports.default = _default;

/***/ }),

/***/ 1054:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(1053));

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(182));
	
	var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(1122));
	
	var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(1121));
	
	var _helpers = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.text.secondary
	    },
	    checked: {},
	    disabled: {},
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var _ref = _react.default.createElement(_RadioButtonUnchecked.default, null);
	
	var _ref2 = _react.default.createElement(_RadioButtonChecked.default, null);
	
	function Radio(props) {
	  var classes = props.classes,
	      color = props.color,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "color"]);
	  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "radio",
	    icon: _ref,
	    checkedIcon: _ref2,
	    classes: {
	      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    }
	  }, other));
	}
	
	Radio.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value`.
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input component property `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.string
	} : {};
	Radio.defaultProps = {
	  color: 'secondary'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiRadio'
	})(Radio);
	
	exports.default = _default;

/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(448));
	
	var _helpers = __webpack_require__(22);
	
	// @inheritedComponent FormGroup
	var RadioGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(RadioGroup, _React$Component);
	
	  function RadioGroup() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, RadioGroup);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = RadioGroup.__proto__ || (0, _getPrototypeOf.default)(RadioGroup)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "radios", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: []
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "focus", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (!_this.radios || !_this.radios.length) {
	          return;
	        }
	
	        var focusRadios = _this.radios.filter(function (n) {
	          return !n.disabled;
	        });
	
	        if (!focusRadios.length) {
	          return;
	        }
	
	        var selectedRadio = (0, _helpers.find)(focusRadios, function (n) {
	          return n.checked;
	        });
	
	        if (selectedRadio) {
	          selectedRadio.focus();
	          return;
	        }
	
	        focusRadios[0].focus();
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleRadioChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event, checked) {
	        if (checked && _this.props.onChange) {
	          _this.props.onChange(event, event.target.value);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(RadioGroup, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          value = _props.value,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "name", "value", "onChange"]);
	      this.radios = [];
	      return _react.default.createElement(_FormGroup.default, (0, _extends2.default)({
	        role: "radiogroup"
	      }, other), _react.default.Children.map(children, function (child, index) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	        return _react.default.cloneElement(child, {
	          key: index,
	          name: name,
	          inputRef: function inputRef(node) {
	            if (node) {
	              _this2.radios.push(node);
	            }
	          },
	          checked: value === child.props.value,
	          onChange: _this2.handleRadioChange
	        });
	      }));
	    }
	  }]);
	  return RadioGroup;
	}(_react.default.Component);
	
	RadioGroup.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * The name used to reference the value of the control.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when a radio button is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value`.
	   * @param {string} value The `value` of the selected radio button
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * Value of the selected radio button.
	   */
	  value: _propTypes.default.string
	} : {};
	var _default = RadioGroup;
	exports.default = _default;

/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	
	var _Radio = _interopRequireDefault(__webpack_require__(1064));
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(1065));

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(455));

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectSpread8 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(31));
	
	var _reactLifecyclesCompat = __webpack_require__(75);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _transitions = __webpack_require__(39);
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(108));
	
	var _helpers = __webpack_require__(22);
	
	var _Slide = _interopRequireDefault(__webpack_require__(94));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(71));
	
	var styles = function styles(theme) {
	  var gutter = theme.spacing.unit * 3;
	  var top = {
	    top: 0
	  };
	  var bottom = {
	    bottom: 0
	  };
	  var right = {
	    justifyContent: 'flex-end'
	  };
	  var left = {
	    justifyContent: 'flex-start'
	  };
	  var topSpace = {
	    top: gutter
	  };
	  var bottomSpace = {
	    bottom: gutter
	  };
	  var rightSpace = {
	    right: gutter
	  };
	  var leftSpace = {
	    left: gutter
	  };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	  return {
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 0,
	      right: 0,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    anchorOriginTopCenter: (0, _objectSpread8.default)({}, top, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({}, center))),
	    anchorOriginBottomCenter: (0, _objectSpread8.default)({}, bottom, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({}, center))),
	    anchorOriginTopRight: (0, _objectSpread8.default)({}, top, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      left: 'auto'
	    }, topSpace, rightSpace))),
	    anchorOriginBottomRight: (0, _objectSpread8.default)({}, bottom, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      left: 'auto'
	    }, bottomSpace, rightSpace))),
	    anchorOriginTopLeft: (0, _objectSpread8.default)({}, top, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      right: 'auto'
	    }, topSpace, leftSpace))),
	    anchorOriginBottomLeft: (0, _objectSpread8.default)({}, bottom, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _objectSpread8.default)({
	      right: 'auto'
	    }, bottomSpace, leftSpace)))
	  };
	};
	
	exports.styles = styles;
	
	var Snackbar =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Snackbar, _React$Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf.default)(Snackbar)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "timerAutoHide", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleMouseEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.onMouseEnter) {
	          _this.props.onMouseEnter(event);
	        }
	
	        _this.handlePause();
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleMouseLeave", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.onMouseLeave) {
	          _this.props.onMouseLeave(event);
	        }
	
	        _this.handleResume();
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClickAway", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (_this.props.onClose) {
	          _this.props.onClose(event, 'clickaway');
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handlePause", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        clearTimeout(_this.timerAutoHide);
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResume", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.props.autoHideDuration != null) {
	          if (_this.props.resumeHideDuration !== undefined) {
	            _this.setAutoHideTimer(_this.props.resumeHideDuration);
	
	            return;
	          }
	
	          _this.setAutoHideTimer((_this.props.autoHideDuration || 0) * 0.5);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExited", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        _this.setState({
	          exited: true
	        });
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Snackbar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.open) {
	        this.setAutoHideTimer();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.open !== this.props.open) {
	        if (this.props.open) {
	          this.setAutoHideTimer();
	        } else {
	          clearTimeout(this.timerAutoHide);
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHide);
	    } // Timer that controls delay before snackbar auto hides
	
	  }, {
	    key: "setAutoHideTimer",
	    value: function setAutoHideTimer() {
	      var _this2 = this;
	
	      var autoHideDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (!this.props.onClose || this.props.autoHideDuration == null) {
	        return;
	      }
	
	      clearTimeout(this.timerAutoHide);
	      this.timerAutoHide = setTimeout(function () {
	        if (!_this2.props.onClose || _this2.props.autoHideDuration == null) {
	          return;
	        }
	
	        _this2.props.onClose(null, 'timeout');
	      }, autoHideDuration || this.props.autoHideDuration || 0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          action = _props.action,
	          _props$anchorOrigin = _props.anchorOrigin,
	          vertical = _props$anchorOrigin.vertical,
	          horizontal = _props$anchorOrigin.horizontal,
	          autoHideDuration = _props.autoHideDuration,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          ContentProps = _props.ContentProps,
	          disableWindowBlurListener = _props.disableWindowBlurListener,
	          message = _props.message,
	          onClose = _props.onClose,
	          onEnter = _props.onEnter,
	          onEntered = _props.onEntered,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExited = _props.onExited,
	          onExiting = _props.onExiting,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          open = _props.open,
	          resumeHideDuration = _props.resumeHideDuration,
	          TransitionComponent = _props.TransitionComponent,
	          transitionDuration = _props.transitionDuration,
	          TransitionProps = _props.TransitionProps,
	          other = (0, _objectWithoutProperties2.default)(_props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]); // So we only render active snackbars.
	
	      if (!open && this.state.exited) {
	        return null;
	      }
	
	      return _react.default.createElement(_ClickAwayListener.default, {
	        onClickAway: this.handleClickAway
	      }, _react.default.createElement("div", (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave
	      }, other), _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onFocus: disableWindowBlurListener ? undefined : this.handleResume,
	        onBlur: disableWindowBlurListener ? undefined : this.handlePause
	      }), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	        appear: true,
	        "in": open,
	        onEnter: onEnter,
	        onEntered: onEntered,
	        onEntering: onEntering,
	        onExit: onExit,
	        onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
	        onExiting: onExiting,
	        timeout: transitionDuration,
	        direction: vertical === 'top' ? 'down' : 'up'
	      }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends2.default)({
	        message: message,
	        action: action
	      }, ContentProps)))));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (typeof prevState.exited === 'undefined') {
	        return {
	          exited: !nextProps.open
	        };
	      }
	
	      if (nextProps.open) {
	        return {
	          exited: false
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return Snackbar;
	}(_react.default.Component);
	
	Snackbar.propTypes =  false ? {
	  /**
	   * The action to display.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]),
	    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])])
	  }),
	
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes.default.number,
	
	  /**
	   * If you wish the take control over the children of the component you can use this property.
	   * When used, you replace the `SnackbarContent` component with the children.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `SnackbarContent` element.
	   */
	  ContentProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	   */
	  disableWindowBlurListener: _propTypes.default.bool,
	
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key property to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes.default.any,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * If true, `Snackbar` is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` property isn't specified, it does nothing.
	   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes.default.number,
	
	  /**
	   * Transition component.
	   */
	  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Properties applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : {};
	Snackbar.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'center'
	  },
	  disableWindowBlurListener: false,
	  TransitionComponent: _Slide.default,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiSnackbar'
	})((0, _reactLifecyclesCompat.polyfill)(Snackbar));
	
	exports.default = _default;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _colorManipulator = __webpack_require__(48);
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  var _root;
	
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	  return {
	    root: (_root = {
	      pointerEvents: 'initial',
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: "6px ".concat(theme.spacing.unit * 3, "px")
	    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
	      minWidth: 288,
	      maxWidth: 568,
	      borderRadius: 2
	    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
	      flexGrow: 1
	    }), _root),
	    message: {
	      padding: "".concat(theme.spacing.unit, "px 0")
	    },
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: theme.spacing.unit * 3,
	      marginRight: -theme.spacing.unit
	    }
	  };
	};
	
	exports.styles = styles;
	
	function SnackbarContent(props) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    component: _Typography.default,
	    headlineMapping: {
	      body1: 'div'
	    },
	    role: "alertdialog",
	    square: true,
	    elevation: 6,
	    className: (0, _classnames.default)(classes.root, className)
	  }, other), _react.default.createElement("div", {
	    className: classes.message
	  }, message), action ? _react.default.createElement("div", {
	    className: classes.action
	  }, action) : null);
	}
	
	SnackbarContent.propTypes =  false ? {
	  /**
	   * The action to display.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSnackbarContent'
	})(SnackbarContent);
	
	exports.default = _default;

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	Object.defineProperty(exports, "SnackbarContent", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(139));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(71));

/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {},
	    horizontal: {
	      paddingLeft: theme.spacing.unit,
	      paddingRight: theme.spacing.unit,
	      '&:first-child': {
	        paddingLeft: 0
	      },
	      '&:last-child': {
	        paddingRight: 0
	      }
	    },
	    vertical: {},
	    alternativeLabel: {
	      flex: 1,
	      position: 'relative'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Step(props) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      connector = props.connector,
	      disabled = props.disabled,
	      index = props.index,
	      last = props.last,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "index", "last", "orientation"]);
	  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), _react.default.Children.map(children, function (child) {
	    return _react.default.cloneElement(child, (0, _objectSpread2.default)({
	      active: active,
	      alternativeLabel: alternativeLabel,
	      completed: completed,
	      disabled: disabled,
	      icon: index + 1,
	      last: last,
	      orientation: orientation
	    }, child.props));
	  }), connector && alternativeLabel && !last && _react.default.cloneElement(connector, {
	    orientation: orientation,
	    alternativeLabel: alternativeLabel
	  }));
	}
	
	Step.propTypes =  false ? {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Passed down from Stepper if alternativeLabel is also set.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : {};
	Step.defaultProps = {
	  active: false,
	  completed: false,
	  disabled: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStep'
	})(Step);
	
	exports.default = _default;

/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(458));
	
	var _reactHelpers = __webpack_require__(72);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    root: {
	      width: '100%',
	      padding: "".concat(theme.spacing.unit * 3, "px ").concat(theme.spacing.unit * 2, "px"),
	      margin: "".concat(-theme.spacing.unit * 3, "px ").concat(-theme.spacing.unit * 2, "px"),
	      boxSizing: 'content-box'
	    },
	    vertical: {
	      justifyContent: 'left'
	    },
	    touchRipple: {
	      color: 'rgba(0, 0, 0, 0.3)'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function StepButton(props) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "icon", "last", "optional", "orientation"]);
	  var childProps = {
	    active: active,
	    alternativeLabel: alternativeLabel,
	    completed: completed,
	    disabled: disabled,
	    icon: icon,
	    optional: optional,
	    orientation: orientation
	  };
	  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react.default.cloneElement(children, childProps) : _react.default.createElement(_StepLabel.default, childProps, children);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    disabled: disabled,
	    TouchRippleProps: {
	      className: classes.touchRipple
	    },
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.vertical, orientation === 'vertical'), classNameProp)
	  }, other), child);
	}
	
	StepButton.propTypes =  false ? {
	  /**
	   * @ignore
	   * Passed in via `Step` - passed through to `StepLabel`.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepButton'
	})(StepButton);
	
	exports.default = _default;

/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto'
	    },
	    horizontal: {},
	    vertical: {
	      marginLeft: 12,
	      // half icon
	      padding: "0 0 ".concat(theme.spacing.unit, "px")
	    },
	    alternativeLabel: {
	      position: 'absolute',
	      top: theme.spacing.unit + 4,
	      left: 'calc(50% + 20px)',
	      right: 'calc(-50% + 20px)'
	    },
	    line: {
	      display: 'block',
	      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	    lineHorizontal: {
	      borderTopStyle: 'solid',
	      borderTopWidth: 1
	    },
	    lineVertical: {
	      borderLeftStyle: 'solid',
	      borderLeftWidth: 1,
	      minHeight: theme.spacing.unit * 3
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	function StepConnector(props) {
	  var _classNames2;
	
	  var alternativeLabel = props.alternativeLabel,
	      classNameProp = props.className,
	      classes = props.classes,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["alternativeLabel", "className", "classes", "orientation"]);
	  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
	  var lineClassName = (0, _classnames.default)(classes.line, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.lineHorizontal, orientation === 'horizontal'), (0, _defineProperty2.default)(_classNames2, classes.lineVertical, orientation === 'vertical'), _classNames2));
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), _react.default.createElement("span", {
	    className: lineClassName
	  }));
	}
	
	StepConnector.propTypes =  false ? {
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : {};
	StepConnector.defaultProps = {
	  alternativeLabel: false,
	  orientation: 'horizontal'
	};
	
	var _default = (0, _withStyles.default)(styles)(StepConnector);
	
	exports.default = _default;

/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _warning = _interopRequireDefault(__webpack_require__(20));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(325));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      marginTop: theme.spacing.unit,
	      marginLeft: 12,
	      // half icon
	      paddingLeft: theme.spacing.unit + 12,
	      // margin + half icon
	      paddingRight: theme.spacing.unit,
	      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
	    },
	    last: {
	      borderLeft: 'none'
	    },
	    transition: {}
	  };
	};
	
	exports.styles = styles;
	
	function StepContent(props) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      TransitionComponent = props.TransitionComponent,
	      transitionDuration = props.transitionDuration,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	   false ? (0, _warning.default)(orientation === 'vertical', 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.last, last), className)
	  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
	    "in": active,
	    className: classes.transition,
	    timeout: transitionDuration,
	    unmountOnExit: true
	  }, TransitionProps), children));
	}
	
	StepContent.propTypes =  false ? {
	  /**
	   * @ignore
	   * Expands the content.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Step content.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the optional property.
	   */
	  optional: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * Collapse component.
	   */
	  TransitionComponent: _propTypes.default.func,
	
	  /**
	   * Adjust the duration of the content expand transition.
	   * Passed as a property to the transition component.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Properties applied to the `Transition` element.
	   */
	  TransitionProps: _propTypes.default.object
	} : {};
	StepContent.defaultProps = {
	  TransitionComponent: _Collapse.default,
	  transitionDuration: 'auto'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepContent'
	})(StepContent);
	
	exports.default = _default;

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _CheckCircle = _interopRequireDefault(__webpack_require__(1120));
	
	var _Warning = _interopRequireDefault(__webpack_require__(1123));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _StepPositionIcon = _interopRequireDefault(__webpack_require__(1072));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'block',
	      '&$active': {
	        color: theme.palette.primary.main
	      },
	      '&$completed': {
	        color: theme.palette.primary.main
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	    active: {},
	    completed: {},
	    error: {}
	  };
	};
	
	exports.styles = styles;
	
	function StepIcon(props) {
	  var completed = props.completed,
	      icon = props.icon,
	      active = props.active,
	      error = props.error,
	      classes = props.classes;
	
	  if (typeof icon === 'number' || typeof icon === 'string') {
	    if (error) {
	      return _react.default.createElement(_Warning.default, {
	        className: (0, _classnames.default)(classes.root, classes.error)
	      });
	    }
	
	    if (completed) {
	      return _react.default.createElement(_CheckCircle.default, {
	        className: (0, _classnames.default)(classes.root, classes.completed)
	      });
	    }
	
	    return _react.default.createElement(_StepPositionIcon.default, {
	      className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active)),
	      position: icon
	    });
	  }
	
	  return icon;
	}
	
	StepIcon.propTypes =  false ? {
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes.default.node.isRequired
	} : {};
	StepIcon.defaultProps = {
	  active: false,
	  completed: false,
	  error: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepIcon'
	})(StepIcon);
	
	exports.default = _default;

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(457));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      '&$alternativeLabel': {
	        flexDirection: 'column'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	    horizontal: {},
	    vertical: {},
	    active: {},
	    completed: {},
	    alternativeLabel: {},
	    error: {},
	    disabled: {},
	    label: {
	      color: theme.palette.text.secondary,
	      '&$active': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$completed': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$alternativeLabel': {
	        textAlign: 'center',
	        marginTop: theme.spacing.unit * 2
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	    iconContainer: {
	      paddingRight: theme.spacing.unit,
	      '&$alternativeLabel': {
	        paddingRight: 0
	      }
	    },
	    labelContainer: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function StepLabel(props) {
	  var _classNames, _classNames3;
	
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      error = props.error,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "icon", "last", "optional", "orientation"]);
	  return _react.default.createElement("span", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames, classes.error, error), _classNames), classNameProp)
	  }, other), icon && _react.default.createElement("span", {
	    className: (0, _classnames.default)(classes.iconContainer, (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel))
	  }, _react.default.createElement(_StepIcon.default, {
	    completed: completed,
	    active: active,
	    error: error,
	    icon: icon,
	    alternativeLabel: alternativeLabel
	  })), _react.default.createElement("span", {
	    className: classes.labelContainer
	  }, _react.default.createElement(_Typography.default, {
	    variant: "body1",
	    component: "span",
	    className: (0, _classnames.default)(classes.label, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames3, classes.completed, completed), (0, _defineProperty2.default)(_classNames3, classes.active, active), (0, _defineProperty2.default)(_classNames3, classes.error, error), _classNames3))
	  }, children), optional));
	}
	
	StepLabel.propTypes =  false ? {
	  /**
	   * @ignore
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * In most cases will simply be a string containing a title for the label.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Override the default icon.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : {};
	StepLabel.defaultProps = {
	  active: false,
	  alternativeLabel: false,
	  completed: false,
	  disabled: false,
	  error: false,
	  last: false,
	  orientation: 'horizontal'
	};
	StepLabel.muiName = 'StepLabel';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepLabel'
	})(StepLabel);
	
	exports.default = _default;

/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.text.disabled
	    },
	    text: {
	      fill: theme.palette.primary.contrastText,
	      fontSize: theme.typography.caption.fontSize,
	      fontFamily: theme.typography.fontFamily
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	var _ref = _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "12"
	});
	
	function StepPositionIcon(props) {
	  var position = props.position,
	      classes = props.classes,
	      className = props.className;
	  return _react.default.createElement(_SvgIcon.default, {
	    className: (0, _classnames.default)(classes.root, className)
	  }, _ref, _react.default.createElement("text", {
	    className: classes.text,
	    x: "12",
	    y: "16",
	    textAnchor: "middle"
	  }, position));
	}
	
	StepPositionIcon.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The step position as a number.
	   */
	  position: _propTypes.default.node
	} : {};
	
	var _default = (0, _withStyles.default)(styles)(StepPositionIcon);
	
	exports.default = _default;

/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(1070));
	
	// @inheritedComponent Paper
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      padding: theme.spacing.unit * 3
	    },
	    horizontal: {
	      flexDirection: 'row',
	      alignItems: 'center'
	    },
	    vertical: {
	      flexDirection: 'column'
	    },
	    alternativeLabel: {
	      alignItems: 'flex-start'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Stepper(props) {
	  var activeStep = props.activeStep,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      connectorProp = props.connector,
	      nonLinear = props.nonLinear,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
	  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
	  var connector = _react.default.isValidElement(connectorProp) ? _react.default.cloneElement(connectorProp, {
	    orientation: orientation
	  }) : null;
	
	  var childrenArray = _react.default.Children.toArray(children);
	
	  var steps = childrenArray.map(function (step, index) {
	    var controlProps = {
	      index: index,
	      orientation: orientation,
	      active: false,
	      completed: false,
	      disabled: false,
	      last: index + 1 === childrenArray.length,
	      alternativeLabel: alternativeLabel,
	      connector: connectorProp
	    };
	
	    if (activeStep === index) {
	      controlProps.active = true;
	    } else if (!nonLinear && activeStep > index) {
	      controlProps.completed = true;
	    } else if (!nonLinear && activeStep < index) {
	      controlProps.disabled = true;
	    }
	
	    return [!alternativeLabel && connector && index > 0 && _react.default.cloneElement(connector, {
	      key: index // eslint-disable-line react/no-array-index-key
	
	    }), _react.default.cloneElement(step, (0, _objectSpread2.default)({}, controlProps, step.props))];
	  });
	  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: className
	  }, other), steps);
	}
	
	Stepper.propTypes =  false ? {
	  /**
	   * Set the active step (zero based index).
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * If set to 'true' and orientation is horizontal,
	   * then the step label will be positioned under the icon.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Two or more `<Step />` components.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * If set the `Stepper` will not assist in controlling steps for linear flow.
	   */
	  nonLinear: _propTypes.default.bool,
	
	  /**
	   * The stepper orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : {};
	Stepper.defaultProps = {
	  activeStep: 0,
	  alternativeLabel: false,
	  connector: _react.default.createElement(_StepConnector.default, null),
	  nonLinear: false,
	  orientation: 'horizontal'
	};
	Stepper.muiName = 'Stepper';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepper'
	})(Stepper);
	
	exports.default = _default;

/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	Object.defineProperty(exports, "StepButton", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	Object.defineProperty(exports, "StepIcon", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	Object.defineProperty(exports, "StepLabel", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	
	var _Stepper = _interopRequireDefault(__webpack_require__(1073));
	
	var _Step = _interopRequireDefault(__webpack_require__(1068));
	
	var _StepButton = _interopRequireDefault(__webpack_require__(1069));
	
	var _StepContent = _interopRequireDefault(__webpack_require__(1071));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(457));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(458));

/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(22);
	
	var _Drawer = __webpack_require__(315);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      height: '100vh',
	      zIndex: theme.zIndex.drawer - 1
	    },
	    discoveryAnchorLeft: {
	      right: 'auto'
	    },
	    discoveryAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    discoveryAnchorTop: {
	      bottom: 'auto',
	      right: 0
	    },
	    discoveryAnchorBottom: {
	      top: 'auto',
	      bottom: 0,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	function SwipeArea(props) {
	  var anchor = props.anchor,
	      classes = props.classes,
	      swipeAreaWidth = props.swipeAreaWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "swipeAreaWidth"]);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classes["discoveryAnchor".concat((0, _helpers.capitalize)(anchor))]),
	    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(props) ? 'width' : 'height', swipeAreaWidth)
	  }, other));
	}
	
	SwipeArea.propTypes =  false ? {
	  /**
	   * Side on which to attach the discovery area.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  swipeAreaWidth: _propTypes.default.number.isRequired
	} : {};
	
	var _default = (0, _withStyles.default)(styles)(SwipeArea);
	
	exports.default = _default;

/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(76);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reset = reset;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _reactLifecyclesCompat = __webpack_require__(75);
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(315));
	
	var _transitions = __webpack_require__(39);
	
	var _withTheme = _interopRequireDefault(__webpack_require__(49));
	
	var _utils = __webpack_require__(95);
	
	var _SwipeArea = _interopRequireDefault(__webpack_require__(1076));
	
	/* eslint-disable consistent-this */
	// @inheritedComponent Drawer
	var Fragment = _react.default.Fragment || 'div'; // This value is closed to what browsers are using internally to
	// trigger a native scroll.
	
	var UNCERTAINTY_THRESHOLD = 3; // px
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	
	var nodeThatClaimedTheSwipe = null; // Exported for test purposes.
	
	function reset() {
	  nodeThatClaimedTheSwipe = null;
	}
	
	var SwipeableDrawer =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(SwipeableDrawer, _React$Component);
	
	  function SwipeableDrawer() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, SwipeableDrawer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = SwipeableDrawer.__proto__ || (0, _getPrototypeOf.default)(SwipeableDrawer)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBodyTouchStart", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // We are not supposed to hanlde this touch move.
	        if (nodeThatClaimedTheSwipe !== null && nodeThatClaimedTheSwipe !== (0, _assertThisInitialized2.default)(_this)) {
	          return;
	        }
	
	        var _this$props = _this.props,
	            disableDiscovery = _this$props.disableDiscovery,
	            disableSwipeToOpen = _this$props.disableSwipeToOpen,
	            open = _this$props.open,
	            swipeAreaWidth = _this$props.swipeAreaWidth;
	        var anchor = (0, _Drawer.getAnchor)(_this.props);
	        var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	        var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY;
	
	        if (!open) {
	          if (disableSwipeToOpen) {
	            return;
	          }
	
	          if ((0, _Drawer.isHorizontal)(_this.props)) {
	            if (currentX > swipeAreaWidth) {
	              return;
	            }
	          } else if (currentY > swipeAreaWidth) {
	            return;
	          }
	        }
	
	        nodeThatClaimedTheSwipe = (0, _assertThisInitialized2.default)(_this);
	        _this.startX = currentX;
	        _this.startY = currentY;
	
	        _this.setState({
	          maybeSwiping: true
	        });
	
	        if (!open && _this.paper) {
	          // the ref may be null when a parent component updates while swiping
	          _this.setPosition(_this.getMaxTranslate() + (disableDiscovery ? 20 : -swipeAreaWidth), {
	            changeTransition: false
	          });
	        }
	
	        document.body.addEventListener('touchmove', _this.handleBodyTouchMove, {
	          passive: false
	        });
	        document.body.addEventListener('touchend', _this.handleBodyTouchEnd); // https://plus.google.com/+PaulIrish/posts/KTwfn1Y2238
	
	        document.body.addEventListener('touchcancel', _this.handleBodyTouchEnd);
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBodyTouchMove", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // the ref may be null when a parent component updates while swiping
	        if (!_this.paper) return;
	        var anchor = (0, _Drawer.getAnchor)(_this.props);
	        var horizontalSwipe = (0, _Drawer.isHorizontal)(_this.props);
	        var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	        var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY; // We don't know yet.
	
	        if (_this.isSwiping == null) {
	          var dx = Math.abs(currentX - _this.startX);
	          var dy = Math.abs(currentY - _this.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.
	
	          if (dx > dy) {
	            event.preventDefault();
	          }
	
	          var isSwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
	
	          if (isSwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
	            _this.isSwiping = isSwiping;
	
	            if (!isSwiping) {
	              _this.handleBodyTouchEnd(event);
	
	              return;
	            } // Shift the starting point.
	
	
	            _this.startX = currentX;
	            _this.startY = currentY; // Compensate for the part of the drawer displayed on touch start.
	
	            if (!_this.props.disableDiscovery && !_this.props.open) {
	              if (horizontalSwipe) {
	                _this.startX -= _this.props.swipeAreaWidth;
	              } else {
	                _this.startY -= _this.props.swipeAreaWidth;
	              }
	            }
	          }
	        }
	
	        if (!_this.isSwiping) {
	          return;
	        } // We are swiping, let's prevent the scroll event on iOS.
	
	
	        event.preventDefault();
	
	        _this.setPosition(_this.getTranslate(horizontalSwipe ? currentX : currentY));
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBodyTouchEnd", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        nodeThatClaimedTheSwipe = null;
	
	        _this.removeBodyTouchListeners();
	
	        _this.setState({
	          maybeSwiping: false
	        }); // The swipe wasn't started.
	
	
	        if (!_this.isSwiping) {
	          _this.isSwiping = null;
	          return;
	        }
	
	        var anchor = (0, _Drawer.getAnchor)(_this.props);
	        var current;
	
	        if ((0, _Drawer.isHorizontal)(_this.props)) {
	          current = anchor === 'right' ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
	        } else {
	          current = anchor === 'bottom' ? window.innerHeight - event.changedTouches[0].clientY : event.changedTouches[0].clientY;
	        }
	
	        var translateRatio = _this.getTranslate(current) / _this.getMaxTranslate(); // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	
	
	        if (translateRatio > 0.5) {
	          if (_this.isSwiping && !_this.props.open) {
	            // Reset the position, the swipe was aborted.
	            _this.setPosition(_this.getMaxTranslate(), {
	              mode: 'enter'
	            });
	          } else {
	            _this.props.onClose();
	          }
	        } else if (_this.isSwiping && !_this.props.open) {
	          _this.props.onOpen();
	        } else {
	          // Reset the position, the swipe was aborted.
	          _this.setPosition(0, {
	            mode: 'exit'
	          });
	        }
	
	        _this.isSwiping = null;
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "backdrop", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "paper", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isSwiping", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "startX", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "startY", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBackdropRef", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        _this.backdrop = node ? _reactDom.default.findDOMNode(node) : null;
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handlePaperRef", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        _this.paper = node ? _reactDom.default.findDOMNode(node) : null;
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(SwipeableDrawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.variant === 'temporary') {
	        this.listenTouchStart();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var variant = this.props.variant;
	      var prevVariant = prevProps.variant;
	
	      if (variant !== prevVariant) {
	        if (variant === 'temporary') {
	          this.listenTouchStart();
	        } else if (prevVariant === 'temporary') {
	          this.removeTouchStart();
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeTouchStart();
	      this.removeBodyTouchListeners(); // We need to release the lock.
	
	      if (nodeThatClaimedTheSwipe === this) {
	        nodeThatClaimedTheSwipe = null;
	      }
	    }
	  }, {
	    key: "getMaxTranslate",
	    value: function getMaxTranslate() {
	      return (0, _Drawer.isHorizontal)(this.props) ? this.paper.clientWidth : this.paper.clientHeight;
	    }
	  }, {
	    key: "getTranslate",
	    value: function getTranslate(current) {
	      var start = (0, _Drawer.isHorizontal)(this.props) ? this.startX : this.startY;
	      return Math.min(Math.max(this.props.open ? start - current : this.getMaxTranslate() + start - current, 0), this.getMaxTranslate());
	    }
	  }, {
	    key: "setPosition",
	    value: function setPosition(translate) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var _options$mode = options.mode,
	          mode = _options$mode === void 0 ? null : _options$mode,
	          _options$changeTransi = options.changeTransition,
	          changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
	      var anchor = (0, _Drawer.getAnchor)(this.props);
	      var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchor) !== -1 ? 1 : -1;
	      var transform = (0, _Drawer.isHorizontal)(this.props) ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
	      var drawerStyle = this.paper.style;
	      drawerStyle.webkitTransform = transform;
	      drawerStyle.transform = transform;
	      var transition = '';
	
	      if (mode) {
	        transition = this.props.theme.transitions.create('all', (0, _utils.getTransitionProps)({
	          timeout: this.props.transitionDuration
	        }, {
	          mode: mode
	        }));
	      }
	
	      if (changeTransition) {
	        drawerStyle.webkitTransition = transition;
	        drawerStyle.transition = transition;
	      }
	
	      if (!this.props.disableBackdropTransition) {
	        var backdropStyle = this.backdrop.style;
	        backdropStyle.opacity = 1 - translate / this.getMaxTranslate();
	
	        if (changeTransition) {
	          backdropStyle.webkitTransition = transition;
	          backdropStyle.transition = transition;
	        }
	      }
	    }
	  }, {
	    key: "listenTouchStart",
	    value: function listenTouchStart() {
	      document.body.addEventListener('touchstart', this.handleBodyTouchStart);
	    }
	  }, {
	    key: "removeTouchStart",
	    value: function removeTouchStart() {
	      document.body.removeEventListener('touchstart', this.handleBodyTouchStart);
	    }
	  }, {
	    key: "removeBodyTouchListeners",
	    value: function removeBodyTouchListeners() {
	      document.body.removeEventListener('touchmove', this.handleBodyTouchMove, {
	        passive: false
	      });
	      document.body.removeEventListener('touchend', this.handleBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', this.handleBodyTouchEnd);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          disableBackdropTransition = _props.disableBackdropTransition,
	          disableDiscovery = _props.disableDiscovery,
	          disableSwipeToOpen = _props.disableSwipeToOpen,
	          _props$ModalProps = _props.ModalProps;
	      _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	      var BackdropProps = _props$ModalProps.BackdropProps,
	          ModalPropsProp = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	          onOpen = _props.onOpen,
	          open = _props.open,
	          PaperProps = _props.PaperProps,
	          swipeAreaWidth = _props.swipeAreaWidth,
	          variant = _props.variant,
	          other = (0, _objectWithoutProperties2.default)(_props, ["disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "ModalProps", "onOpen", "open", "PaperProps", "swipeAreaWidth", "variant"]);
	      var maybeSwiping = this.state.maybeSwiping;
	      return _react.default.createElement(Fragment, null, _react.default.createElement(_Drawer.default, (0, _extends2.default)({
	        open: variant === 'temporary' && maybeSwiping ? true : open,
	        variant: variant,
	        ModalProps: (0, _objectSpread2.default)({
	          BackdropProps: (0, _objectSpread2.default)({}, BackdropProps, {
	            ref: this.handleBackdropRef
	          })
	        }, ModalPropsProp),
	        PaperProps: (0, _objectSpread2.default)({}, PaperProps, {
	          style: {
	            pointerEvents: variant === 'temporary' && !open ? 'none' : ''
	          },
	          ref: this.handlePaperRef
	        })
	      }, other)), !disableDiscovery && !disableSwipeToOpen && variant === 'temporary' && _react.default.createElement(_SwipeArea.default, {
	        anchor: other.anchor,
	        swipeAreaWidth: swipeAreaWidth
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps() {
	      // Reset the maybeSwiping state everytime we receive new properties.
	      return {
	        maybeSwiping: false
	      };
	    }
	  }]);
	  return SwipeableDrawer;
	}(_react.default.Component);
	
	SwipeableDrawer.propTypes =  false ? {
	  /**
	   * @ignore
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * Disable the backdrop transition.
	   * This can improve the FPS on low-end devices.
	   */
	  disableBackdropTransition: _propTypes.default.bool,
	
	  /**
	   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
	   * to promote accidental discovery of the swipe gesture.
	   */
	  disableDiscovery: _propTypes.default.bool,
	
	  /**
	   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
	   * navigation actions. Swipe to open is disabled on iOS browsers by default.
	   */
	  disableSwipeToOpen: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onOpen: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  swipeAreaWidth: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * @ignore
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : {};
	SwipeableDrawer.defaultProps = {
	  anchor: 'left',
	  disableBackdropTransition: false,
	  disableDiscovery: false,
	  disableSwipeToOpen: typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent),
	  swipeAreaWidth: 20,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  },
	  variant: 'temporary' // Mobile first.
	
	};
	
	var _default = (0, _withTheme.default)()((0, _reactLifecyclesCompat.polyfill)(SwipeableDrawer));
	
	exports.default = _default;

/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(1077));

/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(22);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(182));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-flex',
	      width: 62,
	      position: 'relative',
	      flexShrink: 0,
	      // For correct alignment with the text.
	      verticalAlign: 'middle'
	    },
	    icon: {
	      boxShadow: theme.shadows[1],
	      backgroundColor: 'currentColor',
	      width: 20,
	      height: 20,
	      borderRadius: '50%'
	    },
	    iconChecked: {
	      boxShadow: theme.shadows[2]
	    },
	    switchBase: {
	      zIndex: 1,
	      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
	      transition: theme.transitions.create('transform', {
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    checked: {
	      transform: 'translateX(14px)',
	      '& + $bar': {
	        opacity: 0.5
	      }
	    },
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '& + $bar': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '& + $bar': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	    disabled: {
	      '& + $bar': {
	        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
	      },
	      '& $icon': {
	        boxShadow: theme.shadows[1]
	      },
	      '&$switchBase': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
	        '& + $bar': {
	          backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	        }
	      }
	    },
	    bar: {
	      borderRadius: 7,
	      display: 'block',
	      position: 'absolute',
	      width: 34,
	      height: 14,
	      top: '50%',
	      left: '50%',
	      marginTop: -7,
	      marginLeft: -17,
	      transition: theme.transitions.create(['opacity', 'background-color'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Switch(props) {
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
	  return _react.default.createElement("span", {
	    className: (0, _classnames.default)(classes.root, className)
	  }, _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
	    icon: _react.default.createElement("span", {
	      className: classes.icon
	    }),
	    classes: {
	      root: (0, _classnames.default)(classes.switchBase, classes["color".concat((0, _helpers.capitalize)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    checkedIcon: _react.default.createElement("span", {
	      className: (0, _classnames.default)(classes.icon, classes.iconChecked)
	    })
	  }, other)), _react.default.createElement("span", {
	    className: classes.bar
	  }));
	}
	
	Switch.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.checked`.
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input component property `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.string
	} : {};
	Switch.defaultProps = {
	  color: 'secondary'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitch'
	})(Switch);
	
	exports.default = _default;

/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	
	var _Switch = _interopRequireDefault(__webpack_require__(1079));

/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'table',
	      fontFamily: theme.typography.fontFamily,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0
	    }
	  };
	};
	
	exports.styles = styles;
	
	var Table =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck2.default)(this, Table);
	    return (0, _possibleConstructorReturn2.default)(this, (Table.__proto__ || (0, _getPrototypeOf.default)(Table)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(Table, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {}
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          className = _props.className,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, className)
	      }, other));
	    }
	  }]);
	  return Table;
	}(_react.default.Component);
	
	Table.propTypes =  false ? {
	  /**
	   * The content of the table, normally `TableHeader` and `TableBody`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	Table.defaultProps = {
	  component: 'table'
	};
	Table.childContextTypes = {
	  table: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTable'
	})(Table);
	
	exports.default = _default;

/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = {
	  root: {
	    display: 'table-row-group'
	  }
	};
	
	var TableBody =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(TableBody, _React$Component);
	
	  function TableBody() {
	    (0, _classCallCheck2.default)(this, TableBody);
	    return (0, _possibleConstructorReturn2.default)(this, (TableBody.__proto__ || (0, _getPrototypeOf.default)(TableBody)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(TableBody, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {
	          body: true
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          className = _props.className,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, className)
	      }, other));
	    }
	  }]);
	  return TableBody;
	}(_react.default.Component);
	
	TableBody.propTypes =  false ? {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	TableBody.defaultProps = {
	  component: 'tbody'
	};
	TableBody.childContextTypes = {
	  table: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableBody'
	})(TableBody);
	
	exports.default = _default;

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(22);
	
	var _colorManipulator = __webpack_require__(48);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'table-cell',
	      verticalAlign: 'inherit',
	      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
	      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
	      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
	      textAlign: 'left',
	      padding: "".concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit * 7, "px ").concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit * 3, "px"),
	      '&:last-child': {
	        paddingRight: theme.spacing.unit * 3
	      }
	    },
	    head: {
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(12),
	      fontWeight: theme.typography.fontWeightMedium
	    },
	    body: {
	      color: theme.palette.text.primary,
	      fontSize: theme.typography.pxToRem(13),
	      fontWeight: theme.typography.fontWeightRegular
	    },
	    footer: {
	      borderBottom: 0,
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(12)
	    },
	    numeric: {
	      textAlign: 'right',
	      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents
	
	    },
	    paddingDense: {
	      paddingRight: theme.spacing.unit * 3
	    },
	    paddingCheckbox: {
	      padding: '0 12px'
	    },
	    paddingNone: {
	      padding: 0,
	      '&:last-child': {
	        padding: 0
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function TableCell(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      component = props.component,
	      sortDirection = props.sortDirection,
	      numeric = props.numeric,
	      padding = props.padding,
	      scopeProp = props.scope,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "sortDirection", "numeric", "padding", "scope", "variant"]);
	  var table = context.table;
	  var Component;
	
	  if (component) {
	    Component = component;
	  } else {
	    Component = table && table.head ? 'th' : 'td';
	  }
	
	  var scope = scopeProp;
	
	  if (!scope && table && table.head) {
	    scope = 'col';
	  }
	
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, variant ? variant === 'head' : table && table.head), (0, _defineProperty2.default)(_classNames, classes.body, variant ? variant === 'body' : table && table.body), (0, _defineProperty2.default)(_classNames, classes.footer, variant ? variant === 'footer' : table && table.footer), (0, _defineProperty2.default)(_classNames, classes.numeric, numeric), (0, _defineProperty2.default)(_classNames, classes["padding".concat((0, _helpers.capitalize)(padding))], padding !== 'default'), _classNames), classNameProp);
	  var ariaSort = null;
	
	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className,
	    "aria-sort": ariaSort,
	    scope: scope
	  }, other), children);
	}
	
	TableCell.propTypes =  false ? {
	  /**
	   * The table cell contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, content will align to the right.
	   */
	  numeric: _propTypes.default.bool,
	
	  /**
	   * Sets the padding applied to the cell.
	   */
	  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none']),
	
	  /**
	   * Set scope attribute.
	   */
	  scope: _propTypes.default.string,
	
	  /**
	   * Set aria-sort direction.
	   */
	  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),
	
	  /**
	   * Specify the cell type.
	   * By default, the TableHead, TableBody or TableFooter parent component set the value.
	   */
	  variant: _propTypes.default.oneOf(['head', 'body', 'footer'])
	} : {};
	TableCell.defaultProps = {
	  numeric: false,
	  padding: 'default'
	};
	TableCell.contextTypes = {
	  table: _propTypes.default.object.isRequired
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableCell'
	})(TableCell);
	
	exports.default = _default;

/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = {
	  root: {
	    display: 'table-footer-group'
	  }
	};
	
	var TableFooter =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(TableFooter, _React$Component);
	
	  function TableFooter() {
	    (0, _classCallCheck2.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn2.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(TableFooter, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {
	          footer: true
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          className = _props.className,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, className)
	      }, other));
	    }
	  }]);
	  return TableFooter;
	}(_react.default.Component);
	
	TableFooter.propTypes =  false ? {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	TableFooter.defaultProps = {
	  component: 'tfoot'
	};
	TableFooter.childContextTypes = {
	  table: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableFooter'
	})(TableFooter);
	
	exports.default = _default;

/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = {
	  root: {
	    display: 'table-header-group'
	  }
	};
	
	var TableHead =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(TableHead, _React$Component);
	
	  function TableHead() {
	    (0, _classCallCheck2.default)(this, TableHead);
	    return (0, _possibleConstructorReturn2.default)(this, (TableHead.__proto__ || (0, _getPrototypeOf.default)(TableHead)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(TableHead, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {
	          head: true
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          className = _props.className,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "component"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, className)
	      }, other));
	    }
	  }]);
	  return TableHead;
	}(_react.default.Component);
	
	TableHead.propTypes =  false ? {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	TableHead.defaultProps = {
	  component: 'thead'
	};
	TableHead.childContextTypes = {
	  table: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableHead'
	})(TableHead);
	
	exports.default = _default;

/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _Input = _interopRequireDefault(__webpack_require__(178));
	
	var _Menu = __webpack_require__(92);
	
	var _Select = _interopRequireDefault(__webpack_require__(456));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(459));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(460));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _TablePaginationActions = _interopRequireDefault(__webpack_require__(1086));
	
	// @inheritedComponent TableCell
	var styles = function styles(theme) {
	  return {
	    root: {
	      fontSize: theme.typography.pxToRem(12),
	      // Increase the specificity to override TableCell.
	      '&:last-child': {
	        padding: 0
	      }
	    },
	    toolbar: {
	      height: 56,
	      minHeight: 56,
	      paddingRight: 2
	    },
	    spacer: {
	      flex: '1 1 100%'
	    },
	    menuItem: {},
	    caption: {
	      flexShrink: 0
	    },
	    input: {
	      fontSize: 'inherit',
	      flexShrink: 0
	    },
	    selectRoot: {
	      marginRight: theme.spacing.unit * 4,
	      marginLeft: theme.spacing.unit,
	      color: theme.palette.text.secondary
	    },
	    select: {
	      paddingLeft: theme.spacing.unit,
	      paddingRight: theme.spacing.unit * 2
	    },
	    selectIcon: {
	      top: 1
	    },
	    actions: {
	      flexShrink: 0,
	      color: theme.palette.text.secondary,
	      marginLeft: theme.spacing.unit * 2.5
	    }
	  };
	};
	/**
	 * A `TableCell` based component for placing inside `TableFooter` for pagination.
	 */
	
	
	exports.styles = styles;
	
	var TablePagination =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(TablePagination, _React$Component);
	
	  function TablePagination() {
	    (0, _classCallCheck2.default)(this, TablePagination);
	    return (0, _possibleConstructorReturn2.default)(this, (TablePagination.__proto__ || (0, _getPrototypeOf.default)(TablePagination)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(TablePagination, [{
	    key: "componentDidUpdate",
	    // This logic would be better handled on userside.
	    // However, we have it just in case.
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          count = _props.count,
	          onChangePage = _props.onChangePage,
	          page = _props.page,
	          rowsPerPage = _props.rowsPerPage;
	      var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
	
	      if (page > newLastPage) {
	        onChangePage(null, newLastPage);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          ActionsComponent = _props2.ActionsComponent,
	          backIconButtonProps = _props2.backIconButtonProps,
	          classes = _props2.classes,
	          colSpanProp = _props2.colSpan,
	          Component = _props2.component,
	          count = _props2.count,
	          labelDisplayedRows = _props2.labelDisplayedRows,
	          labelRowsPerPage = _props2.labelRowsPerPage,
	          nextIconButtonProps = _props2.nextIconButtonProps,
	          onChangePage = _props2.onChangePage,
	          onChangeRowsPerPage = _props2.onChangeRowsPerPage,
	          page = _props2.page,
	          rowsPerPage = _props2.rowsPerPage,
	          rowsPerPageOptions = _props2.rowsPerPageOptions,
	          SelectProps = _props2.SelectProps,
	          other = (0, _objectWithoutProperties2.default)(_props2, ["ActionsComponent", "backIconButtonProps", "classes", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
	      var colSpan;
	
	      if (Component === _TableCell.default || Component === 'td') {
	        colSpan = colSpanProp || 1000; // col-span over everything
	      }
	
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: classes.root,
	        colSpan: colSpan
	      }, other), _react.default.createElement(_Toolbar.default, {
	        className: classes.toolbar
	      }, _react.default.createElement("div", {
	        className: classes.spacer
	      }), rowsPerPageOptions.length > 1 && _react.default.createElement(_Typography.default, {
	        variant: "caption",
	        className: classes.caption
	      }, labelRowsPerPage), rowsPerPageOptions.length > 1 && _react.default.createElement(_Select.default, (0, _extends2.default)({
	        classes: {
	          root: classes.selectRoot,
	          select: classes.select,
	          icon: classes.selectIcon
	        },
	        input: _react.default.createElement(_Input.default, {
	          className: classes.input,
	          disableUnderline: true
	        }),
	        value: rowsPerPage,
	        onChange: onChangeRowsPerPage
	      }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
	        return _react.default.createElement(_Menu.MenuItem, {
	          className: classes.menuItem,
	          key: rowsPerPageOption,
	          value: rowsPerPageOption
	        }, rowsPerPageOption);
	      })), _react.default.createElement(_Typography.default, {
	        variant: "caption",
	        className: classes.caption
	      }, labelDisplayedRows({
	        from: count === 0 ? 0 : page * rowsPerPage + 1,
	        to: Math.min(count, (page + 1) * rowsPerPage),
	        count: count,
	        page: page
	      })), _react.default.createElement(ActionsComponent, {
	        className: classes.actions,
	        backIconButtonProps: backIconButtonProps,
	        count: count,
	        nextIconButtonProps: nextIconButtonProps,
	        onChangePage: onChangePage,
	        page: page,
	        rowsPerPage: rowsPerPage
	      })));
	    }
	  }]);
	  return TablePagination;
	}(_react.default.Component);
	
	TablePagination.propTypes =  false ? {
	  /**
	   * The component used for displaying the actions.
	   * Either a string to use a DOM element or a component.
	   */
	  ActionsComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Properties applied to the back arrow `IconButton` component.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  colSpan: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Useful to customize the displayed rows label.
	   */
	  labelDisplayedRows: _propTypes.default.func,
	
	  /**
	   * Useful to customize the rows per page label. Invoked with a `{ from, to, count, page }`
	   * object.
	   */
	  labelRowsPerPage: _propTypes.default.node,
	
	  /**
	   * Properties applied to the next arrow `IconButton` element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {number} page The page selected
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the number of rows per page is changed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onChangeRowsPerPage: _propTypes.default.func,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes.default.number.isRequired,
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired,
	
	  /**
	   * Customizes the options of the rows per page select field. If less than two options are
	   * available, no select field will be displayed.
	   */
	  rowsPerPageOptions: _propTypes.default.array,
	
	  /**
	   * Properties applied to the rows per page `Select` element.
	   */
	  SelectProps: _propTypes.default.object
	} : {};
	TablePagination.defaultProps = {
	  ActionsComponent: _TablePaginationActions.default,
	  component: _TableCell.default,
	  labelDisplayedRows: function labelDisplayedRows(_ref) {
	    var from = _ref.from,
	        to = _ref.to,
	        count = _ref.count;
	    return "".concat(from, "-").concat(to, " of ").concat(count);
	  },
	  labelRowsPerPage: 'Rows per page:',
	  rowsPerPageOptions: [5, 10, 25]
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTablePagination'
	})(TablePagination);
	
	exports.default = _default;

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(466));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(467));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(49));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(70));
	
	var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, null);
	
	var _ref3 = _react.default.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref4 = _react.default.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref5 = _react.default.createElement(_KeyboardArrowRight.default, null);
	
	/**
	 * @ignore - internal component.
	 */
	var TablePaginationActions =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(TablePaginationActions, _React$Component);
	
	  function TablePaginationActions() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, TablePaginationActions);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = TablePaginationActions.__proto__ || (0, _getPrototypeOf.default)(TablePaginationActions)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleBackButtonClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        _this.props.onChangePage(event, _this.props.page - 1);
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleNextButtonClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        _this.props.onChangePage(event, _this.props.page + 1);
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(TablePaginationActions, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          backIconButtonProps = _props.backIconButtonProps,
	          count = _props.count,
	          nextIconButtonProps = _props.nextIconButtonProps,
	          onChangePage = _props.onChangePage,
	          page = _props.page,
	          rowsPerPage = _props.rowsPerPage,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties2.default)(_props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage", "theme"]);
	      return _react.default.createElement("div", other, _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	        onClick: this.handleBackButtonClick,
	        disabled: page === 0
	      }, backIconButtonProps), theme.direction === 'rtl' ? _ref2 : _ref3), _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	        onClick: this.handleNextButtonClick,
	        disabled: page >= Math.ceil(count / rowsPerPage) - 1
	      }, nextIconButtonProps), theme.direction === 'rtl' ? _ref4 : _ref5));
	    }
	  }]);
	  return TablePaginationActions;
	}(_react.default.Component);
	
	TablePaginationActions.propTypes =  false ? {
	  /**
	   * Properties applied to the back arrow `IconButton` element.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Properties applied to the next arrow `IconButton` element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {number} page The page selected
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes.default.number.isRequired,
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired
	} : {};
	
	var _default = (0, _withTheme.default)()(TablePaginationActions);
	
	exports.default = _default;

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: 'inherit',
	      display: 'table-row',
	      height: 48,
	      verticalAlign: 'middle',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 'none',
	      '&$selected': {
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
	        : 'rgba(255, 255, 255, 0.08)'
	      },
	      '&$hover:hover': {
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
	        : 'rgba(255, 255, 255, 0.14)'
	      }
	    },
	    selected: {},
	    hover: {},
	    head: {
	      height: 56
	    },
	    footer: {
	      height: 56
	    }
	  };
	};
	/**
	 * Will automatically set dynamic row height
	 * based on the material table element parent (head, body, etc).
	 */
	
	
	exports.styles = styles;
	
	function TableRow(props, context) {
	  var _classNames;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      hover = props.hover,
	      selected = props.selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
	  var table = context.table;
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, table && table.head), (0, _defineProperty2.default)(_classNames, classes.footer, table && table.footer), (0, _defineProperty2.default)(_classNames, classes.hover, table && hover), (0, _defineProperty2.default)(_classNames, classes.selected, table && selected), _classNames), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other));
	}
	
	TableRow.propTypes =  false ? {
	  /**
	   * Should be valid <tr> children such as `TableCell`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, the table row will shade on hover.
	   */
	  hover: _propTypes.default.bool,
	
	  /**
	   * If `true`, the table row will have the selected shading.
	   */
	  selected: _propTypes.default.bool
	} : {};
	TableRow.defaultProps = {
	  component: 'tr',
	  hover: false,
	  selected: false
	};
	TableRow.contextTypes = {
	  table: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableRow'
	})(TableRow);
	
	exports.default = _default;

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _ArrowDownward = _interopRequireDefault(__webpack_require__(1117));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	var _helpers = __webpack_require__(22);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    root: {
	      cursor: 'pointer',
	      display: 'inline-flex',
	      justifyContent: 'flex-start',
	      flexDirection: 'inherit',
	      alignItems: 'center',
	      '&:hover': {
	        color: theme.palette.text.primary
	      },
	      '&:focus': {
	        color: theme.palette.text.primary
	      }
	    },
	    active: {
	      color: theme.palette.text.primary,
	      '& $icon': {
	        opacity: 1
	      }
	    },
	    icon: {
	      height: 16,
	      marginRight: 4,
	      marginLeft: 4,
	      opacity: 0,
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shorter
	      }),
	      userSelect: 'none',
	      width: 16
	    },
	    iconDirectionDesc: {
	      transform: 'rotate(0deg)'
	    },
	    iconDirectionAsc: {
	      transform: 'rotate(180deg)'
	    }
	  };
	};
	/**
	 * A button based label for placing inside `TableCell` for column sorting.
	 */
	
	
	exports.styles = styles;
	
	function TableSortLabel(props) {
	  var active = props.active,
	      classes = props.classes,
	      className = props.className,
	      children = props.children,
	      direction = props.direction,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "classes", "className", "children", "direction"]);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active), className),
	    component: "span",
	    disableRipple: true
	  }, other), children, _react.default.createElement(_ArrowDownward.default, {
	    className: (0, _classnames.default)(classes.icon, classes["iconDirection".concat((0, _helpers.capitalize)(direction))])
	  }));
	}
	
	TableSortLabel.propTypes =  false ? {
	  /**
	   * If `true`, the label will have the active styling (should be true for the sorted column).
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Label contents, the arrow will be appended automatically.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The current sort direction.
	   */
	  direction: _propTypes.default.oneOf(['asc', 'desc'])
	} : {};
	TableSortLabel.defaultProps = {
	  active: false,
	  direction: 'desc'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableSortLabel'
	})(TableSortLabel);
	
	exports.default = _default;

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	Object.defineProperty(exports, "TableHead", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	Object.defineProperty(exports, "TablePagination", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	Object.defineProperty(exports, "TableSortLabel", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	
	var _Table = _interopRequireDefault(__webpack_require__(1081));
	
	var _TableBody = _interopRequireDefault(__webpack_require__(1082));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(459));
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(1083));
	
	var _TableHead = _interopRequireDefault(__webpack_require__(1084));
	
	var _TablePagination = _interopRequireDefault(__webpack_require__(1085));
	
	var _TableRow = _interopRequireDefault(__webpack_require__(1087));
	
	var _TableSortLabel = _interopRequireDefault(__webpack_require__(1088));

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	var _helpers = __webpack_require__(22);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    root: (0, _objectSpread3.default)({}, theme.typography.button, (0, _defineProperty2.default)({
	      maxWidth: 264,
	      position: 'relative',
	      minWidth: 72,
	      padding: 0,
	      height: 48,
	      flex: 'none',
	      overflow: 'hidden'
	    }, theme.breakpoints.up('md'), {
	      minWidth: 160
	    })),
	    labelIcon: {
	      height: 72
	    },
	    textColorInherit: {
	      color: 'inherit',
	      opacity: 0.7,
	      '&$selected': {
	        opacity: 1
	      },
	      '&$disabled': {
	        opacity: 0.4
	      }
	    },
	    textColorPrimary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	    textColorSecondary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	    selected: {},
	    disabled: {},
	    fullWidth: {
	      flexGrow: 1
	    },
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	    labelContainer: (0, _defineProperty2.default)({
	      paddingTop: 6,
	      paddingBottom: 6,
	      paddingLeft: 12,
	      paddingRight: 12
	    }, theme.breakpoints.up('md'), {
	      paddingLeft: theme.spacing.unit * 3,
	      paddingRight: theme.spacing.unit * 3
	    }),
	    label: (0, _defineProperty2.default)({
	      fontSize: theme.typography.pxToRem(14),
	      whiteSpace: 'normal'
	    }, theme.breakpoints.up('md'), {
	      fontSize: theme.typography.pxToRem(13)
	    }),
	    labelWrapped: (0, _defineProperty2.default)({}, theme.breakpoints.down('sm'), {
	      fontSize: theme.typography.pxToRem(12)
	    })
	  };
	};
	
	exports.styles = styles;
	
	var Tab =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Tab, _React$Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Tab);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf.default)(Tab)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {
	        wrappedText: false
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var _this$props = _this.props,
	            onChange = _this$props.onChange,
	            value = _this$props.value,
	            onClick = _this$props.onClick;
	
	        if (onChange) {
	          onChange(event, value);
	        }
	
	        if (onClick) {
	          onClick(event);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "label", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "checkTextWrap", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.label) {
	          var wrappedText = _this.label.getClientRects().length > 1;
	
	          if (_this.state.wrappedText !== wrappedText) {
	            _this.setState({
	              wrappedText: wrappedText
	            });
	          }
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Tab, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.checkTextWrap();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.wrappedText === prevState.wrappedText) {
	        /**
	         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
	         * font size still only requires one line.  This check will prevent an infinite render loop
	         * fron occurring in that scenario.
	         */
	        this.checkTextWrap();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this,
	          _classNames2;
	
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          indicator = _props.indicator,
	          labelProp = _props.label,
	          onChange = _props.onChange,
	          selected = _props.selected,
	          textColor = _props.textColor,
	          value = _props.value,
	          other = (0, _objectWithoutProperties2.default)(_props, ["classes", "className", "disabled", "fullWidth", "icon", "indicator", "label", "onChange", "selected", "textColor", "value"]);
	      var label;
	
	      if (labelProp !== undefined) {
	        label = _react.default.createElement("span", {
	          className: classes.labelContainer
	        }, _react.default.createElement("span", {
	          className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.labelWrapped, this.state.wrappedText)),
	          ref: function ref(node) {
	            _this2.label = node;
	          }
	        }, labelProp));
	      }
	
	      var className = (0, _classnames.default)(classes.root, classes["textColor".concat((0, _helpers.capitalize)(textColor))], (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.labelIcon, icon && label), (0, _defineProperty2.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), classNameProp);
	      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	        focusRipple: true,
	        className: className,
	        role: "tab",
	        "aria-selected": selected,
	        disabled: disabled
	      }, other, {
	        onClick: this.handleChange
	      }), _react.default.createElement("span", {
	        className: classes.wrapper
	      }, icon, label), indicator);
	    }
	  }]);
	  return Tab;
	}(_react.default.Component);
	
	Tab.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the tab will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * For server side rendering consideration, we let the selected tab
	   * render the indicator.
	   */
	  indicator: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any
	} : {};
	Tab.defaultProps = {
	  disabled: false,
	  textColor: 'inherit'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTab'
	})(Tab);
	
	exports.default = _default;

/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _helpers = __webpack_require__(22);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      height: 2,
	      bottom: 0,
	      width: '100%',
	      transition: theme.transitions.create(),
	      willChange: 'left, width'
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	function TabIndicator(props) {
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
	  return _react.default.createElement("span", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], className)
	  }, other));
	}
	
	TabIndicator.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * The color of the tab indicator.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary'])
	} : {};
	
	var _default = (0, _withStyles.default)(styles)(TabIndicator);
	
	exports.default = _default;

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(466));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(467));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: 'inherit',
	      flex: "0 0 ".concat(theme.spacing.unit * 7, "px")
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	var _ref = _react.default.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, null);
	
	function TabScrollButton(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      direction = props.direction,
	      onClick = props.onClick,
	      visible = props.visible,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "onClick", "visible"]);
	  var className = (0, _classnames.default)(classes.root, classNameProp);
	
	  if (!visible) {
	    return _react.default.createElement("div", {
	      className: className
	    });
	  }
	
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: className,
	    onClick: onClick,
	    tabIndex: -1
	  }, other), direction === 'left' ? _ref : _ref2);
	}
	
	TabScrollButton.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Which direction should the button indicate?
	   */
	  direction: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Callback to execute for button press.
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Should the button be present or just consume space.
	   */
	  visible: _propTypes.default.bool
	} : {};
	TabScrollButton.defaultProps = {
	  visible: true
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabScrollButton'
	})(TabScrollButton);
	
	exports.default = _default;

/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _isNan = _interopRequireDefault(__webpack_require__(356));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _warning = _interopRequireDefault(__webpack_require__(20));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(31));
	
	var _debounce = _interopRequireDefault(__webpack_require__(56));
	
	var _reactScrollbarSize = _interopRequireDefault(__webpack_require__(1385));
	
	var _normalizeScrollLeft = __webpack_require__(1141);
	
	var _scroll = _interopRequireDefault(__webpack_require__(1405));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _TabIndicator = _interopRequireDefault(__webpack_require__(1091));
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(1092));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      overflow: 'hidden',
	      minHeight: 48,
	      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	    },
	    flexContainer: {
	      display: 'flex'
	    },
	    scroller: {
	      position: 'relative',
	      display: 'inline-block',
	      flex: '1 1 auto',
	      whiteSpace: 'nowrap'
	    },
	    fixed: {
	      overflowX: 'hidden',
	      width: '100%'
	    },
	    scrollable: {
	      overflowX: 'scroll'
	    },
	    centered: {
	      justifyContent: 'center'
	    },
	    scrollButtons: {},
	    scrollButtonsAuto: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
	      display: 'none'
	    }),
	    indicator: {}
	  };
	};
	
	exports.styles = styles;
	
	var Tabs =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf.default)(Tabs)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {
	        indicatorStyle: {},
	        scrollerStyle: {
	          marginBottom: 0
	        },
	        showLeftScroll: false,
	        showRightScroll: false,
	        mounted: false
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "getConditionalElements", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        var _this$props = _this.props,
	            classes = _this$props.classes,
	            scrollable = _this$props.scrollable,
	            ScrollButtonComponent = _this$props.ScrollButtonComponent,
	            scrollButtons = _this$props.scrollButtons,
	            theme = _this$props.theme;
	        var conditionalElements = {};
	        conditionalElements.scrollbarSizeListener = scrollable ? _react.default.createElement(_reactScrollbarSize.default, {
	          onLoad: _this.handleScrollbarSizeChange,
	          onChange: _this.handleScrollbarSizeChange
	        }) : null;
	        var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');
	        conditionalElements.scrollButtonLeft = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
	          direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
	          onClick: _this.handleLeftScrollClick,
	          visible: _this.state.showLeftScroll,
	          className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
	        }) : null;
	        conditionalElements.scrollButtonRight = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
	          direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
	          onClick: _this.handleRightScrollClick,
	          visible: _this.state.showRightScroll,
	          className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
	        }) : null;
	        return conditionalElements;
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "getTabsMeta", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(_value, direction) {
	        var tabsMeta;
	
	        if (_this.tabs) {
	          var rect = _this.tabs.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
	
	
	          tabsMeta = {
	            clientWidth: _this.tabs ? _this.tabs.clientWidth : 0,
	            scrollLeft: _this.tabs ? _this.tabs.scrollLeft : 0,
	            scrollLeftNormalized: _this.tabs ? (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, direction) : 0,
	            scrollWidth: _this.tabs ? _this.tabs.scrollWidth : 0,
	            left: rect.left,
	            right: rect.right
	          };
	        }
	
	        var tabMeta;
	
	        if (_this.tabs && _value !== false) {
	          var children = _this.tabs.children[0].children;
	
	          if (children.length > 0) {
	            var tab = children[_this.valueToIndex[_value]];
	             false ? (0, _warning.default)(tab, "Material-UI: the value provided `".concat(_value, "` is invalid")) : void 0;
	            tabMeta = tab ? tab.getBoundingClientRect() : null;
	          }
	        }
	
	        return {
	          tabsMeta: tabsMeta,
	          tabMeta: tabMeta
	        };
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "tabs", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "valueToIndex", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        _this.updateIndicatorState(_this.props);
	
	        _this.updateScrollButtonState();
	      }, 166)
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleLeftScrollClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.tabs) {
	          _this.moveTabsScroll(-_this.tabs.clientWidth);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleRightScrollClick", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        if (_this.tabs) {
	          _this.moveTabsScroll(_this.tabs.clientWidth);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleScrollbarSizeChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(_ref2) {
	        var scrollbarHeight = _ref2.scrollbarHeight;
	
	        _this.setState({
	          scrollerStyle: {
	            marginBottom: -scrollbarHeight
	          }
	        });
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleTabsScroll", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        _this.updateScrollButtonState();
	      }, 166)
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "moveTabsScroll", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(delta) {
	        var theme = _this.props.theme;
	
	        if (_this.tabs) {
	          var multiplier = theme.direction === 'rtl' ? -1 : 1;
	          var nextScrollLeft = _this.tabs.scrollLeft + delta * multiplier; // Fix for Edge
	
	          var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
	
	          _scroll.default.left(_this.tabs, invert * nextScrollLeft);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "scrollSelectedIntoView", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        var _this$props2 = _this.props,
	            theme = _this$props2.theme,
	            value = _this$props2.value;
	
	        var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
	            tabsMeta = _this$getTabsMeta.tabsMeta,
	            tabMeta = _this$getTabsMeta.tabMeta;
	
	        if (!tabMeta || !tabsMeta) {
	          return;
	        }
	
	        if (tabMeta.left < tabsMeta.left) {
	          // left side of button is out of view
	          var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);
	
	          _scroll.default.left(_this.tabs, nextScrollLeft);
	        } else if (tabMeta.right > tabsMeta.right) {
	          // right side of button is out of view
	          var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);
	
	          _scroll.default.left(_this.tabs, _nextScrollLeft);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "updateScrollButtonState", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        var _this$props3 = _this.props,
	            scrollable = _this$props3.scrollable,
	            scrollButtons = _this$props3.scrollButtons,
	            theme = _this$props3.theme;
	
	        if (_this.tabs && scrollable && scrollButtons !== 'off') {
	          var _this$tabs = _this.tabs,
	              scrollWidth = _this$tabs.scrollWidth,
	              clientWidth = _this$tabs.clientWidth;
	          var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, theme.direction);
	          var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;
	          var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;
	
	          if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
	            _this.setState({
	              showLeftScroll: showLeftScroll,
	              showRightScroll: showRightScroll
	            });
	          }
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Tabs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // eslint-disable-next-line react/no-did-mount-set-state
	      this.setState({
	        mounted: true
	      });
	      this.updateIndicatorState(this.props);
	      this.updateScrollButtonState();
	
	      if (this.props.action) {
	        this.props.action({
	          updateIndicator: this.handleResize
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.updateScrollButtonState(); // The index might have changed at the same time.
	      // We need to check again the right indicator position.
	
	      this.updateIndicatorState(this.props);
	
	      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
	        this.scrollSelectedIntoView();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleTabsScroll.cancel();
	    }
	  }, {
	    key: "updateIndicatorState",
	    value: function updateIndicatorState(props) {
	      var theme = props.theme,
	          value = props.value;
	
	      var _getTabsMeta = this.getTabsMeta(value, theme.direction),
	          tabsMeta = _getTabsMeta.tabsMeta,
	          tabMeta = _getTabsMeta.tabMeta;
	
	      var left = 0;
	
	      if (tabMeta && tabsMeta) {
	        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
	        left = tabMeta.left - tabsMeta.left + correction;
	      }
	
	      var indicatorStyle = {
	        left: left,
	        // May be wrong until the font is loaded.
	        width: tabMeta ? tabMeta.width : 0
	      };
	
	      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !(0, _isNan.default)(indicatorStyle.left) && !(0, _isNan.default)(indicatorStyle.width)) {
	        this.setState({
	          indicatorStyle: indicatorStyle
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames3,
	          _this2 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          centered = _props.centered,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          fullWidth = _props.fullWidth,
	          indicatorColor = _props.indicatorColor,
	          onChange = _props.onChange,
	          scrollable = _props.scrollable,
	          ScrollButtonComponent = _props.ScrollButtonComponent,
	          scrollButtons = _props.scrollButtons,
	          TabIndicatorProps = _props.TabIndicatorProps,
	          textColor = _props.textColor,
	          theme = _props.theme,
	          value = _props.value,
	          other = (0, _objectWithoutProperties2.default)(_props, ["action", "centered", "children", "classes", "className", "fullWidth", "indicatorColor", "onChange", "scrollable", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "theme", "value"]);
	       false ? (0, _warning.default)(!centered || !scrollable, 'Material-UI: you can not use the `centered={true}` and `scrollable={true}` properties ' + 'at the same time on a `Tabs` component.') : void 0;
	      var className = (0, _classnames.default)(classes.root, classNameProp);
	      var scrollerClassName = (0, _classnames.default)(classes.scroller, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.fixed, !scrollable), (0, _defineProperty2.default)(_classNames3, classes.scrollable, scrollable), _classNames3));
	      var flexContainerClassName = (0, _classnames.default)(classes.flexContainer, (0, _defineProperty2.default)({}, classes.centered, centered && !scrollable));
	
	      var indicator = _react.default.createElement(_TabIndicator.default, (0, _extends2.default)({
	        style: this.state.indicatorStyle,
	        className: classes.indicator,
	        color: indicatorColor
	      }, TabIndicatorProps));
	
	      this.valueToIndex = {};
	      var childIndex = 0;
	
	      var children = _react.default.Children.map(childrenProp, function (child) {
	        if (!_react.default.isValidElement(child)) {
	          return null;
	        }
	
	        var childValue = child.props.value === undefined ? childIndex : child.props.value;
	        _this2.valueToIndex[childValue] = childIndex;
	        var selected = childValue === value;
	        childIndex += 1;
	        return _react.default.cloneElement(child, {
	          fullWidth: fullWidth,
	          indicator: selected && !_this2.state.mounted && indicator,
	          selected: selected,
	          onChange: onChange,
	          textColor: textColor,
	          value: childValue
	        });
	      });
	
	      var conditionalElements = this.getConditionalElements();
	      return _react.default.createElement("div", (0, _extends2.default)({
	        className: className
	      }, other), _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }), conditionalElements.scrollbarSizeListener, _react.default.createElement("div", {
	        className: classes.flexContainer
	      }, conditionalElements.scrollButtonLeft, _react.default.createElement("div", {
	        className: scrollerClassName,
	        style: this.state.scrollerStyle,
	        ref: function ref(node) {
	          _this2.tabs = node;
	        },
	        role: "tablist",
	        onScroll: this.handleTabsScroll
	      }, _react.default.createElement("div", {
	        className: flexContainerClassName
	      }, children), this.state.mounted && indicator), conditionalElements.scrollButtonRight));
	    }
	  }]);
	  return Tabs;
	}(_react.default.Component);
	
	Tabs.propTypes =  false ? {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports `updateIndicator()` action.
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes.default.func,
	
	  /**
	   * If `true`, the tabs will be centered.
	   * This property is intended for large views.
	   */
	  centered: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the tabs will grow to use all the available space.
	   * This property is intended for small views, like on mobile.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determines the color of the indicator.
	   */
	  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {number} value We default to the index of the child
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * True invokes scrolling properties and allow for horizontally scrolling
	   * (or swiping) the tab bar.
	   */
	  scrollable: _propTypes.default.bool,
	
	  /**
	   * The component used to render the scroll buttons.
	   */
	  ScrollButtonComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Determine behavior of scroll buttons when tabs are set to scroll
	   * `auto` will only present them on medium and larger viewports
	   * `on` will always present them
	   * `off` will never present them
	   */
	  scrollButtons: _propTypes.default.oneOf(['auto', 'on', 'off']),
	
	  /**
	   * Properties applied to the `TabIndicator` element.
	   */
	  TabIndicatorProps: _propTypes.default.object,
	
	  /**
	   * Determines the color of the `Tab`.
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The value of the currently selected `Tab`.
	   * If you don't want any selected `Tab`, you can set this property to `false`.
	   */
	  value: _propTypes.default.any
	} : {};
	Tabs.defaultProps = {
	  centered: false,
	  fullWidth: false,
	  indicatorColor: 'secondary',
	  scrollable: false,
	  ScrollButtonComponent: _TabScrollButton.default,
	  scrollButtons: 'auto',
	  textColor: 'inherit'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabs',
	  withTheme: true
	})(Tabs);
	
	exports.default = _default;

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	
	var _Tabs = _interopRequireDefault(__webpack_require__(1093));
	
	var _Tab = _interopRequireDefault(__webpack_require__(1090));

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var styles = function styles(theme) {
	  return {
	    root: (0, _objectSpread2.default)({}, theme.mixins.toolbar, {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    }),
	    gutters: theme.mixins.gutters()
	  };
	};
	
	exports.styles = styles;
	
	function Toolbar(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableGutters = props.disableGutters,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Toolbar.propTypes =  false ? {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool
	} : {};
	Toolbar.defaultProps = {
	  disableGutters: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(1096));

/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(31));
	
	var _debounce = _interopRequireDefault(__webpack_require__(56));
	
	var _warning = _interopRequireDefault(__webpack_require__(20));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactPopper = __webpack_require__(1343);
	
	var _helpers = __webpack_require__(22);
	
	var _RootRef = _interopRequireDefault(__webpack_require__(465));
	
	var _Portal = _interopRequireDefault(__webpack_require__(318));
	
	var _common = _interopRequireDefault(__webpack_require__(319));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	/* eslint-disable react/no-multi-comp, no-underscore-dangle */
	var styles = function styles(theme) {
	  return {
	    // Will be gone once we drop React 15.x support.
	    root: {
	      display: 'inline-block',
	      flexDirection: 'inherit' // Makes the wrapper more transparent.
	
	    },
	    popper: {
	      zIndex: theme.zIndex.tooltip,
	      pointerEvents: 'none',
	      '&$open': {
	        pointerEvents: 'auto'
	      }
	    },
	    open: {},
	    tooltip: {
	      backgroundColor: theme.palette.grey[700],
	      borderRadius: 2,
	      color: _common.default.white,
	      fontFamily: theme.typography.fontFamily,
	      opacity: 0,
	      transform: 'scale(0)',
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shortest,
	        easing: theme.transitions.easing.easeIn
	      }),
	      minHeight: 0,
	      padding: "".concat(theme.spacing.unit / 2, "px ").concat(theme.spacing.unit, "px"),
	      fontSize: theme.typography.pxToRem(10),
	      lineHeight: "".concat(theme.typography.round(14 / 10), "em"),
	      '&$open': {
	        opacity: 0.9,
	        transform: 'scale(1)',
	        transition: theme.transitions.create(['opacity', 'transform'], {
	          duration: theme.transitions.duration.shortest,
	          easing: theme.transitions.easing.easeOut
	        })
	      }
	    },
	    touch: {
	      padding: "".concat(theme.spacing.unit, "px ").concat(theme.spacing.unit * 2, "px"),
	      fontSize: theme.typography.pxToRem(14),
	      lineHeight: "".concat(theme.typography.round(16 / 14), "em")
	    },
	    tooltipPlacementLeft: (0, _defineProperty2.default)({
	      transformOrigin: 'right center',
	      margin: "0 ".concat(theme.spacing.unit * 3, "px")
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	    tooltipPlacementRight: (0, _defineProperty2.default)({
	      transformOrigin: 'left center',
	      margin: "0 ".concat(theme.spacing.unit * 3, "px")
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	    tooltipPlacementTop: (0, _defineProperty2.default)({
	      transformOrigin: 'center bottom',
	      margin: "".concat(theme.spacing.unit * 3, "px 0")
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	    tooltipPlacementBottom: (0, _defineProperty2.default)({
	      transformOrigin: 'center top',
	      margin: "".concat(theme.spacing.unit * 3, "px 0")
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    })
	  };
	};
	
	exports.styles = styles;
	
	function flipPlacement(placement) {
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	
	    case 'bottom-start':
	      return 'bottom-end';
	
	    case 'top-end':
	      return 'top-start';
	
	    case 'top-start':
	      return 'top-end';
	
	    default:
	      return placement;
	  }
	}
	
	var Tooltip =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Tooltip, _React$Component);
	
	  function Tooltip(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Tooltip);
	    _this = (0, _possibleConstructorReturn2.default)(this, (Tooltip.__proto__ || (0, _getPrototypeOf.default)(Tooltip)).call(this, props, context));
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "enterTimer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "leaveTimer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "touchTimer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "closeTimer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isControlled", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "popper", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "children", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "ignoreNonTouchEvents", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        if (_this.popper) {
	          _this.popper._popper.scheduleUpdate();
	        }
	      }, 166)
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var _this$props = _this.props,
	            children = _this$props.children,
	            enterDelay = _this$props.enterDelay;
	        var childrenProps = children.props;
	
	        if (event.type === 'focus' && childrenProps.onFocus) {
	          childrenProps.onFocus(event);
	        }
	
	        if (event.type === 'mouseover' && childrenProps.onMouseOver) {
	          childrenProps.onMouseOver(event);
	        }
	
	        if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
	          return;
	        }
	
	        clearTimeout(_this.enterTimer);
	        clearTimeout(_this.leaveTimer);
	
	        if (enterDelay) {
	          event.persist();
	          _this.enterTimer = setTimeout(function () {
	            _this.handleOpen(event);
	          }, enterDelay);
	        } else {
	          _this.handleOpen(event);
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleOpen", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (!_this.isControlled) {
	          _this.setState({
	            open: true
	          });
	        }
	
	        if (_this.props.onOpen) {
	          _this.props.onOpen(event, true);
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleLeave", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var _this$props2 = _this.props,
	            children = _this$props2.children,
	            leaveDelay = _this$props2.leaveDelay;
	        var childrenProps = children.props;
	
	        if (event.type === 'blur' && childrenProps.onBlur) {
	          childrenProps.onBlur(event);
	        }
	
	        if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
	          childrenProps.onMouseLeave(event);
	        }
	
	        clearTimeout(_this.enterTimer);
	        clearTimeout(_this.leaveTimer);
	
	        if (leaveDelay) {
	          event.persist();
	          _this.leaveTimer = setTimeout(function () {
	            _this.handleClose(event);
	          }, leaveDelay);
	        } else {
	          _this.handleClose(event);
	        }
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClose", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        if (!_this.isControlled) {
	          _this.setState({
	            open: false
	          });
	        }
	
	        if (_this.props.onClose) {
	          _this.props.onClose(event, false);
	        }
	
	        clearTimeout(_this.closeTimer);
	        _this.closeTimer = setTimeout(function () {
	          _this.ignoreNonTouchEvents = false;
	        }, _this.props.theme.transitions.duration.shortest);
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleTouchStart", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        _this.ignoreNonTouchEvents = true;
	        var _this$props3 = _this.props,
	            children = _this$props3.children,
	            enterTouchDelay = _this$props3.enterTouchDelay;
	        var childrenProps = children.props;
	
	        if (childrenProps.onTouchStart) {
	          childrenProps.onTouchStart(event);
	        }
	
	        clearTimeout(_this.leaveTimer);
	        clearTimeout(_this.closeTimer);
	        clearTimeout(_this.touchTimer);
	        event.persist();
	        _this.touchTimer = setTimeout(function () {
	          _this.handleEnter(event);
	        }, enterTouchDelay);
	      }
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleTouchEnd", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var _this$props4 = _this.props,
	            children = _this$props4.children,
	            leaveTouchDelay = _this$props4.leaveTouchDelay;
	        var childrenProps = children.props;
	
	        if (childrenProps.onTouchEnd) {
	          childrenProps.onTouchEnd(event);
	        }
	
	        clearTimeout(_this.touchTimer);
	        clearTimeout(_this.leaveTimer);
	        event.persist();
	        _this.leaveTimer = setTimeout(function () {
	          _this.handleClose(event);
	        }, leaveTouchDelay);
	      }
	    });
	    _this.isControlled = props.open != null;
	
	    if (!_this.isControlled) {
	      // not controlled, use internal state
	      _this.state.open = false;
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Tooltip, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	       false ? (0, _warning.default)(!this.children || !this.children.disabled || !this.children.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n')) : void 0;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	      clearTimeout(this.touchTimer);
	      clearTimeout(this.closeTimer);
	      this.handleResize.cancel();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          disableFocusListener = _props.disableFocusListener,
	          disableHoverListener = _props.disableHoverListener,
	          disableTouchListener = _props.disableTouchListener,
	          enterDelay = _props.enterDelay,
	          enterTouchDelay = _props.enterTouchDelay,
	          id = _props.id,
	          leaveDelay = _props.leaveDelay,
	          leaveTouchDelay = _props.leaveTouchDelay,
	          onClose = _props.onClose,
	          onOpen = _props.onOpen,
	          openProp = _props.open,
	          placementProp = _props.placement,
	          _props$PopperProps = _props.PopperProps;
	      _props$PopperProps = _props$PopperProps === void 0 ? {} : _props$PopperProps;
	      var PopperClassName = _props$PopperProps.className,
	          PopperProps = (0, _objectWithoutProperties2.default)(_props$PopperProps, ["className"]),
	          theme = _props.theme,
	          title = _props.title,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "theme", "title"]);
	      var placement = theme.direction === 'rtl' ? flipPlacement(placementProp) : placementProp;
	      var open = this.isControlled ? openProp : this.state.open;
	      var childrenProps = {
	        'aria-describedby': id
	      }; // There is no point at displaying an empty tooltip.
	
	      if (title === '') {
	        open = false;
	      }
	
	      if (!disableTouchListener) {
	        childrenProps.onTouchStart = this.handleTouchStart;
	        childrenProps.onTouchEnd = this.handleTouchEnd;
	      }
	
	      if (!disableHoverListener) {
	        childrenProps.onMouseOver = this.handleEnter;
	        childrenProps.onMouseLeave = this.handleLeave;
	      }
	
	      if (!disableFocusListener) {
	        childrenProps.onFocus = this.handleEnter;
	        childrenProps.onBlur = this.handleLeave;
	      }
	
	       false ? (0, _warning.default)(!children.props.title, ['Material-UI: you have been providing a `title` property to the child of <Tooltip />.', "Remove this title property `".concat(children.props.title, "` or the Tooltip component.")].join('\n')) : void 0;
	      return _react.default.createElement(_reactPopper.Manager, (0, _extends2.default)({
	        tag: _reactDom.default.createPortal ? false : 'div',
	        className: (0, _classnames.default)(classes.root, className)
	      }, other), _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }), _react.default.createElement(_reactPopper.Target, null, function (_ref) {
	        var targetProps = _ref.targetProps;
	        return _react.default.createElement(_RootRef.default, {
	          rootRef: function rootRef(node) {
	            _this2.children = node;
	            targetProps.ref(_this2.children);
	          }
	        }, _react.default.cloneElement(children, childrenProps));
	      }), _react.default.createElement(_Portal.default, null, _react.default.createElement(_reactPopper.Popper, (0, _extends2.default)({
	        placement: placement,
	        eventsEnabled: open,
	        className: (0, _classnames.default)(classes.popper, (0, _defineProperty2.default)({}, classes.open, open), PopperClassName),
	        ref: function ref(node) {
	          _this2.popper = node;
	        }
	      }, PopperProps), function (_ref2) {
	        var popperProps = _ref2.popperProps,
	            restProps = _ref2.restProps;
	        var actualPlacement = (popperProps['data-placement'] || placement).split('-')[0];
	        return _react.default.createElement("div", (0, _extends2.default)({}, popperProps, restProps, {
	          style: (0, _objectSpread2.default)({}, popperProps.style, {
	            top: popperProps.style.top || 0,
	            left: popperProps.style.left || 0
	          }, restProps.style)
	        }), _react.default.createElement("div", {
	          id: id,
	          role: "tooltip",
	          "aria-hidden": !open,
	          className: (0, _classnames.default)(classes.tooltip, (0, _defineProperty2.default)({}, classes.open, open), (0, _defineProperty2.default)({}, classes.touch, _this2.ignoreNonTouchEvents), classes["tooltipPlacement".concat((0, _helpers.capitalize)(actualPlacement))])
	        }, title));
	      })));
	    }
	  }]);
	  return Tooltip;
	}(_react.default.Component);
	
	Tooltip.propTypes =  false ? {
	  /**
	   * Tooltip reference element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Do not respond to focus events.
	   */
	  disableFocusListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to hover events.
	   */
	  disableHoverListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to long press touch events.
	   */
	  disableTouchListener: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip.
	   * This property won't impact the enter touch delay (`enterTouchDelay`).
	   */
	  enterDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds a user must touch the element before showing the tooltip.
	   */
	  enterTouchDelay: _propTypes.default.number,
	
	  /**
	   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
	   * By providing this property, we can use aria-describedby to solve the accessibility issue.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The number of milliseconds to wait before hiding the tooltip.
	   * This property won't impact the leave touch delay (`leaveTouchDelay`).
	   */
	  leaveDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
	   */
	  leaveTouchDelay: _propTypes.default.number,
	
	  /**
	   * Callback fired when the tooltip requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the tooltip requests to be open.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * If `true`, the tooltip is shown.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Tooltip placement
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Properties applied to the `Popper` element.
	   */
	  PopperProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * Tooltip title. Zero-length titles string are never displayed.
	   */
	  title: _propTypes.default.node.isRequired
	} : {};
	Tooltip.defaultProps = {
	  disableFocusListener: false,
	  disableHoverListener: false,
	  disableTouchListener: false,
	  enterDelay: 0,
	  enterTouchDelay: 1000,
	  leaveDelay: 0,
	  leaveTouchDelay: 1500,
	  placement: 'bottom'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTooltip',
	  withTheme: true
	})(Tooltip);
	
	exports.default = _default;

/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(1097));

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var amber = {
	  50: '#fff8e1',
	  100: '#ffecb3',
	  200: '#ffe082',
	  300: '#ffd54f',
	  400: '#ffca28',
	  500: '#ffc107',
	  600: '#ffb300',
	  700: '#ffa000',
	  800: '#ff8f00',
	  900: '#ff6f00',
	  A100: '#ffe57f',
	  A200: '#ffd740',
	  A400: '#ffc400',
	  A700: '#ffab00'
	};
	var _default = amber;
	exports.default = _default;

/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blueGrey = {
	  50: '#eceff1',
	  100: '#cfd8dc',
	  200: '#b0bec5',
	  300: '#90a4ae',
	  400: '#78909c',
	  500: '#607d8b',
	  600: '#546e7a',
	  700: '#455a64',
	  800: '#37474f',
	  900: '#263238',
	  A100: '#cfd8dc',
	  A200: '#b0bec5',
	  A400: '#78909c',
	  A700: '#455a64'
	};
	var _default = blueGrey;
	exports.default = _default;

/***/ }),

/***/ 1103:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var brown = {
	  50: '#efebe9',
	  100: '#d7ccc8',
	  200: '#bcaaa4',
	  300: '#a1887f',
	  400: '#8d6e63',
	  500: '#795548',
	  600: '#6d4c41',
	  700: '#5d4037',
	  800: '#4e342e',
	  900: '#3e2723',
	  A100: '#d7ccc8',
	  A200: '#bcaaa4',
	  A400: '#8d6e63',
	  A700: '#5d4037'
	};
	var _default = brown;
	exports.default = _default;

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var cyan = {
	  50: '#e0f7fa',
	  100: '#b2ebf2',
	  200: '#80deea',
	  300: '#4dd0e1',
	  400: '#26c6da',
	  500: '#00bcd4',
	  600: '#00acc1',
	  700: '#0097a7',
	  800: '#00838f',
	  900: '#006064',
	  A100: '#84ffff',
	  A200: '#18ffff',
	  A400: '#00e5ff',
	  A700: '#00b8d4'
	};
	var _default = cyan;
	exports.default = _default;

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepOrange = {
	  50: '#fbe9e7',
	  100: '#ffccbc',
	  200: '#ffab91',
	  300: '#ff8a65',
	  400: '#ff7043',
	  500: '#ff5722',
	  600: '#f4511e',
	  700: '#e64a19',
	  800: '#d84315',
	  900: '#bf360c',
	  A100: '#ff9e80',
	  A200: '#ff6e40',
	  A400: '#ff3d00',
	  A700: '#dd2c00'
	};
	var _default = deepOrange;
	exports.default = _default;

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepPurple = {
	  50: '#ede7f6',
	  100: '#d1c4e9',
	  200: '#b39ddb',
	  300: '#9575cd',
	  400: '#7e57c2',
	  500: '#673ab7',
	  600: '#5e35b1',
	  700: '#512da8',
	  800: '#4527a0',
	  900: '#311b92',
	  A100: '#b388ff',
	  A200: '#7c4dff',
	  A400: '#651fff',
	  A700: '#6200ea'
	};
	var _default = deepPurple;
	exports.default = _default;

/***/ }),

/***/ 1107:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "common", {
	  enumerable: true,
	  get: function get() {
	    return _common.default;
	  }
	});
	Object.defineProperty(exports, "red", {
	  enumerable: true,
	  get: function get() {
	    return _red.default;
	  }
	});
	Object.defineProperty(exports, "pink", {
	  enumerable: true,
	  get: function get() {
	    return _pink.default;
	  }
	});
	Object.defineProperty(exports, "purple", {
	  enumerable: true,
	  get: function get() {
	    return _purple.default;
	  }
	});
	Object.defineProperty(exports, "deepPurple", {
	  enumerable: true,
	  get: function get() {
	    return _deepPurple.default;
	  }
	});
	Object.defineProperty(exports, "indigo", {
	  enumerable: true,
	  get: function get() {
	    return _indigo.default;
	  }
	});
	Object.defineProperty(exports, "blue", {
	  enumerable: true,
	  get: function get() {
	    return _blue.default;
	  }
	});
	Object.defineProperty(exports, "lightBlue", {
	  enumerable: true,
	  get: function get() {
	    return _lightBlue.default;
	  }
	});
	Object.defineProperty(exports, "cyan", {
	  enumerable: true,
	  get: function get() {
	    return _cyan.default;
	  }
	});
	Object.defineProperty(exports, "teal", {
	  enumerable: true,
	  get: function get() {
	    return _teal.default;
	  }
	});
	Object.defineProperty(exports, "green", {
	  enumerable: true,
	  get: function get() {
	    return _green.default;
	  }
	});
	Object.defineProperty(exports, "lightGreen", {
	  enumerable: true,
	  get: function get() {
	    return _lightGreen.default;
	  }
	});
	Object.defineProperty(exports, "lime", {
	  enumerable: true,
	  get: function get() {
	    return _lime.default;
	  }
	});
	Object.defineProperty(exports, "yellow", {
	  enumerable: true,
	  get: function get() {
	    return _yellow.default;
	  }
	});
	Object.defineProperty(exports, "amber", {
	  enumerable: true,
	  get: function get() {
	    return _amber.default;
	  }
	});
	Object.defineProperty(exports, "orange", {
	  enumerable: true,
	  get: function get() {
	    return _orange.default;
	  }
	});
	Object.defineProperty(exports, "deepOrange", {
	  enumerable: true,
	  get: function get() {
	    return _deepOrange.default;
	  }
	});
	Object.defineProperty(exports, "brown", {
	  enumerable: true,
	  get: function get() {
	    return _brown.default;
	  }
	});
	Object.defineProperty(exports, "grey", {
	  enumerable: true,
	  get: function get() {
	    return _grey.default;
	  }
	});
	Object.defineProperty(exports, "blueGrey", {
	  enumerable: true,
	  get: function get() {
	    return _blueGrey.default;
	  }
	});
	
	var _common = _interopRequireDefault(__webpack_require__(319));
	
	var _red = _interopRequireDefault(__webpack_require__(464));
	
	var _pink = _interopRequireDefault(__webpack_require__(463));
	
	var _purple = _interopRequireDefault(__webpack_require__(1113));
	
	var _deepPurple = _interopRequireDefault(__webpack_require__(1106));
	
	var _indigo = _interopRequireDefault(__webpack_require__(462));
	
	var _blue = _interopRequireDefault(__webpack_require__(1101));
	
	var _lightBlue = _interopRequireDefault(__webpack_require__(1109));
	
	var _cyan = _interopRequireDefault(__webpack_require__(1104));
	
	var _teal = _interopRequireDefault(__webpack_require__(1114));
	
	var _green = _interopRequireDefault(__webpack_require__(1107));
	
	var _lightGreen = _interopRequireDefault(__webpack_require__(1110));
	
	var _lime = _interopRequireDefault(__webpack_require__(1111));
	
	var _yellow = _interopRequireDefault(__webpack_require__(1115));
	
	var _amber = _interopRequireDefault(__webpack_require__(1100));
	
	var _orange = _interopRequireDefault(__webpack_require__(1112));
	
	var _deepOrange = _interopRequireDefault(__webpack_require__(1105));
	
	var _brown = _interopRequireDefault(__webpack_require__(1103));
	
	var _grey = _interopRequireDefault(__webpack_require__(461));
	
	var _blueGrey = _interopRequireDefault(__webpack_require__(1102));

/***/ }),

/***/ 1109:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightBlue = {
	  50: '#e1f5fe',
	  100: '#b3e5fc',
	  200: '#81d4fa',
	  300: '#4fc3f7',
	  400: '#29b6f6',
	  500: '#03a9f4',
	  600: '#039be5',
	  700: '#0288d1',
	  800: '#0277bd',
	  900: '#01579b',
	  A100: '#80d8ff',
	  A200: '#40c4ff',
	  A400: '#00b0ff',
	  A700: '#0091ea'
	};
	var _default = lightBlue;
	exports.default = _default;

/***/ }),

/***/ 1110:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightGreen = {
	  50: '#f1f8e9',
	  100: '#dcedc8',
	  200: '#c5e1a5',
	  300: '#aed581',
	  400: '#9ccc65',
	  500: '#8bc34a',
	  600: '#7cb342',
	  700: '#689f38',
	  800: '#558b2f',
	  900: '#33691e',
	  A100: '#ccff90',
	  A200: '#b2ff59',
	  A400: '#76ff03',
	  A700: '#64dd17'
	};
	var _default = lightGreen;
	exports.default = _default;

/***/ }),

/***/ 1111:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lime = {
	  50: '#f9fbe7',
	  100: '#f0f4c3',
	  200: '#e6ee9c',
	  300: '#dce775',
	  400: '#d4e157',
	  500: '#cddc39',
	  600: '#c0ca33',
	  700: '#afb42b',
	  800: '#9e9d24',
	  900: '#827717',
	  A100: '#f4ff81',
	  A200: '#eeff41',
	  A400: '#c6ff00',
	  A700: '#aeea00'
	};
	var _default = lime;
	exports.default = _default;

/***/ }),

/***/ 1112:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ }),

/***/ 1113:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var purple = {
	  50: '#f3e5f5',
	  100: '#e1bee7',
	  200: '#ce93d8',
	  300: '#ba68c8',
	  400: '#ab47bc',
	  500: '#9c27b0',
	  600: '#8e24aa',
	  700: '#7b1fa2',
	  800: '#6a1b9a',
	  900: '#4a148c',
	  A100: '#ea80fc',
	  A200: '#e040fb',
	  A400: '#d500f9',
	  A700: '#aa00ff'
	};
	var _default = purple;
	exports.default = _default;

/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var teal = {
	  50: '#e0f2f1',
	  100: '#b2dfdb',
	  200: '#80cbc4',
	  300: '#4db6ac',
	  400: '#26a69a',
	  500: '#009688',
	  600: '#00897b',
	  700: '#00796b',
	  800: '#00695c',
	  900: '#004d40',
	  A100: '#a7ffeb',
	  A200: '#64ffda',
	  A400: '#1de9b6',
	  A700: '#00bfa5'
	};
	var _default = teal;
	exports.default = _default;

/***/ }),

/***/ 1115:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var yellow = {
	  50: '#fffde7',
	  100: '#fff9c4',
	  200: '#fff59d',
	  300: '#fff176',
	  400: '#ffee58',
	  500: '#ffeb3b',
	  600: '#fdd835',
	  700: '#fbc02d',
	  800: '#f9a825',
	  900: '#f57f17',
	  A100: '#ffff8d',
	  A200: '#ffff00',
	  A400: '#ffea00',
	  A700: '#ffd600'
	};
	var _default = yellow;
	exports.default = _default;

/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

	/** @license Material-UI v1.0.0-beta.47
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(76);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "AppBar", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigation", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigationAction", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.BottomNavigationAction;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	Object.defineProperty(exports, "ButtonBase", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardActions", {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardActions;
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardContent;
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardHeader;
	  }
	});
	Object.defineProperty(exports, "CardMedia", {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardMedia;
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	Object.defineProperty(exports, "Chip", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	Object.defineProperty(exports, "ClickAwayListener", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	Object.defineProperty(exports, "CssBaseline", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	Object.defineProperty(exports, "Dialog", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	Object.defineProperty(exports, "DialogActions", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogActions;
	  }
	});
	Object.defineProperty(exports, "DialogContent", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogContent;
	  }
	});
	Object.defineProperty(exports, "DialogContentText", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogContentText;
	  }
	});
	Object.defineProperty(exports, "DialogTitle", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogTitle;
	  }
	});
	Object.defineProperty(exports, "withMobileDialog", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.withMobileDialog;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanel", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelActions", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.ExpansionPanelActions;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelDetails", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.ExpansionPanelDetails;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelSummary", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.ExpansionPanelSummary;
	  }
	});
	Object.defineProperty(exports, "FormControl", {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormControl;
	  }
	});
	Object.defineProperty(exports, "FormGroup", {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormGroup;
	  }
	});
	Object.defineProperty(exports, "FormLabel", {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormLabel;
	  }
	});
	Object.defineProperty(exports, "FormHelperText", {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormHelperText;
	  }
	});
	Object.defineProperty(exports, "FormControlLabel", {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormControlLabel;
	  }
	});
	Object.defineProperty(exports, "Hidden", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "IconButton", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	Object.defineProperty(exports, "InputLabel", {
	  enumerable: true,
	  get: function get() {
	    return _Input.InputLabel;
	  }
	});
	Object.defineProperty(exports, "InputAdornment", {
	  enumerable: true,
	  get: function get() {
	    return _Input.InputAdornment;
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	Object.defineProperty(exports, "GridList", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	Object.defineProperty(exports, "GridListTile", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.GridListTile;
	  }
	});
	Object.defineProperty(exports, "GridListTileBar", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.GridListTileBar;
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItem;
	  }
	});
	Object.defineProperty(exports, "ListItemAvatar", {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemAvatar;
	  }
	});
	Object.defineProperty(exports, "ListItemIcon", {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemIcon;
	  }
	});
	Object.defineProperty(exports, "ListItemSecondaryAction", {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemSecondaryAction;
	  }
	});
	Object.defineProperty(exports, "ListItemText", {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemText;
	  }
	});
	Object.defineProperty(exports, "ListSubheader", {
	  enumerable: true,
	  get: function get() {
	    return _List.ListSubheader;
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.MenuItem;
	  }
	});
	Object.defineProperty(exports, "MenuList", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.MenuList;
	  }
	});
	Object.defineProperty(exports, "MobileStepper", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "Backdrop", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.Backdrop;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.ModalManager;
	  }
	});
	Object.defineProperty(exports, "Paper", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	Object.defineProperty(exports, "CircularProgress", {
	  enumerable: true,
	  get: function get() {
	    return _Progress.CircularProgress;
	  }
	});
	Object.defineProperty(exports, "LinearProgress", {
	  enumerable: true,
	  get: function get() {
	    return _Progress.LinearProgress;
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.RadioGroup;
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Snackbar", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	Object.defineProperty(exports, "SnackbarContent", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.SnackbarContent;
	  }
	});
	Object.defineProperty(exports, "Stepper", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.Step;
	  }
	});
	Object.defineProperty(exports, "StepButton", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepButton;
	  }
	});
	Object.defineProperty(exports, "StepIcon", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepIcon;
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepContent;
	  }
	});
	Object.defineProperty(exports, "StepLabel", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepLabel;
	  }
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createGenerateClassName;
	  }
	});
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createMuiTheme;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.MuiThemeProvider;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _styles.withStyles;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _styles.withTheme;
	  }
	});
	Object.defineProperty(exports, "SvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "SwipeableDrawer", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableBody;
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableCell;
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableFooter;
	  }
	});
	Object.defineProperty(exports, "TableHead", {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableHead;
	  }
	});
	Object.defineProperty(exports, "TablePagination", {
	  enumerable: true,
	  get: function get() {
	    return _Table.TablePagination;
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableRow;
	  }
	});
	Object.defineProperty(exports, "TableSortLabel", {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableSortLabel;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.Tab;
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	Object.defineProperty(exports, "TextField", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	Object.defineProperty(exports, "Toolbar", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Slide;
	  }
	});
	Object.defineProperty(exports, "Grow", {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Grow;
	  }
	});
	Object.defineProperty(exports, "Fade", {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Fade;
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Collapse;
	  }
	});
	Object.defineProperty(exports, "Zoom", {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Zoom;
	  }
	});
	Object.defineProperty(exports, "withWidth", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	exports.colors = void 0;
	
	var _AppBar = _interopRequireDefault(__webpack_require__(1010));
	
	var _Avatar = _interopRequireDefault(__webpack_require__(446));
	
	var _Badge = _interopRequireDefault(__webpack_require__(1012));
	
	var _BottomNavigation = _interopRequireWildcard(__webpack_require__(1015));
	
	var _Button = _interopRequireDefault(__webpack_require__(38));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(57));
	
	var _Card = _interopRequireWildcard(__webpack_require__(312));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(314));
	
	var _Chip = _interopRequireDefault(__webpack_require__(1022));
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(108));
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(1024));
	
	var _Dialog = _interopRequireWildcard(__webpack_require__(134));
	
	var _Divider = _interopRequireDefault(__webpack_require__(105));
	
	var _Drawer = _interopRequireDefault(__webpack_require__(1026));
	
	var _ExpansionPanel = _interopRequireWildcard(__webpack_require__(1031));
	
	var _Form = __webpack_require__(450);
	
	var _Hidden = _interopRequireDefault(__webpack_require__(451));
	
	var _Icon = _interopRequireDefault(__webpack_require__(160));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(70));
	
	var _Input = _interopRequireWildcard(__webpack_require__(178));
	
	var _Grid = _interopRequireDefault(__webpack_require__(1035));
	
	var _GridList = _interopRequireWildcard(__webpack_require__(1039));
	
	var _List = _interopRequireWildcard(__webpack_require__(317));
	
	var _Menu = _interopRequireWildcard(__webpack_require__(92));
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(1054));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(138));
	
	var _Paper = _interopRequireDefault(__webpack_require__(29));
	
	var _Popover = _interopRequireDefault(__webpack_require__(454));
	
	var _Portal = _interopRequireDefault(__webpack_require__(318));
	
	var _Progress = __webpack_require__(85);
	
	var _Radio = _interopRequireWildcard(__webpack_require__(1066));
	
	var _Select = _interopRequireDefault(__webpack_require__(456));
	
	var _Snackbar = _interopRequireWildcard(__webpack_require__(140));
	
	var _Stepper = _interopRequireWildcard(__webpack_require__(1074));
	
	var _styles = __webpack_require__(44);
	
	var colors = _interopRequireWildcard(__webpack_require__(1108));
	
	exports.colors = colors;
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(1078));
	
	var _Switch = _interopRequireDefault(__webpack_require__(1080));
	
	var _Table = _interopRequireWildcard(__webpack_require__(1089));
	
	var _Tabs = _interopRequireWildcard(__webpack_require__(1094));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _TextField = _interopRequireDefault(__webpack_require__(93));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(460));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(1098));
	
	var _transitions = __webpack_require__(1137);
	
	var _withWidth = _interopRequireDefault(__webpack_require__(96));

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(70));
	
	// @inheritedComponent IconButton
	var styles = {
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    transition: 'none',
	    '&:hover': {
	      // Disable the hover effect for the IconButton.
	      backgroundColor: 'transparent'
	    }
	  },
	  checked: {},
	  disabled: {},
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0
	  }
	};
	exports.styles = styles;
	
	var SwitchBase =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(SwitchBase, _React$Component);
	
	  function SwitchBase(props, context) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, SwitchBase);
	    _this = (0, _possibleConstructorReturn2.default)(this, (SwitchBase.__proto__ || (0, _getPrototypeOf.default)(SwitchBase)).call(this, props, context));
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: {}
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "input", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "isControlled", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    });
	    Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleInputChange", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        var checked = event.target.checked;
	
	        if (!_this.isControlled) {
	          _this.setState({
	            checked: checked
	          });
	        }
	
	        if (_this.props.onChange) {
	          _this.props.onChange(event, checked);
	        }
	      }
	    });
	    _this.isControlled = props.checked != null;
	
	    if (!_this.isControlled) {
	      // not controlled, use internal state
	      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
	    }
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(SwitchBase, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          checkedProp = _props.checked,
	          checkedIcon = _props.checkedIcon,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          disabledProp = _props.disabled,
	          icon = _props.icon,
	          id = _props.id,
	          inputProps = _props.inputProps,
	          inputRef = _props.inputRef,
	          name = _props.name,
	          onChange = _props.onChange,
	          tabIndex = _props.tabIndex,
	          type = _props.type,
	          value = _props.value,
	          other = (0, _objectWithoutProperties2.default)(_props, ["checked", "checkedIcon", "classes", "className", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onChange", "tabIndex", "type", "value"]);
	      var muiFormControl = this.context.muiFormControl;
	      var disabled = disabledProp;
	
	      if (muiFormControl) {
	        if (typeof disabled === 'undefined') {
	          disabled = muiFormControl.disabled;
	        }
	      }
	
	      var checked = this.isControlled ? checkedProp : this.state.checked;
	      var hasLabelFor = type === 'checkbox' || type === 'radio';
	      return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
	        component: "span",
	        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.checked, checked), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp),
	        disabled: disabled,
	        tabIndex: null,
	        role: undefined
	      }, other), checked ? checkedIcon : icon, _react.default.createElement("input", (0, _extends2.default)({
	        id: hasLabelFor && id,
	        type: type,
	        name: name,
	        checked: checked,
	        onChange: this.handleInputChange,
	        className: classes.input,
	        disabled: disabled,
	        tabIndex: tabIndex,
	        value: value,
	        ref: inputRef
	      }, inputProps)));
	    }
	  }]);
	  return SwitchBase;
	}(_react.default.Component); // NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	
	SwitchBase.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node.isRequired,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node.isRequired,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes.default.func,
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.checked`.
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The input component property `type`.
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.string
	} : {};
	SwitchBase.defaultProps = {
	  type: 'checkbox'
	};
	SwitchBase.contextTypes = {
	  muiFormControl: _propTypes.default.object
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitchBase'
	})(SwitchBase);
	
	exports.default = _default;

/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var ArrowDownward = function ArrowDownward(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	ArrowDownward = (0, _pure.default)(ArrowDownward);
	ArrowDownward.muiName = 'SvgIcon';
	var _default = ArrowDownward;
	exports.default = _default;

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var Cancel = function Cancel(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	Cancel = (0, _pure.default)(Cancel);
	Cancel.muiName = 'SvgIcon';
	var _default = Cancel;
	exports.default = _default;

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var CheckBox = function CheckBox(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	CheckBox = (0, _pure.default)(CheckBox);
	CheckBox.muiName = 'SvgIcon';
	var _default = CheckBox;
	exports.default = _default;

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	CheckBoxOutlineBlank = (0, _pure.default)(CheckBoxOutlineBlank);
	CheckBoxOutlineBlank.muiName = 'SvgIcon';
	var _default = CheckBoxOutlineBlank;
	exports.default = _default;

/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var CheckCircle = function CheckCircle(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	CheckCircle = (0, _pure.default)(CheckCircle);
	CheckCircle.muiName = 'SvgIcon';
	var _default = CheckCircle;
	exports.default = _default;

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	IndeterminateCheckBox = (0, _pure.default)(IndeterminateCheckBox);
	IndeterminateCheckBox.muiName = 'SvgIcon';
	var _default = IndeterminateCheckBox;
	exports.default = _default;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	KeyboardArrowLeft = (0, _pure.default)(KeyboardArrowLeft);
	KeyboardArrowLeft.muiName = 'SvgIcon';
	var _default = KeyboardArrowLeft;
	exports.default = _default;

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var KeyboardArrowRight = function KeyboardArrowRight(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	KeyboardArrowRight = (0, _pure.default)(KeyboardArrowRight);
	KeyboardArrowRight.muiName = 'SvgIcon';
	var _default = KeyboardArrowRight;
	exports.default = _default;

/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var RadioButtonChecked = function RadioButtonChecked(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	RadioButtonChecked = (0, _pure.default)(RadioButtonChecked);
	RadioButtonChecked.muiName = 'SvgIcon';
	var _default = RadioButtonChecked;
	exports.default = _default;

/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	RadioButtonUnchecked = (0, _pure.default)(RadioButtonUnchecked);
	RadioButtonUnchecked.muiName = 'SvgIcon';
	var _default = RadioButtonUnchecked;
	exports.default = _default;

/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _pure = _interopRequireDefault(__webpack_require__(43));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(41));
	
	var _ref = _react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var Warning = function Warning(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	Warning = (0, _pure.default)(Warning);
	Warning.muiName = 'SvgIcon';
	var _default = Warning;
	exports.default = _default;

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = _interopRequireDefault(__webpack_require__(98));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(8));
	
	var _transitions = __webpack_require__(39);
	
	var _utils = __webpack_require__(95);
	
	// @inheritedComponent Transition
	var styles = function styles(theme) {
	  return {
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	    entered: {
	      height: 'auto'
	    },
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	
	var Collapse =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Collapse, _React$Component);
	
	  function Collapse() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Collapse);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Collapse.__proto__ || (0, _getPrototypeOf.default)(Collapse)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "wrapper", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "autoTransitionDuration", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: undefined
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "timer", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        node.style.height = _this.props.collapsedHeight;
	
	        if (_this.props.onEnter) {
	          _this.props.onEnter(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEntering", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var _this$props = _this.props,
	            timeout = _this$props.timeout,
	            theme = _this$props.theme;
	        var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	        var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'enter'
	        }),
	            transitionDuration = _getTransitionProps.duration;
	
	        if (timeout === 'auto') {
	          var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	          node.style.transitionDuration = "".concat(duration2, "ms");
	          _this.autoTransitionDuration = duration2;
	        } else {
	          node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	        }
	
	        node.style.height = "".concat(wrapperHeight, "px");
	
	        if (_this.props.onEntering) {
	          _this.props.onEntering(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEntered", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        node.style.height = 'auto';
	
	        if (_this.props.onEntered) {
	          _this.props.onEntered(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	        node.style.height = "".concat(wrapperHeight, "px");
	
	        if (_this.props.onExit) {
	          _this.props.onExit(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExiting", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var _this$props2 = _this.props,
	            timeout = _this$props2.timeout,
	            theme = _this$props2.theme;
	        var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	        var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'exit'
	        }),
	            transitionDuration = _getTransitionProps2.duration;
	
	        if (timeout === 'auto') {
	          var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	          node.style.transitionDuration = "".concat(duration2, "ms");
	          _this.autoTransitionDuration = duration2;
	        } else {
	          node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	        }
	
	        node.style.height = _this.props.collapsedHeight;
	
	        if (_this.props.onExiting) {
	          _this.props.onExiting(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "addEndListener", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(_, next) {
	        if (_this.props.timeout === 'auto') {
	          _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Collapse, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          collapsedHeight = _props.collapsedHeight,
	          Component = _props.component,
	          onEnter = _props.onEnter,
	          onEntered = _props.onEntered,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExiting = _props.onExiting,
	          style = _props.style,
	          theme = _props.theme,
	          timeout = _props.timeout,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntered: this.handleEntered,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExiting: this.handleExiting,
	        addEndListener: this.addEndListener,
	        timeout: timeout === 'auto' ? null : timeout
	      }, other), function (state, childProps) {
	        return _react.default.createElement(Component, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
	          style: (0, _objectSpread2.default)({}, style, {
	            minHeight: collapsedHeight
	          })
	        }, childProps), _react.default.createElement("div", {
	          className: classes.wrapper,
	          ref: function ref(node) {
	            _this2.wrapper = node;
	          }
	        }, _react.default.createElement("div", {
	          className: classes.wrapperInner
	        }, children)));
	      });
	    }
	  }]);
	  return Collapse;
	}(_react.default.Component);
	
	Collapse.propTypes =  false ? {
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  }), _propTypes.default.oneOf(['auto'])])
	} : {};
	Collapse.defaultProps = {
	  collapsedHeight: '0px',
	  component: 'div',
	  timeout: _transitions.duration.standard
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  withTheme: true,
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(31));
	
	var _debounce = _interopRequireDefault(__webpack_require__(56));
	
	var _Transition = _interopRequireDefault(__webpack_require__(98));
	
	var _reactLifecyclesCompat = __webpack_require__(75);
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(141));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(49));
	
	var _transitions = __webpack_require__(39);
	
	var _utils = __webpack_require__(95);
	
	// @inheritedComponent Transition
	var GUTTER = 24; // Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `translate3d(0, 0, 0)`.`
	
	function getTranslateValue(props, node) {
	  var direction = props.direction;
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
	  } else if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
	  } else if (direction === 'up') {
	    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
	}
	
	function setTranslateValue(props, node) {
	  var transform = getTranslateValue(props, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	/**
	 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	var Slide =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Slide, _React$Component);
	
	  function Slide() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Slide);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Slide.__proto__ || (0, _getPrototypeOf.default)(Slide)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mounted", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "transition", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        // Skip configuration where the position is screen size invariant.
	        if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
	          return;
	        }
	
	        var node = _reactDom.default.findDOMNode(_this.transition);
	
	        if (node) {
	          setTranslateValue(_this.props, node);
	        }
	      }, 166)
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        setTranslateValue(_this.props, node);
	        (0, _utils.reflow)(node);
	
	        if (_this.props.onEnter) {
	          _this.props.onEnter(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEntering", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var theme = _this.props.theme;
	        var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'enter'
	        });
	        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.easeOut
	        }));
	        node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.easeOut
	        }));
	        node.style.webkitTransform = 'translate(0, 0)';
	        node.style.transform = 'translate(0, 0)';
	
	        if (_this.props.onEntering) {
	          _this.props.onEntering(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var theme = _this.props.theme;
	        var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'exit'
	        });
	        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.sharp
	        }));
	        node.style.transition = theme.transitions.create('transform', (0, _objectSpread2.default)({}, transitionProps, {
	          easing: theme.transitions.easing.sharp
	        }));
	        setTranslateValue(_this.props, node);
	
	        if (_this.props.onExit) {
	          _this.props.onExit(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExited", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        // No need for transitions when the component is hidden
	        node.style.webkitTransition = '';
	        node.style.transition = '';
	
	        if (_this.props.onExited) {
	          _this.props.onExited(node);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Slide, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // state.mounted handle SSR, once the component is mounted, we need
	      // to properly hide it.
	      if (!this.props.in) {
	        // We need to set initial translate values of transition element
	        // otherwise component will be shown when in=false.
	        this.updatePosition();
	      }
	
	      this.mounted = true;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.direction !== this.props.direction && !this.props.in) {
	        // We need to update the position of the drawer when the direction change and
	        // when it's hidden.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	    }
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      var node = _reactDom.default.findDOMNode(this.transition);
	
	      if (node) {
	        node.style.visibility = 'inherit';
	        setTranslateValue(this.props, node);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExited = _props.onExited,
	          styleProp = _props.style,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
	      var style = {}; // We use this state to handle the server-side rendering.
	      // We don't know the width of the children ahead of time.
	      // We need to render it.
	
	      if (!this.props.in && !this.mounted) {
	        style.visibility = 'hidden';
	      }
	
	      style = (0, _objectSpread2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExited: this.handleExited,
	        appear: true,
	        style: style,
	        ref: function ref(node) {
	          _this2.transition = node;
	        }
	      }, other), children));
	    }
	  }]);
	  return Slide;
	}(_react.default.Component);
	
	Slide.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Slide.defaultProps = {
	  direction: 'down',
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()((0, _reactLifecyclesCompat.polyfill)(Slide));
	
	exports.default = _default;

/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = _interopRequireDefault(__webpack_require__(98));
	
	var _transitions = __webpack_require__(39);
	
	var _withTheme = _interopRequireDefault(__webpack_require__(49));
	
	var _utils = __webpack_require__(95);
	
	// @inheritedComponent Transition
	var styles = {
	  entering: {
	    transform: 'scale(1)'
	  },
	  entered: {
	    transform: 'scale(1)'
	  }
	};
	/**
	 * The Zoom transition can be used for the floating variant of the
	 * [Button](https://material-ui-next.com/demos/buttons/#floating-action-buttons) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Zoom =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Zoom, _React$Component);
	
	  function Zoom() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Zoom);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Zoom.__proto__ || (0, _getPrototypeOf.default)(Zoom)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleEnter", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var theme = _this.props.theme;
	        (0, _utils.reflow)(node); // So the animation always start from the start.
	
	        var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'enter'
	        });
	        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	        node.style.transition = theme.transitions.create('transform', transitionProps);
	
	        if (_this.props.onEnter) {
	          _this.props.onEnter(node);
	        }
	      }
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleExit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(node) {
	        var theme = _this.props.theme;
	        var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	          mode: 'exit'
	        });
	        node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	        node.style.transition = theme.transitions.create('transform', transitionProps);
	
	        if (_this.props.onExit) {
	          _this.props.onExit(node);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(Zoom, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onExit = _props.onExit,
	          styleProp = _props.style,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "onEnter", "onExit", "style", "theme"]);
	      var style = (0, _objectSpread2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        appear: true,
	        onEnter: this.handleEnter,
	        onExit: this.handleExit
	      }, other), function (state, childProps) {
	        return _react.default.cloneElement(children, (0, _objectSpread2.default)({
	          style: (0, _objectSpread2.default)({
	            transform: 'scale(0)',
	            willChange: 'transform'
	          }, styles[state], style)
	        }, childProps));
	      });
	    }
	  }]);
	  return Zoom;
	}(_react.default.Component);
	
	Zoom.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Zoom.defaultProps = {
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()(Zoom);
	
	exports.default = _default;

/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "Grow", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	Object.defineProperty(exports, "Fade", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	Object.defineProperty(exports, "Zoom", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(94));
	
	var _Grow = _interopRequireDefault(__webpack_require__(472));
	
	var _Fade = _interopRequireDefault(__webpack_require__(161));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(325));
	
	var _Zoom = _interopRequireDefault(__webpack_require__(1136));

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(31));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(47));
	
	// @inheritedComponent EventListener
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null && target.parentNode) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	
	  return false;
	};
	/**
	 * Listen for click events that are triggered outside of the component children.
	 */
	
	
	var ClickAwayListener =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ClickAwayListener, _React$Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "mounted", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: false
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleClickAway", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value(event) {
	        // Ignore events that have been `event.preventDefault()` marked.
	        if (event.defaultPrevented) {
	          return;
	        } // IE11 support, which trigger the handleClickAway even after the unbind
	
	
	        if (!_this.mounted) {
	          return;
	        }
	
	        var el = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this));
	
	        var doc = (0, _ownerDocument.default)(el);
	
	        if (doc.documentElement && doc.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(ClickAwayListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          mouseEvent = _props.mouseEvent,
	          touchEvent = _props.touchEvent,
	          onClickAway = _props.onClickAway,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
	      var listenerProps = {};
	
	      if (mouseEvent !== false) {
	        listenerProps[mouseEvent] = this.handleClickAway;
	      }
	
	      if (touchEvent !== false) {
	        listenerProps[touchEvent] = this.handleClickAway;
	      }
	
	      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
	        target: "document"
	      }, listenerProps, other), children);
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.default.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  children: _propTypes.default.node.isRequired,
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	  onClickAway: _propTypes.default.func.isRequired,
	  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
	} : {};
	ClickAwayListener.defaultProps = {
	  mouseEvent: 'onMouseUp',
	  touchEvent: 'onTouchEnd'
	};
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	//  weak
	var requirePropFactory = function requirePropFactory(componentNameInError) {
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error("The property `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
	      }
	
	      return null;
	    };
	  };
	
	  return requireProp;
	};
	
	var _default = requirePropFactory;
	exports.default = _default;

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isWidthDown = exports.isWidthUp = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(4));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(12));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(14));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(31));
	
	var _debounce = _interopRequireDefault(__webpack_require__(56));
	
	var _wrapDisplayName = _interopRequireDefault(__webpack_require__(106));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(104));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(49));
	
	var _createBreakpoints = __webpack_require__(107);
	
	// By default, returns true if screen width is the same or greater than the given breakpoint.
	var isWidthUp = function isWidthUp(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
	  }
	
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
	}; // By default, returns true if screen width is the same or less than the given breakpoint.
	
	
	exports.isWidthUp = isWidthUp;
	
	var isWidthDown = function isWidthDown(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	
	  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	exports.isWidthDown = isWidthDown;
	
	var withWidth = function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$resizeInterv = options.resizeInterval,
	        resizeInterval = _options$resizeInterv === void 0 ? 166 : _options$resizeInterv,
	        _options$withTheme = options.withTheme,
	        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme;
	
	    var WithWidth =
	    /*#__PURE__*/
	    function (_React$Component) {
	      (0, _inherits2.default)(WithWidth, _React$Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this;
	
	        (0, _classCallCheck2.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf.default)(WithWidth)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "state", {
	          configurable: true,
	          enumerable: true,
	          writable: true,
	          value: {
	            width: undefined
	          }
	        }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	          configurable: true,
	          enumerable: true,
	          writable: true,
	          value: (0, _debounce.default)(function () {
	            _this.updateWidth(window.innerWidth);
	          }, resizeInterval)
	        }), _temp));
	      }
	
	      (0, _createClass2.default)(WithWidth, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          this.updateWidth(window.innerWidth);
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          this.handleResize.cancel();
	        }
	      }, {
	        key: "updateWidth",
	        value: function updateWidth(innerWidth) {
	          var breakpoints = this.props.theme.breakpoints;
	          var width = null;
	          /**
	           * Start with the slowest value as low end devices often have a small screen.
	           *
	           * innerWidth |xs      sm      md      lg      xl
	           *            |-------|-------|-------|-------|------>
	           * width      |  xs   |  sm   |  md   |  lg   |  xl
	           */
	
	          var index = 1;
	
	          while (width === null && index < _createBreakpoints.keys.length) {
	            var currentWidth = _createBreakpoints.keys[index]; // @media are inclusive, so reproduce the behavior here.
	
	            if (innerWidth < breakpoints.values[currentWidth]) {
	              width = _createBreakpoints.keys[index - 1];
	              break;
	            }
	
	            index += 1;
	          }
	
	          width = width || 'xl';
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          var _props = this.props,
	              initialWidth = _props.initialWidth,
	              theme = _props.theme,
	              width = _props.width,
	              other = (0, _objectWithoutProperties2.default)(_props, ["initialWidth", "theme", "width"]);
	          var props = (0, _objectSpread2.default)({
	            width: width || this.state.width || initialWidth
	          }, other);
	          var more = {};
	
	          if (withThemeOption) {
	            more.theme = theme;
	          } // When rendering the component on the server,
	          // we have no idea about the client browser screen width.
	          // In order to prevent blinks and help the reconciliation of the React tree
	          // we are not rendering the child component.
	          //
	          // An alternative is to use the `initialWidth` property.
	
	
	          if (props.width === undefined) {
	            return null;
	          }
	
	          return _react.default.createElement(_reactEventListener.default, {
	            target: "window",
	            onResize: this.handleResize
	          }, _react.default.createElement(Component, (0, _extends2.default)({}, more, props)));
	        }
	      }]);
	      return WithWidth;
	    }(_react.default.Component);
	
	    WithWidth.propTypes =  false ? {
	      /**
	       * As `window.innerWidth` is unavailable on the server,
	       * we default to rendering an empty componenent during the first mount.
	       * In some situation you might want to use an heristic to approximate
	       * the screen width of the client browser screen width.
	       *
	       * For instance, you could be using the user-agent or the client-hints.
	       * http://caniuse.com/#search=client%20hint
	       */
	      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	      /**
	       * @ignore
	       */
	      theme: _propTypes.default.object.isRequired,
	
	      /**
	       * Bypass the width calculation logic.
	       */
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
	    } : {};
	
	    if (false) {
	      WithWidth.displayName = (0, _wrapDisplayName.default)(Component, 'WithWidth');
	    }
	
	    (0, _hoistNonReactStatics.default)(WithWidth, Component);
	    return (0, _withTheme.default)()(WithWidth);
	  };
	};
	
	var _default = withWidth;
	exports.default = _default;

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
	var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var cachedType;
	function _setScrollType(type) {
	    cachedType = type;
	}
	exports._setScrollType = _setScrollType;
	// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
	function detectScrollType() {
	    if (cachedType) {
	        return cachedType;
	    }
	    if (!inDOM || !window.document.body) {
	        return 'indeterminate';
	    }
	    var dummy = window.document.createElement('div');
	    dummy.appendChild(document.createTextNode('ABCD'));
	    dummy.dir = 'rtl';
	    dummy.style.fontSize = '14px';
	    dummy.style.width = '4px';
	    dummy.style.height = '1px';
	    dummy.style.position = 'absolute';
	    dummy.style.top = '-1000px';
	    dummy.style.overflow = 'scroll';
	    document.body.appendChild(dummy);
	    cachedType = 'reverse';
	    if (dummy.scrollLeft > 0) {
	        cachedType = 'default';
	    }
	    else {
	        dummy.scrollLeft = 1;
	        if (dummy.scrollLeft === 0) {
	            cachedType = 'negative';
	        }
	    }
	    document.body.removeChild(dummy);
	    return cachedType;
	}
	exports.detectScrollType = detectScrollType;
	// Based on https://stackoverflow.com/a/24394376
	function getNormalizedScrollLeft(element, direction) {
	    var scrollLeft = element.scrollLeft;
	    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	    if (direction !== 'rtl') {
	        return scrollLeft;
	    }
	    var type = detectScrollType();
	    if (type === 'indeterminate') {
	        return Number.NaN;
	    }
	    switch (type) {
	        case 'negative':
	            return element.scrollWidth - element.clientWidth + scrollLeft;
	        case 'reverse':
	            return element.scrollWidth - element.clientWidth - scrollLeft;
	    }
	    return scrollLeft;
	}
	exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
	function setNormalizedScrollLeft(element, scrollLeft, direction) {
	    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	    if (direction !== 'rtl') {
	        element.scrollLeft = scrollLeft;
	        return;
	    }
	    var type = detectScrollType();
	    if (type === 'indeterminate') {
	        return;
	    }
	    switch (type) {
	        case 'negative':
	            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
	            break;
	        case 'reverse':
	            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
	            break;
	        default:
	            element.scrollLeft = scrollLeft;
	            break;
	    }
	}
	exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.14.3
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
	}
	
	function getWindowSizes() {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && parent.nodeName === 'HTML') {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  boundaries.left += padding;
	  boundaries.top += padding;
	  boundaries.right -= padding;
	  boundaries.bottom -= padding;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var styles = getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroy the popper
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger onUpdate callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // Avoid blurry text by using full pixel integers.
	  // For pixel-perfect positioning, top/bottom prefers rounded
	  // values, while left/right prefers floored values.
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.round(popper.top),
	    bottom: Math.round(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    top = -offsetParentRect.height + offsets.bottom;
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    left = -offsetParentRect.width + offsets.right;
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjuction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-right` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unitless, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the height.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * An scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper this makes sure the popper has always a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier, can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near eachothers
	   * without leaving any gap between the two. Expecially useful when the arrow is
	   * enabled and you want to assure it to point to its reference element.
	   * It cares only about the first axis, you can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjuction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations).
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position,
	     * the popper will never be placed outside of the defined boundaries
	     * (except if keepTogether is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define you own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the informations used by Popper.js
	 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overriden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass as 3rd argument an object with the same
	 * structure of this object, example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated, this callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Create a new Popper.js instance
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper.
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedule an update, it will run on the next UI update available
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1148:
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(958)
	
	/**
	 * `requestAnimationFrame()`
	 */
	
	var request = global.requestAnimationFrame
	  || global.webkitRequestAnimationFrame
	  || global.mozRequestAnimationFrame
	  || fallback
	
	var prev = +new Date
	function fallback (fn) {
	  var curr = +new Date
	  var ms = Math.max(0, 16 - (curr - prev))
	  var req = setTimeout(fn, ms)
	  return prev = curr, req
	}
	
	/**
	 * `cancelAnimationFrame()`
	 */
	
	var cancel = global.cancelAnimationFrame
	  || global.webkitCancelAnimationFrame
	  || global.mozCancelAnimationFrame
	  || clearTimeout
	
	if (Function.prototype.bind) {
	  request = request.bind(global)
	  cancel = cancel.bind(global)
	}
	
	exports = module.exports = request
	exports.cancel = cancel


/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ELEMENT_ID = 'firebaseui_container';
	
	var firebaseUiDeletion = Promise.resolve();
	
	var FirebaseAuth = function (_React$Component) {
	  _inherits(FirebaseAuth, _React$Component);
	
	  function FirebaseAuth(props) {
	    _classCallCheck(this, FirebaseAuth);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.uiConfig = props.uiConfig;
	    _this.firebaseAuth = props.firebaseAuth;
	    _this.className = props.className;
	    _this.uiCallback = props.uiCallback;
	    return _this;
	  }
	
	  FirebaseAuth.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    __webpack_require__(910);
	
	    var firebaseui = __webpack_require__(299);
	
	    firebaseUiDeletion.then(function () {
	      _this2.firebaseUiWidget = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(_this2.firebaseAuth);
	      if (_this2.uiConfig.signInFlow === 'popup') {
	        _this2.firebaseUiWidget.reset();
	      }
	
	      _this2.userSignedIn = false;
	      _this2.unregisterAuthObserver = _this2.firebaseAuth.onAuthStateChanged(function (user) {
	        if (!user && _this2.userSignedIn) {
	          _this2.firebaseUiWidget.reset();
	        }
	        _this2.userSignedIn = !!user;
	      });
	
	      if (_this2.uiCallback) {
	        _this2.uiCallback(_this2.firebaseUiWidget);
	      }
	
	      _this2.firebaseUiWidget.start('#' + ELEMENT_ID, _this2.uiConfig);
	    });
	  };
	
	  FirebaseAuth.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unregisterAuthObserver();
	    firebaseUiDeletion = this.firebaseUiWidget.delete();
	  };
	
	  FirebaseAuth.prototype.render = function render() {
	    return _react2.default.createElement('div', { className: this.className, id: ELEMENT_ID });
	  };
	
	  return FirebaseAuth;
	}(_react2.default.Component);
	
	exports.default = FirebaseAuth;
	//# sourceMappingURL=FirebaseAuth.js.map

/***/ }),

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

	module.exports=function(i){var e={};function o(t){if(e[t])return e[t].exports;var a=e[t]={i:t,l:!1,exports:{}};return i[t].call(a.exports,a,a.exports,o),a.l=!0,a.exports}return o.m=i,o.c=e,o.d=function(i,e,t){o.o(i,e)||Object.defineProperty(i,e,{configurable:!1,enumerable:!0,get:t})},o.r=function(i){Object.defineProperty(i,"__esModule",{value:!0})},o.n=function(i){var e=i&&i.__esModule?function(){return i.default}:function(){return i};return o.d(e,"a",e),e},o.o=function(i,e){return Object.prototype.hasOwnProperty.call(i,e)},o.p="",o(o.s=7)}([function(i,e){i.exports=__webpack_require__(299)},function(i,e){i.exports=function(i){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!i||"string"!=typeof i)return i;var o=e.protocol+"//"+e.host,t=o+e.pathname.replace(/\/[^\/]*$/,"/");return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(i,e){var a,r=e.trim().replace(/^"(.*)"$/,function(i,e){return e}).replace(/^'(.*)'$/,function(i,e){return e});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r)?i:(a=0===r.indexOf("//")?r:0===r.indexOf("/")?o+r:t+r.replace(/^\.\//,""),"url("+JSON.stringify(a)+")")})}},function(i,e,o){var t,a,r={},n=(t=function(){return window&&document&&document.all&&!window.atob},function(){return void 0===a&&(a=t.apply(this,arguments)),a}),l=function(i){var e={};return function(i){if("function"==typeof i)return i();if(void 0===e[i]){var o=function(i){return document.querySelector(i)}.call(this,i);if(window.HTMLIFrameElement&&o instanceof window.HTMLIFrameElement)try{o=o.contentDocument.head}catch(i){o=null}e[i]=o}return e[i]}}(),s=null,d=0,p=[],b=o(1);function f(i,e){for(var o=0;o<i.length;o++){var t=i[o],a=r[t.id];if(a){a.refs++;for(var n=0;n<a.parts.length;n++)a.parts[n](t.parts[n]);for(;n<t.parts.length;n++)a.parts.push(h(t.parts[n],e))}else{var l=[];for(n=0;n<t.parts.length;n++)l.push(h(t.parts[n],e));r[t.id]={id:t.id,refs:1,parts:l}}}}function u(i,e){for(var o=[],t={},a=0;a<i.length;a++){var r=i[a],n=e.base?r[0]+e.base:r[0],l={css:r[1],media:r[2],sourceMap:r[3]};t[n]?t[n].parts.push(l):o.push(t[n]={id:n,parts:[l]})}return o}function g(i,e){var o=l(i.insertInto);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var t=p[p.length-1];if("top"===i.insertAt)t?t.nextSibling?o.insertBefore(e,t.nextSibling):o.appendChild(e):o.insertBefore(e,o.firstChild),p.push(e);else if("bottom"===i.insertAt)o.appendChild(e);else{if("object"!=typeof i.insertAt||!i.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var a=l(i.insertInto+" "+i.insertAt.before);o.insertBefore(e,a)}}function c(i){if(null===i.parentNode)return!1;i.parentNode.removeChild(i);var e=p.indexOf(i);e>=0&&p.splice(e,1)}function x(i){var e=document.createElement("style");return void 0===i.attrs.type&&(i.attrs.type="text/css"),m(e,i.attrs),g(i,e),e}function m(i,e){Object.keys(e).forEach(function(o){i.setAttribute(o,e[o])})}function h(i,e){var o,t,a,r;if(e.transform&&i.css){if(!(r=e.transform(i.css)))return function(){};i.css=r}if(e.singleton){var n=d++;o=s||(s=x(e)),t=w.bind(null,o,n,!1),a=w.bind(null,o,n,!0)}else i.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(o=function(i){var e=document.createElement("link");return void 0===i.attrs.type&&(i.attrs.type="text/css"),i.attrs.rel="stylesheet",m(e,i.attrs),g(i,e),e}(e),t=function(i,e,o){var t=o.css,a=o.sourceMap,r=void 0===e.convertToAbsoluteUrls&&a;(e.convertToAbsoluteUrls||r)&&(t=b(t));a&&(t+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */");var n=new Blob([t],{type:"text/css"}),l=i.href;i.href=URL.createObjectURL(n),l&&URL.revokeObjectURL(l)}.bind(null,o,e),a=function(){c(o),o.href&&URL.revokeObjectURL(o.href)}):(o=x(e),t=function(i,e){var o=e.css,t=e.media;t&&i.setAttribute("media",t);if(i.styleSheet)i.styleSheet.cssText=o;else{for(;i.firstChild;)i.removeChild(i.firstChild);i.appendChild(document.createTextNode(o))}}.bind(null,o),a=function(){c(o)});return t(i),function(e){if(e){if(e.css===i.css&&e.media===i.media&&e.sourceMap===i.sourceMap)return;t(i=e)}else a()}}i.exports=function(i,e){if("undefined"!="boolean"&&(true)&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");(e=e||{}).attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||"boolean"==typeof e.singleton||(e.singleton=n()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var o=u(i,e);return f(o,e),function(i){for(var t=[],a=0;a<o.length;a++){var n=o[a];(l=r[n.id]).refs--,t.push(l)}i&&f(u(i,e),e);for(a=0;a<t.length;a++){var l;if(0===(l=t[a]).refs){for(var s=0;s<l.parts.length;s++)l.parts[s]();delete r[l.id]}}}};var k,_=(k=[],function(i,e){return k[i]=e,k.filter(Boolean).join("\n")});function w(i,e,o,t){var a=o?"":t.css;if(i.styleSheet)i.styleSheet.cssText=_(e,a);else{var r=document.createTextNode(a),n=i.childNodes;n[e]&&i.removeChild(n[e]),n.length?i.insertBefore(r,n[e]):i.appendChild(r)}}},function(i,e){i.exports=function(i){var e=[];return e.toString=function(){return this.map(function(e){var o=function(i,e){var o=i[1]||"",t=i[3];if(!t)return o;if(e&&"function"==typeof btoa){var a=(n=t,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */"),r=t.sources.map(function(i){return"/*# sourceURL="+t.sourceRoot+i+" */"});return[o].concat(r).concat([a]).join("\n")}var n;return[o].join("\n")}(e,i);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(i,o){"string"==typeof i&&(i=[[null,i,""]]);for(var t={},a=0;a<this.length;a++){var r=this[a][0];"number"==typeof r&&(t[r]=!0)}for(a=0;a<i.length;a++){var n=i[a];"number"==typeof n[0]&&t[n[0]]||(o&&!n[2]?n[2]=o:o&&(n[2]="("+n[2]+") and ("+o+")"),e.push(n))}},e}},function(i,e,o){(e=i.exports=o(3)(!1)).push([i.i,"@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);",""]),e.push([i.i,'.mdl-button{background:0 0;border:none;border-radius:2px;color:#000;position:relative;height:36px;margin:0;min-width:64px;padding:0 16px;display:inline-block;font-family:Roboto,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;text-transform:uppercase;line-height:1;letter-spacing:0;overflow:hidden;will-change:box-shadow;transition:box-shadow .2s cubic-bezier(.4,0,1,1),background-color .2s cubic-bezier(.4,0,.2,1),color .2s cubic-bezier(.4,0,.2,1);outline:0;cursor:pointer;text-decoration:none;text-align:center;line-height:36px;vertical-align:middle}.mdl-button::-moz-focus-inner{border:0}.mdl-button:hover{background-color:hsla(0,0%,62%,.2)}.mdl-button:focus:not(:active){background-color:rgba(0,0,0,.12)}.mdl-button:active{background-color:hsla(0,0%,62%,.4)}.mdl-button.mdl-button--colored{color:#3f51b5}.mdl-button.mdl-button--colored:focus:not(:active){background-color:rgba(0,0,0,.12)}input.mdl-button[type=submit]{-webkit-appearance:none}.mdl-button--raised{background:hsla(0,0%,62%,.2);box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-button--raised:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--raised.mdl-button--colored{background:#3f51b5;color:#fff}.mdl-button--raised.mdl-button--colored:active,.mdl-button--raised.mdl-button--colored:focus:not(:active),.mdl-button--raised.mdl-button--colored:hover{background-color:#3f51b5}.mdl-button--raised.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--fab{border-radius:50%;font-size:24px;height:56px;margin:auto;min-width:56px;width:56px;padding:0;overflow:hidden;background:hsla(0,0%,62%,.2);box-shadow:0 1px 1.5px 0 rgba(0,0,0,.12),0 1px 1px 0 rgba(0,0,0,.24);position:relative;line-height:normal}.mdl-button--fab .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--fab.mdl-button--mini-fab{height:40px;min-width:40px;width:40px}.mdl-button--fab .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button--fab:active{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab:focus:not(:active){box-shadow:0 0 8px rgba(0,0,0,.18),0 8px 16px rgba(0,0,0,.36);background-color:hsla(0,0%,62%,.4)}.mdl-button--fab.mdl-button--colored{background:#ff4081;color:#fff}.mdl-button--fab.mdl-button--colored:active,.mdl-button--fab.mdl-button--colored:focus:not(:active),.mdl-button--fab.mdl-button--colored:hover{background-color:#ff4081}.mdl-button--fab.mdl-button--colored .mdl-ripple{background:#fff}.mdl-button--icon{border-radius:50%;font-size:24px;height:32px;margin-left:0;margin-right:0;min-width:32px;width:32px;padding:0;overflow:hidden;color:inherit;line-height:normal}.mdl-button--icon .material-icons{position:absolute;top:50%;left:50%;transform:translate(-12px,-12px);line-height:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon{height:24px;min-width:24px;width:24px}.mdl-button--icon.mdl-button--mini-icon .material-icons{top:0;left:0}.mdl-button--icon .mdl-button__ripple-container{border-radius:50%;-webkit-mask-image:-webkit-radial-gradient(circle,#fff,#000)}.mdl-button__ripple-container{display:block;height:100%;left:0;position:absolute;top:0;width:100%;z-index:0;overflow:hidden}.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple{background-color:transparent}.mdl-button--primary.mdl-button--primary{color:#3f51b5}.mdl-button--primary.mdl-button--primary .mdl-ripple{background:#fff}.mdl-button--primary.mdl-button--primary.mdl-button--fab,.mdl-button--primary.mdl-button--primary.mdl-button--raised{color:#fff;background-color:#3f51b5}.mdl-button--accent.mdl-button--accent{color:#ff4081}.mdl-button--accent.mdl-button--accent .mdl-ripple{background:#fff}.mdl-button--accent.mdl-button--accent.mdl-button--fab,.mdl-button--accent.mdl-button--accent.mdl-button--raised{color:#fff;background-color:#ff4081}.mdl-button.mdl-button--disabled.mdl-button--disabled,.mdl-button[disabled][disabled]{color:rgba(0,0,0,.26);cursor:default;background-color:transparent}.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,.mdl-button--fab[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,.mdl-button--raised[disabled][disabled]{background-color:rgba(0,0,0,.12);color:rgba(0,0,0,.26);box-shadow:none}.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,.mdl-button--colored[disabled][disabled]{color:rgba(0,0,0,.26)}.mdl-button .material-icons{vertical-align:middle}.mdl-card{display:flex;flex-direction:column;font-size:16px;font-weight:400;min-height:200px;overflow:hidden;width:330px;z-index:1;position:relative;background:#fff;border-radius:2px;box-sizing:border-box}.mdl-card__media{background-color:#ff4081;background-repeat:repeat;background-position:50% 50%;background-size:cover;background-origin:padding-box;background-attachment:scroll;box-sizing:border-box}.mdl-card__title{align-items:center;color:#000;display:block;display:flex;justify-content:stretch;line-height:normal;padding:16px;perspective-origin:165px 56px;transform-origin:165px 56px;box-sizing:border-box}.mdl-card__title.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__title-text{align-self:flex-end;color:inherit;display:block;display:flex;font-size:24px;font-weight:300;line-height:normal;overflow:hidden;transform-origin:149px 48px;margin:0}.mdl-card__subtitle-text{font-size:14px;color:rgba(0,0,0,.54);margin:0}.mdl-card__supporting-text{color:rgba(0,0,0,.54);font-size:1rem;line-height:18px;overflow:hidden;padding:16px;width:90%}.mdl-card__supporting-text.mdl-card--border{border-bottom:1px solid rgba(0,0,0,.1)}.mdl-card__actions{font-size:16px;line-height:normal;width:100%;background-color:transparent;padding:8px;box-sizing:border-box}.mdl-card__actions.mdl-card--border{border-top:1px solid rgba(0,0,0,.1)}.mdl-card--expand{flex-grow:1}.mdl-card__menu{position:absolute;right:16px;top:16px}.mdl-dialog{border:none;box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2);width:280px}.mdl-dialog__title{padding:24px 24px 0;margin:0;font-size:2.5rem}.mdl-dialog__actions{padding:8px 8px 8px 24px;display:flex;flex-direction:row-reverse;flex-wrap:wrap}.mdl-dialog__actions>*{margin-right:8px;height:36px}.mdl-dialog__actions>:first-child{margin-right:0}.mdl-dialog__actions--full-width{padding:0 0 8px}.mdl-dialog__actions--full-width>*{height:48px;flex:0 0 100%;padding-right:16px;margin-right:0;text-align:right}.mdl-dialog__content{padding:20px 24px 24px;color:rgba(0,0,0,.54)}.mdl-progress{display:block;position:relative;height:4px;width:500px;max-width:100%}.mdl-progress>.bar{display:block;position:absolute;top:0;bottom:0;width:0;transition:width .2s cubic-bezier(.4,0,.2,1)}.mdl-progress>.progressbar{background-color:#3f51b5;z-index:1;left:0}.mdl-progress>.bufferbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);z-index:0;left:0}.mdl-progress>.auxbar{right:0}@supports (-webkit-appearance:none){.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.7),hsla(0,0%,100%,.7)),linear-gradient(90deg,#3f51b5,#3f51b5);mask:url(/images/buffer.svg?embed)}}.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar{background-image:linear-gradient(90deg,hsla(0,0%,100%,.9),hsla(0,0%,100%,.9)),linear-gradient(90deg,#3f51b5,#3f51b5)}.mdl-progress.mdl-progress--indeterminate>.bar1,.mdl-progress.mdl-progress__indeterminate>.bar1{background-color:#3f51b5;animation-name:indeterminate1;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}.mdl-progress.mdl-progress--indeterminate>.bar3,.mdl-progress.mdl-progress__indeterminate>.bar3{background-image:none;background-color:#3f51b5;animation-name:indeterminate2;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes indeterminate1{0%{left:0;width:0}50%{left:25%;width:75%}75%{left:100%;width:0}}@keyframes indeterminate2{0%{left:0;width:0}50%{left:0;width:0}75%{left:0;width:25%}to{left:100%;width:0}}.mdl-shadow--2dp{box-shadow:0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12)}.mdl-shadow--3dp{box-shadow:0 3px 4px 0 rgba(0,0,0,.14),0 3px 3px -2px rgba(0,0,0,.2),0 1px 8px 0 rgba(0,0,0,.12)}.mdl-shadow--4dp{box-shadow:0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12),0 2px 4px -1px rgba(0,0,0,.2)}.mdl-shadow--6dp{box-shadow:0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12),0 3px 5px -1px rgba(0,0,0,.2)}.mdl-shadow--8dp{box-shadow:0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2)}.mdl-shadow--16dp{box-shadow:0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12),0 8px 10px -5px rgba(0,0,0,.2)}.mdl-shadow--24dp{box-shadow:0 9px 46px 8px rgba(0,0,0,.14),0 11px 15px -7px rgba(0,0,0,.12),0 24px 38px 3px rgba(0,0,0,.2)}.mdl-spinner{display:inline-block;position:relative;width:28px;height:28px}.mdl-spinner:not(.is-upgraded).is-active:after{content:"Loading..."}.mdl-spinner.is-upgraded.is-active{animation:mdl-spinner__container-rotate 1.568s linear infinite}@keyframes mdl-spinner__container-rotate{to{transform:rotate(1turn)}}.mdl-spinner__layer{position:absolute;width:100%;height:100%;opacity:0}.mdl-spinner__layer-1{border-color:#42a5f5}.mdl-spinner--single-color .mdl-spinner__layer-1{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-1{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-2{border-color:#f44336}.mdl-spinner--single-color .mdl-spinner__layer-2{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-2{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-3{border-color:#fdd835}.mdl-spinner--single-color .mdl-spinner__layer-3{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-3{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__layer-4{border-color:#4caf50}.mdl-spinner--single-color .mdl-spinner__layer-4{border-color:#3f51b5}.mdl-spinner.is-active .mdl-spinner__layer-4{animation:mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4,0,.2,1) infinite both,mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__fill-unfill-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}to{transform:rotate(3turn)}}@keyframes mdl-spinner__layer-1-fade-in-out{0%{opacity:.99}25%{opacity:.99}26%{opacity:0}89%{opacity:0}90%{opacity:.99}to{opacity:.99}}@keyframes mdl-spinner__layer-2-fade-in-out{0%{opacity:0}15%{opacity:0}25%{opacity:.99}50%{opacity:.99}51%{opacity:0}}@keyframes mdl-spinner__layer-3-fade-in-out{0%{opacity:0}40%{opacity:0}50%{opacity:.99}75%{opacity:.99}76%{opacity:0}}@keyframes mdl-spinner__layer-4-fade-in-out{0%{opacity:0}65%{opacity:0}75%{opacity:.99}90%{opacity:.99}to{opacity:0}}.mdl-spinner__gap-patch{position:absolute;box-sizing:border-box;top:0;left:45%;width:10%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__gap-patch .mdl-spinner__circle{width:1000%;left:-450%}.mdl-spinner__circle-clipper{display:inline-block;position:relative;width:50%;height:100%;overflow:hidden;border-color:inherit}.mdl-spinner__circle-clipper.mdl-spinner__left{float:left}.mdl-spinner__circle-clipper.mdl-spinner__right{float:right}.mdl-spinner__circle-clipper .mdl-spinner__circle{width:200%}.mdl-spinner__circle{box-sizing:border-box;height:100%;border-width:3px;border-style:solid;border-color:inherit;border-bottom-color:transparent!important;border-radius:50%;animation:none;position:absolute;top:0;right:0;bottom:0;left:0}.mdl-spinner__left .mdl-spinner__circle{border-right-color:transparent!important;transform:rotate(129deg)}.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle{animation:mdl-spinner__left-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}.mdl-spinner__right .mdl-spinner__circle{left:-100%;border-left-color:transparent!important;transform:rotate(-129deg)}.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle{animation:mdl-spinner__right-spin 1333ms cubic-bezier(.4,0,.2,1) infinite both}@keyframes mdl-spinner__left-spin{0%{transform:rotate(130deg)}50%{transform:rotate(-5deg)}to{transform:rotate(130deg)}}@keyframes mdl-spinner__right-spin{0%{transform:rotate(-130deg)}50%{transform:rotate(5deg)}to{transform:rotate(-130deg)}}.mdl-textfield{position:relative;font-size:16px;display:inline-block;box-sizing:border-box;width:300px;max-width:100%;margin:0;padding:20px 0}.mdl-textfield .mdl-button{position:absolute;bottom:20px}.mdl-textfield--align-right{text-align:right}.mdl-textfield--full-width{width:100%}.mdl-textfield--expandable{min-width:32px;width:auto;min-height:32px}.mdl-textfield--expandable .mdl-button--icon{top:16px}.mdl-textfield__input{border:none;border-bottom:1px solid rgba(0,0,0,.12);display:block;font-size:16px;font-family:Helvetica,Arial,sans-serif;margin:0;padding:4px 0;width:100%;background:0 0;text-align:left;color:inherit}.mdl-textfield__input[type=number]{-moz-appearance:textfield}.mdl-textfield__input[type=number]::-webkit-inner-spin-button,.mdl-textfield__input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mdl-textfield.is-focused .mdl-textfield__input{outline:0}.mdl-textfield.is-invalid .mdl-textfield__input{border-color:#d50000;box-shadow:none}.mdl-textfield.is-disabled .mdl-textfield__input,fieldset[disabled] .mdl-textfield .mdl-textfield__input{background-color:transparent;border-bottom:1px dotted rgba(0,0,0,.12);color:rgba(0,0,0,.26)}.mdl-textfield textarea.mdl-textfield__input{display:block}.mdl-textfield__label{bottom:0;color:rgba(0,0,0,.26);font-size:16px;left:0;right:0;pointer-events:none;position:absolute;display:block;top:24px;width:100%;overflow:hidden;white-space:nowrap;text-align:left}.mdl-textfield.has-placeholder .mdl-textfield__label,.mdl-textfield.is-dirty .mdl-textfield__label{visibility:hidden}.mdl-textfield--floating-label .mdl-textfield__label{transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label{transition:none}.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,fieldset[disabled] .mdl-textfield .mdl-textfield__label{color:rgba(0,0,0,.26)}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#3f51b5;font-size:12px;top:4px;visibility:visible}.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label{top:-16px}.mdl-textfield--floating-label.is-invalid .mdl-textfield__label{color:#d50000;font-size:12px}.mdl-textfield__label:after{background-color:#3f51b5;bottom:20px;content:"";height:2px;left:45%;position:absolute;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:hidden;width:10px}.mdl-textfield.is-focused .mdl-textfield__label:after{left:0;visibility:visible;width:100%}.mdl-textfield.is-invalid .mdl-textfield__label:after{background-color:#d50000}.mdl-textfield__error{color:#d50000;position:absolute;font-size:12px;margin-top:3px;visibility:hidden;display:block}.mdl-textfield.is-invalid .mdl-textfield__error{visibility:visible}.mdl-textfield__expandable-holder{position:relative;margin-left:32px;transition-duration:.2s;transition-timing-function:cubic-bezier(.4,0,.2,1);display:inline-block;max-width:.1px}.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,.mdl-textfield.is-focused .mdl-textfield__expandable-holder{max-width:600px}.mdl-textfield__expandable-holder .mdl-textfield__label:after{bottom:0}dialog{position:absolute;left:0;right:0;width:-moz-fit-content;width:-webkit-fit-content;width:fit-content;height:-moz-fit-content;height:-webkit-fit-content;height:fit-content;margin:auto;border:solid;padding:1em;background:#fff;color:#000;display:block}dialog:not([open]){display:none}dialog+.backdrop{background:rgba(0,0,0,.1)}._dialog_overlay,dialog+.backdrop{position:fixed;top:0;right:0;bottom:0;left:0}dialog.fixed{position:fixed;top:50%;transform:translateY(-50%)}.firebaseui-container{background-color:#fff;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;color:rgba(0,0,0,.87);direction:ltr;font:16px Roboto,arial,sans-serif;margin:0 auto;max-width:360px;overflow:hidden;position:relative;text-align:left;width:100%}.firebaseui-card-header{padding:24px 24px 0}.firebaseui-card-content,.firebaseui-card-footer{padding:0 24px}.firebaseui-card-actions{box-sizing:border-box;display:table;font-size:14px;padding:8px 24px 24px;text-align:left;width:100%}.firebaseui-form-links{display:table-cell;vertical-align:middle;width:100%}.firebaseui-form-actions{display:table-cell;text-align:right;white-space:nowrap;width:100%}.firebaseui-subtitle,.firebaseui-title{color:rgba(0,0,0,.87);direction:ltr;font-size:20px;font-weight:500;line-height:24px;margin:0;padding:0;text-align:left}.firebaseui-title{padding-bottom:20px}.firebaseui-subtitle{margin:16px 0}.firebaseui-text{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;line-height:24px;text-align:left}.firebaseui-text-emphasis{font-weight:700}.firebaseui-error{color:#dd2c00;direction:ltr;font-size:12px;line-height:16px;margin:0;text-align:left}.firebaseui-text-input-error{margin:-16px 0 16px}.firebaseui-error-wrapper{min-height:16px}.firebaseui-list-item{direction:ltr;margin:0;padding:0;text-align:left}.firebaseui-hidden{display:none}.firebaseui-relative-wrapper{position:relative}.firebaseui-label{color:rgba(0,0,0,.54);direction:ltr;font-size:16px;text-align:left}.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,.mdl-textfield--floating-label.is-focused .mdl-textfield__label{color:#757575}.firebaseui-input,.firebaseui-input-invalid{border-radius:0;color:rgba(0,0,0,.87);direction:ltr;font-size:16px;width:100%}input.firebaseui-input,input.firebaseui-input-invalid{direction:ltr;text-align:left}.firebaseui-input-invalid{border-color:#dd2c00}.firebaseui-textfield{width:100%}.firebaseui-textfield.mdl-textfield .firebaseui-input{border-color:rgba(0,0,0,.12)}.firebaseui-textfield.mdl-textfield .firebaseui-label:after{background-color:#3f51b5}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-input{border-color:#dd2c00}.firebaseui-textfield-invalid.mdl-textfield .firebaseui-label:after{background-color:#dd2c00}.firebaseui-button{display:inline-block;height:36px;margin-left:8px;min-width:88px}.firebaseui-link{color:#4285f4;font-variant:normal;font-weight:400;text-decoration:none}.firebaseui-link:hover{text-decoration:underline}.firebaseui-indent{margin-left:1em}.firebaseui-tos{color:#757575;direction:ltr;font-size:12px;line-height:16px;margin-bottom:24px;margin-top:0;text-align:left}.firebaseui-page-provider-sign-in{background:inherit}.firebaseui-idp-list{list-style:none;margin:1em 0;padding:0}.firebaseui-idp-button{direction:ltr;font-weight:500;height:auto;line-height:normal;max-width:220px;min-height:40px;padding:8px 16px;text-align:left;width:100%}.firebaseui-idp-list>.firebaseui-list-item{margin-bottom:15px;text-align:center}.firebaseui-idp-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-idp-icon{height:18px;width:18px}.firebaseui-idp-favicon,.firebaseui-idp-icon{border:none;display:inline-block;vertical-align:middle}.firebaseui-idp-favicon{height:14px;margin-right:5px;width:14px}.firebaseui-idp-text{color:#fff;display:table-cell;font-size:14px;padding-left:16px;text-transform:none;vertical-align:middle}.firebaseui-idp-text.firebaseui-idp-text-long{display:table-cell}.firebaseui-idp-text.firebaseui-idp-text-short{display:none}@media (max-width:268px){.firebaseui-idp-text.firebaseui-idp-text-long{display:none}.firebaseui-idp-text.firebaseui-idp-text-short{display:table-cell}}@media (max-width:320px){.firebaseui-recaptcha-container>div>div{transform:scale(.9);-webkit-transform:scale(.9);transform-origin:0 0;-webkit-transform-origin:0 0}}.firebaseui-idp-password,.firebaseui-idp-password:hover,.mdl-button.firebaseui-idp-password:active,.mdl-button.firebaseui-idp-password:focus{background-color:#db4437}.firebaseui-idp-phone,.firebaseui-idp-phone:hover,.mdl-button.firebaseui-idp-phone:active,.mdl-button.firebaseui-idp-phone:focus{background-color:#02bd7e}.firebaseui-idp-google,.firebaseui-idp-google:hover,.mdl-button.firebaseui-idp-google:active,.mdl-button.firebaseui-idp-google:focus{background-color:#fff}.firebaseui-idp-google>.firebaseui-idp-text{color:#757575}.firebaseui-idp-github,.firebaseui-idp-github:hover,.mdl-button.firebaseui-idp-github:active,.mdl-button.firebaseui-idp-github:focus{background-color:#333}.firebaseui-idp-facebook,.firebaseui-idp-facebook:hover,.mdl-button.firebaseui-idp-facebook:active,.mdl-button.firebaseui-idp-facebook:focus{background-color:#3b5998}.firebaseui-idp-twitter,.firebaseui-idp-twitter:hover,.mdl-button.firebaseui-idp-twitter:active,.mdl-button.firebaseui-idp-twitter:focus{background-color:#55acee}.firebaseui-info-bar{background-color:#f9edbe;border:1px solid #f0c36d;box-shadow:0 2px 4px rgba(0,0,0,.2);-webkit-box-shadow:0 2px 4px rgba(0,0,0,.2);-moz-box-shadow:0 2px 4px rgba(0,0,0,.2);left:10%;padding:8px 16px;position:absolute;right:10%;text-align:center;top:0}.firebaseui-info-bar-message{font-size:12px;margin:0}.firebaseui-dialog{box-sizing:border-box;color:rgba(0,0,0,.87);font:16px Roboto,arial,sans-serif;height:auto;padding:24px;text-align:left}.firebaseui-dialog-icon-wrapper{display:table-cell;vertical-align:middle}.firebaseui-dialog-icon{float:left;height:40px;margin-right:24px;width:40px}.firebaseui-progress-dialog-message{display:table-cell;font-size:16px;font-weight:400;min-height:40px;vertical-align:middle}.firebaseui-progress-dialog-loading-icon{height:28px;margin:6px 30px 6px 6px;width:28px}.firebaseui-icon-done{background-image:url(https://www.gstatic.com/images/icons/material/system/2x/done_googgreen_36dp.png);background-position:50%;background-repeat:no-repeat;background-size:36px 36px}.firebaseui-phone-number{display:flex}.firebaseui-country-selector{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/arrow_drop_down_grey600_18dp.png);background-position:100%;background-repeat:no-repeat;background-size:18px auto;border-radius:0;border-bottom:1px solid rgba(0,0,0,.12);color:rgba(0,0,0,.87);flex-shrink:0;font-size:16px;font-weight:400;height:auto;line-height:normal;margin:20px 24px 20px 0;padding:4px 20px 4px 0;width:90px}.firebaseui-country-selector-flag{display:inline-block;margin-right:1ex}.firebaseui-flag{background-image:url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);background-size:100% auto;filter:drop-shadow(1px 1px 1px rgba(0,0,0,.54));height:14px;width:24px}.firebaseui-list-box-dialog{max-height:90%;overflow:auto;padding:8px 0 0}.firebaseui-list-box-actions{padding-bottom:8px}.firebaseui-list-box-icon-wrapper{padding-right:24px}.firebaseui-list-box-icon-wrapper,.firebaseui-list-box-label-wrapper{display:table-cell;vertical-align:top}.firebaseui-list-box-dialog-button{color:rgba(0,0,0,.87);direction:ltr;font-size:16px;font-weight:400;height:auto;line-height:normal;min-height:48px;padding:14px 24px;text-align:left;text-transform:none;width:100%}.firebaseui-phone-number-error{margin-left:114px}.firebaseui-busy-indicator{height:2px;left:0;position:absolute;top:55px;width:100%}.firebaseui-callback-indicator-container .firebaseui-busy-indicator{top:0}.firebaseui-callback-indicator-container{height:120px}.firebaseui-new-password-component{display:inline-block;position:relative;width:100%}.firebaseui-input-floating-button{background-position:50%;background-repeat:no-repeat;display:block;height:24px;position:absolute;right:0;top:20px;width:24px}.firebaseui-input-toggle-on{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_black_24dp.png)}.firebaseui-input-toggle-off{background-image:url(https://www.gstatic.com/images/icons/material/system/1x/visibility_off_black_24dp.png)}.firebaseui-input-toggle-focus{opacity:.87}.firebaseui-input-toggle-blur{opacity:.38}.firebaseui-recaptcha-wrapper{display:table;margin:0 auto;padding-bottom:8px}.firebaseui-recaptcha-container{display:table-cell}.firebaseui-recaptcha-error-wrapper{caption-side:bottom;display:table-caption}.firebaseui-change-phone-number-link{display:block}.firebaseui-resend-container{direction:ltr;margin:20px 0;text-align:center}.firebaseui-id-resend-countdown{color:rgba(0,0,0,.38)}.firebaseui-id-page-phone-sign-in-start .firebaseui-form-actions div{float:left}@media (max-width:480px){.firebaseui-container{box-shadow:none;max-width:none;width:100%}.firebaseui-card-header{border-bottom:1px solid #e0e0e0;margin-bottom:16px;padding:16px 24px 0}.firebaseui-title{padding-bottom:16px}.firebaseui-card-actions{padding-right:24px}.firebaseui-busy-indicator{top:0}}.mdl-textfield__label{font-weight:400;margin-bottom:0}.firebaseui-flag-KY{background-position:0 0}.firebaseui-flag-AC{background-position:0 -14px}.firebaseui-flag-AE{background-position:0 -28px}.firebaseui-flag-AF{background-position:0 -42px}.firebaseui-flag-AG{background-position:0 -56px}.firebaseui-flag-AI{background-position:0 -70px}.firebaseui-flag-AL{background-position:0 -84px}.firebaseui-flag-AM{background-position:0 -98px}.firebaseui-flag-AO{background-position:0 -112px}.firebaseui-flag-AQ{background-position:0 -126px}.firebaseui-flag-AR{background-position:0 -140px}.firebaseui-flag-AS{background-position:0 -154px}.firebaseui-flag-AT{background-position:0 -168px}.firebaseui-flag-AU{background-position:0 -182px}.firebaseui-flag-AW{background-position:0 -196px}.firebaseui-flag-AX{background-position:0 -210px}.firebaseui-flag-AZ{background-position:0 -224px}.firebaseui-flag-BA{background-position:0 -238px}.firebaseui-flag-BB{background-position:0 -252px}.firebaseui-flag-BD{background-position:0 -266px}.firebaseui-flag-BE{background-position:0 -280px}.firebaseui-flag-BF{background-position:0 -294px}.firebaseui-flag-BG{background-position:0 -308px}.firebaseui-flag-BH{background-position:0 -322px}.firebaseui-flag-BI{background-position:0 -336px}.firebaseui-flag-BJ{background-position:0 -350px}.firebaseui-flag-BL{background-position:0 -364px}.firebaseui-flag-BM{background-position:0 -378px}.firebaseui-flag-BN{background-position:0 -392px}.firebaseui-flag-BO{background-position:0 -406px}.firebaseui-flag-BQ{background-position:0 -420px}.firebaseui-flag-BR{background-position:0 -434px}.firebaseui-flag-BS{background-position:0 -448px}.firebaseui-flag-BT{background-position:0 -462px}.firebaseui-flag-BV{background-position:0 -476px}.firebaseui-flag-BW{background-position:0 -490px}.firebaseui-flag-BY{background-position:0 -504px}.firebaseui-flag-BZ{background-position:0 -518px}.firebaseui-flag-CA{background-position:0 -532px}.firebaseui-flag-CC{background-position:0 -546px}.firebaseui-flag-CD{background-position:0 -560px}.firebaseui-flag-CF{background-position:0 -574px}.firebaseui-flag-CG{background-position:0 -588px}.firebaseui-flag-CH{background-position:0 -602px}.firebaseui-flag-CI{background-position:0 -616px}.firebaseui-flag-CK{background-position:0 -630px}.firebaseui-flag-CL{background-position:0 -644px}.firebaseui-flag-CM{background-position:0 -658px}.firebaseui-flag-CN{background-position:0 -672px}.firebaseui-flag-CO{background-position:0 -686px}.firebaseui-flag-CP{background-position:0 -700px}.firebaseui-flag-CR{background-position:0 -714px}.firebaseui-flag-CU{background-position:0 -728px}.firebaseui-flag-CV{background-position:0 -742px}.firebaseui-flag-CW{background-position:0 -756px}.firebaseui-flag-CX{background-position:0 -770px}.firebaseui-flag-CY{background-position:0 -784px}.firebaseui-flag-CZ{background-position:0 -798px}.firebaseui-flag-DE{background-position:0 -812px}.firebaseui-flag-DG{background-position:0 -826px}.firebaseui-flag-DJ{background-position:0 -840px}.firebaseui-flag-DK{background-position:0 -854px}.firebaseui-flag-DM{background-position:0 -868px}.firebaseui-flag-DO{background-position:0 -882px}.firebaseui-flag-DZ{background-position:0 -896px}.firebaseui-flag-EA{background-position:0 -910px}.firebaseui-flag-EC{background-position:0 -924px}.firebaseui-flag-EE{background-position:0 -938px}.firebaseui-flag-EG{background-position:0 -952px}.firebaseui-flag-EH{background-position:0 -966px}.firebaseui-flag-ER{background-position:0 -980px}.firebaseui-flag-ES{background-position:0 -994px}.firebaseui-flag-ET{background-position:0 -1008px}.firebaseui-flag-EU{background-position:0 -1022px}.firebaseui-flag-FI{background-position:0 -1036px}.firebaseui-flag-FJ{background-position:0 -1050px}.firebaseui-flag-FK{background-position:0 -1064px}.firebaseui-flag-FM{background-position:0 -1078px}.firebaseui-flag-FO{background-position:0 -1092px}.firebaseui-flag-FR{background-position:0 -1106px}.firebaseui-flag-GA{background-position:0 -1120px}.firebaseui-flag-GB{background-position:0 -1134px}.firebaseui-flag-GD{background-position:0 -1148px}.firebaseui-flag-GE{background-position:0 -1162px}.firebaseui-flag-GF{background-position:0 -1176px}.firebaseui-flag-GG{background-position:0 -1190px}.firebaseui-flag-GH{background-position:0 -1204px}.firebaseui-flag-GI{background-position:0 -1218px}.firebaseui-flag-GL{background-position:0 -1232px}.firebaseui-flag-GM{background-position:0 -1246px}.firebaseui-flag-GN{background-position:0 -1260px}.firebaseui-flag-GP{background-position:0 -1274px}.firebaseui-flag-GQ{background-position:0 -1288px}.firebaseui-flag-GR{background-position:0 -1302px}.firebaseui-flag-GS{background-position:0 -1316px}.firebaseui-flag-GT{background-position:0 -1330px}.firebaseui-flag-GU{background-position:0 -1344px}.firebaseui-flag-GW{background-position:0 -1358px}.firebaseui-flag-GY{background-position:0 -1372px}.firebaseui-flag-HK{background-position:0 -1386px}.firebaseui-flag-HM{background-position:0 -1400px}.firebaseui-flag-HN{background-position:0 -1414px}.firebaseui-flag-HR{background-position:0 -1428px}.firebaseui-flag-HT{background-position:0 -1442px}.firebaseui-flag-HU{background-position:0 -1456px}.firebaseui-flag-IC{background-position:0 -1470px}.firebaseui-flag-ID{background-position:0 -1484px}.firebaseui-flag-IE{background-position:0 -1498px}.firebaseui-flag-IL{background-position:0 -1512px}.firebaseui-flag-IM{background-position:0 -1526px}.firebaseui-flag-IN{background-position:0 -1540px}.firebaseui-flag-IO{background-position:0 -1554px}.firebaseui-flag-IQ{background-position:0 -1568px}.firebaseui-flag-IR{background-position:0 -1582px}.firebaseui-flag-IS{background-position:0 -1596px}.firebaseui-flag-IT{background-position:0 -1610px}.firebaseui-flag-JE{background-position:0 -1624px}.firebaseui-flag-JM{background-position:0 -1638px}.firebaseui-flag-JO{background-position:0 -1652px}.firebaseui-flag-JP{background-position:0 -1666px}.firebaseui-flag-KE{background-position:0 -1680px}.firebaseui-flag-KG{background-position:0 -1694px}.firebaseui-flag-KH{background-position:0 -1708px}.firebaseui-flag-KI{background-position:0 -1722px}.firebaseui-flag-KM{background-position:0 -1736px}.firebaseui-flag-KN{background-position:0 -1750px}.firebaseui-flag-KP{background-position:0 -1764px}.firebaseui-flag-KR{background-position:0 -1778px}.firebaseui-flag-KW{background-position:0 -1792px}.firebaseui-flag-AD{background-position:0 -1806px}.firebaseui-flag-KZ{background-position:0 -1820px}.firebaseui-flag-LA{background-position:0 -1834px}.firebaseui-flag-LB{background-position:0 -1848px}.firebaseui-flag-LC{background-position:0 -1862px}.firebaseui-flag-LI{background-position:0 -1876px}.firebaseui-flag-LK{background-position:0 -1890px}.firebaseui-flag-LR{background-position:0 -1904px}.firebaseui-flag-LS{background-position:0 -1918px}.firebaseui-flag-LT{background-position:0 -1932px}.firebaseui-flag-LU{background-position:0 -1946px}.firebaseui-flag-LV{background-position:0 -1960px}.firebaseui-flag-LY{background-position:0 -1974px}.firebaseui-flag-MA{background-position:0 -1988px}.firebaseui-flag-MC{background-position:0 -2002px}.firebaseui-flag-MD{background-position:0 -2016px}.firebaseui-flag-ME{background-position:0 -2030px}.firebaseui-flag-MF{background-position:0 -2044px}.firebaseui-flag-MG{background-position:0 -2058px}.firebaseui-flag-MH{background-position:0 -2072px}.firebaseui-flag-MK{background-position:0 -2086px}.firebaseui-flag-ML{background-position:0 -2100px}.firebaseui-flag-MM{background-position:0 -2114px}.firebaseui-flag-MN{background-position:0 -2128px}.firebaseui-flag-MO{background-position:0 -2142px}.firebaseui-flag-MP{background-position:0 -2156px}.firebaseui-flag-MQ{background-position:0 -2170px}.firebaseui-flag-MR{background-position:0 -2184px}.firebaseui-flag-MS{background-position:0 -2198px}.firebaseui-flag-MT{background-position:0 -2212px}.firebaseui-flag-MU{background-position:0 -2226px}.firebaseui-flag-MV{background-position:0 -2240px}.firebaseui-flag-MW{background-position:0 -2254px}.firebaseui-flag-MX{background-position:0 -2268px}.firebaseui-flag-MY{background-position:0 -2282px}.firebaseui-flag-MZ{background-position:0 -2296px}.firebaseui-flag-NA{background-position:0 -2310px}.firebaseui-flag-NC{background-position:0 -2324px}.firebaseui-flag-NE{background-position:0 -2338px}.firebaseui-flag-NF{background-position:0 -2352px}.firebaseui-flag-NG{background-position:0 -2366px}.firebaseui-flag-NI{background-position:0 -2380px}.firebaseui-flag-NL{background-position:0 -2394px}.firebaseui-flag-NO{background-position:0 -2408px}.firebaseui-flag-NP{background-position:0 -2422px}.firebaseui-flag-NR{background-position:0 -2436px}.firebaseui-flag-NU{background-position:0 -2450px}.firebaseui-flag-NZ{background-position:0 -2464px}.firebaseui-flag-OM{background-position:0 -2478px}.firebaseui-flag-PA{background-position:0 -2492px}.firebaseui-flag-PE{background-position:0 -2506px}.firebaseui-flag-PF{background-position:0 -2520px}.firebaseui-flag-PG{background-position:0 -2534px}.firebaseui-flag-PH{background-position:0 -2548px}.firebaseui-flag-PK{background-position:0 -2562px}.firebaseui-flag-PL{background-position:0 -2576px}.firebaseui-flag-PM{background-position:0 -2590px}.firebaseui-flag-PN{background-position:0 -2604px}.firebaseui-flag-PR{background-position:0 -2618px}.firebaseui-flag-PS{background-position:0 -2632px}.firebaseui-flag-PT{background-position:0 -2646px}.firebaseui-flag-PW{background-position:0 -2660px}.firebaseui-flag-PY{background-position:0 -2674px}.firebaseui-flag-QA{background-position:0 -2688px}.firebaseui-flag-RE{background-position:0 -2702px}.firebaseui-flag-RO{background-position:0 -2716px}.firebaseui-flag-RS{background-position:0 -2730px}.firebaseui-flag-RU{background-position:0 -2744px}.firebaseui-flag-RW{background-position:0 -2758px}.firebaseui-flag-SA{background-position:0 -2772px}.firebaseui-flag-SB{background-position:0 -2786px}.firebaseui-flag-SC{background-position:0 -2800px}.firebaseui-flag-SD{background-position:0 -2814px}.firebaseui-flag-SE{background-position:0 -2828px}.firebaseui-flag-SG{background-position:0 -2842px}.firebaseui-flag-SH{background-position:0 -2856px}.firebaseui-flag-SI{background-position:0 -2870px}.firebaseui-flag-SJ{background-position:0 -2884px}.firebaseui-flag-SK{background-position:0 -2898px}.firebaseui-flag-SL{background-position:0 -2912px}.firebaseui-flag-SM{background-position:0 -2926px}.firebaseui-flag-SN{background-position:0 -2940px}.firebaseui-flag-SO{background-position:0 -2954px}.firebaseui-flag-SR{background-position:0 -2968px}.firebaseui-flag-SS{background-position:0 -2982px}.firebaseui-flag-ST{background-position:0 -2996px}.firebaseui-flag-SV{background-position:0 -3010px}.firebaseui-flag-SX{background-position:0 -3024px}.firebaseui-flag-SY{background-position:0 -3038px}.firebaseui-flag-SZ{background-position:0 -3052px}.firebaseui-flag-TA{background-position:0 -3066px}.firebaseui-flag-TC{background-position:0 -3080px}.firebaseui-flag-TD{background-position:0 -3094px}.firebaseui-flag-TF{background-position:0 -3108px}.firebaseui-flag-TG{background-position:0 -3122px}.firebaseui-flag-TH{background-position:0 -3136px}.firebaseui-flag-TJ{background-position:0 -3150px}.firebaseui-flag-TK{background-position:0 -3164px}.firebaseui-flag-TL{background-position:0 -3178px}.firebaseui-flag-TM{background-position:0 -3192px}.firebaseui-flag-TN{background-position:0 -3206px}.firebaseui-flag-TO{background-position:0 -3220px}.firebaseui-flag-TR{background-position:0 -3234px}.firebaseui-flag-TT{background-position:0 -3248px}.firebaseui-flag-TV{background-position:0 -3262px}.firebaseui-flag-TW{background-position:0 -3276px}.firebaseui-flag-TZ{background-position:0 -3290px}.firebaseui-flag-UA{background-position:0 -3304px}.firebaseui-flag-UG{background-position:0 -3318px}.firebaseui-flag-UM{background-position:0 -3332px}.firebaseui-flag-UN{background-position:0 -3346px}.firebaseui-flag-US{background-position:0 -3360px}.firebaseui-flag-UY{background-position:0 -3374px}.firebaseui-flag-UZ{background-position:0 -3388px}.firebaseui-flag-VA{background-position:0 -3402px}.firebaseui-flag-VC{background-position:0 -3416px}.firebaseui-flag-VE{background-position:0 -3430px}.firebaseui-flag-VG{background-position:0 -3444px}.firebaseui-flag-VI{background-position:0 -3458px}.firebaseui-flag-VN{background-position:0 -3472px}.firebaseui-flag-VU{background-position:0 -3486px}.firebaseui-flag-WF{background-position:0 -3500px}.firebaseui-flag-WS{background-position:0 -3514px}.firebaseui-flag-XK{background-position:0 -3528px}.firebaseui-flag-YE{background-position:0 -3542px}.firebaseui-flag-YT{background-position:0 -3556px}.firebaseui-flag-ZA{background-position:0 -3570px}.firebaseui-flag-ZM{background-position:0 -3584px}.firebaseui-flag-ZW{background-position:0 -3598px}',""])},function(i,e,o){var t=o(4);"string"==typeof t&&(t=[[i.i,t,""]]);var a={hmr:!0,transform:void 0,insertInto:void 0};o(2)(t,a);t.locals&&(i.exports=t.locals)},function(i,e){i.exports=__webpack_require__(2)},function(i,e,o){"use strict";e.__esModule=!0;var t,a=o(6),r=(t=a)&&t.__esModule?t:{default:t};var n=Promise.resolve(),l=function(i){function e(o){!function(i,e){if(!(i instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var t=function(i,e){if(!i)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?i:e}(this,i.call(this,o));return t.uiConfig=o.uiConfig,t.firebaseAuth=o.firebaseAuth,t.className=o.className,t.uiCallback=o.uiCallback,t}return function(i,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);i.prototype=Object.create(e&&e.prototype,{constructor:{value:i,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(i,e):i.__proto__=e)}(e,i),e.prototype.componentDidMount=function(){var i=this;o(5);var e=o(0);n.then(function(){i.firebaseUiWidget=e.auth.AuthUI.getInstance()||new e.auth.AuthUI(i.firebaseAuth),"popup"===i.uiConfig.signInFlow&&i.firebaseUiWidget.reset(),i.userSignedIn=!1,i.unregisterAuthObserver=i.firebaseAuth.onAuthStateChanged(function(e){!e&&i.userSignedIn&&i.firebaseUiWidget.reset(),i.userSignedIn=!!e}),i.uiCallback&&i.uiCallback(i.firebaseUiWidget),i.firebaseUiWidget.start("#firebaseui_container",i.uiConfig)})},e.prototype.componentWillUnmount=function(){this.unregisterAuthObserver(),n=this.firebaseUiWidget.delete()},e.prototype.render=function(){return r.default.createElement("div",{className:this.className,id:"firebaseui_container"})},e}(r.default.Component);e.default=l}]);
	//# sourceMappingURL=StyledFirebaseAuth.js.map

/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _FirebaseAuth = __webpack_require__(1336);
	
	var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);
	
	var _StyledFirebaseAuth = __webpack_require__(1337);
	
	var _StyledFirebaseAuth2 = _interopRequireDefault(_StyledFirebaseAuth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.FirebaseAuth = _FirebaseAuth2.default;
	exports.StyledFirebaseAuth = _StyledFirebaseAuth2.default;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(1386);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(891);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(1339);
	
	var _HelmetConstants = __webpack_require__(539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 1339:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(97);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(539);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(2);
	var PropTypes = _interopDefault(__webpack_require__(3));
	var PopperJS = _interopDefault(__webpack_require__(1143));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var Manager = function (_Component) {
	  inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return react.createElement(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	  return Manager;
	}(react.Component);
	
	Manager.childContextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	Manager.propTypes = {
	  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: PropTypes.object.isRequired
	};
	
	Target.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	var placements = PopperJS.placements;
	
	var Popper = function (_Component) {
	  inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      if (_this.props.target) {
	        return _this.props.target;
	      } else if (!_this.context.popperManager || !_this.context.popperManager.getTargetNode()) {
	        throw new Error('Target missing. Popper must be given a target from the Popper Manager, or as a prop.');
	      }
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	
	      if (!_this._popper || !data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      return _extends({
	        position: data.offsets.popper.position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _this._handlePopperRef = function (node) {
	      _this._popperNode = node;
	      if (node) {
	        _this._createPopper();
	      } else {
	        _this._destroyPopper();
	      }
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this._scheduleUpdate = function () {
	      _this._popper && _this._popper.scheduleUpdate();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled || lastProps.target !== this.props.target) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	      if (lastProps.children !== this.props.children) {
	        this._scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _this2 = this;
	
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled,
	          positionFixed = _props.positionFixed;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	      if (this._arrowNode) {
	        modifiers.arrow = _extends({}, this.props.modifiers.arrow || {}, {
	          element: this._arrowNode
	        });
	      }
	      this._popper = new PopperJS(this._getTargetNode(), this._popperNode, {
	        placement: placement,
	        positionFixed: positionFixed,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
	      setTimeout(function () {
	        return _this2._scheduleUpdate();
	      });
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          positionFixed = _props2.positionFixed,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'positionFixed', 'modifiers', 'children']);
	
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var popperProps = {
	          ref: this._handlePopperRef,
	          style: popperStyle,
	          'data-placement': popperPlacement,
	          'data-x-out-of-boundaries': popperHide
	        };
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: this._scheduleUpdate
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = this._handlePopperRef;
	      } else {
	        componentProps.innerRef = this._handlePopperRef;
	      }
	
	      return react.createElement(component, componentProps, children);
	    }
	  }]);
	  return Popper;
	}(react.Component);
	
	Popper.contextTypes = {
	  popperManager: PropTypes.object
	};
	Popper.childContextTypes = {
	  popper: PropTypes.object.isRequired
	};
	Popper.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  placement: PropTypes.oneOf(placements),
	  eventsEnabled: PropTypes.bool,
	  positionFixed: PropTypes.bool,
	  modifiers: PropTypes.object,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  target: PropTypes.oneOfType([
	  // the following check is needed for SSR
	  PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object), PropTypes.shape({
	    getBoundingClientRect: PropTypes.func.isRequired,
	    clientWidth: PropTypes.number.isRequired,
	    clientHeight: PropTypes.number.isRequired
	  })])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  positionFixed: false,
	  modifiers: {}
	};
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return react.createElement(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: PropTypes.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  innerRef: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
	};
	
	exports.Manager = Manager;
	exports.Target = Target;
	exports.Popper = Popper;
	exports.placements = placements;
	exports.Arrow = Arrow;
	//# sourceMappingURL=react-popper.js.map


/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(626);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(149);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(631);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(169);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(168);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(31);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _stifle = __webpack_require__(1418);
	
	var _stifle2 = _interopRequireDefault(_stifle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
		width: '100px',
		height: '100px',
		position: 'absolute',
		top: '-100000px',
		overflow: 'scroll',
		msOverflowStyle: 'scrollbar'
	};
	
	var ScrollbarSize = function (_Component) {
		(0, _inherits3.default)(ScrollbarSize, _Component);
	
		function ScrollbarSize() {
			var _ref;
	
			var _temp, _this, _ret;
	
			(0, _classCallCheck3.default)(this, ScrollbarSize);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollbarSize.__proto__ || (0, _getPrototypeOf2.default)(ScrollbarSize)).call.apply(_ref, [this].concat(args))), _this), _this.setMeasurements = function () {
				_this.scrollbarHeight = _this.node.offsetHeight - _this.node.clientHeight;
				_this.scrollbarWidth = _this.node.offsetWidth - _this.node.clientWidth;
			}, _this.handleResize = (0, _stifle2.default)(function () {
				var onChange = _this.props.onChange;
	
	
				var prevHeight = _this.scrollbarHeight;
				var prevWidth = _this.scrollbarWidth;
				_this.setMeasurements();
				if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
					onChange({ scrollbarHeight: _this.scrollbarHeight, scrollbarWidth: _this.scrollbarWidth });
				}
			}, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
		}
	
		(0, _createClass3.default)(ScrollbarSize, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var onLoad = this.props.onLoad;
	
	
				if (onLoad) {
					this.setMeasurements();
					onLoad({ scrollbarHeight: this.scrollbarHeight, scrollbarWidth: this.scrollbarWidth });
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.handleResize.cancel();
			}
		}, {
			key: 'render',
			// Corresponds to 10 frames at 60 Hz.
	
			value: function render() {
				var _this2 = this;
	
				var onChange = this.props.onChange;
	
	
				return _react2.default.createElement(
					'div',
					null,
					onChange ? _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }) : null,
					_react2.default.createElement('div', {
						style: styles,
						ref: function ref(node) {
							_this2.node = node;
						}
					})
				);
			}
		}]);
		return ScrollbarSize;
	}(_react.Component);
	
	ScrollbarSize.defaultProps = {
		onLoad: null,
		onChange: null
	};
	exports.default = ScrollbarSize;

/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScrollbarSize = __webpack_require__(1384);
	
	var _ScrollbarSize2 = _interopRequireDefault(_ScrollbarSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollbarSize2.default;

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(909));
	var shallowEqual = _interopDefault(__webpack_require__(1408));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {

	var raf = __webpack_require__(1148)
	var E_NOSCROLL = new Error('Element already at target scroll position')
	var E_CANCELLED = new Error('Scroll cancelled')
	var min = Math.min
	
	module.exports = {
	  left: make('scrollLeft'),
	  top: make('scrollTop')
	}
	
	function make (prop) {
	  return function scroll (el, to, opts, cb) {
	    opts = opts || {}
	
	    if (typeof opts == 'function') cb = opts, opts = {}
	    if (typeof cb != 'function') cb = noop
	
	    var start = +new Date
	    var from = el[prop]
	    var ease = opts.ease || inOutSine
	    var duration = !isNaN(opts.duration) ? +opts.duration : 350
	    var cancelled = false
	
	    return from === to ?
	      cb(E_NOSCROLL, el[prop]) :
	      raf(animate), cancel
	
	    function cancel () {
	      cancelled = true
	    }
	
	    function animate (timestamp) {
	      if (cancelled) return cb(E_CANCELLED, el[prop])
	
	      var now = +new Date
	      var time = min(1, ((now - start) / duration))
	      var eased = ease(time)
	
	      el[prop] = (eased * (to - from)) + from
	
	      time < 1 ? raf(animate) : raf(function () {
	        cb(null, el[prop])
	      })
	    }
	  }
	}
	
	function inOutSine (n) {
	  return 0.5 * (1 - Math.cos(Math.PI * n))
	}
	
	function noop () {}


/***/ }),

/***/ 1408:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 1418:
/***/ (function(module, exports) {

	module.exports = stifle;
	
	
	function stifle (fn, wait) {
	  if (typeof fn !== 'function' || typeof wait !== 'number') {
	    throw new Error('stifle(fn, wait) -- expected a function and number of milliseconds, got (' + typeof fn + ', ' + typeof wait + ')');
	  }
	
	  var timer;    // Timer to fire after `wait` has elapsed
	  var called;   // Keep track if it gets called during the `wait`
	
	  var wrapper = function () {
	
	    // Check if still "cooling down" from a previous call
	    if (timer) {
	      called = true;
	    } else {
	      // Start a timer to fire after the `wait` is over
	      timer = setTimeout(afterWait, wait);
	      // And call the wrapped function
	      fn();
	    }
	  }
	
	  // Add a cancel method, to kill and pending calls
	  wrapper.cancel = function () {
	    // Clear the called flag, or it would fire twice when called again later
	    called = false;
	
	    // Turn off the timer, so it won't fire after the wait expires
	    if (timer) {
	      clearTimeout(timer);
	      timer = undefined;
	    }
	  }
	
	  function afterWait() {
	    // Empty out the timer
	    timer = undefined;
	
	    // If it was called during the `wait`, fire it again
	    if (called) {
	      called = false;
	      wrapper();
	    }
	  }
	
	  return wrapper;
	}


/***/ }),

/***/ 563:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(604);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(304);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFirebaseui = __webpack_require__(1338);
	
	var _firebaseui = __webpack_require__(299);
	
	var _firebaseui2 = _interopRequireDefault(_firebaseui);
	
	var _Typography = __webpack_require__(24);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Paper = __webpack_require__(29);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _styles = __webpack_require__(44);
	
	var _Divider = __webpack_require__(105);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _reactHelmet = __webpack_require__(538);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _googleYoloManager = __webpack_require__(249);
	
	var _googleYoloManager2 = _interopRequireDefault(_googleYoloManager);
	
	var _firebase = __webpack_require__(148);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  return {
	    root: theme.mixins.gutters({
	      display: "flex",
	      alignItems: "center",
	      justifyContent: "center",
	      width: "100%",
	      height: "500px"
	    }),
	    errorMessageContainer: theme.mixins.gutters({
	      paddingTop: 16,
	      paddingBottom: 16,
	      marginTop: theme.spacing.unit * 3
	    }),
	    signInContainer: {
	      marginTop: "5px"
	    }
	  };
	};
	
	var WithAuthentication = function (_React$Component) {
	  _inherits(WithAuthentication, _React$Component);
	
	  function WithAuthentication(props) {
	    _classCallCheck(this, WithAuthentication);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      user: _firebase2.default.auth().currentUser,
	      needsManualSignIn: false,
	      addYolo: false
	    };
	    _this.authMetadataCallback = null;
	    _this.authMetadataRef = null;
	    _this.uiConfig = {
	      signInFlow: "popup",
	      signInSuccessUrl: "/admin",
	      credentialHelper: _firebaseui2.default.auth ? _firebaseui2.default.auth.CredentialHelper.GOOGLE_YOLO : "",
	      signInOptions: [_firebaseui2.default.auth ? _firebase2.default.auth.GoogleAuthProvider.PROVIDER_ID : ""],
	      callbacks: {
	        signInSuccess: function signInSuccess(currentUser, credential, redirectUrl) {
	          return false;
	        }
	      }
	    };
	    return _this;
	  }
	
	  WithAuthentication.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.unsubscribeAuthChangeListener = _firebase2.default.auth().onAuthStateChanged(function (user) {
	      return _this2.authChangeListener(user);
	    });
	    _googleYoloManager2.default.addOnLoadListener();
	    this.addYoloTimer = setTimeout(function () {
	      return _this2.setState({ addYolo: true });
	    }, 1000);
	  };
	
	  WithAuthentication.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeAuthChangeListener) {
	      this.unsubscribeAuthChangeListener();
	    }
	    if (this.addYoloTimer) {
	      this.addYoloTimer.clearTimeout();
	      this.addYoloTimer = null;
	    }
	  };
	
	  WithAuthentication.prototype.authChangeListener = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
	      var signedIn;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (this.authMetadataCallback) {
	                this.authMetadataRef.off("value", this.authMetadataCallback);
	              }
	
	              if (!user) {
	                _context.next = 7;
	                break;
	              }
	
	              this.setState({ user: user });
	              this.authMetadataRef = _firebase.adminDatabase.ref("accountInfo/" + user.uid);
	              this.authMetadataCallback = this.authMetadataRef.on("value", function (snapshot) {
	                user.getIdToken(true);
	              });
	              _context.next = 12;
	              break;
	
	            case 7:
	              this.setState({ user: null });
	              _context.next = 10;
	              return _googleYoloManager2.default.login();
	
	            case 10:
	              signedIn = _context.sent;
	
	              this.setState({ needsManualSignIn: !signedIn });
	
	            case 12:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    function authChangeListener(_x) {
	      return _ref.apply(this, arguments);
	    }
	
	    return authChangeListener;
	  }();
	
	  WithAuthentication.prototype.render = function render() {
	    var classes = this.props.classes;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      this.state.addYolo && _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement("script", {
	          type: "text/javascript",
	          charSet: "UTF-8",
	          src: "https://smartlock.google.com/client"
	        })
	      ),
	      this.state.user && this.props.children,
	      !this.state.user && _react2.default.createElement(
	        "div",
	        { className: classes.root },
	        _react2.default.createElement(
	          _Paper2.default,
	          { className: classes.errorMessageContainer, elevation: 4 },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _Typography2.default,
	              { type: "headline", component: "h3" },
	              "You must be logged in to see this page"
	            ),
	            this.state.needsManualSignIn && _react2.default.createElement(
	              "div",
	              { className: classes.signInContainer },
	              _react2.default.createElement(_Divider2.default, null),
	              _react2.default.createElement(_reactFirebaseui.FirebaseAuth, {
	                uiConfig: this.uiConfig,
	                firebaseAuth: _firebase2.default.auth()
	              })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return WithAuthentication;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(styles)(WithAuthentication);
	module.exports = exports["default"];

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(429);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _materialUi = __webpack_require__(1116);
	
	var _styles = __webpack_require__(44);
	
	var _Typography = __webpack_require__(24);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Button = __webpack_require__(38);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Avatar = __webpack_require__(446);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Menu = __webpack_require__(92);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _firebase = __webpack_require__(148);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _googleYoloManager = __webpack_require__(249);
	
	var _googleYoloManager2 = _interopRequireDefault(_googleYoloManager);
	
	var _config = __webpack_require__(146);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  root: {
	    width: "100%"
	  },
	  flex: {
	    flex: 1
	  }
	};
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.logOutFromAccount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _googleYoloManager2.default.logout();
	
	            case 2:
	              _context.next = 4;
	              return _firebase2.default.auth().signOut();
	
	            case 4:
	              (0, _gatsbyLink.navigateTo)("/");
	
	            case 5:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.state = {
	      user: _firebase2.default.auth().currentUser,
	      showLogout: false
	    };
	    return _this;
	  }
	
	  Header.prototype.componentWillMount = function componentWillMount() {
	    var _this3 = this;
	
	    this.unsubscribeAuthChangeListener = _firebase2.default.auth().onAuthStateChanged(function (user) {
	      return _this3.setState(user);
	    });
	  };
	
	  Header.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeAuthChangeListener) {
	      this.unsubscribeAuthChangeListener();
	    }
	  };
	
	  Header.prototype.render = function render() {
	    var _this4 = this;
	
	    var classes = this.props.classes;
	    var user = this.state.user;
	
	    return _react2.default.createElement(
	      "div",
	      { className: classes.root },
	      user && _react2.default.createElement(
	        _materialUi.AppBar,
	        {
	          position: "static",
	          color: _config2.default.production ? "secondary" : "primary"
	        },
	        _react2.default.createElement(
	          _materialUi.Toolbar,
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            { type: "title", color: "inherit", className: classes.flex },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                href: "/admin",
	                to: "/admin",
	                activeStyle: { color: "white", textDecoration: "none" }
	              },
	              "Cliffhanger Admin",
	              " ",
	              "" + (_config2.default.production ? "PRODUCTION" : "DEVELOPMENT")
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                style: {
	                  color: "white",
	                  verticalAlign: "middle",
	                  display: "flex",
	                  alignItems: "center"
	                }
	              },
	              user.displayName + "<" + user.email + ">",
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  className: classes.button,
	                  color: "primary",
	                  onClick: function onClick(event) {
	                    _this4.setState({
	                      showLogout: true,
	                      anchorEl: event.currentTarget
	                    });
	                  }
	                },
	                _react2.default.createElement(_Avatar2.default, { alt: user.displayName, src: user.photoURL })
	              )
	            ),
	            _react2.default.createElement(
	              _Menu2.default,
	              {
	                id: "simple-menu",
	                anchorEl: this.state.anchorEl,
	                open: this.state.showLogout,
	                onClose: function onClose() {
	                  _this4.setState({ showLogout: false });
	                }
	              },
	              _react2.default.createElement(
	                _Menu.MenuItem,
	                { onClick: this.logOutFromAccount },
	                "Logout"
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(styles)(Header);
	module.exports = exports["default"];

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(538);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Permissions = __webpack_require__(145);
	
	var _header = __webpack_require__(603);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _WithAuthentication = __webpack_require__(602);
	
	var _WithAuthentication2 = _interopRequireDefault(_WithAuthentication);
	
	var _WithPermission = __webpack_require__(166);
	
	var _WithPermission2 = _interopRequireDefault(_WithPermission);
	
	__webpack_require__(911);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexWrapper = function IndexWrapper(_ref) {
	  var location = _ref.location,
	      children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: "Cliffhanger: Thrilling Chat Stories",
	        meta: [{ name: "description", content: "Cliffhanger: Thrilling Chat Stories" }, { name: "keywords", content: "Cliffhanger Thrilling Chat Stories" }]
	      },
	      _react2.default.createElement("link", {
	        href: "https://fonts.googleapis.com/icon?family=Material+Icons",
	        rel: "stylesheet"
	      })
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      !location.pathname.startsWith("/admin") && children(),
	      location.pathname.startsWith("/admin") && _react2.default.createElement(
	        _WithAuthentication2.default,
	        null,
	        _react2.default.createElement(
	          _WithPermission2.default,
	          { permission: _Permissions.Permissions.ADMIN },
	          _react2.default.createElement(_header2.default, null),
	          _react2.default.createElement(
	            "div",
	            null,
	            children()
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexWrapper;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-162d7e2e52f408bdab9b.js